// src/pages/shop/ShopPage.js - Updated with Manual Save

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import TreasureMap from '../../components/map/TreasureMap';
import styled, { ThemeProvider, keyframes } from 'styled-components';
import ValidatedEditableText from '../../components/common/ValidatedEditableText';
import { VALIDATION_RULES, validateShopData, validateAllItems } from '../../utils/inputValidation';
import logo from './logo512.png';
import { auth, db } from '../../firebase/config';
import { collection, query, doc, getDoc, updateDoc, where, deleteDoc, getDocs, orderBy, serverTimestamp, setDoc, arrayUnion, arrayRemove, deleteField, onSnapshot } from 'firebase/firestore';
import StripeWizard from '../../components/Stripe/StripeWizard';
import { compressProfileImage, compressProductImage, validateImageFile, compressCommunityImage, validateVideoFile, compressCommunityClip, readFileAsDataURL, generateImageVariants } from '../../utils/mediaCompression';
import { DEFAULT_THEME } from '../../theme/config/themes';
import { ref, uploadBytes, getDownloadURL, deleteObject  } from 'firebase/storage';
import { storage } from '../../firebase/config';
import { ChevronUp, ChevronDown, TrendingUp, Plus, Users, DollarSign , ChevronLeft, ChevronRight, X, Film, Check, Package, Home, CreditCard, Store, Building2, User, Clock, CheckSquare, Square, Flag, Lock, Unlock, Sparkles, Star, Navigation, Grid, Calendar, MessageSquare, Phone, Info, Heart, Briefcase, Search } from 'lucide-react';
import { useActiveShop } from '../../contexts/ActiveShopContext';
import { Trash2, Save, RotateCcw, AlertCircle } from 'lucide-react';
//import AddressInput from '../../components/shop/AddressInput';
import AddressInput from '../../components/AddressInput';
import ThemeSelector from '../../components/ThemeSelector/ThemeSelector';
import QuantitySelector from '../../components/shop/QuantitySelector';
import { WELCOME_STYLES } from '../../theme/welcomeStyles';
import { signOut } from 'firebase/auth';
import { RefreshCw, ThumbsUp, LogOut, Menu, Settings, MoreHorizontal } from 'lucide-react';
import ProfileContent from './components/ProfileContent';
import { uploadCommunityMedia, uploadCommunityThumbnail,
  saveCommunityPost,
  getCommunityPostsForShop,
  deleteCommunityPost, updateCommunityPost, getShopEvents, uploadProductMedia, uploadProductThumbnail, getNearbyShops, updateSingleField } from '../../firebase/firebaseService';
import { mirrorItemsFull, mirrorServicesFull, buildShopFields } from '../../firebase/itemsCollectionSync';
  import AccountBalanceButton from '../../components/Billing/AccountBalanceButton';

import WebsiteScraper from '../../components/shop/WebsiteScraper';
import MenuScanner from '../../components/shop/MenuScanner';
import MassLocationUpdater from '../../components/shop/MassLocationUpdater';
import { Download, MapPin, Upload, Globe, ScanLine, Power } from 'lucide-react';
import RideRoutePreview from '../../components/map/RideRoutePreview';
import { invalidateShopCache } from './ShopPublicView';
import {
  StreetwearTemplate,
  OrganizationTemplate,
  TechTemplate,
  MinimalistTemplate,
  LocalMarketTemplate,
  SECTION_TYPES,
  HeroBannerSection,
  FeaturedItemsSection,
  PhotoGallerySection,
  FeaturedVideoSection,
  MissionStatementSection,
  CalendarEventsSection,
  ServicesGridSection,
  ContactSection,
  FeaturedServicesSection,
  TextBlockSection,
  MapSection,
  FaqSection,
  ReviewsSection
} from './HomePageTemplate';

import {
  calculateOutstandingBalance,
  shouldHideItems,
  getPaymentBreakdown,
  formatCurrency,
  getPlanFromBilling,
  getPlanPermissions,
  canItemTypeBeVisible,
  countVisibleByType,
  canAddOrShowTab,
  PLAN_ORDER,
  PLANS,
} from '../../utils/billingTiers';
import PaymentModal from '../../components/Billing/PaymentModal';
import FreePlanHomeOverlay from '../../components/Billing/FreePlanHomeOverlay';
import { STORE_TYPES, JOB_TYPES, getCategoriesForStoreType, getStoreTypeById } from '../../constants/categories';
import { getJobTypeBookingTemplate } from '../../utils/orderFormConfig';
import { formatShopPrice } from '../../utils/currency';
import { fetchIPLocation } from '../../utils/locationUtils';
import { normalizeTabs, TAB_ICON_OPTIONS, CORE_TAB_IDS, getDefaultTabs } from '../../utils/tabConfig';



// Icon registry for dynamic tab icons (string name → component)
const TAB_ICONS = {
  Home, Store, Users, Grid, Calendar, MessageSquare, Package,
  Phone, Info, Heart, Briefcase, Navigation, Search, Star, MapPin, Globe, Clock,
};

const haversineDistanceMiles = (lat1, lng1, lat2, lng2) => {
  const R = 3959;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
  return (2 * R * Math.asin(Math.sqrt(a))).toFixed(1);
};

const SERVICE_TYPE_DEFAULTS = {
  rides:       { pickupAddress: '', pickupCoordinates: null, destinationAddress: '', destinationCoordinates: null, rideDateTime: '', passengers: 1, vehicleType: 'any', estimatedDistance: null, useRouteMapImage: false },
  home_repair: { serviceAddress: '', serviceDateTime: '', jobScope: 'moderate', urgency: 'flexible', materialsIncluded: false, accessInstructions: '' },
  cleaning:    { serviceAddress: '', serviceDateTime: '', propertyType: 'house', bedrooms: 1, bathrooms: 1, frequency: 'one-time', suppliesProvided: 'provider' },
  moving:      { pickupAddress: '', pickupCoordinates: null, destinationAddress: '', destinationCoordinates: null, moveDate: '', estimatedLoad: 'moderate', hasHeavyItems: false, packingHelp: false },
  delivery:    { pickupAddress: '', pickupCoordinates: null, deliveryAddress: '', deliveryCoordinates: null, itemDescription: '', itemSize: 'medium', deliveryByDateTime: '', fragile: false },
  tutoring:    { subject: '', gradeLevel: 'high', sessionDuration: '1hr', sessionMode: 'either', preferredSchedule: '' },
  pet_care:    { petType: 'dog', petBreed: '', petServiceType: 'walking', serviceDateTime: '', serviceDuration: '1', specialNeeds: '' },
  handyman:    { serviceAddress: '', serviceDateTime: '', urgency: 'flexible', estimatedHours: 1, toolsProvided: false },
  beauty:      { beautyServiceType: 'haircut', serviceLocation: 'home-visit', serviceAddress: '', serviceDateTime: '', duration: '1' },
  tech:        { deviceType: 'laptop', serviceMode: 'in-person', serviceAddress: '', urgency: 'flexible', os: 'windows' },
  events:      { eventType: 'birthday', eventDate: '', eventAddress: '', guestCount: 50, servicesNeeded: [], eventDuration: '4' },
  other:       { serviceAddress: '', serviceDateTime: '', urgency: 'flexible', estimatedDuration: '' },
};



const CompressionProgress = styled.div`
  position: fixed;
  bottom: 8rem;
  left: 50%;
  transform: translateX(-50%);
  background: ${props => `${props.theme?.colors?.surface}F5`};
  backdrop-filter: blur(10px);
  border: 2px solid ${props => props.theme?.colors?.accent};
  border-radius: 12px;
  padding: 1rem 1.5rem;
  z-index: 1000;
  min-width: 250px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  .progress-text {
    color: ${props => props.theme?.colors?.text};
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    text-align: center;
  }

  .progress-bar {
    width: 100%;
    height: 6px;
    background: ${props => `${props.theme?.colors?.accent}20`};
    border-radius: 3px;
    overflow: hidden;

    .progress-fill {
      height: 100%;
      background: ${props => props.theme?.colors?.accent};
      transition: width 0.3s ease;
    }
  }
`;


const ItemGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); // CHANGED BACK to 320px
  gap: 2rem;
  margin: 4rem 0;
  align-items: start; /* ADD THIS - prevents vertical stretching */

  /* Desktop: Single column for detailed cards */
  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 3rem;
  }

  /* Mobile: 2 columns for compact cards */
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr); // This is CORRECT - keep this
    gap: 0.75rem;
    margin: 2rem 0;
    padding: 0 0.5rem;
  }
`;

const ShopCategoryGrid = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(${props => props.$rows || 2}, auto);
  grid-auto-columns: calc(50% - 0.375rem);
  gap: 0.75rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 0.5rem;
  align-items: start;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar { height: 4px; }
  &::-webkit-scrollbar-track { background: ${props => `${props.$accent || '#800000'}20`}; border-radius: 10px; }
  &::-webkit-scrollbar-thumb { background: ${props => props.$accent || '#800000'}; border-radius: 10px; }
  > * { scroll-snap-align: start; min-width: 0; }

  @media (max-width: 767px) {
    grid-template-rows: repeat(${props => props.$mobileRows || 2}, auto);
    grid-auto-columns: ${props => `calc(${100 / (props.$cols || 2)}% - 0.375rem)`};
    gap: 0.5rem;
  }

  @media (min-width: 768px) {
    grid-auto-columns: calc(20% - 0.8rem);
    gap: 1rem;
  }
`;

const SaveButton = styled.button`
  background: ${props => `${props.theme?.colors?.accent || '#800000'}DD`};
  color: white;
  border: none;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  white-space: nowrap;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px ${props => `${props.theme?.colors?.accent}40`};

  &:hover {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}60`};
  }

  &:active {
    transform: scale(0.98);
  }

  svg {
    width: 16px;
    height: 16px;
  }
  
  @media (max-width: 767px) {
    padding: 0.35rem 0.65rem;
    font-size: 0.68rem;
  }

  @media (min-width: 768px) {
    padding: clamp(0.3rem, 0.5vh, 0.42rem) clamp(0.5rem, 0.9vw, 0.72rem);
    font-size: clamp(0.48rem, 0.78vh, 0.62rem);
  }
`;

const EditModal = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    position: fixed;
    top: 55px; /* CHANGED from 10px to 0 to take full screen */
    left: 10px; /* CHANGED from 10px to 0 to take full screen */
    right: 5px;
    padding-bottom: 20px;
    background: rgba(0, 0, 0, 0.98); /* INCREASED opacity for better blocking */
    backdrop-filter: blur(20px); /* INCREASED blur */
    background: rgba(0, 0, 0, 0.98);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 0;
    overflow: hidden;
    
    /* ADD these to block all interactions */
    pointer-events: auto; /* Allow clicks on modal */
    
    /* Ensure modal content blocks background */
    & > * {
      pointer-events: auto;
    }
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 5;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 2000;
  display: ${props => props.show ? 'block' : 'none'};
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.3s ease;
  
  /* FORCE block all interactions when overlay is shown */
  pointer-events: ${props => props.show ? 'auto' : 'none'};
  
  /* PREVENT scrolling when overlay is visible */
  body {
    overflow: ${props => props.show ? 'hidden' : 'auto'};
    position: ${props => props.show ? 'fixed' : 'static'};
    width: 100%;
  }
`;

// UPDATE EditModalContent to position it higher:
const EditModalContent = styled.div`
  background: ${props => props.theme?.colors?.background || '#000000'};
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 12px;
  width: calc(100% - 40px); /* ADD margins on sides */
  max-width: 400px;
  height: calc(100vh - 100px); /* Set height relative to viewport, minus top margin */
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 80px auto 20px; /* CHANGED: 80px top margin moves it up by ~1 inch */
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8); /* DARKER shadow */
  overflow: hidden;
  z-index: 2001;
  
  @media (max-width: 767px) {
    width: calc(100% - 40px); /* Keep side margins */
    height: calc(100vh - 100px); /* Full viewport height minus top/bottom margins */
    max-width: none;
    max-height: 70vh; /* Limit max height */
    margin: 65px 25px 20px; /* Top margin of 80px (~1 inch), side margins 20px */
  }
`;


const ResetButton = styled.button`
  background: ${props => `${props.theme?.colors?.background || '#000000'}DD`};
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  border: 1px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 8px;
  padding: 0.6rem 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  white-space: nowrap;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  
  &:hover {
    background: ${props => `${props.theme?.colors?.accent}20`};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}40`};
  }

  &:active {
    transform: scale(0.98);
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  @media (max-width: 767px) {
    padding: 0.35rem 0.65rem;
    font-size: 0.68rem;
  }

  @media (min-width: 768px) {
    padding: clamp(0.3rem, 0.5vh, 0.42rem) clamp(0.5rem, 0.9vw, 0.72rem);
    font-size: clamp(0.48rem, 0.78vh, 0.62rem);
  }
`;


const MobileDeleteButton = styled.button`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.7)'}DD`};
  border: 1px solid ${props => `${props.theme?.colors?.accent}60` || 'rgba(255, 255, 255, 0.3)'};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff4444;
  cursor: pointer;
  z-index: 4;
  opacity: 0.9;
  transition: all 0.2s ease;

  &:active {
    transform: scale(0.9);
    background: ${props => props.theme?.colors?.accent || '#800000'};
    color: white;
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;

const ImageActionButtons = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 0.75rem;
  z-index: 10;
  background: ${props => `${props.theme?.colors?.background || '#000000'}F5`};
  backdrop-filter: blur(10px);
  padding: 0.75rem;
  justify-content: center;
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(255, 255, 255, 0.1)'};
`;

const ImageActionButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  
  &.check {
    background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}E5`};
    color: #4CAF50;
    
    &:active {
      background: #4CAF50;
      color: white;
      transform: scale(0.95);
    }
  }
  
  &.close {
    background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}E5`};
    color: #ff4444;
    
    &:active {
      background: #ff4444;
      color: white;
      transform: scale(0.95);
    }
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const EditModalScrollContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 2px;
  }
`;

const EditModalImageSection = styled.div`
  width: 100%;
  min-height: 100px;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(255, 255, 255, 0.1)'};
`;

const EditModalBody = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const SectionTypeOption = styled.button`
  width: 100%;
  background: ${props => props.theme?.colors?.background || 'rgba(0, 0, 0, 0.3)'};
  border: 2px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'};
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    padding: 0.875rem;
    gap: 0.75rem;
    margin-bottom: 0.625rem;
  }

  &:hover {
    border-color: ${props => props.theme?.colors?.accent};
    background: ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.2)'};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}40`};
  }

  &:active {
    transform: translateY(0);
  }

  .icon {
    font-size: 1.5rem;
    
    @media (max-width: 768px) {
      font-size: 1.25rem;
    }
  }

  .info {
    flex: 1;
    
    .label {
      color: ${props => props.theme?.colors?.text};
      font-weight: 600;
      font-size: 0.95rem;
      margin-bottom: 0.25rem;
      
      @media (max-width: 768px) {
        font-size: 0.875rem;
      }
    }
  }
`;

const TemplateSelectorWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  padding: 0 1rem;
  
  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
    padding: 0 0.5rem;
  }
`;

const TemplateSelectorContainer = styled.div`
  background: ${props => `${props.theme?.colors?.surface}50`};
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40`};
  max-width: 900px;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 1rem;
    border-radius: 8px;
  }
`;

const LivePreviewHeader = styled.h3`
  text-align: center;
  margin-bottom: 2rem;
  color: ${props => props.theme?.colors?.accent};
  font-size: 1.1rem;
  padding: 1rem;
  
  @media (min-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: 3rem;
  }
`;

const LivePreviewContainer = styled.div`
  /* REMOVE background and border from here - sections will have their own */
  border-radius: 0;
  padding: 0;
  border: none;
  background: transparent;
  
  @media (min-width: 768px) {
    padding: 0;
  }
  
  @media (max-width: 768px) {
    padding: 0;
    border-radius: 0;
  }
`;

const SectionWrapper = styled.div`
  background: ${props => props.$isHero ? 'transparent' : `${props.theme?.colors?.surface}30`};
  border: ${props => props.$isHero ? 'none' : `2px solid ${props.theme?.colors?.accent}30`};
  border-radius: ${props => props.$isHero ? '0' : '12px'};
  padding: ${props => props.$isHero ? '0' : '1rem'};
  margin-bottom: 1.5rem;
  position: relative;
  transition: all 0.3s ease;

  /* Desktop: lighter boxing — sections own their own padding via hpt-wrap.
     The faint border remains so the editor can distinguish section blocks. */
  @media (min-width: 768px) {
    background: ${props => props.$isHero ? 'transparent' : `${props.theme?.colors?.surface}18`};
    border: ${props => props.$isHero ? 'none' : `1px solid ${props.theme?.colors?.accent}18`};
    border-radius: ${props => props.$isHero ? '0' : '20px'};
    padding: ${props => props.$isHero ? '0' : '0'};
    margin-bottom: ${props => props.$isHero ? '0' : '1.5rem'};
    overflow: hidden;
  }

  @media (max-width: 768px) {
    padding: ${props => props.$isHero ? '0' : '0.75rem'};
    margin-bottom: 1rem;
    border-radius: ${props => props.$isHero ? '0' : '8px'};
  }

  &:hover {
    border-color: ${props => props.theme?.colors?.accent};

    .section-controls {
      opacity: 1;
    }
  }
`;

const SectionControls = styled.div`
  position: absolute;
  ${props => props.$bottomRight ? 'bottom: 0.5rem;' : 'top: 0.5rem;'}
  right: 0.5rem;
  display: flex;
  gap: 0.5rem;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 10;
  background: ${props => `${props.theme?.colors?.background}E5`};
  backdrop-filter: blur(10px);
  padding: 0.5rem;
  border-radius: 8px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40`};

  @media (max-width: 768px) {
    opacity: 1;
    ${props => props.$bottomRight ? 'bottom: 0.25rem;' : 'top: 0.25rem;'}
    right: 0.25rem;
    padding: 0.25rem;
    gap: 0.25rem;
  }
`;

const SectionControlButton = styled.button`
  background: transparent;
  border: 1px solid ${props => props.theme?.colors?.accent};
  color: ${props => props.theme?.colors?.accent};
  padding: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  min-width: 32px;
  min-height: 32px;

  @media (max-width: 768px) {
    min-width: 28px;
    min-height: 28px;
    padding: 0.35rem;
  }

  &:hover {
    background: ${props => `${props.theme?.colors?.accent}20`};
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &.delete {
    border-color: #ff4444;
    color: #ff4444;

    &:hover {
      background: rgba(255, 68, 68, 0.2);
    }
  }

  svg {
    width: 16px;
    height: 16px;
    
    @media (max-width: 768px) {
      width: 14px;
      height: 14px;
    }
  }
`;

const ShopProfileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 800px;
  margin: 0rem auto 0rem;
  padding: 0rem;
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}30`};
  backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.3)'};
  position: relative;
  z-index: 2;
  overflow: visible; /* CHANGED from hidden */

  @media (min-width: 768px) {
    padding: 0rem;
  }

  .profile-image {
    margin-bottom: 1rem;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.1);
    border: 3px solid ${props => props.theme?.colors?.accent || '#800000'};
    box-shadow: 0 0 20px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'};
    position: relative;
    z-index: 3;
    
    @media (min-width: 768px) {
      width: 150px;
      height: 150px;
    }
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .shop-name-container {
    width: 100%;
    margin: 0.5rem 0;
    position: relative;
    z-index: 3;

    input {
      width: 100%;
      text-align: center;
      background: transparent;
      border: none;
      font-size: ${props => Math.min(props.fontSize || 2.5, 2)}rem;
      font-family: ${props => props.theme?.fonts?.heading};
      color: ${props => props.theme?.colors?.accent || '#800000'} !important; /* ADD !important */
      outline: none;
      padding: 0.5rem;
      caret-color: ${props => props.theme?.colors?.accent || '#800000'}; /* ADD caret color */
      
      @media (min-width: 768px) {
        font-size: ${props => props.fontSize || '2.5rem'};
      }

      &:focus {
        color: ${props => props.theme?.colors?.accent || '#800000'} !important;
      }

      &::placeholder {
        color: ${props => `${props.theme?.colors?.accent}80` || 'rgba(128, 0, 0, 0.5)'};
      }
    }
  }

  .shop-description-container {
    width: 100%;
    margin-top: 0.25rem;
    position: relative;
    z-index: 3;

    textarea {
      width: 100%;
      text-align: center;
      background: transparent;
      border: none;
      font-size: 1rem;
      font-family: ${props => props.theme?.fonts?.body};
      color: ${props => props.theme?.colors?.text};
      opacity: 0.8;
      outline: none;
      padding: 0.5rem;
      resize: none;
      min-height: 60px;

      @media (min-width: 768px) {
        font-size: 1.1rem;
      }

      &:focus {
        opacity: 1;
      }

      &::placeholder {
        color: ${props => props.theme?.colors?.text};
        opacity: 0.5;
      }
    }
  }
`;

// 2. UPDATE BackgroundDrawer with backdrop (around line 900)
const DrawerBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  opacity: ${props => props.isOpen ? 1 : 0};
  pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
  transition: opacity 0.3s ease;
`;

// 3. UPDATE EditBackgroundButton positioning (around line 950)
const EditBackgroundButton = styled.button`
  background: ${props => props.theme?.colors?.accent || '#800000'};
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: absolute;
  bottom: -2.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10; /* INCREASED z-index */
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px ${props => `${props.theme?.colors?.accent}60`};

  &:hover {
    transform: translateX(-50%) translateY(-2px);
    box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}80`};
  }

  &:active {
    transform: translateX(-50%) scale(0.98);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const ShopNameInput = styled.input`
  width: 100%;
  text-align: center;
  background: transparent;
  border: none;
  border-bottom: none;
  font-size: ${props => Math.min(props.fontSize || 2.5, 2)}rem;
  font-family: ${props => props.theme?.fonts?.heading};
  color: ${props => props.theme?.colors?.accent || '#FF0000'} !important;
  outline: none;
  padding: none;
  transition: all 0.3s ease;
  caret-color: ${props => props.theme?.colors?.accent || '#800000'};
  font-weight: 900; /* ADD THIS - Make text super bold */
  letter-spacing: 0.5px; /* ADD THIS - Slightly more spacing for bold text */
  
  /* REMOVE gradient background */
  -webkit-text-fill-color: ${props => props.theme?.colors?.accent || '#FF0000'};
  
  @media (min-width: 768px) {
    font-size: ${props => props.fontSize || '2.5rem'};
    letter-spacing: 1px; /* ADD THIS - More spacing on desktop */
  }

  &:focus {
    text-shadow: 0 0 10px ${props => `${props.theme?.colors?.accent}40`}; /* ADD THIS - Subtle glow on focus */
  }

  &::placeholder {
    color: ${props => `${props.theme?.colors?.accent}80` || 'rgba(255, 0, 0, 0.5)'}; // Changed from 60 to 80
    -webkit-text-fill-color: ${props => `${props.theme?.colors?.accent}80` || 'rgba(255, 0, 0, 0.5)'};
  }
`;

const AddSectionCard = styled.div`
  background: ${props => `${props.theme?.colors?.surface}30`};
  border: 2px dashed ${props => `${props.theme?.colors?.accent}40`};
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 120px;

  @media (min-width: 768px) {
    padding: 2rem;
    min-height: 150px;
  }
  
  @media (max-width: 768px) {
    padding: 5rem;
    margin-bottom: 1rem;
    min-height: 100px;
    gap: 0.75rem;
  }

  &:hover {
    border-color: ${props => props.theme?.colors?.accent};
    background: ${props => `${props.theme?.colors?.accent}10`};
  }

  &:active {
    transform: scale(0.98);
  }

  .plus-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${props => `${props.theme?.colors?.accent}20`};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme?.colors?.accent};
    transition: all 0.3s ease;
    
    @media (min-width: 768px) {
      width: 48px;
      height: 48px;
    }
    
    @media (max-width: 768px) {
      width: 36px;
      height: 36px;
    }

    svg {
      width: 24px;
      height: 24px;
      
      @media (min-width: 768px) {
        width: 28px;
        height: 28px;
      }
      
      @media (max-width: 768px) {
        width: 20px;
        height: 20px;
      }
    }
  }

  &:hover .plus-icon {
    background: ${props => props.theme?.colors?.accent};
    color: white;
    transform: scale(1.1);
  }

  &:active .plus-icon {
    transform: scale(1.05);
  }

  .add-text {
    color: ${props => props.theme?.colors?.text};
    font-size: 0.9rem;
    font-weight: 600;
    opacity: 0.8;
    transition: opacity 0.3s ease;
    
    @media (min-width: 768px) {
      font-size: 1rem;
    }
    
    @media (max-width: 768px) {
      font-size: 0.85rem;
    }
  }

  &:hover .add-text {
    opacity: 1;
  }
`;

// 1. UPDATE the Header styled component (around line 500):
const Header = styled.header`
  width: 100%;
  /* When header tab buttons are hidden (burger-only nav), this row absorbs the
     space the mobile tab bar row would have used, so it can render a taller,
     more prominent logo/name instead of leaving that space empty. */
  height: ${props => props.$expanded ? '124px' : '78px'}; /* More breathing room; content sits a little lower via padding-top below */
  padding: 12px 1rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  backdrop-filter: none;
  border-bottom: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  transform: ${props => props.$hidden ? 'translateY(-100%)' : 'translateY(0)'};
  transition: transform 0.3s ease, height 0.2s ease;

  @media (min-width: 768px) {
    height: clamp(72px, 10.5vh, 100px);
    padding: clamp(6px, 0.9vh, 12px) 2rem 0;
  }
`;

// 2. UPDATE the MainContent styled component (around line 510):
const MainContent = styled.main`
  /* Header is now always position:fixed (matches the public page), so it no longer
     occupies its own flow space — every non-hero tab needs explicit top clearance
     for it. Hero tabs ($noTopPad) keep 0: their own content (e.g. ShopProfileSection)
     already pads itself to clear the header. */
  padding: ${props => props.$noTopPad ? '0rem' : '78px'} 0rem 0rem 0rem;
  position: relative;
  z-index: 1;
  max-width: 100%;
  overflow-x: hidden;

  @media (min-width: 768px) {
    max-width: 100%;
    margin: 0 auto;
    /* Sections handle their own horizontal containment via hpt-wrap / max-width.
       Keep vertical clearance for the fixed header; no side padding here so
       full-bleed sections (hero, contact footer) can reach the viewport edges. */
    padding: ${props => props.$noTopPad ? '0' : 'clamp(72px, 10.5vh, 100px)'} 0 2rem 0;
  }

  @media (max-width: 768px) {
    /* 78px header + ~50px fixed MobileTabBar below it — or just the taller
       124px merged header when tab buttons are hidden (no tab bar row). */
    padding-top: ${props => props.$noTopPad ? '0rem' : props.$expanded ? '124px' : 'calc(78px + 3.5rem)'};
    padding-bottom: 6rem;  /* clear fixed bottom nav (80px) */
  }

  @media (max-width: 480px) {
    padding: ${props => props.$noTopPad ? '0rem' : props.$expanded ? '124px' : 'calc(78px + 3.5rem)'} 0rem 6rem 0rem;
  }
`;

// 3. UPDATE the PageContainer to ensure header stays at top:
const PageContainer = styled.div`
  min-height: 100vh;
  background: ${props => props.theme?.colors?.background || '#000000'};
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  position: relative;
  overflow-x: hidden;
  
  /* Ensure header is at the very top */
  padding-top: 0;
  margin-top: 0;
  
  /* Zoom level adjustments */
  @media (min-resolution: 1.5dppx) {
    font-size: 14px;
  }
  
  @media (min-resolution: 2dppx) {
    font-size: 13px;
  }
`;

// 5. UPDATE the HeaderCenter to ensure proper alignment:
const HeaderCenter = styled.div`
  display: none;
  
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: 1rem;
    position: static; /* CHANGE from absolute to static */
    left: auto; /* REMOVE absolute positioning */
    transform: none; /* REMOVE centering transform */
    margin: 0 auto; /* Center within flex container */
  }
`;

// 6. UPDATE HeaderLeft and HeaderRight for better distribution:
const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1; /* Allow it to take space */
`;

const LogoImage = styled.img`
  width: ${props => props.$expanded ? '46px' : '32px'};
  height: ${props => props.$expanded ? '46px' : '32px'};
  object-fit: ${props => props.$isProfile ? 'cover' : 'contain'};
  border-radius: ${props => props.$isProfile ? '50%' : '0'};
  cursor: pointer;
  transition: transform 0.3s ease, width 0.2s ease, height 0.2s ease;
  flex-shrink: 0;

  @media (min-width: 768px) {
    width: ${props => props.$expanded ? 'clamp(24px, 3.2vh, 32px)' : 'clamp(20px, 2.6vh, 26px)'};
    height: ${props => props.$expanded ? 'clamp(24px, 3.2vh, 32px)' : 'clamp(20px, 2.6vh, 26px)'};
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (hover: hover) {
    &:hover {
      transform: scale(1.05);
    }
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  flex: 1;
  justify-content: flex-end;
  padding-right: 0.2rem;

  @media (max-width: 767px) {
    margin-right: -0.99rem;
  }

  .mobile-tabs {
    display: none;
  }

  .desktop-controls {
    display: flex;
    gap: 0;
  }
`;

// 7. If you want to keep the minimal overlay tabs for mobile, update their positioning:
const MinimalOverlayTabs = styled.div`
  position: fixed; /* Keep fixed for mobile */
  bottom: 5rem; /* Move to bottom instead of floating */
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  display: flex;
  gap: 1rem; /* Reduce gap */
  padding: 0.5rem 1rem;
  background: ${props => `${props.theme?.colors?.background}DD`};
  backdrop-filter: blur(10px);
  border-radius: 25px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40`};
  animation: fadeInUp 0.5s ease-out;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate(-50%, 20px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }

  @media (min-width: 768px) {
    display: none; /* Hide on desktop */
  }
`;

// 4. NEW MinimalTabButton - text-only with subtle blur behind each button
const MinimalTabButton = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.active ?
    props.theme?.colors?.accent || '#800000' :
    `${props.theme?.colors?.text}99`};
  padding: 0.35rem 1.05rem;
  cursor: pointer;
  font-size: 0.84rem;
  font-weight: ${props => props.active ? '700' : '600'};
  letter-spacing: 0.5px;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  min-width: 60px;
  text-align: center;

  /* Blurred background behind each button */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(75% + 0.5rem);
    height: calc(20% + 0.75rem);
    background: ${props => `${props.theme?.colors?.background || '#000000'}60`};
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 50px;
    z-index: -1;
    opacity: ${props => props.active ? 0.8 : 0.6};
    transition: all 0.3s ease;
    border: 1px solid ${props => `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.1)'};
  }

  /* Active state blur enhancement */
  ${props => props.active && `
    &::before {
      opacity: 0.9;
      background: ${props.theme?.colors?.background || '#000000'}80;
      border: .5px solid ${props.theme?.colors?.accent || '#800000'}40;
      box-shadow: 0 0 5px ${props.theme?.colors?.accent || '#800000'}20;
    }
  `}

  /* Underline effect for active tab */
  &::after {
    content: '';
    position: absolute;
    bottom: 0.25rem;
    left: 50%;
    width: ${props => props.active ? '70%' : '0%'};
    height: 2px;
    background: ${props => props.theme?.colors?.accent || '#800000'};
    transform: translateX(-50%);
    transition: width 0.3s ease;
    border-radius: 1px;
    z-index: 1;
  }

  &:active {
    transform: scale(0.95);
  }

  /* Text glow effect for active tab */
  ${props => props.active && `
    text-shadow: 0 0 8px ${props.theme?.colors?.accent}80;
  `}

  /* Hover effect */
  @media (hover: hover) {
    &:hover {
      color: ${props => props.theme?.colors?.accent || '#800000'};
      
      &::after {
        width: 70%;
      }
    }
  }
`;


// 5. UPDATE MobileTabBar position to account for taller header
const MobileTabBar = styled.div`
  position: fixed;
  top: 66px; /* Pulled up closer under the header content to tighten the gap */
  left: 0;
  right: 0;
  z-index: 95;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.35rem;
  padding: 0.28rem 1rem;
  background: transparent;
  backdrop-filter: none;
  border-bottom: none;
  transition: top 0.3s ease, transform 0.3s ease;
  box-shadow: none;
  pointer-events: auto;
  transform: ${props => props.$hidden ? 'translateY(-130px)' : 'translateY(0)'};

  /* Allow content behind to be visible */
  & > * {
    pointer-events: auto;
  }

  @media (min-width: 768px) {
    display: none;
    transform: none;
  }
`;

const MinimalDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 280px;
  background: ${props => props.theme?.colors?.surface || '#ffffff'};
  border: 1px solid ${props => props.theme?.colors?.accent || '#667eea'};
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  opacity: ${props => props.show ? '1' : '0'};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  transform: ${props => props.show ? 'translateY(0)' : 'translateY(-8px)'};
  transition: all 0.2s ease;
  z-index: 1000;
  overflow: hidden;
  
  @media (max-width: 768px) {
    right: auto;
    left: 50%;
    transform: ${props => props.show ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(-8px)'};
    min-width: 260px;
  }
`;

const MinimalTierRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid ${props => props.theme?.colors?.border || '#e0e0e0'};
  background: ${props => props.isActive 
    ? props.theme?.colors?.surfaceHover || props.theme?.colors?.surface || '#f5f5f5'
    : props.theme?.colors?.surface || '#ffffff'
  };
  transition: all 0.15s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: ${props => props.theme?.colors?.surfaceHover || props.theme?.colors?.surface || '#f5f5f5'};
  }
  
  .tier-info {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
  }
  
  .tier-name {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    font-weight: ${props => props.isActive ? '700' : '600'};
    color: ${props => props.theme?.colors?.text || '#1a1a1a'};
  }
  
  .current-badge {
    font-size: 0.65rem;
    font-weight: 700;
    color: white;
    background: ${props => props.theme?.colors?.accent || '#667eea'};
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    text-transform: lowercase;
    letter-spacing: 0.3px;
  }
  
  .tier-range {
    font-size: 0.75rem;
    color: ${props => props.theme?.colors?.textSecondary || '#30ff3eff'};
    font-weight: 500;
  }
  
  .tier-price {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.15rem;
    font-size: 0.95rem;
    font-weight: 700;
    color: ${props => props.theme?.colors?.text || '#c5b2b2ff'};
  }
  
  .monthly {
    font-size: 0.7rem;
    color: ${props => props.theme?.colors?.textSecondary || '#b5b3b3ff'};
    font-weight: 600;
  }
`;

const MoreTiersNote = styled.div`
  padding: 0.75rem 1.25rem;
  text-align: center;
  font-size: 0.75rem;
  color: ${props => props.theme?.colors?.textSecondary || '#fcfcfcff'};
  background: ${props => props.theme?.colors?.surfaceHover || props.theme?.colors?.surface || '#fafafa'};
  border-top: 1px solid ${props => props.theme?.colors?.border || '#e0e0e0'};
  font-weight: 500;
`;

const BillingDropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const BillingButton = styled.button`
  background: transparent;
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  color: ${props => props.theme?.colors?.accent || '#800000'};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
  font-weight: bold;
  
  &:hover {
    background: ${props => `${props.theme?.colors?.accent}20`};
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
`;

const BillingTierCard = styled.div`
  background: ${props => props.isActive ? 
    `${props.theme?.colors?.accent}20` : 
    'transparent'};
  border: 2px solid ${props => props.isActive ? 
    props.theme?.colors?.accent : 
    `${props.theme?.colors?.accent}40`};
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  transition: all 0.3s ease;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  ${props => props.isActive && `
    box-shadow: 0 0 20px ${props.theme?.colors?.accent}40;
  `}
`;

const TierHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

const TierName = styled.h4`
  margin: 0;
  color: ${props => props.theme?.colors?.accent};
  font-size: 1.1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const TierBadge = styled.span`
  background: ${props => props.theme?.colors?.accent};
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const TierDetails = styled.div`
  font-size: 0.85rem;
  color: ${props => props.theme?.colors?.text};
  opacity: 0.8;
  line-height: 1.5;
  
  .detail-row {
    display: flex;
    justify-content: space-between;
    margin: 0.25rem 0;
  }
  
  .label {
    opacity: 0.7;
  }
  
  .value {
    font-weight: 600;
    color: ${props => props.theme?.colors?.accent};
  }
`;

const BillingNote = styled.div`
  background: ${props => `${props.theme?.colors?.accent}10`};
  border-left: 3px solid ${props => props.theme?.colors?.accent};
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 4px;
  font-size: 0.85rem;
  color: ${props => props.theme?.colors?.text};
  line-height: 1.5;
  
  strong {
    color: ${props => props.theme?.colors?.accent};
    font-weight: 700;
  }
`;


const BillingDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: ${props => props.theme?.colors?.background || '#000000'};
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 8px;
  padding: 1rem;
  width: 280px;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  opacity: ${props => props.show ? 1 : 0};
  transform: translateY(${props => props.show ? '0' : '-10px'});
  pointer-events: ${props => props.show ? 'auto' : 'none'};
  transition: all 0.2s ease;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 70px;
    right: 1rem;
    left: 1rem;
    width: auto;
  }
`;

const CurrentTierDisplay = styled.div`
  text-align: center;
  padding: 1rem;
  background: ${props => `${props.theme?.colors?.accent}20`};
  border-radius: 6px;
  margin-bottom: 0.75rem;
  
  .tier-name {
    font-size: 1.2rem;
    font-weight: 700;
    color: ${props => props.theme?.colors?.accent};
    margin-bottom: 0.25rem;
  }
  
  .tier-range {
    font-size: 0.8rem;
    opacity: 0.7;
    color: ${props => props.theme?.colors?.text};
  }
  
  .item-count {
    font-size: 1.5rem;
    font-weight: 700;
    color: ${props => props.theme?.colors?.accent};
    margin-top: 0.5rem;
  }
`;

const TierList = styled.div`
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 0.75rem;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.colors?.accent};
    border-radius: 2px;
  }
`;

const TierRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border-radius: 4px;
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
  background: ${props => props.isActive ? 
    `${props.theme?.colors?.accent}15` : 
    'transparent'};
  border-left: 3px solid ${props => props.isActive ? 
    props.theme?.colors?.accent : 
    'transparent'};
  
  .tier-info {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
  
  .tier-name {
    font-weight: 600;
    color: ${props => props.isActive ? 
      props.theme?.colors?.accent : 
      props.theme?.colors?.text};
  }
  
  .tier-range {
    opacity: 0.6;
    font-size: 0.75rem;
  }
  
  .tier-price {
    font-weight: 600;
    color: ${props => props.theme?.colors?.accent};
    font-size: 0.8rem;
  }
`;

const PaymentNote = styled.div`
  font-size: 0.75rem;
  text-align: center;
  padding: 0.75rem;
  background: ${props => `${props.theme?.colors?.accent}10`};
  border-radius: 4px;
  color: ${props => props.theme?.colors?.text};
  line-height: 1.4;
  
  strong {
    color: ${props => props.theme?.colors?.accent};
  }
`;

// 6. UPDATE HeaderTabButton to match taller header (remove icons from header too)
const HeaderTabButton = styled.button`
  background: transparent;
  backdrop-filter: blur(10px);
  border: none;
  border-bottom: 3px solid ${props => props.active ?
    props.theme?.colors?.accent :
    'transparent'};
  color: ${props => props.active ? 
    props.theme?.colors?.accent : 
    `${props.theme?.colors?.text}70`};
  padding: 1rem 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  flex-direction: row;
  font-size: 1rem;
  
  @media (min-width: 768px) {
    padding: clamp(0.38rem, 0.68vh, 0.55rem) clamp(0.8rem, 1.5vw, 1.3rem);
    gap: clamp(0.28rem, 0.48vh, 0.44rem);
    font-size: clamp(0.55rem, 0.95vh, 0.76rem);
  }
  
  @media (hover: hover) and (min-width: 768px) {
    &:hover {
      color: ${props => props.theme?.colors?.accent};
      background: ${props => `${props.theme?.colors?.accent}08`};
      border-bottom-color: ${props => props.theme?.colors?.accent};
      transform: translateY(-3px);
      
      
    }
  }
  
  &:active {
    transform: translateY(-1px);
  }
  
  .tab-label {
    font-size: 0.9rem;
    font-weight: ${props => props.active ? '700' : '600'};
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: all 0.3s ease;
    white-space: nowrap;
    
    @media (min-width: 768px) {
      font-size: clamp(0.5rem, 0.88vh, 0.7rem);
      font-weight: ${props => props.active ? '800' : '600'};
      letter-spacing: 1.5px;
    }
  }
`;

const FloatingButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${props => props.theme?.colors?.accent || '#800000'};
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'};
  transition: all 0.3s ease;
  
  ${props => props.isPinned && `
    background: white;
    color: ${props.theme?.colors?.accent || '#800000'};
    border: 2px solid ${props.theme?.colors?.accent || '#800000'};
  `}
  
  @media (min-width: 768px) {
    width: clamp(22px, 2.6vh, 30px);
    height: clamp(22px, 2.6vh, 30px);
  }

  &:active {
    transform: scale(0.9);
  }

  @media (hover: hover) {
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.4)'};
    }
  }

  &.spinning {
    animation: spin 0.5s ease-in-out;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  svg {
    width: 18px;
    height: 18px;

    @media (min-width: 768px) {
      width: clamp(11px, 1.4vh, 14px);
      height: clamp(11px, 1.4vh, 14px);
    }
  }
`;

// Add after existing styled components in ShopPage.js (around line 800)
const ShopNameInputContainer = styled.div`
  width: 100%;
  margin: 0.5rem 0;
  position: relative;
`;

const ShopNameError = styled.div`
  color: #ff4444;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  text-align: center;
  font-family: ${props => props.theme?.fonts?.body || "'Inter', sans-serif"};
  min-height: 20px;
  
  @media (min-width: 768px) {
    font-size: 0.9rem;
  }
`;

const ShopNameSuccess = styled.div`
  color: #4CAF50;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  text-align: center;
  font-family: ${props => props.theme?.fonts?.body || "'Inter', sans-serif"};
  min-height: 20px;
  
  @media (min-width: 768px) {
    font-size: 0.9rem;
  }
`;



const ChevronButton = styled.button`
  background: ${props => `${props.theme?.colors?.background || '#000000'}E5`};
  border: none;  /* REMOVED: 2px solid border */
  color: ${props => props.theme?.colors?.accent || '#800000'};
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%) rotate(${props => props.isOpen ? '180deg' : '0deg'});
  z-index: 10;
  border-radius: 50%;  /* KEPT for circular shape */

  &:hover {
    transform: translateX(-50%) rotate(${props => props.isOpen ? '180deg' : '0deg'}) scale(1.1);
    box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}80`};
    background: ${props => props.theme?.colors?.accent || '#800000'};
    color: white;
  }

  &:active {
    transform: translateX(-50%) rotate(${props => props.isOpen ? '180deg' : '0deg'}) scale(0.95);
  }

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    bottom: -18px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const SaveControlsContainer = styled.div`
  position: fixed;
  /* Shop settings panel + its overlay sit at z-index 9998/9999 — outrank them
     while that panel is open so Save/Reset stay clickable on top of it. */
  z-index: ${props => props.$aboveSettingsPanel ? 10000 : 100};
  display: ${props => props.show ? 'flex' : 'none'};  /* Only show when changes exist */
  gap: 0.75rem;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.3s ease;
  pointer-events: ${props => props.show ? 'auto' : 'none'};
  
  /* Mobile: bottom right stacked */
  @media (max-width: 767px) {
    bottom: 5rem;
    right: 1rem;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  /* Tablet: right side */
  @media (min-width: 768px) and (max-width: 1023px) {
    bottom: 5rem;
    right: 1rem;
    flex-direction: column;
  }
  
  /* Desktop: right side */
  @media (min-width: 1024px) {
    bottom: 2rem;
    right: 2rem;
    flex-direction: column;
  }
`;


// UPDATE the SectionTypeModal styled component:
const SectionTypeModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${props => props.theme?.colors?.surface || 'rgba(30, 30, 30, 0.95)'};
  backdrop-filter: blur(20px);
  border: 2px solid ${props => props.theme?.colors?.accent};
  border-radius: 16px;
  padding: 1.5rem;
  z-index: 2001;
  max-width: 90vw;
  width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);

  @media (max-width: 768px) {
    width: calc(100vw - 2rem);
    max-height: 70vh;
    padding: 1.25rem;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.colors?.accent};
    border-radius: 3px;
  }
`;

const WidgetContainer = styled.div`
  padding: ${props => props.noPadding ? '0' : 'clamp(0.75rem, 2vw, 2rem)'};
  position: relative;
  opacity: ${props => props.isHidden ? 0.5 : 1};
  transition: all 0.3s ease;
  max-width: 100%;
  overflow-x: hidden;
  
  ${props => props.isDragging && `
    background: ${props.theme?.colors?.accent}10;
    border: 2px dashed ${props.theme?.colors?.accent};
    border-radius: clamp(6px, 1vw, 8px);
  `}
`;

const ThemeContainer = styled.div`
  position: fixed;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Mobile: bottom center */
  @media (max-width: 767px) {
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
  }

  /* Desktop: bottom center */
  @media (min-width: 768px) {
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
  }

  & > div > div:nth-child(2) {
    bottom: calc(100% + 0.5rem);
    top: auto;
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
`;

/* ── Floating theme picker (bottom-left) ─────────────────────────────── */

const FloatingThemeWrap = styled.div`
  position: fixed;
  bottom: calc(80px + 1rem);
  left: 1rem;
  z-index: 100;
  @media (min-width: 768px) {
    bottom: 2rem;
    left: 2rem;
  }
`;

const FloatingThemeBtn = styled.button`
  background: ${p => `${p.theme?.colors?.background || '#000000'}E8`};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: ${p => p.theme?.colors?.text || '#fff'};
  padding: 0.4rem 0.55rem;
  border-radius: 20px;
  font-size: 0.8rem;

  @media (max-width: 767px) {
    padding: 0.28rem 0.4rem;
    font-size: 0.68rem;
  }

  @media (min-width: 768px) {
    padding: clamp(0.22rem, 0.36vh, 0.3rem) clamp(0.3rem, 0.5vw, 0.42rem);
    font-size: clamp(0.42rem, 0.68vh, 0.54rem);
  }
  display: flex;
  align-items: center;
  gap: 0.32rem;
  border: 1px solid ${p => `${p.theme?.colors?.accent || '#800000'}45`};
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(0,0,0,0.35);

  &:hover {
    background: ${p => `${p.theme?.colors?.background || '#000000'}F5`};
    border-color: ${p => p.theme?.colors?.accent || '#800000'};
  }
  &:active { transform: scale(0.95); }

  .refresh-btn, .pin-btn {
    display: flex; align-items: center; justify-content: center;
    padding: 0.25rem; border-radius: 50%;
    transition: background 0.15s;
    &:hover { background: ${p => `${p.theme?.colors?.accent || '#800000'}30`}; }
    &:active { transform: scale(0.88); }
  }
  .refresh-btn { color: ${p => p.theme?.colors?.accent || '#800000'}; }
  .pin-btn { color: ${p => p.$isPinned ? (p.theme?.colors?.accent || '#800000') : (p.theme?.colors?.text || '#fff')}; }

  .theme-name {
    max-width: 200px;
    overflow: hidden; text-overflow: ellipsis;
    @media (max-width: 480px) { max-width: 150px; }
  }
`;

const FloatingThemeMenu = styled.div`
  position: absolute;
  bottom: calc(100% + 0.6rem);
  left: 0;
  background: ${p => `${p.theme?.colors?.background || '#000000'}F5`};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid ${p => `${p.theme?.colors?.accent || '#800000'}40`};
  border-radius: 14px;
  padding: 0.75rem;
  max-height: 320px;
  overflow-y: auto;
  opacity: ${p => p.$isOpen ? 1 : 0};
  visibility: ${p => p.$isOpen ? 'visible' : 'hidden'};
  transform: translateY(${p => p.$isOpen ? '0' : '12px'});
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
  min-width: 260px;
  box-shadow: 0 12px 32px rgba(0,0,0,0.5);
  z-index: 101;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb { background: ${p => `${p.theme?.colors?.accent || '#800000'}50`}; border-radius: 2px; }

  @media (min-width: 768px) {
    min-width: 360px;
    max-height: 400px;
  }
`;

const FloatingThemeListItem = styled.button`
  width: 100%;
  background: ${p => p.$active ? `${p.theme?.colors?.accent || '#800000'}30` : 'transparent'};
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: white;
  text-align: left;
  margin-bottom: 0.25rem;

  &:hover {
    background: ${p => `${p.theme?.colors?.accent || '#800000'}20`};
    transform: translateX(2px);
  }

  &:active {
    transform: scale(0.98);
  }

  .style-number {
    font-weight: bold;
    font-size: 0.9rem;
    color: ${p => p.theme?.colors?.accent || '#800000'};
    min-width: 30px;
  }

  .style-name {
    font-size: 0.85rem;
    flex: 1;
  }

  .active-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${p => p.theme?.colors?.accent || '#800000'};
    opacity: ${p => p.$active ? 1 : 0};
  }

  @media (max-width: 768px) {
    padding: 0.6rem 0.85rem;
    .style-number, .style-name { font-size: 0.8rem; }
  }
`;

const MobileItemContent = styled.div`
  /* CHANGED: Reduced padding to fit 10% space */
  padding: 0.35rem 0.5rem; /* Reduced from 0.5rem */
  flex: 0 0 auto; /* Changed from flex: 1 */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center content in smaller space */
  min-height: 22px; /* 10% of card */

  .item-name {
    font-size: 0.7rem; /* Reduced from 0.75rem */
    font-weight: 600;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    margin-bottom: 0.15rem; /* Reduced from 0.25rem */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.1; /* Tighter line height */
  }

  .item-price {
    font-size: 0.8rem; /* Reduced from 0.85rem */
    font-weight: bold;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    text-align: right;
    line-height: 1;
  }

  .empty-text {
    font-size: 0.65rem; /* Reduced from 0.7rem */
    color: ${props => `${props.theme?.colors?.text}60` || 'rgba(255, 255, 255, 0.4)'};
    font-style: italic;
  }
`;


// Around line 150, UPDATE MobileItemImageContainer:
const MobileItemImageContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 5 / 6;
  overflow: hidden;
  background: ${props => `${props.theme?.colors?.background || '#000000'}50`};
  display: flex;
  align-items: center;
  justify-content: center;

  /* ADD: Blurred background layer */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${props => props.$bgImage ? `url(${props.$bgImage})` : 'none'};
    background-size: cover;
    background-position: center;
    filter: blur(15px);
    transform: scale(1.1);
    z-index: 0;
    opacity: 0.6;
  }

  img, video {
    width: 100%;
    height: 100%;
    object-fit: contain; /* CHANGED from cover */
    position: relative;
    z-index: 1;
  }

  .placeholder {
    color: ${props => props.theme?.colors?.text || '#fff'};
    opacity: 0.3;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    position: relative;
    z-index: 1;

    svg {
      width: 24px;
      height: 24px;
    }

    span {
      font-size: 0.75rem;
      font-weight: 500;
    }
  }

  .mobile-carousel-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.7)'}DD`};
    border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.2)'};
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme?.colors?.text || 'white'};
    cursor: pointer;
    z-index: 3;
    opacity: 0.8;
    transition: all 0.2s ease;

    &:active {
      opacity: 1;
      transform: translateY(-50%) scale(0.9);
      background: ${props => props.theme?.colors?.accent || '#800000'};
    }

    &.left {
      left: 0.25rem;
    }

    &.right {
      right: 0.25rem;
    }

    svg {
      width: 12px;
      height: 12px;
    }
  }

  .image-dots {
    position: absolute;
    bottom: 0.25rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 0.2rem;
    z-index: 2;
    
    .dot {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: ${props => props.theme?.colors?.text || '#FFFFFF'};
      opacity: 0.3;
      transition: opacity 0.3s ease;
      
      &.active {
        opacity: 1;
      }
    }
  }

  @media (max-width: 768px) {
    aspect-ratio: 4 / 3;
  }

  @media (max-width: 480px) {
    aspect-ratio: 1 / 1;
  }
`;

// Welcoming ease-in, matching the Home tab's section reveal — callers stagger
// it via an inline `animationDelay` at the item's .map() call site.
const cardFadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

// Plain wrapper for one-off fade-ins outside a dedicated styled-component —
// keyframes only inject reliably from a tagged template (styled/css), not
// from interpolating `cardFadeIn` into a plain inline-style string.
const FadeInBlock = styled.div`
  animation: ${cardFadeIn} 0.5s cubic-bezier(0.4, 0, 0.2, 1) ${props => props.$delay || 0}s both;
`;

const MobileItemCard = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'};
  border-radius: ${props => props.theme?.styles?.borderRadius || '12px'};
  overflow: hidden;
  border: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(255, 255, 255, 0.1)'};
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  animation: ${cardFadeIn} 0.5s cubic-bezier(0.4, 0, 0.2, 1) both;

  &:active {
    transform: scale(0.98);
    border-color: ${props => props.theme?.colors?.accent};
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

const AddItemButton = styled.button`
  background: ${props => props.theme?.colors?.accent || '#800000'};
  color: ${props => props.theme?.colors?.background || '#000000'};
  border: none;
  border-radius: ${props => props.theme?.styles?.borderRadius || '8px'};
  padding: 1rem 1.5rem;
  font-weight: 600;
  font-family: ${props => props.theme?.fonts?.heading || "'Space Grotesk', sans-serif"};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  margin: 1rem auto 1rem;
  margin-top: 2rem; /* CHANGE from 0.25rem to 0.1rem */

  transition: all 0.3s ease;
  justify-content: center;
  box-shadow: 0 4px 10px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg, 
      transparent, 
      rgba(255, 255, 255, 0.2), 
      transparent
    );
    transition: left 0.7s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.4)'};
    
    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 5px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'};
  }
`;


const CategorySelect = styled.select`
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  background-color: #111114 !important;
  background-image: ${props => {
    const accent = encodeURIComponent(props.theme?.colors?.accent || '#800000');
    return `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='${accent}' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`;
  }};
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px;
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: ${props => props.theme?.styles?.borderRadius || '12px'};
  padding: 0.85rem 2.5rem 0.85rem 1rem;
  color: ${props => props.theme?.colors?.accent || '#800000'} !important;
  font-family: ${props => props.theme?.fonts?.body || "'Inter', sans-serif"};
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 1rem;
  box-shadow: 0 6px 18px rgba(0,0,0,0.45);
  transition: all 0.18s ease;

  &:hover {
    background-color: #1a1a1e !important;
    border-color: ${props => props.theme?.colors?.accent || '#800000'};
  }

  &:focus {
    outline: none;
    background-color: #1a1a1e !important;
    border-color: ${props => props.theme?.colors?.accent || '#800000'};
    box-shadow: 0 8px 24px ${props => `${props.theme?.colors?.accent}35` || 'rgba(128,0,0,0.15)'};
  }

  option {
    background: ${props => props.theme?.colors?.surface || '#0f0f11'} !important;
    /* Note: option backgrounds are OS-controlled in most browsers */
    color: ${props => props.theme?.colors?.accent || '#800000'} !important;
    font-weight: 500;
    padding: 0.6rem;
  }

  option:checked {
    background: ${props => `${props.theme?.colors?.accent}50`} !important;
    color: ${props => props.theme?.colors?.accent || '#800000'} !important;
    font-weight: 700;
  }
`;

const BulkModeBar = styled.div`
  position: sticky;
  top: ${props => window.innerWidth <= 768 ? '78px' : '140px'};
  z-index: 90;
  background: ${props => `${props.theme?.colors?.surface}F5`};
  backdrop-filter: blur(20px);
  border-bottom: 2px solid ${props => props.theme?.colors?.accent};
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

const BulkModeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  
  .selected-count {
    background: ${props => props.theme?.colors?.accent};
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-weight: 700;
    font-size: 0.9rem;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

const BulkModeActions = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

const BulkActionButton = styled.button`
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  border: none;
  
  &.select-all {
    background: ${props => `${props.theme?.colors?.accent}30`};
    border: 1px solid ${props => props.theme?.colors?.accent};
    color: ${props => props.theme?.colors?.accent};
    
    &:hover {
      background: ${props => `${props.theme?.colors?.accent}50`};
    }
  }
  
  &.deselect-all {
    background: transparent;
    border: 1px solid ${props => `${props.theme?.colors?.text}40`};
    color: ${props => props.theme?.colors?.text};
    
    &:hover {
      background: ${props => `${props.theme?.colors?.text}10`};
    }
  }
  
  &.edit-price {
    background: #2196F3;
    color: white;
    
    &:hover {
      background: #1976D2;
      transform: translateY(-2px);
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  
  &.delete {
    background: #ff4444;
    color: white;
    
    &:hover {
      background: #cc0000;
      transform: translateY(-2px);
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  
  &.cancel {
    background: transparent;
    border: 1px solid ${props => `${props.theme?.colors?.text}40`};
    color: ${props => props.theme?.colors?.text};
    
    &:hover {
      background: ${props => `${props.theme?.colors?.text}10`};
    }
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }
`;

const SelectionCheckbox = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 32px;
  height: 32px;
  border: 3px solid ${props => props.checked ? 
    props.theme?.colors?.accent : 
    `${props.theme?.colors?.text}60`};
  border-radius: 8px;
  background: ${props => props.checked ? 
    props.theme?.colors?.accent : 
    `${props.theme?.colors?.background}DD`};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 5;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}60`};
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: 20px;
    height: 20px;
    color: white;
    opacity: ${props => props.checked ? 1 : 0};
    transition: opacity 0.2s ease;
  }
  
  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
    border-width: 2px;
    
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const ClearFieldButton = styled.button`
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: ${props => `${props.theme?.colors?.background}DD`};
  border: 1px solid ${props => `${props.theme?.colors?.accent}40`};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.2s ease;
  z-index: 2;
  
  &:hover {
    opacity: 1;
    background: ${props => props.theme?.colors?.accent};
    border-color: ${props => props.theme?.colors?.accent};
    transform: translateY(-50%) scale(1.1);
    
    svg {
      color: white;
    }
  }
  
  &:active {
    transform: translateY(-50%) scale(0.9);
  }
  
  svg {
    width: 12px;
    height: 12px;
    color: ${props => props.theme?.colors?.text};
    transition: color 0.2s ease;
  }
`;

const BulkEditModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(10px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  animation: fadeIn 0.3s ease;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const BulkEditModalContent = styled.div`
  background: ${props => props.theme?.colors?.background};
  border: 2px solid ${props => props.theme?.colors?.accent};
  border-radius: 16px;
  padding: 2rem;
  max-width: 400px;
  width: 100%;
  animation: scaleIn 0.3s ease;
  
  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  h3 {
    margin: 0 0 1.5rem 0;
    color: ${props => props.theme?.colors?.accent};
    font-size: 1.5rem;
    text-align: center;
  }
  
  .input-group {
    margin-bottom: 1.5rem;
    
    label {
      display: block;
      margin-bottom: 0.5rem;
      color: ${props => props.theme?.colors?.text};
      font-weight: 600;
      font-size: 0.9rem;
    }
    
    input {
      width: 100%;
      background: ${props => `${props.theme?.colors?.surface}50`};
      border: 1px solid ${props => `${props.theme?.colors?.accent}40`};
      border-radius: 8px;
      padding: 0.75rem;
      color: ${props => props.theme?.colors?.text};
      font-size: 1rem;
      
      &:focus {
        outline: none;
        border-color: ${props => props.theme?.colors?.accent};
        box-shadow: 0 0 0 3px ${props => `${props.theme?.colors?.accent}20`};
      }
    }
  }
  
  .info-text {
    font-size: 0.85rem;
    color: ${props => props.theme?.colors?.text};
    opacity: 0.7;
    text-align: center;
    margin-bottom: 1.5rem;
  }
  
  .modal-actions {
    display: flex;
    gap: 0.75rem;
    justify-content: center;
  }
`;

const ItemCard = styled.div`
  background: ${props => props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'};
  border-radius: ${props => props.theme?.styles?.borderRadius || '12px'};
  overflow: hidden;
  border: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(255, 255, 255, 0.1)'};
  position: relative;
  transition: all 0.3s ease;
  width: 100%;
  min-width: 320px;
  animation: ${cardFadeIn} 0.5s cubic-bezier(0.4, 0, 0.2, 1) both;

  &:hover {
    transform: translateY(-5px);
    border-color: ${props => props.theme?.colors?.accent};
  }
`;



const DesktopItemCard = styled(ItemCard)`
  width: 100%;
  min-width: 0;
  height: fit-content;
  align-self: start;
  transition: all 0.3s ease;

  @media (max-width: 767px) {
    display: none;
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  z-index: 10;
  opacity: 0.7;
  transition: all 0.3s ease;
  
  &:hover {
    opacity: 1;
    background: rgba(255, 0, 0, 0.5);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const ItemImageContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 5 / 6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => `${props.theme?.colors?.background || '#000000'}50`};

  @media (max-width: 768px) {
    aspect-ratio: 4 / 3;
  }

  @media (max-width: 480px) {
    aspect-ratio: 1 / 1;
  }

  /* ADD: Blurred background layer */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${props => props.$bgImage ? `url(${props.$bgImage})` : 'none'};
    background-size: cover;
    background-position: center;
    filter: blur(20px);
    transform: scale(1.1);
    z-index: 0;
    opacity: 0.6;
  }

  .image-container {
    width: 100%;
    height: 100%;
    position: relative;
    touch-action: pan-y;
    z-index: 1; /* ADD: Ensure it's above blurred background */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: ${props => props.theme?.colors?.text || '#fff'};
    opacity: 0.5;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 1rem;
    position: relative;
    z-index: 1;
    
    &:hover {
      opacity: 0.8;
      background: ${props => `${props.theme?.colors?.accent}10` || 'rgba(255, 255, 255, 0.05)'};
      
      > div:first-child {
        transform: scale(1.1);
        background: ${props => `${props.theme?.colors?.accent}25`};
      }
    }
    
    &:active {
      opacity: 1;
      
      > div:first-child {
        transform: scale(0.95);
      }
    }
    
    span {
      font-size: 0.9rem;
      font-family: ${props => props.theme?.fonts?.body || "'Inter', sans-serif"};
    }
  }

  .carousel-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: ${props => `${props.theme?.colors?.background || '#000000'}80`};
    border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.2)'};
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme?.colors?.text || 'white'};
    cursor: pointer;
    z-index: 2;
    opacity: 0.8;
    transition: all 0.3s ease;

    @media (max-width: 767px) {
      width: 28px;
      height: 28px;
      opacity: 0.9;
      
      &:active {
        transform: translateY(-50%) scale(0.9);
      }
    }

    &:hover {
      background: ${props => `${props.theme?.colors?.accent}40` || 'rgba(0, 0, 0, 0.7)'};
      opacity: 1;
    }

    &.left {
      left: 10px;
    }

    &.right {
      right: 10px;
    }
  }

  .add-image {
    position: absolute;
    top: 10px;
    right: 10px;
    background: ${props => `${props.theme?.colors?.background || '#000000'}80`};
    border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.2)'};
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme?.colors?.text || 'white'};
    cursor: pointer;
    z-index: 2;
    transition: all 0.3s ease;
    opacity: 0.7;

    &:hover {
      background: ${props => props.theme?.colors?.accent || 'rgba(0, 0, 0, 0.8)'};
      opacity: 1;
    }
  }
`;


const FadingUnderline = styled.div`
  width: 100%;
  height: 2px;
  background: linear-gradient(
    to right,
    transparent 0%,
    ${props => props.theme?.colors?.accent || '#fff'} 20%,
    ${props => props.theme?.colors?.accent || '#fff'} 80%,
    transparent 100%
  );
  margin-top: 1rem; /* CHANGE from 0.25rem to 0.1rem */
  opacity: 0.6;
`;


// 2. REPLACE BackgroundDrawer - make it slide down (around line 900)
const BackgroundDrawer = styled.div`
  position: relative;
  width: 100%;
  max-height: ${props => props.isOpen ? '400px' : '0'};
  opacity: ${props => props.isOpen ? 1 : 0};
  overflow: hidden;
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}50`};
  backdrop-filter: blur(10px);
  border: ${props => props.isOpen ? `1px solid ${props.theme?.colors?.accent}30` : 'none'};
  border-top: none;
  border-radius: 0 0 16px 16px;
  padding: ${props => props.isOpen ? '1.5rem' : '0 1.5rem'};
  margin: 0 auto;
  max-width: 800px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  margin-top: -16px; /* Overlap with profile section border */

  @media (min-width: 768px) {
    padding: ${props => props.isOpen ? '2rem' : '0 2rem'};
    max-height: ${props => props.isOpen ? '350px' : '0'};
  }

  @media (max-width: 768px) {
    max-height: ${props => props.isOpen ? '450px' : '0'};
  }
`;

const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}30`};

  h3 {
    color: ${props => props.theme?.colors?.accent || '#800000'};
    font-size: 1rem;
    margin: 0;
    font-weight: 600;
    
    @media (min-width: 768px) {
      font-size: 1.1rem;
    }
  }
`;

// Update the StripeRequiredNotification to stack vertically:
const StripeRequiredNotification = styled.div`
  position: fixed;
  bottom: ${props => props.show ? '2rem' : '-200px'};
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  background: ${props => props.theme?.colors?.background || '#000000'};
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center; /* ✅ Center horizontally */
  text-align: center; /* ✅ Center text */
  gap: 1rem;
  max-width: 500px;
  width: calc(100% - 2rem);
  transition: bottom 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  
  @media (max-width: 768px) {
    padding: 1rem;
    max-width: calc(100% - 2rem);
  }
`;
const StripeRequiredMessage = styled.div`
  flex: 1;
  text-align: center; /* ✅ ADD: Center text */
  
  .title {
    color: ${props => props.theme?.colors?.accent || '#800000'};
    font-weight: 700;
    font-size: 0.95rem;
    margin-bottom: 0.25rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  .text {
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    font-size: 0.85rem;
    opacity: 1;
    line-height: 1.4;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }
  
  @media (max-width: 768px) {
    .title {
      font-size: 0.9rem;
    }
    
    .text {
      font-size: 0.8rem;
    }
  }
`;

const StripeRequiredActions = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: center; /* ✅ ADD: Center buttons */
  width: 100%; /* ✅ ADD: Full width for centering */
  
  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const StripeRequiredIcon = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, ${props => props.theme?.colors?.accent || '#800000'} 0%, ${props => props.theme?.colors?.primary || '#4A0404'} 100%);
  border-radius: 50%;
  display: flex;
  left: 50%;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  svg {
    width: 20px;
    height: 20px;
    color: white;
  }
`;

const StripeNotificationButton = styled.button`
  flex: 1; /* Make buttons equal width */
  padding: 0.6rem 1.25rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center; /* Center content */
  gap: 0.5rem;
  border: none;
  white-space: nowrap;
  
  &.primary {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    color: white;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.4)'};
    }
    
    &:active {
      transform: translateY(0);
    }
  }
  
  &.secondary {
    background: transparent;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'};
    
    &:hover {
      background: ${props => `${props.theme?.colors?.accent}10` || 'rgba(128, 0, 0, 0.1)'};
    }
    
    &:active {
      transform: scale(0.98);
    }
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }
`;

// 5. UPDATE BackgroundImagesGrid to be more compact (around line 980)
const BackgroundImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (max-width: 480px) {
    gap: 0.5rem;
  }
`;

// 6. UPDATE BackgroundImageSlot to be smaller (around line 990)
const BackgroundImageSlot = styled.div`
  aspect-ratio: 16 / 9;
  border: 2px dashed ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}80`};

  &:hover {
    border-color: ${props => props.theme?.colors?.accent};
    transform: scale(1.02);
  }

  &:active {
    transform: scale(0.98);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    opacity: 0.6;
    padding: 0.5rem;

    span {
      font-size: 0.65rem;
      text-align: center;
      font-weight: 500;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

// 7. UPDATE DrawerActions to be more compact (around line 1050)
const DrawerActions = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  padding-top: 0.75rem;
  border-top: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.3)'};
`;

const ItemContent = styled.div`
  /* CHANGED: Reduced padding to fit 10% space (40px of 400px card) */
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* Reduced from 0.75rem */
  flex: 0 0 auto; /* Changed from flex: 1 to prevent expansion */
  min-height: 20px; /* 10% of 400px card height */
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}70`};

  .editable-text {
    width: 100%;
    
    input {
      width: 100%;
      background: transparent;
      border: none;
      border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(255, 255, 255, 0.1)'};
      padding: 0.4rem 0; /* Reduced from 0.5rem */
      color: ${props => props.theme?.colors?.text || '#FFFFFF'};
      font-size: 0.9rem; /* Reduced from 1rem */
      font-family: ${props => props.theme?.fonts?.body || "'Inter', sans-serif"};
      transition: all 0.3s ease;
      text-align: left;
      
      &:focus {
        border-bottom-color: ${props => props.theme?.colors?.accent || '#800000'};
      }

      &::placeholder {
        color: ${props => `${props.theme?.colors?.text}90` || 'rgba(255, 255, 255, 0.5)'};
      }
    }

    textarea {
      width: 100%;
      background: transparent;
      border: none;
      border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(255, 255, 255, 0.1)'};
      padding: 0.4rem 0; /* Reduced from 0.5rem */
      color: ${props => props.theme?.colors?.text || '#FFFFFF'};
      font-size: 0.9rem; /* Reduced from 1rem */
      font-family: ${props => props.theme?.fonts?.body || "'Inter', sans-serif"};
      transition: all 0.3s ease;
      resize: none;
      text-align: left;
      
      &:focus {
        border-bottom-color: ${props => props.theme?.colors?.accent || '#800000'};
      }

      &::placeholder {
        color: ${props => `${props.theme?.colors?.text}90` || 'rgba(255, 255, 255, 0.5)'};
      }
    }
  }
`;


const HeaderLogo = styled.div`
  color: ${props => props.theme?.colors?.accent || '#800000'};
  font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
  /* Fixed rem size + fixed line-height so the rendered text stays the same
     visual size across themes — different heading fonts have very different
     default line-height metrics, which is what made this look wider/shorter
     as the theme changed even though font-size itself never varied. */
  font-size: ${props => props.$expanded ? '1.7rem' : '1.4rem'};
  line-height: 1.2;
  letter-spacing: 1px;
  transform: skew(-5deg);
  cursor: pointer;
  flex-shrink: 0;
  transition: font-size 0.2s ease;

  @media (min-width: 768px) {
    font-size: ${props => props.$expanded ? 'clamp(1.0rem, 1.72vh, 1.4rem)' : 'clamp(0.88rem, 1.48vh, 1.2rem)'};
    letter-spacing: 2px;
  }
`;


const HeaderButton = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.theme?.colors?.accent || '#800000'};
  padding: 0.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  opacity: 0.8;
  
  &:active {
    transform: scale(0.9);
    opacity: 1;
  }
  
  @media (hover: hover) {
    &:hover {
      opacity: 1;
      background: ${props => `${props.theme?.colors?.accent}10` || 'rgba(128, 0, 0, 0.1)'};
    }
  }
  
  &.pinned {
    color: ${props => props.theme?.colors?.accent || '#800000'};
    opacity: 1;
  }
  
  &.spinning {
    animation: spin 0.5s ease-in-out;
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  svg {
    width: 16px;
    height: 16px;

    @media (min-width: 768px) {
      width: clamp(11px, 1.4vh, 14px);
      height: clamp(11px, 1.4vh, 14px);
    }
  }
`;


const UploadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 3;
`;

const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0;
  margin: 0;
  transition: background 0.2s ease;
  min-height: auto;
  
  &:hover {
    background: ${props => `${props.theme?.colors?.accent}10` || 'rgba(128, 0, 0, 0.1)'};
  }
  
  h3 {
    margin: 0;
    padding: 0;
    font-size: 0.9rem; /* Reduced from 1rem */
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    line-height: 1.2;
    flex: 1;
    
    @media (min-width: 768px) {
      font-size: 0.95rem; /* Reduced from 1.1rem */
    }
  }
`;

const ExpandButton = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.theme?.colors?.accent || '#800000'};
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  
  &:active {
    transform: scale(0.9);
  }
`;


// UPDATE ShopTabContainer to move it up:
const ShopTabContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: -0.5rem 0 0.5rem 0; /* CHANGED from 0rem 0 1rem to -0.5rem 0 0.5rem */
  padding: 0.5rem; /* REDUCED padding */
  position: relative;
  z-index: 2;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    padding: 0.25rem; /* REDUCED */
  }
`;

// Sell/Buy Service sub-tabs, docked inline in the main tab row on desktop.
// Hidden on mobile in favor of ServiceSubTabRow below, which stacks them
// underneath the Products/Services tabs instead of crowding the same row.
const ServiceSubTabInline = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: 767px) {
    display: none;
  }
`;

const ServiceSubTabRow = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin: -0.25rem auto 0.5rem;
    max-width: 500px;
  }
`;


const ItemDetails = styled.div`
  max-height: ${props => props.expanded ? '2000px' : '0'};
  opacity: ${props => props.expanded ? '1' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  
  .details-content {
    padding-top: ${props => props.expanded ? '0.75rem' : '0'};
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    transition: all 0.3s ease;
  }
`;

const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;


const cleanDataForFirestore = (data) => {
  if (!data) return data;
  
  // Handle File objects - REMOVE completely
  if (data instanceof File) {
    console.warn('⚠️ File object found, removing');
    return null;
  }
  
  // Handle Date objects
  if (data instanceof Date) {
    return data.toISOString();
  }
  
  if (Array.isArray(data)) {
    return data
      .map(item => cleanDataForFirestore(item))
      .filter(item => item !== null && item !== undefined);
  }
  
  if (typeof data === 'object' && data !== null) {
    const cleanedData = {};
    for (const [key, value] of Object.entries(data)) {
      // Skip File objects
      if (value instanceof File) {
        console.warn(`⚠️ Skipping File object at key: ${key}`);
        continue;
      }
      
      // Skip undefined and null
      if (value === null || value === undefined) continue;
      
      // Skip functions
      if (typeof value === 'function') continue;
      
      // ✅ CHANGED: Only skip 'file' key, keep preview URLs
      if (key === 'file') {
        console.warn(`⚠️ Skipping file key`);
        continue;
      }
      
      // ✅ CHANGED: Filter data URLs from arrays
      if (key === 'images' && Array.isArray(value)) {
        cleanedData[key] = value
          .map(img => {
            if (!img) return null;
            if (typeof img === 'string' && img.startsWith('http')) return img;
            return null; // Remove data URLs
          })
          .filter(Boolean);
        continue;
      }
      
      cleanedData[key] = cleanDataForFirestore(value);
    }
    return cleanedData;
  }
  
  return data;
};


const ShopTab = styled.button`
  background: ${props => props.active ? 
    props.theme?.colors?.accent || '#800000' : 'transparent'};
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  color: ${props => props.active ? 
    'white' : props.theme?.colors?.accent || '#800000'};
  padding: 0.4rem 1rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 0.68rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;

  @media (min-width: 768px) {
    padding: clamp(0.32rem, 0.56vh, 0.46rem) clamp(0.8rem, 1.4vw, 1.1rem);
    font-size: clamp(0.44rem, 0.76vh, 0.6rem);
    gap: clamp(0.2rem, 0.36vh, 0.32rem);
  }

  &:active {
    transform: scale(0.98);
  }

  @media (hover: hover) {
    &:hover {
      background: ${props => props.active ? 
        props.theme?.colors?.primary || '#4A0404' : 
        `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
    }
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;


const DrawerCloseButton = styled.button`
  background: transparent;
  border: 1px solid ${props => props.theme?.colors?.accent || '#800000'};
  color: ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    color: white;
  }

  &:active {
    transform: scale(0.9);
  }
`;

const UtilityOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  backdrop-filter: blur(0px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  animation: fadeInOverlay 0.4s ease forwards;
  
  @keyframes fadeInOverlay {
    from { 
      background: rgba(0, 0, 0, 0);
      backdrop-filter: blur(0px);
    }
    to { 
      background: rgba(0, 0, 0, 0.85);
      backdrop-filter: blur(10px);
    }
  }
`;

const UtilityOverlayContent = styled.div`
  background: ${props => props.theme?.colors?.background || '#000000'};
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transform: scale(0.95);
  animation: fadeInContent 0.4s ease 0.1s forwards;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  
  @keyframes fadeInContent {
    from { 
      opacity: 0;
      transform: scale(0.95);
    }
    to { 
      opacity: 1;
      transform: scale(1);
    }
  }
  
  @media (max-width: 768px) {
    max-height: 90vh;
  }
`;

const RemoveImageButton = styled.button`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`};
  border: 1px solid ${props => props.theme?.colors?.accent || '#800000'};
  color: #ff4444;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: all 0.2s ease;

  &:hover {
    background: #ff4444;
    color: white;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

const UtilityButton = styled.button`
  background: transparent;
  border: 1px solid ${props => props.theme?.colors?.accent || '#800000'};
  color: ${props => props.theme?.colors?.accent || '#800000'};
  padding: 0.6rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: ${props => `${props.theme?.colors?.accent}20`};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 16px;
    height: 16px;
  }

  @media (max-width: 768px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

const UtilityButtonsRow = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-top: 0.75rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 0.4rem;
    margin-top: 0.5rem;
  }
`;

const OverlayHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}30`};
  
  h3 {
    margin: 0;
    color: ${props => props.theme?.colors?.accent};
    font-size: 1.2rem;
    font-weight: 600;
  }
`;

const OverlayBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.colors?.accent};
    border-radius: 3px;
  }
`;

const OverlayFooter = styled.div`
  padding: 1.5rem;
  border-top: 1px solid ${props => `${props.theme?.colors?.accent}30`};
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`;

const ItemSelectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.5rem;
  max-height: 300px;
  overflow-y: auto;
  padding: 0.5rem;
  background: ${props => `${props.theme?.colors?.surface}20`};
  border-radius: 8px;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.colors?.accent};
    border-radius: 2px;
  }
`;

const ItemSelectionCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem;
  background: ${props => props.selected ? 
    `${props.theme?.colors?.accent}20` : 
    `${props.theme?.colors?.surface}30`};
  border: 2px solid ${props => props.selected ? 
    props.theme?.colors?.accent : 
    `${props.theme?.colors?.accent}20`};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: ${props => props.theme?.colors?.accent};
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const ItemCheckbox = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid ${props => props.checked ? 
    props.theme?.colors?.accent : 
    `${props.theme?.colors?.accent}40`};
  border-radius: 6px;
  background: ${props => props.checked ? 
    props.theme?.colors?.accent : 
    'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
  
  svg {
    width: 14px;
    height: 14px;
    color: white;
    opacity: ${props => props.checked ? 1 : 0};
    transition: opacity 0.2s ease;
  }
`;

const ItemInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  
  .item-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: ${props => props.theme?.colors?.text};
  }
  
  .item-details {
    font-size: 0.75rem;
    color: ${props => props.theme?.colors?.text};
    opacity: 0.6;
  }
`;

const SelectionActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const SelectionButton = styled.button`
  background: transparent;
  border: 1px solid ${props => props.theme?.colors?.accent};
  color: ${props => props.theme?.colors?.accent};
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => `${props.theme?.colors?.accent}20`};
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const ShopPage = () => {
  const navigate = useNavigate();
  const { accessibleShops, activeShopId, activeShopData, isOwnShop, setActiveShop, reloadShopAccess, newlyAddedShops, clearNewlyAddedShops, loadingShopAccess } = useActiveShop();
  // canEditActiveShop: true for primary shop and sub-shops the user owns; false for shared shops
  const activeShopEntry = accessibleShops.find(s => s.shopId === activeShopId);
  const canEditActiveShop = isOwnShop || activeShopEntry?.isOwn === true;
  // canEditShopCards: like canEditActiveShop, but also true for shared-shop staff with the
  // 'admin' role — they get the editable item/service cards instead of the read-only view.
  const canEditShopCards = canEditActiveShop || activeShopEntry?.role === 'admin';
  const prevActiveShopRef = React.useRef(null);
  const [showShopsDropdown, setShowShopsDropdown] = useState(false);
  const [removingShopId, setRemovingShopId] = useState(null);
  const shopsDropdownRef = useRef(null);
  useEffect(() => {
    if (!showShopsDropdown) return;
    const handler = (e) => {
      if (shopsDropdownRef.current && !shopsDropdownRef.current.contains(e.target)) {
        setShowShopsDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showShopsDropdown]);
  const [showNewShopModal, setShowNewShopModal] = useState(false);
  const [newShopName, setNewShopName] = useState('');
  const [isCreatingShop, setIsCreatingShop] = useState(false);
  const [showUnlockTabsModal, setShowUnlockTabsModal] = useState(false);
  // Share-access state (scoped to activeShopId)
  const [shopAccessData, setShopAccessData] = useState(null);
  const [loadingShareAccess, setLoadingShareAccess] = useState(false);
  const [shareEmail, setShareEmail] = useState('');
  const [shareRole, setShareRole] = useState('staff');
  const [shareLoading, setShareLoading] = useState(false);
  const [shareError, setShareError] = useState('');
  const [shareSuccess, setShareSuccess] = useState('');
  // Shared-user To-Do list state
  const [todoItems, setTodoItems] = useState([]);
  const [newTodoText, setNewTodoText] = useState('');
  const [todoSaving, setTodoSaving] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
const [selectingLocationFor, setSelectingLocationFor] = useState(null);
  const [shopData, setShopData] = useState(null);
  const [originalShopData, setOriginalShopData] = useState(null); // Track original data
  const shopIpLocationRef = useRef(null); // cached IP location for items without coordinates
  const [isReady, setIsReady] = useState(false);
  const [activeTab, setActiveTab] = useState(() => {
  // Load saved tab from sessionStorage, default to 'shop'
  const savedTab = sessionStorage.getItem('shopPageActiveTab') || 'shop';
  // Map old 'community' to new 'profile'
  return savedTab === 'community' ? 'profile' : savedTab;
});
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState({});
  const [tabPosition, setTabPosition] = useState('top');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [showHomeEditor, setShowHomeEditor] = useState(false);
  // Add these state variables at the top of ShopPage component (around line 1000)
  const [expandedItems, setExpandedItems] = useState(new Set());
  const [editingItem, setEditingItem] = useState(null);
  const [editingPost, setEditingPost] = useState(null);
  const [editingEvent, setEditingEvent] = useState(null);
  const [tempFileStorage, setTempFileStorage] = useState({});
  const [originalShopName, setOriginalShopName] = useState(''); // ADD THIS

  const [originalStoreStatus, setOriginalStoreStatus] = useState(true);

  const [shopContentType, setShopContentType] = useState('products');
  const [serviceSubTab, setServiceSubTab] = useState('offer'); // 'need' | 'offer'
  const [showJobTypeMenu, setShowJobTypeMenu] = useState(false);
  const [selectedHomeTemplate, setSelectedHomeTemplate] = useState(1);
  const [homeSections, setHomeSections] = useState([]);
  const [showSectionTypeModal, setShowSectionTypeModal] = useState(false);
  const [aiSectionLoading, setAiSectionLoading] = useState(null); // section id being AI-written
  const [navPanelOpen, setNavPanelOpen] = useState(false);
  // Header hide-on-scroll-down / reveal-on-scroll-up — matches ShopPublicView.js
  const [headerHidden, setHeaderHidden] = useState(false);
  const lastScrollY = useRef(0);
  const editSwipeRef = useRef(null); // touch-swipe tracking for the mobile edit overlay
  const [categoryApplyFlash, setCategoryApplyFlash] = useState(null); // service id showing the "applied" checkmark
  const [showShopSettingsPanel, setShowShopSettingsPanel] = useState(false);
  const [shareSectionExpanded, setShareSectionExpanded] = useState(false);
  const [todoSectionExpanded, setTodoSectionExpanded] = useState(false);
  const [tabSettingsExpanded, setTabSettingsExpanded] = useState(false);
  const [showMoreUtilities, setShowMoreUtilities] = useState(false);
  const [themeMenuOpen, setThemeMenuOpen] = useState(false);
  const [communityContentType, setCommunityContentType] = useState('images');
  const [userLocation, setUserLocation] = useState(null);
  const [communityPosts, setCommunityPosts] = useState([]);
  const [loadingCommunityPosts, setLoadingCommunityPosts] = useState(false);
  const [profileBackgroundImages, setProfileBackgroundImages] = useState([
  'https://images.unsplash.com/photo-1522124624696-7ea32eb9592c?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
          'https://images.unsplash.com/photo-1444080748397-f442aa95c3e5?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
          'https://images.unsplash.com/photo-1520034475321-cbe63696469a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
        ]);
const [currentBgIndex, setCurrentBgIndex] = useState(0);
const [showBgDrawer, setShowBgDrawer] = useState(false);
const [statusMessage, setStatusMessage] = useState(null);
const [isBulkUploading, setIsBulkUploading] = useState(false);

const [showTierDetails, setShowTierDetails] = useState(false);

const [compressionProgress, setCompressionProgress] = useState(null);

const [licenses, setLicenses] = useState([]);
const [uploadingLicense, setUploadingLicense] = useState(false);
const [storeOpen, setStoreOpen] = useState(true);
const [hideFromWelcomePage, setHideFromWelcomePage] = useState(false);

const [stripeStatus, setStripeStatus] = useState(null);
const [stripeLoading, setStripeLoading] = useState(true);
const [stripeChecked, setStripeChecked] = useState(false);
const [showStripeWizard, setShowStripeWizard] = useState(false);
const [tempBackgroundImages, setTempBackgroundImages] = useState([]);

const [profileBgFocalPoint, setProfileBgFocalPoint] = useState({ x: 50, y: 50 });
const [profileBgDragMode, setProfileBgDragMode] = useState(false);
const [profileBgDragging, setProfileBgDragging] = useState(false);
const [profileBgDragStart, setProfileBgDragStart] = useState({ x: 0, y: 0 });
const profileBgRef = useRef(null);

const [autoSaveInProgress, setAutoSaveInProgress] = useState(false);
const IMAGE_QUEUE_THRESHOLD = 3; // Trigger at 3 images

const [showWebsiteScraper, setShowWebsiteScraper] = useState(false);
const [showMenuScanner, setShowMenuScanner] = useState(false);
const [showLocationUpdater, setShowLocationUpdater] = useState(false);
const [locationUpdateMode, setLocationUpdateMode] = useState(null); // 'items' or 'services'

const [showBillingDropdown, setShowBillingDropdown] = useState(false);

const [licensesExpanded, setLicensesExpanded] = useState(false);

const [billingDataForPayment, setBillingDataForPayment] = useState(null);

const [storeType, setStoreType] = useState(() => {
  // Try to load from shopData or default to 'other'
  return shopData?.storeType || 'other';
});
const [showStoreTypeDropdown, setShowStoreTypeDropdown] = useState(false);
const [guestFieldsExpanded, setGuestFieldsExpanded] = useState(false);
const [masterAddresses, setMasterAddresses] = useState([]);
const [addressesJustApplied, setAddressesJustApplied] = useState(false);

const [bulkEditMode, setBulkEditMode] = useState(false);
const [selectedItemsForBulk, setSelectedItemsForBulk] = useState(new Set());
const [showBulkEditModal, setShowBulkEditModal] = useState(false);
const [bulkEditPrice, setBulkEditPrice] = useState('');
const [bulkEditAttributes, setBulkEditAttributes] = useState([]);
const [bulkAttrInput, setBulkAttrInput] = useState({});
const [bulkEditJobType, setBulkEditJobType] = useState('');

// Add From Store
const [showAddFromStore, setShowAddFromStore] = useState(false); // 'stores' | 'items' | false
const [addFromStoreStep, setAddFromStoreStep] = useState('stores'); // 'stores' | 'items'
const [nearbyShops, setNearbyShops] = useState([]);
const [loadingNearbyShops, setLoadingNearbyShops] = useState(false);
const [selectedSourceShop, setSelectedSourceShop] = useState(null);
const [selectedImportItems, setSelectedImportItems] = useState(new Set());
const [importingItems, setImportingItems] = useState(false);

const [featuredSelectMode, setFeaturedSelectMode] = useState(false);
const [selectedFeatured, setSelectedFeatured] = useState(new Set());

const [showAddCategoryInput, setShowAddCategoryInput] = useState(false);
const [newCategoryName, setNewCategoryName] = useState('');
const [newCategoryType, setNewCategoryType] = useState(null);
const [openTypePicker, setOpenTypePicker] = useState(null);
const [visibilityToast, setVisibilityToast] = useState(null); // { id, msg }
const [shopMobileColumns, setShopMobileColumns] = useState(2);

const [showLocationOverlay, setShowLocationOverlay] = useState(false);
const [showCategoryOverlay, setShowCategoryOverlay] = useState(false);
const [selectedItemsForUpdate, setSelectedItemsForUpdate] = useState(new Set());
const [overlayAddress, setOverlayAddress] = useState('');
const [overlayCoordinates, setOverlayCoordinates] = useState(null);
const [overlayCategory, setOverlayCategory] = useState('');

const [billingData, setBillingData] = useState(null);
const [showPaymentModal, setShowPaymentModal] = useState(false);
const [storeStatus, setStoreStatus] = useState('active');
const [events, setEvents] = useState([]);


const [changeQueue, setChangeQueue] = useState({
  shopDetails: null,      // { name, description, profile, etc }
  items: {},              // { itemId: itemData }
  services: {},           // { serviceId: serviceData }
  homeSections: null,     // entire homeSections array
  communityPosts: {},
  events: {},   // { postId: postData }
  licenses: null,         // entire licenses array
  backgrounds: null,      // profileBackgroundImages array
  storeStatus: null,      // boolean
  tabs: null,             // tabs array when owner edits navigation
});

const [hasPendingChanges, setHasPendingChanges] = useState(false);

// Fetch IP location once on mount — used as fallback for items with no coordinates
useEffect(() => {
  fetchIPLocation().then(loc => { if (loc) shopIpLocationRef.current = loc; });
}, []); // eslint-disable-line react-hooks/exhaustive-deps

// ADD handlers for profile background positioning
const handleProfileBgMouseDown = (e) => {
  if (!profileBgDragMode) return;
  setProfileBgDragging(true);
  setProfileBgDragStart({
    x: e.clientX,
    y: e.clientY
  });
};

useEffect(() => {
  const loadUserBillingData = async () => {
    if (!auth.currentUser) return;
    
    try {
      // Load user data (where totalEarnings should be stored)
      const userRef = doc(db, 'users', auth.currentUser.uid);
      const userDoc = await getDoc(userRef);
      
      let totalEarned = 0;
      if (userDoc.exists()) {
        const userData = userDoc.data();
        totalEarned = userData.totalEarnings || 0;
        console.log('💰 Loaded total earnings from user data:', totalEarned);
      }
      
      // Get or create billing document
      const billingRef = doc(db, 'billing', auth.currentUser.uid);
      const billingDoc = await getDoc(billingRef);
      
      let billing;
      
      if (!billingDoc.exists()) {
        // Create new billing record
        billing = {
          userId: auth.currentUser.uid,
          totalSales: totalEarned,
          paymentHistory: {
            paidMilestoneFees: [],
            payments: []
          },
          itemsHiddenDueToBalance: false,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        };
        
        await setDoc(billingRef, billing);
        console.log('✅ Created new billing record from user data');
      } else {
        billing = billingDoc.data();
        
        // Update total sales from user data
        if (billing.totalSales !== totalEarned) {
          await updateDoc(billingRef, {
            totalSales: totalEarned,
            updatedAt: serverTimestamp()
          });
          
          billing.totalSales = totalEarned;
          console.log('✅ Updated billing total sales to:', totalEarned);
        }
      }
      
      // Calculate payment status
      const balance = calculateOutstandingBalance(billing);
      const itemsShouldBeHidden = shouldHideItems(billing);

      console.log('📊 Payment status:', {
        plan: billing.plan || 'legacy',
        totalSales: totalEarned,
        balance,
        itemsShouldBeHidden
      });

      setBillingData(billing);

      // Self-heal the public-facing plan mirror on shops/{id}.plan — billing
      // records written before the Free-plan gating on the public page never
      // had `plan` mirrored onto the shop doc, which made every existing
      // shop's Home tab (and other plan-gated tabs) look locked to visitors
      // regardless of what plan was actually paid for. Runs harmlessly every
      // load; only writes when the mirror is actually stale.
      try {
        const resolvedPlan = getPlanFromBilling(billing);
        const shopRef = doc(db, 'shops', auth.currentUser.uid);
        const shopSnap = await getDoc(shopRef);
        if (shopSnap.exists() && shopSnap.data().plan !== resolvedPlan) {
          await updateDoc(shopRef, { plan: resolvedPlan });
          console.log('🔧 Synced shop doc plan mirror:', resolvedPlan);
        }
      } catch (syncErr) {
        console.warn('Could not sync plan to shop doc:', syncErr);
      }

      // For new plan-based billing: only auto-hide on monthly overdue (balance > 0)
      // For legacy milestone billing: keep existing hide/unhide logic
      if (billing.plan) {
        // New system — only hide when monthly payment is overdue
        if (balance > 0 && !billing.itemsHiddenDueToBalance) {
          console.log('⚠️ Monthly payment overdue - hiding items');
          await hideItemsDueToBalance(billing, balance);
        } else if (balance === 0 && billing.itemsHiddenDueToBalance) {
          console.log('✅ Balance cleared - unhiding items');
          await unhideItemsAfterPayment();
        }
      } else {
        // Legacy milestone system
        if (itemsShouldBeHidden && !billing.itemsHiddenDueToBalance) {
          console.log('⚠️ Milestone reached - hiding items');
          await hideItemsDueToBalance(billing, balance);
        } else if (!itemsShouldBeHidden && billing.itemsHiddenDueToBalance) {
          console.log('✅ Balance cleared - unhiding items');
          await unhideItemsAfterPayment();
        }
      }
      
    } catch (error) {
      console.error('❌ Error loading user billing data:', error);
    }
  };
  
  loadUserBillingData();
}, [auth.currentUser]);

// Check for newly shared shops on every page load
useEffect(() => {
  reloadShopAccess();
}, []); // eslint-disable-line react-hooks/exhaustive-deps

// Reload billing whenever the active shop changes (sub-shops and shared shops)
useEffect(() => {
  if (!activeShopId || !auth.currentUser) return;
  // Primary shop billing is handled by the loadUserBillingData effect above
  if (activeShopId === auth.currentUser.uid) return;

  const loadBillingForShop = async () => {
    try {
      const billingDoc = await getDoc(doc(db, 'billing', activeShopId));
      if (billingDoc.exists()) {
        const billing = billingDoc.data();
        setBillingData(billing);

        // Same plan-mirror self-heal as the primary shop's billing load.
        try {
          const resolvedPlan = getPlanFromBilling(billing);
          const shopRef = doc(db, 'shops', activeShopId);
          const shopSnap = await getDoc(shopRef);
          if (shopSnap.exists() && shopSnap.data().plan !== resolvedPlan) {
            await updateDoc(shopRef, { plan: resolvedPlan });
            console.log('🔧 Synced shop doc plan mirror:', resolvedPlan);
          }
        } catch (syncErr) {
          console.warn('Could not sync plan to shop doc:', syncErr);
        }
      } else {
        setBillingData(null);
      }
    } catch (err) {
      console.warn('Could not load billing for shop:', activeShopId, err);
      setBillingData(null);
    }
  };

  loadBillingForShop();
}, [activeShopId]); // eslint-disable-line react-hooks/exhaustive-deps

useEffect(() => {
  if (shopData?.storeType) {
    setStoreType(shopData.storeType);
  }
}, [shopData?.storeType]);

// Merge hardcoded store-type categories with owner-defined custom categories.
// Always deduplicated; custom categories appear after the built-in ones.
const getAllCategories = (isService = false) => {
  const base = getCategoriesForStoreType(storeType, isService);
  const custom = isService
    ? (shopData?.serviceCategories || [])
    : (shopData?.productCategories || []);
  return [...new Set([...base, ...custom])];
};

// The "Service Type" dropdowns (gig/job marketplace) are built from the fixed
// JOB_TYPES list. Owner-defined custom service categories aren't real job
// types, but selecting one should still work — it just falls back to the
// generic booking-form template (see getJobTypeBookingTemplate's catch-all in
// utils/orderFormConfig.js), same as any unrecognized jobType id already does.
const getAllServiceTypes = () => {
  const builtInIds = new Set(JOB_TYPES.map(j => j.id));
  const customTypes = (shopData?.serviceCategories || [])
    .filter(name => !builtInIds.has(name))
    .map(name => ({ id: name, label: name, icon: '💼' }));
  return [...JOB_TYPES, ...customTypes];
};

useEffect(() => {
  if (shopData?.masterAddresses) {
    setMasterAddresses(shopData.masterAddresses);
  }
}, [shopData?.masterAddresses]);

// Self-heal services sitting in a custom (owner-defined) category with no
// "Service Type" assigned yet — e.g. cards added via "Add Card" before jobType
// auto-assignment existed. Without a jobType, the booking-form editor never
// renders and getItemFormFields() ignores any saved bookingForm, so Apply-to-
// Category silently has no effect. Custom categories double as Service Type
// options (see getAllServiceTypes), so backfilling jobType = category is safe.
useEffect(() => {
  if (!shopData?.services?.length || !shopData?.serviceCategories?.length) return;
  const customCats = new Set(shopData.serviceCategories);
  const orphaned = shopData.services.filter(s => s.isService && !s.jobType && customCats.has(s.category));
  if (orphaned.length === 0) return;
  const patchedIds = new Set(orphaned.map(s => s.id));
  setShopData(prev => ({
    ...prev,
    services: (prev.services || []).map(s => patchedIds.has(s.id) ? { ...s, jobType: s.category } : s),
  }));
  setChangeQueue(prev => ({
    ...prev,
    services: {
      ...prev.services,
      ...Object.fromEntries(orphaned.map(s => [s.id, { ...(prev.services[s.id] || {}), jobType: s.category, id: s.id }])),
    },
  }));
  setHasPendingChanges(true);
}, [shopData?.services, shopData?.serviceCategories]);


const toggleBulkSelection = (itemId) => {
  setSelectedItemsForBulk(prev => {
    const newSet = new Set(prev);
    if (newSet.has(itemId)) {
      newSet.delete(itemId);
    } else {
      newSet.add(itemId);
    }
    return newSet;
  });
};

const selectAllForBulk = () => {
  const allIds = shopContentType === 'services' 
    ? shopData?.services?.map(s => s.id) || []
    : shopData?.items?.map(i => i.id) || [];
  setSelectedItemsForBulk(new Set(allIds));
};

const deselectAllBulk = () => {
  setSelectedItemsForBulk(new Set());
};

// Add this near your other helper functions
const getDefaultCategoryForStore = (storeTypeId) => {
  return getStoreTypeById(storeTypeId)?.defaultCategory || 'General Merchandise';
};

const handleSaveFeatured = () => {
  if (shopContentType === 'services') {
    const updatedServices = (shopData?.services || []).map(service => ({
      ...service,
      isFeatured: selectedFeatured.has(service.id)
    }));
    setShopData(prev => ({ ...prev, services: updatedServices }));
    setChangeQueue(prev => ({ ...prev, services: updatedServices }));
  } else {
    const updatedItems = (shopData?.items || []).map(item => ({
      ...item,
      isFeatured: selectedFeatured.has(item.id)
    }));
    setShopData(prev => ({ ...prev, items: updatedItems }));
    setChangeQueue(prev => ({ ...prev, items: updatedItems }));
  }
  setHasPendingChanges(true);
  setFeaturedSelectMode(false);
};

const handleBulkDelete = () => {
  if (selectedItemsForBulk.size === 0) return;
  
  if (!window.confirm(`Delete ${selectedItemsForBulk.size} ${shopContentType}?`)) {
    return;
  }
  
  if (shopContentType === 'services') {
    const remainingServices = shopData.services.filter(
      s => !selectedItemsForBulk.has(s.id)
    );
    setShopData(prev => ({ ...prev, services: remainingServices }));
  } else {
    const remainingItems = shopData.items.filter(
      i => !selectedItemsForBulk.has(i.id)
    );
    setShopData(prev => ({ ...prev, items: remainingItems }));
  }
  
  setSelectedItemsForBulk(new Set());
  setBulkEditMode(false);
  
  console.log(`✅ Deleted ${selectedItemsForBulk.size} ${shopContentType}`);
};

const handleBulkPriceEdit = () => {
  if (selectedItemsForBulk.size === 0 || !bulkEditPrice) return;
  
  const priceValue = parseFloat(bulkEditPrice);
  if (isNaN(priceValue) || priceValue < 0) {
    alert('Please enter a valid price');
    return;
  }
  
  if (shopContentType === 'services') {
    const updatedServices = shopData.services.map(service =>
      selectedItemsForBulk.has(service.id)
        ? { ...service, price: priceValue.toFixed(2) }
        : service
    );
    setShopData(prev => ({ ...prev, services: updatedServices }));
  } else {
    const updatedItems = shopData.items.map(item =>
      selectedItemsForBulk.has(item.id)
        ? { ...item, price: priceValue.toFixed(2) }
        : item
    );
    setShopData(prev => ({ ...prev, items: updatedItems }));
  }
  
  setShowBulkEditModal(false);
  setBulkEditPrice('');
  setBulkEditAttributes([]);
  setBulkAttrInput({});
  setSelectedItemsForBulk(new Set());
  setBulkEditMode(false);

  console.log(`✅ Updated price for ${selectedItemsForBulk.size} ${shopContentType}`);
};

const handleBulkApply = () => {
  if (selectedItemsForBulk.size === 0) return;
  const priceValue = bulkEditPrice !== '' ? parseFloat(bulkEditPrice) : null;
  if (priceValue !== null && (isNaN(priceValue) || priceValue < 0)) {
    alert('Please enter a valid price');
    return;
  }
  const validAttrs = bulkEditAttributes.filter(a => a.name.trim() && a.values.length > 0);
  const list = shopContentType === 'services' ? shopData.services : shopData.items;
  const updated = list.map(item => {
    if (!selectedItemsForBulk.has(item.id)) return item;
    const patch = {};
    if (priceValue !== null) patch.price = priceValue.toFixed(2);
    if (validAttrs.length > 0) patch.attributes = validAttrs;
    if (bulkEditJobType) {
      patch.jobType = bulkEditJobType;
      patch.bookingForm = { fields: [] };
      Object.assign(patch, SERVICE_TYPE_DEFAULTS[bulkEditJobType] || {});
    }
    return { ...item, ...patch };
  });
  if (shopContentType === 'services') {
    setShopData(prev => ({ ...prev, services: updated }));
  } else {
    setShopData(prev => ({ ...prev, items: updated }));
  }
  setShowBulkEditModal(false);
  setBulkEditPrice('');
  setBulkEditAttributes([]);
  setBulkAttrInput({});
  setBulkEditJobType('');
  setSelectedItemsForBulk(new Set());
  setBulkEditMode(false);
};

const openAddFromStore = async () => {
  setShowAddFromStore(true);
  setAddFromStoreStep('stores');
  setSelectedSourceShop(null);
  setSelectedImportItems(new Set());
  setLoadingNearbyShops(true);
  try {
    const shops = await getNearbyShops(userLocation, auth.currentUser?.uid, 5);
    setNearbyShops(shops);
  } catch (e) {
    console.error('Error fetching nearby shops:', e);
    setNearbyShops([]);
  } finally {
    setLoadingNearbyShops(false);
  }
};

const handleSelectSourceShop = (shop) => {
  setSelectedSourceShop(shop);
  setSelectedImportItems(new Set());
  setAddFromStoreStep('items');
};

const handleImportItems = () => {
  if (selectedImportItems.size === 0) return;
  setImportingItems(true);

  const shopLocked = billingData?.itemsHiddenDueToBalance === true;
  const importPerms = getPlanPermissions(billingData);
  const itemsToImport = (selectedSourceShop.items || [])
    .filter(i => selectedImportItems.has(i.id))
    .map(i => {
      const { visibleTotal: impVisCount } = countVisibleByType(shopData?.items || [], shopData?.services || []);
      const allowed = !shopLocked && importPerms.maxVisible > 0 && impVisCount < importPerms.maxVisible;
      return {
        ...i,
        id: `imported-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        visible: allowed,
        userSetVisibility: true,
        hiddenDueToBalance: !allowed,
        deleted: false,
        importedFrom: selectedSourceShop.id,
      };
    });

  const updatedItems = [...itemsToImport, ...(shopData.items || [])];
  setShopData(prev => ({ ...prev, items: updatedItems }));

  const newQueue = {};
  itemsToImport.forEach(item => {
    newQueue[item.id] = { ...item, isNew: true };
  });
  setChangeQueue(prev => ({
    ...prev,
    items: { ...prev.items, ...newQueue },
  }));

  setImportingItems(false);
  setShowAddFromStore(false);
  setSelectedSourceShop(null);
  setSelectedImportItems(new Set());
};

const hideItemsDueToBalance = async (billing, balance) => {
  try {
    if (!auth.currentUser) return;
    
    // Get fresh shop data from Firestore
    const shopRef = doc(db, 'shops', activeShopId || auth.currentUser.uid);
    const shopDoc = await getDoc(shopRef);

    if (!shopDoc.exists()) {
      console.error('❌ Shop not found');
      return;
    }

    const currentShopData = shopDoc.data();

    // Hide all items and services, preserve userSetVisibility
    const updatedItems = (currentShopData.items || []).map(item => ({
      ...item,
      userSetVisibility: item.visible, // Save current visibility preference
      visible: false,
      hiddenDueToBalance: true
    }));
    
    const updatedServices = (currentShopData.services || []).map(service => ({
      ...service,
      userSetVisibility: service.visible, // Save current visibility preference
      visible: false,
      hiddenDueToBalance: true
    }));

    // Save to Firestore FIRST
    await updateDoc(shopRef, {
      items: updatedItems,
      services: updatedServices,
      storeStatus: 'suspended',
      suspendedReason: 'payment_due',
      suspendedAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    console.log('✅ Firestore updated - items hidden');

    // Mirror into the top-level items/services collections — best-effort.
    {
      const mirrorShopId = activeShopId || auth.currentUser.uid;
      const mirrorShopFields = buildShopFields(mirrorShopId, currentShopData);
      mirrorItemsFull(mirrorShopId, updatedItems, mirrorShopFields);
      mirrorServicesFull(mirrorShopId, updatedServices, mirrorShopFields);
    }

    // Update billing record
    const billingRef = doc(db, 'billing', activeShopId || auth.currentUser.uid);
    await updateDoc(billingRef, {
      itemsHiddenDueToBalance: true,
      hiddenAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    // Now update local state
    setShopData(prev => ({
      ...prev,
      items: updatedItems,
      services: updatedServices,
      storeStatus: 'suspended'
    }));
    
    setStoreStatus('suspended');

    setStatusMessage({
      type: 'error',
      text: `⚠️ Store suspended - ${formatCurrency(balance)} payment required`
    });
    
    // Auto-show payment modal — skip on first sign-in, let balance button surface it
    setBillingDataForPayment(billing);
    const isNewAccount = sessionStorage.getItem('is_new_account');
    if (isNewAccount) {
      sessionStorage.removeItem('is_new_account');
    } else {
      setShowPaymentModal(true);
    }

    console.log('✅ Items hidden due to balance');
  } catch (error) {
    console.error('❌ Error hiding items:', error);
  }
};


const unhideItemsAfterPayment = async () => {
  try {
    if (!auth.currentUser) return;
    
    // First, get fresh shop data from Firestore
    const shopRef = doc(db, 'shops', activeShopId || auth.currentUser.uid);
    const shopDoc = await getDoc(shopRef);

    if (!shopDoc.exists()) {
      console.error('❌ Shop not found');
      return;
    }

    const currentShopData = shopDoc.data();

    // Restore items that were hidden due to balance
    const updatedItems = (currentShopData.items || []).map(item => {
      if (item.hiddenDueToBalance) {
        return {
          ...item,
          visible: item.userSetVisibility !== false,
          hiddenDueToBalance: false
        };
      }
      return item;
    });
    
    const updatedServices = (currentShopData.services || []).map(service => {
      if (service.hiddenDueToBalance) {
        return {
          ...service,
          visible: service.userSetVisibility !== false,
          hiddenDueToBalance: false
        };
      }
      return service;
    });

    // Save to Firestore FIRST
    await updateDoc(shopRef, {
      items: updatedItems,
      services: updatedServices,
      storeStatus: 'active',
      suspendedReason: null,
      suspendedAt: null,
      restoredAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    console.log('✅ Firestore updated - items unhidden');

    // Mirror into the top-level items/services collections — best-effort.
    {
      const mirrorShopId = activeShopId || auth.currentUser.uid;
      const mirrorShopFields = buildShopFields(mirrorShopId, currentShopData);
      mirrorItemsFull(mirrorShopId, updatedItems, mirrorShopFields);
      mirrorServicesFull(mirrorShopId, updatedServices, mirrorShopFields);
    }

    // Update billing record
    const billingRef = doc(db, 'billing', activeShopId || auth.currentUser.uid);
    await updateDoc(billingRef, {
      itemsHiddenDueToBalance: false,
      restoredAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    // Now update local state
    setShopData(prev => ({
      ...prev,
      items: updatedItems,
      services: updatedServices,
      storeStatus: 'active'
    }));
    
    setOriginalShopData(prev => ({
      ...prev,
      items: updatedItems,
      services: updatedServices,
      storeStatus: 'active'
    }));
    
    setStoreStatus('active');

    setStatusMessage({
      type: 'success',
      text: '✅ Store reactivated - items restored'
    });

    console.log('✅ Items restored after payment');
  } catch (error) {
    console.error('❌ Error unhiding items:', error);
    setStatusMessage({
      type: 'error',
      text: '⚠️ Error restoring items. Please reload the page.'
    });
  }
};

const handlePaymentSuccess = async (result) => {
  console.log('💳 Payment successful, reloading data...', result);

  setShowPaymentModal(false);
  setBillingDataForPayment(null);

  // Immediately apply the plan from the API response so the UI reflects it
  // before the Firestore re-read completes.
  if (result?.plan) {
    setBillingData(prev => ({
      ...(prev || {}),
      plan: result.plan,
      itemsHiddenDueToBalance: false,
    }));
  }

  try {
    const targetShopId = activeShopId || auth.currentUser.uid;
    const { PLANS: PLAN_DEFS } = await import('../../utils/billingTiers');

    // Reload billing data from Firestore (authoritative copy)
    const billingRef = doc(db, 'billing', targetShopId);
    const billingDoc = await getDoc(billingRef);

    if (billingDoc.exists()) {
      const updatedBilling = billingDoc.data();
      console.log('📊 Reloaded billing data:', updatedBilling);
      setBillingData({
        ...updatedBilling,
        itemsHiddenDueToBalance: false,
      });
    }

    // Reload shop data to get updated item visibility from API
    const shopRef = doc(db, 'shops', targetShopId);
    const shopDoc = await getDoc(shopRef);

    if (shopDoc.exists()) {
      const updatedShopData = shopDoc.data();

      setShopData(prev => ({
        ...prev,
        items: updatedShopData.items || prev.items,
        services: updatedShopData.services || prev.services,
        storeStatus: 'active',
      }));

      setOriginalShopData(prev => ({
        ...prev,
        items: updatedShopData.items || prev.items,
        services: updatedShopData.services || prev.services,
        storeStatus: 'active',
      }));

      setStoreStatus('active');
      console.log('✅ Shop data reloaded after payment');
    }

    const planLabel = result?.plan ? (PLAN_DEFS[result.plan]?.label || result.plan) : null;
    setStatusMessage({
      type: 'success',
      text: planLabel
        ? `✅ Upgraded to ${planLabel} plan! Your store is active.`
        : '✅ Payment successful! Your store is now active.',
    });
    setTimeout(() => setStatusMessage(null), 6000);

  } catch (error) {
    console.error('❌ Error reloading data after payment:', error);
    setStatusMessage({
      type: 'error',
      text: '⚠️ Payment processed but failed to refresh. Please reload the page.',
    });
  }
};

useEffect(() => {
  // Auto-hide items if Stripe becomes inactive
  if (stripeStatus && (!stripeStatus.stripeReady || stripeStatus.status !== 'active')) {
    const hasVisibleItems = shopData?.items?.some(i => i.visible !== false) || 
                           shopData?.services?.some(s => s.visible !== false);
    
    if (hasVisibleItems) {
      console.log('⚠️ Stripe inactive - auto-hiding all items');
      
      // Hide all items
      if (shopData?.items?.length > 0) {
        const hiddenItems = shopData.items.map(item => ({
          ...item,
          visible: false
        }));
        
        setShopData(prev => ({
          ...prev,
          items: hiddenItems
        }));
      }
      
      // Hide all services
      if (shopData?.services?.length > 0) {
        const hiddenServices = shopData.services.map(service => ({
          ...service,
          visible: false
        }));
        
        setShopData(prev => ({
          ...prev,
          services: hiddenServices
        }));
      }
      
      // Show warning
      setStatusMessage({
        type: 'error',
        text: '⚠️ All items hidden - Stripe account required to accept payments'
      });
      setTimeout(() => setStatusMessage(null), 7000);
    }
  }
}, [stripeStatus?.status, stripeStatus?.stripeReady]);

useEffect(() => {
  if (!shopData) return;
  
  const items = shopContentType === 'services' ? shopData.services : shopData.items;
  
  
}, [shopData?.items?.length, shopData?.services?.length, shopContentType]);

const handleProfileBgMouseMove = (e) => {
  if (!profileBgDragging || !profileBgDragMode) return;
  
  if (profileBgRef.current) {
    const rect = profileBgRef.current.getBoundingClientRect();
    const focalX = ((e.clientX - rect.left) / rect.width) * 100;
    const focalY = ((e.clientY - rect.top) / rect.height) * 100;
    setProfileBgFocalPoint({ 
      x: Math.max(0, Math.min(100, focalX)),
      y: Math.max(0, Math.min(100, focalY))
    });
  }
};

const handleProfileBgMouseUp = () => {
  setProfileBgDragging(false);
};

useEffect(() => {
  if (profileBgDragging) {
    window.addEventListener('mousemove', handleProfileBgMouseMove);
    window.addEventListener('mouseup', handleProfileBgMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleProfileBgMouseMove);
      window.removeEventListener('mouseup', handleProfileBgMouseUp);
    };
  }
}, [profileBgDragging, profileBgDragMode]);

const handleSaveProfileBgPosition = async () => {
  try {
    const shopRef = doc(db, 'shops', auth.currentUser.uid);
    await updateDoc(shopRef, {
      profileBackgroundFocalPoint: profileBgFocalPoint,
      updatedAt: new Date().toISOString()
    });
    
    setShopData(prev => ({
      ...prev,
      profileBackgroundFocalPoint: profileBgFocalPoint
    }));
    
    setOriginalShopData(prev => ({
      ...prev,
      profileBackgroundFocalPoint: profileBgFocalPoint
    }));
    
    setProfileBgDragMode(false);
    console.log('✅ Profile background position saved');
  } catch (error) {
    console.error('❌ Error saving position:', error);
  }
};

const handleBulkImageUpload = async (files, categoryName) => {
  if (!files || files.length === 0) return;

  try {
    setIsBulkUploading(true);
    
    // CHANGED: Only take the first 8 files
    const filesToProcess = Array.from(files).slice(0, 8);
    
    console.log(`📦 Processing ${filesToProcess.length} images (first 8 of ${files.length}) for bulk upload...`);
    
    setCompressionProgress({
      text: `Processing ${filesToProcess.length} files...`,
      percent: 0
    });

    const newItems = [];

    for (let i = 0; i < filesToProcess.length; i++) {
      const file = filesToProcess[i];
      
      // CHANGED: Only allow images
      if (!file.type.startsWith('image/')) {
        console.warn(`⚠️ Skipping non-image file: ${file.name}`);
        continue;
      }
      
      setCompressionProgress({
        text: `Processing image ${i + 1}/${filesToProcess.length}...`,
        percent: Math.round((i / filesToProcess.length) * 100)
      });

      try {
        validateImageFile(file, 20);

        const compressedFile = await compressProductImage(file, (progress) => {
          setCompressionProgress({
            text: `Compressing image ${i + 1}/${filesToProcess.length}...`,
            percent: Math.round(((i + progress / 100) / filesToProcess.length) * 100)
          });
        });

        const preview = await readFileAsDataURL(compressedFile);
        const newId = `bulk-${Date.now()}-${i}`;
          const newItem = {
            id: newId,
            name: shopContentType === 'services' ? 'Service Name' : 'Item Name',
            price: '',
            description: '',
            category: categoryName || (shopContentType === 'services' ? 'Other' :
                      shopData?.isRestaurant ? 'Appetizers' : 'Other'),
            images: [{
              preview,
              file: compressedFile,
              type: compressedFile.type,
              isVideo: false
            }, null, null],
            currentImageIndex: 0,
            address: '',
            coordinates: null,
            visible: (() => {
              const p = getPlanPermissions(billingData);
              const locked = billingData?.itemsHiddenDueToBalance;
              const { visibleTotal } = countVisibleByType(shopData?.items || [], shopData?.services || []);
              if (locked) return false;
              return p.maxVisible > 0 && visibleTotal < p.maxVisible;
            })(),
            userSetVisibility: true,
            hiddenDueToBalance: (() => {
              const p = getPlanPermissions(billingData);
              const locked = billingData?.itemsHiddenDueToBalance;
              const { visibleTotal } = countVisibleByType(shopData?.items || [], shopData?.services || []);
              if (locked) return true;
              return !(p.maxVisible > 0 && visibleTotal < p.maxVisible);
            })(),
            ...(shopContentType === 'services' ?
              { slots: 1, isService: true, serviceTab: serviceSubTab } :
              { quantity: 1 }
            )
          };

          newItems.push(newItem);

          const storageKey = `${newId}-0`;
          const metadataKey = `${storageKey}-metadata`;
          setTempFileStorage(prev => ({
            ...prev,
            [storageKey]: compressedFile,
          [metadataKey]: { isVideo: false, type: compressedFile.type }
        }));

      } catch (error) {
        console.error(`❌ Failed to process file ${i + 1}:`, error);
      }
    }

    setCompressionProgress(null);

    // ADD THIS: Track new items in change queue
    const newItemsWithIds = newItems.map(item => ({
      ...item,
      isNew: true, // Flag to indicate this is a new item
      createdAt: new Date().toISOString()
    }));

    if (shopContentType === 'services') {
      setShopData(prev => ({
        ...prev,
        services: [...newItemsWithIds, ...(prev.services || [])]
      }));
      
      // Add to change queue with new flag
      setChangeQueue(prev => {
        const newServices = {};
        newItemsWithIds.forEach(item => {
          newServices[item.id] = {
            ...item,
            isNew: true, // Flag for new items
            status: 'pending_create' // Special status
          };
        });
        
        return {
          ...prev,
          services: {
            ...prev.services,
            ...newServices
          }
        };
      });
    } else {
      setShopData(prev => ({
        ...prev,
        items: [...newItemsWithIds, ...(prev.items || [])]
      }));
      
      // Add to change queue with new flag
      setChangeQueue(prev => {
        const newItemsObj = {};
        newItemsWithIds.forEach(item => {
          newItemsObj[item.id] = {
            ...item,
            isNew: true, // Flag for new items
            status: 'pending_create' // Special status
          };
        });
        
        return {
          ...prev,
          items: {
            ...prev.items,
            ...newItemsObj
          }
        };
      });
    }

    const newIds = newItemsWithIds.map(item => item.id);
    setExpandedItems(new Set(newIds));
    
    setHasPendingChanges(true); // Trigger save button

    console.log(`✅ Created ${newItems.length} new ${shopContentType} (first 8 of ${files.length}) and added to queue`);
    console.log('📋 Change queue now has:', {
      items: Object.keys(changeQueue.items).length,
      services: Object.keys(changeQueue.services).length
    });
    
    setStatusMessage({
      type: 'success',
      text: `✓ Created ${newItems.length} ${shopContentType} from first 8 images (ready to save)`
    });
    setTimeout(() => setStatusMessage(null), 5000);

  } catch (error) {
    console.error('❌ Bulk upload failed:', error);
    setCompressionProgress(null);
    alert('Bulk upload failed. Please try again.');
  } finally {
    setIsBulkUploading(false);
  }
};

const handleApplyLocationToSelected = async () => {
  if (selectedItemsForUpdate.size === 0) {
    alert('Select at least one item');
    return;
  }
  
  if (!overlayAddress && !overlayCoordinates) {
    alert('Enter a location');
    return;
  }
  
  const updateData = {
    address: overlayAddress,
    coordinates: overlayCoordinates
  };
  
  if (shopContentType === 'services') {
    const updatedServices = shopData.services.map(service => 
      selectedItemsForUpdate.has(service.id) 
        ? { ...service, ...updateData }
        : service
    );
    setShopData(prev => ({ ...prev, services: updatedServices }));
    
    // Add to change queue
    selectedItemsForUpdate.forEach(serviceId => {
      setChangeQueue(prev => ({
        ...prev,
        services: {
          ...prev.services,
          [serviceId]: {
            ...(prev.services[serviceId] || {}),
            ...updateData,
            id: serviceId
          }
        }
      }));
    });
  } else {
    const updatedItems = shopData.items.map(item => 
      selectedItemsForUpdate.has(item.id) 
        ? { ...item, ...updateData }
        : item
    );
    setShopData(prev => ({ ...prev, items: updatedItems }));
    
    // Add to change queue
    selectedItemsForUpdate.forEach(itemId => {
      setChangeQueue(prev => ({
        ...prev,
        items: {
          ...prev.items,
          [itemId]: {
            ...(prev.items[itemId] || {}),
            ...updateData,
            id: itemId
          }
        }
      }));
    });
  }
  
  setHasPendingChanges(true);
  
  console.log(`✅ Updated location for ${selectedItemsForUpdate.size} ${shopContentType}`);
  
  // Reset and close
  setShowLocationOverlay(false);
  setSelectedItemsForUpdate(new Set());
  setSelectedItemsForBulk(new Set()); // Clear bulk selection too
  setOverlayAddress('');
  setOverlayCoordinates(null);
};

// ── Master Addresses ────────────────────────────────────────────────────────
const handleAddMasterAddress = () => {
  if (masterAddresses.length >= 5) return;
  const newAddr = { id: `ma_${Date.now()}`, label: '', address: '', coordinates: null };
  const updated = [...masterAddresses, newAddr];
  setMasterAddresses(updated);
  handleUpdateShop({ masterAddresses: updated });
};

const handleRemoveMasterAddress = (id) => {
  const updated = masterAddresses.filter(a => a.id !== id);
  setMasterAddresses(updated);
  handleUpdateShop({ masterAddresses: updated });
};

const handleMasterAddressTextChange = (id, text) => {
  const updated = masterAddresses.map(a => a.id === id ? { ...a, address: text, coordinates: null, geocodeFailed: false } : a);
  setMasterAddresses(updated);
};

const handleGeocodeMasterAddress = async (id, text) => {
  if (!text.trim()) return;
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(text)}&limit=1`,
      { headers: { 'Accept-Language': 'en', 'User-Agent': 'KalKode/1.0' } }
    );
    const data = await res.json();
    if (!data.length) {
      setMasterAddresses(prev => prev.map(a => a.id === id ? { ...a, geocodeFailed: true } : a));
      return;
    }
    const { lat, lon, display_name } = data[0];
    const coords = { lat: parseFloat(lat), lng: parseFloat(lon), latitude: parseFloat(lat), longitude: parseFloat(lon) };
    const updated = masterAddresses.map(a =>
      a.id === id ? { ...a, address: display_name || text, coordinates: coords } : a
    );
    setMasterAddresses(updated);
    handleUpdateShop({ masterAddresses: updated });
    propagateMasterAddressesToItems(updated);
  } catch (err) {
    console.error('Geocode error:', err);
  }
};

const propagateMasterAddressesToItems = (addresses) => {
  const shopMasterAddresses = addresses
    .filter(a => a.address && a.coordinates)
    .map(a => ({ id: a.id, address: a.address, coordinates: a.coordinates }));

  const updatedItems = (shopData?.items || []).map(item => ({ ...item, shopMasterAddresses }));
  const updatedServices = (shopData?.services || []).map(service => ({ ...service, shopMasterAddresses }));

  setShopData(prev => ({ ...prev, items: updatedItems, services: updatedServices }));

  updatedItems.forEach(item => {
    setChangeQueue(prev => ({
      ...prev,
      items: { ...prev.items, [item.id]: { ...(prev.items[item.id] || {}), shopMasterAddresses, id: item.id } }
    }));
  });

  updatedServices.forEach(service => {
    setChangeQueue(prev => ({
      ...prev,
      services: { ...prev.services, [service.id]: { ...(prev.services[service.id] || {}), shopMasterAddresses, id: service.id } }
    }));
  });

  setHasPendingChanges(true);
};

const handleOpenMapForMasterAddress = (id) => {
  setSelectingLocationFor({ isMasterAddress: true, masterAddrId: id });
  setMapOpen(true);
};

const handleApplyPrimaryAddressToAllItems = () => {
  const valid = masterAddresses.filter(a => a.address && a.coordinates);
  if (valid.length === 0) { alert('Set at least one address first.'); return; }
  propagateMasterAddressesToItems(masterAddresses);
  setAddressesJustApplied(true);
  setTimeout(() => setAddressesJustApplied(false), 2000);
};
// ── End Master Addresses ────────────────────────────────────────────────────

const handleApplyCategoryToSelected = () => {
  if (selectedItemsForUpdate.size === 0) {
    alert('Select at least one item');
    return;
  }

  if (!overlayCategory) {
    alert('Select a category');
    return;
  }
  
  if (shopContentType === 'services') {
    const updatedServices = shopData.services.map(service => 
      selectedItemsForUpdate.has(service.id) 
        ? { ...service, category: overlayCategory }
        : service
    );
    setShopData(prev => ({ ...prev, services: updatedServices }));
    
    // Add to change queue
    selectedItemsForUpdate.forEach(serviceId => {
      setChangeQueue(prev => ({
        ...prev,
        services: {
          ...prev.services,
          [serviceId]: {
            ...(prev.services[serviceId] || {}),
            category: overlayCategory,
            id: serviceId
          }
        }
      }));
    });
  } else {
    const updatedItems = shopData.items.map(item => 
      selectedItemsForUpdate.has(item.id) 
        ? { ...item, category: overlayCategory }
        : item
    );
    setShopData(prev => ({ ...prev, items: updatedItems }));
    
    // Add to change queue
    selectedItemsForUpdate.forEach(itemId => {
      setChangeQueue(prev => ({
        ...prev,
        items: {
          ...prev.items,
          [itemId]: {
            ...(prev.items[itemId] || {}),
            category: overlayCategory,
            id: itemId
          }
        }
      }));
    });
  }
  
  setHasPendingChanges(true);
  
  console.log(`✅ Updated category for ${selectedItemsForUpdate.size} ${shopContentType}`);
  
  // Reset and close
  setShowCategoryOverlay(false);
  setSelectedItemsForUpdate(new Set());
  setSelectedItemsForBulk(new Set()); // Clear bulk selection too
  setOverlayCategory('');
};

const toggleItemSelection = (itemId) => {
  setSelectedItemsForUpdate(prev => {
    const newSet = new Set(prev);
    if (newSet.has(itemId)) {
      newSet.delete(itemId);
    } else {
      newSet.add(itemId);
    }
    return newSet;
  });
};

const selectAllItems = () => {
  const allIds = shopContentType === 'services' 
    ? shopData.services.map(s => s.id)
    : shopData.items.map(i => i.id);
  setSelectedItemsForUpdate(new Set(allIds));
};

const deselectAllItems = () => {
  setSelectedItemsForUpdate(new Set());
};


useEffect(() => {
  const handleClickOutside = (event) => {
    if (showBillingDropdown && !event.target.closest('[class*="BillingDropdown"]')) {
      setShowBillingDropdown(false);
    }
  };

  if (showBillingDropdown) {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }
}, [showBillingDropdown]);

// Load saved focal point on mount
useEffect(() => {
  if (shopData?.profileBackgroundFocalPoint) {
    setProfileBgFocalPoint(shopData.profileBackgroundFocalPoint);
  }
}, [shopData?.profileBackgroundFocalPoint]);

  // ADD this useEffect near your other useEffects to debug:
useEffect(() => {
  console.log('Home sections updated:', homeSections);
}, [homeSections]);

// Also add this to track modal state:
useEffect(() => {
  console.log('Section type modal:', showSectionTypeModal);
}, [showSectionTypeModal]);

  useEffect(() => {
    // Save active tab to sessionStorage whenever it changes
    sessionStorage.setItem('shopPageActiveTab', activeTab);
  }, [activeTab]);

  useEffect(() => {
  if (!shopData) return;
  // Always sync, including down to an empty array — a newly created shop
  // (or one switched to via the shops dropdown) legitimately has zero
  // sections, and skipping the sync on empty left the previously active
  // shop's sections lingering in local state instead of showing blank.
  console.log('🔄 Syncing shopData homeSections with local state');
  setHomeSections(shopData.homeSections || []);
}, [shopData?.homeSections]);

const handleToggleItemVisibility = (itemId, isService = false) => {
  // ✅ ADD: Safety check for shopData
  if (!shopData) {
    console.error('❌ shopData not loaded yet');
    return;
  }
  
  // Check if there's an outstanding balance
  const hasOutstandingBalance = billingData && calculateOutstandingBalance(billingData) > 0;
  
  if (isService) {
    // ✅ ADD: Safety check for services array
    if (!shopData.services || shopData.services.length === 0) {
      console.error('❌ No services found');
      return;
    }
    
    const currentService = shopData.services.find(s => s.id === itemId);
    
    // ✅ ADD: Check if service was found
    if (!currentService) {
      console.error('❌ Service not found:', itemId);
      return;
    }
    
    // Check if trying to make visible but plan doesn't allow it or balance owed
    const svcAllowed = canItemTypeBeVisible(billingData, { ...currentService, isService: true });
    const { visibleTotal } = countVisibleByType(shopData.items || [], shopData.services || []);
    const perms = getPlanPermissions(billingData);
    const atServiceCap = currentService.visible === false && svcAllowed && visibleTotal >= perms.maxVisible;
    if (currentService.visible === false && (hasOutstandingBalance || !svcAllowed || atServiceCap)) {
      let msg;
      if (!svcAllowed) msg = 'Upgrade your plan to post Service cards';
      else if (atServiceCap) msg = `Plan allows up to ${perms.maxVisible} visible card${perms.maxVisible !== 1 ? 's' : ''}. Upgrade to add more.`;
      else msg = 'Payment required to make services visible';
      const openFrom = !svcAllowed || atServiceCap ? 'upgrade' : 'payment';
      setVisibilityToast({ id: itemId, msg, billingPayload: { ...billingData, openFrom } });
      return;
    }

    // Update local state
    setShopData(prev => ({
      ...prev,
      services: prev.services.map(s =>
        s.id === itemId ? { 
          ...s, 
          visible: !s.visible,
          userSetVisibility: !s.visible
        } : s
      )
    }));
    
    // Add to change queue
    setChangeQueue(prev => ({
      ...prev,
      services: {
        ...prev.services,
        [itemId]: {
          ...(prev.services[itemId] || currentService),
          visible: !currentService.visible,
          userSetVisibility: !currentService.visible,
          id: itemId
        }
      }
    }));
    
    setHasPendingChanges(true);
    
    console.log(`🔄 Service visibility toggled: ${currentService.name} → ${!currentService.visible}`);
    
  } else {
    // ✅ ADD: Safety check for items array
    if (!shopData.items || shopData.items.length === 0) {
      console.error('❌ No items found');
      return;
    }
    
    const currentItem = shopData.items.find(i => i.id === itemId);
    
    // ✅ ADD: Check if item was found
    if (!currentItem) {
      console.error('❌ Item not found:', itemId);
      return;
    }
    
    // Check if trying to make visible but plan doesn't allow it or balance owed
    const itemAllowed = canItemTypeBeVisible(billingData, currentItem);
    const { visibleTotal } = countVisibleByType(shopData.items || [], shopData.services || []);
    const prodPerms = getPlanPermissions(billingData);
    const isGig = !!(currentItem.jobType || (currentItem.isService && (currentItem.serviceTab || 'offer') === 'need'));
    const atProductCap = currentItem.visible === false && itemAllowed && !isGig && visibleTotal >= prodPerms.maxVisible;
    if (currentItem.visible === false && (hasOutstandingBalance || !itemAllowed || atProductCap)) {
      let msg;
      if (!itemAllowed) msg = 'Upgrade your plan to make this item visible';
      else if (atProductCap) msg = `Plan allows up to ${prodPerms.maxVisible} visible card${prodPerms.maxVisible !== 1 ? 's' : ''}. Upgrade to add more.`;
      else msg = 'Payment required to make items visible';
      const openFrom = !itemAllowed || atProductCap ? 'upgrade' : 'payment';
      setVisibilityToast({ id: itemId, msg, billingPayload: { ...billingData, openFrom } });
      return;
    }

    // Update local state
    setShopData(prev => ({
      ...prev,
      items: prev.items.map(i =>
        i.id === itemId ? { 
          ...i, 
          visible: !i.visible,
          userSetVisibility: !i.visible
        } : i
      )
    }));
    
    // Add to change queue
    setChangeQueue(prev => ({
      ...prev,
      items: {
        ...prev.items,
        [itemId]: {
          ...(prev.items[itemId] || currentItem),
          visible: !currentItem.visible,
          userSetVisibility: !currentItem.visible,
          id: itemId
        }
      }
    }));
    
    setHasPendingChanges(true);
    
    console.log(`🔄 Item visibility toggled: ${currentItem.name} → ${!currentItem.visible}`);
  }
};


useEffect(() => {
  // Try to get user location WITHOUT automatic permission request
  const getUserLocation = async () => {
    // First, check if geolocation is available
    if (!navigator.geolocation) {
      console.log('Geolocation not supported, using IP-based location');
      await getIPLocation();
      return;
    }
    
    // Check current permission status
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' })
        .then((permissionStatus) => {
          console.log('Geolocation permission status:', permissionStatus.state);
          
          if (permissionStatus.state === 'granted') {
            // Permission already granted, get location
            getHighAccuracyLocation();
          } else if (permissionStatus.state === 'prompt') {
            // Don't request automatically - wait for user to explicitly request
            console.log('Geolocation permission not yet requested');
            // Use IP location as fallback
            getIPLocation();
          } else {
            // Permission denied or not available
            console.log('Geolocation permission denied or not available');
            getIPLocation();
          }
        })
        .catch(() => {
          // Permissions API not supported, use IP location
          console.log('Permissions API not supported, using IP location');
          getIPLocation();
        });
    } else {
      // Permissions API not available, use IP location
      console.log('Permissions API not available, using IP location');
      getIPLocation();
    }
  };

  getUserLocation();
}, []);



// Community posts are loaded by loadShopData (onAuthStateChanged) and loadActiveShop (shop switch)

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentBgIndex((prev) => (prev + 1) % profileBackgroundImages.length);
  }, 9000); // Change image every 9 seconds

  return () => clearInterval(interval);
}, [profileBackgroundImages.length]);



useEffect(() => {
  const checkStripeOnce = async () => {
    if (!auth.currentUser || stripeChecked) return;
    
    try {
      setStripeLoading(true);
      console.log('🔍 Initial Stripe check for user:', auth.currentUser.uid);
      
      // Check Firestore first (fast)
      const shopRef = doc(db, 'shops', auth.currentUser.uid);
      const shopSnap = await getDoc(shopRef);
      
      if (shopSnap.exists()) {
        const data = shopSnap.data();
        setStripeStatus({
          accountId: data.stripeAccountId,
          status: data.stripeAccountStatus,
          chargesEnabled: data.chargesEnabled,
          payoutsEnabled: data.payoutsEnabled,
          stripeReady: data.stripeReady
        });
        console.log('✅ Stripe status from Firestore:', data.stripeAccountStatus);
      } else {
        console.log('📦 No shop document - Stripe not set up');
        setStripeStatus(null);
      }
      
      setStripeChecked(true);
    } catch (error) {
      console.error('❌ Error checking Stripe:', error);
      setStripeStatus(null);
      setStripeChecked(true);
    } finally {
      setStripeLoading(false);
    }
  };
  
  checkStripeOnce();
}, [stripeChecked]);

// Around line 1900, UPDATE:
useEffect(() => {
  if (editingItem || editingPost || editingEvent) {  // CHANGED
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  } else {
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
  }
  
  return () => {
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
  };
}, [editingItem, editingPost, editingEvent]);  // CHANGED

// Handle return from Stripe
useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const stripeParam = urlParams.get('stripe');
  
  if (stripeParam) {
    console.log('🔙 Returned from Stripe:', stripeParam);
    
    if (stripeParam === 'success') {
      setStatusMessage({ 
        type: 'success', 
        text: '⏳ Checking account status...' 
      });
      
      // Wait 2 seconds, then refresh Stripe status
      setTimeout(async () => {
        setStripeChecked(false);
        await manualCheckStripe();
      }, 2000);
      
    } else if (stripeParam === 'refresh') {
      setStatusMessage({ 
        type: 'warning', 
        text: '⚠️ Setup interrupted. Click Connect Stripe to continue.' 
      });
    }
    
    // Clean URL
    window.history.replaceState({}, '', '/shop/manage');
  }
}, []);

// 3. ADD animation keyframes (around line 850, with other styled components)
const profileBgFadeAnimation = `
  @keyframes profileBgFade {
    0%, 100% { opacity: 0; }
    33.33% { opacity: 1; }
    66.66% { opacity: 1; }
  }
`;


const handleAddPost = () => {
  const newPost = {
    id: `post-${Date.now()}`,
    type: 'image',
    images: [null, null, null],
    currentImageIndex: 0,
    caption: '',
    coordinates: null,
    address: '',
    visible: true,
    userSetVisibility: true,
    createdAt: new Date().toISOString()
  };
  
  // ✅ FIX: Add to communityPosts state
  setCommunityPosts(prev => [newPost, ...(prev || [])]);
  
  // ✅ FIX: Add to communityPosts queue (not items)
  setChangeQueue(prev => ({
    ...prev,
    communityPosts: {
      ...prev.communityPosts,
      [newPost.id]: newPost
    }
  }));
  
  setHasPendingChanges(true);
  
  // ✅ FIX: Set editingPost, NOT editingItem
  if (window.innerWidth < 768) {
    setEditingPost({
      ...newPost,
      images: [null, null, null],
      currentImageIndex: 0,
      isCommunityPost: true
    });
  } else {
    setExpandedItems(new Set([newPost.id]));
  }
  
  console.log('✅ New post created - awaiting media upload');
};

const handleAddEvent = () => {
  const newEvent = {
    id: `event-${Date.now()}`,
    type: 'event',
    name: '',
    description: '',
    price: '',
    category: 'Other',
    images: [null, null, null],
    currentImageIndex: 0,
    address: '',
    coordinates: null,
    eventDate: '',
    eventTime: '',
    slots: 1,
    isEvent: true,
    visible: true,
    userSetVisibility: true,
    createdAt: new Date().toISOString()
  };
  
  // ✅ FIX: Add to events state, not items
  setEvents(prev => [newEvent, ...(prev || [])]);
  
  // ✅ FIX: Add to events queue
  setChangeQueue(prev => ({
    ...prev,
    events: {
      ...prev.events,
      [newEvent.id]: newEvent
    }
  }));
  
  setHasPendingChanges(true);
  
  // ✅ FIX: Set editingEvent, NOT editingItem
  if (window.innerWidth < 768) {
    setEditingEvent({
      ...newEvent,
      images: [null, null, null],
      currentImageIndex: 0,
      isEvent: true
    });
  } else {
    setExpandedItems(new Set([newEvent.id]));
  }
  
  console.log('✅ New event created and added to queue');
};

const handleEditEvent = (event) => {
  setEditingItem({
    ...event,
    images: [...event.images],
    currentImageIndex: event.currentImageIndex || 0,
    isEvent: true
  });
};

const handleDeleteEvent = (eventId) => {
  setEvents(prev => prev.filter(e => e.id !== eventId));
  
  setChangeQueue(prev => ({
    ...prev,
    events: {
      ...prev.events,
      [eventId]: { id: eventId, deleted: true }
    }
  }));
  
  setHasPendingChanges(true);
  console.log('🗑️ Event marked for deletion');
};

const handleEventUpdate = (eventId, updates) => {
  console.log('🔄 Queuing event update:', { eventId, updates });
  
  // Update local state
  setEvents(prev =>
    prev.map(event =>
      event.id === eventId ? { ...event, ...updates } : event
    )
  );
  
  // ✅ FIX: Get the current event data to preserve all fields
  const currentEvent = events.find(e => e.id === eventId);
  
  // Add to change queue with all existing data
  setChangeQueue(prev => {
    const updatedQueue = {
      ...prev,
      events: {
        ...prev.events,
        [eventId]: {
          ...(currentEvent || {}), // ✅ Preserve existing event data
          ...(prev.events[eventId] || {}), // ✅ Preserve queued changes
          ...updates, // ✅ Apply new updates
          id: eventId,
          isEvent: true, // ✅ ENSURE isEvent flag is always present
          type: 'event' // ✅ ENSURE type is set
        }
      }
    };
    console.log('📋 Updated events queue:', updatedQueue.events);
    return updatedQueue;
  });
  
  setHasPendingChanges(true);
};

// Load store open/closed state
useEffect(() => {
  if (shopData?.storeOpen !== undefined) {
    setStoreOpen(shopData.storeOpen);
  }
}, [shopData?.storeOpen]);

useEffect(() => {
  setHideFromWelcomePage(shopData?.hideFromWelcomePage === true);
}, [shopData?.hideFromWelcomePage]);

useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const shouldOpenPayment = urlParams.get('openPayment');
  
  if (shouldOpenPayment === 'true' && shopData) {
    // Wait for billing data to load
    setTimeout(() => {
      console.log('💳 Auto-opening payment modal from redirect');
      
      // Trigger payment modal (you'll need to create billingData)
      // This assumes AccountBalanceButton will detect and open
      const button = document.querySelector('[title="View billing tiers"]');
      if (button) {
        button.click();
      }
    }, 1000);
    
    
    // Clean URL
    window.history.replaceState({}, '', '/profile');
  }
}, [shopData]);

// Dynamic tab list for ShopPage (editor view)
const shopTabs = useMemo(
  () => normalizeTabs(shopData?.tabs, shopData?.storeType),
  [shopData?.tabs, shopData?.storeType]
);

// When tab buttons are hidden (Shop Settings toggle), every tab moves into
// the burger/nav-panel menu instead of only the overflow past the first 3 —
// matches ShopPublicView.js so the owner's editor mirrors what visitors see.
const hideHeaderTabButtons = !!shopData?.hideHeaderTabs;
const mainHeaderTabs = hideHeaderTabButtons ? [] : shopTabs.slice(0, 3);

// Contact section is authored once (as a 'contact' home-section, on whichever
// Home tab it was added to) but now shows at the bottom of every tab — not
// just that one Home tab — so it reads as a persistent site footer. Skip the
// footer copy only on the one tab that already renders it inline as part of
// its own ordered section list, so it never shows twice. Matches ShopPublicView.js.
const globalContactSection = useMemo(
  () => (homeSections || []).find(s => s.type === 'contact'),
  [homeSections]
);
const activeTabHasOwnContactSection = useMemo(() => {
  const activeTabObj = shopTabs.find(t => t.id === activeTab);
  if (activeTabObj?.type !== 'home') return false;
  return (homeSections || []).some(s => (s.tabId || 'home') === activeTab && s.type === 'contact');
}, [shopTabs, activeTab, homeSections]);

useEffect(() => {
  // If the active tab doesn't exist on the currently viewed shop (e.g. it was
  // a 4th/5th custom tab and we just switched to a shop that only has the
  // 3 default tabs, or the tab was deleted), fall back to the Shop tab
  // instead of rendering blank.
  if (shopTabs.length > 0 && !shopTabs.some(t => t.id === activeTab)) {
    setActiveTab('shop');
  }
}, [shopTabs, activeTab]);

// Only a Home-type tab whose own first section is the hero banner gets the
// transparent fixed header — every other section (or a Home tab that
// doesn't start with a hero) gets a normal solid header + top clearance.
const heroLeadsActiveHomeTab = useMemo(() => {
  const activeTabObj = shopTabs.find(t => t.id === activeTab);
  if (activeTabObj?.type !== 'home') return false;
  const tabSections = (homeSections || [])
    .filter(s => (s.tabId || 'home') === activeTab)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  return tabSections[0]?.type === 'hero-banner';
}, [shopTabs, activeTab, homeSections]);

// Hide header on scroll down, reveal on scroll up — matches ShopPublicView.js
useEffect(() => {
  const onScroll = () => {
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    const delta = y - lastScrollY.current;
    if (delta > 8 && y > 80) {
      setHeaderHidden(true);
    } else if (delta < -8 || y < 10) {
      setHeaderHidden(false);
    }
    lastScrollY.current = y;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true });
  return () => {
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('scroll', onScroll);
  };
}, []);

// Monitor change queue for debugging
useEffect(() => {
  if (Object.keys(changeQueue.items).length > 0 ||
      Object.keys(changeQueue.services).length > 0 ||
      changeQueue.shopDetails ||
      changeQueue.homeSections ||
      changeQueue.licenses ||
      changeQueue.backgrounds ||
      changeQueue.tabs ||
      changeQueue.storeStatus !== null) {
    
    console.log('📋 CHANGE QUEUE UPDATE:', {
      shopDetails: changeQueue.shopDetails ? '✓ Modified' : '✗',
      items: Object.keys(changeQueue.items).length > 0 ? 
        `${Object.keys(changeQueue.items).length} items` : '✗',
      services: Object.keys(changeQueue.services).length > 0 ? 
        `${Object.keys(changeQueue.services).length} services` : '✗',
      homeSections: changeQueue.homeSections ? 
        `${changeQueue.homeSections.length} sections` : '✗',
      licenses: changeQueue.licenses ? 
        `${changeQueue.licenses.length} licenses` : '✗',
      backgrounds: changeQueue.backgrounds ? 
        `${changeQueue.backgrounds.length} backgrounds` : '✗',
      storeStatus: changeQueue.storeStatus !== null ? 
        changeQueue.storeStatus ? 'OPEN' : 'CLOSED' : '✗',
      totalChanges: getTotalChanges()
    });
    
    // Detailed item changes
    if (Object.keys(changeQueue.items).length > 0) {
      console.log('📦 Item changes:', changeQueue.items);
    }
    
    // Detailed service changes
    if (Object.keys(changeQueue.services).length > 0) {
      console.log('🛠️ Service changes:', changeQueue.services);
    }
    
    // Detailed shop changes
    if (changeQueue.shopDetails) {
      console.log('🏪 Shop details changes:', changeQueue.shopDetails);
    }
  }
}, [changeQueue]);


const handleItemUpdate = (itemId, updates) => {
  console.log('🔄 Queuing item update:', { itemId, updates });
  
  // Update local state immediately
  setShopData(prev => ({
    ...prev,
    items: prev.items.map(item =>
      item.id === itemId ? { ...item, ...updates } : item
    )
  }));
  
  // Add to change queue
  setChangeQueue(prev => {
    const newQueue = {
      ...prev,
      items: {
        ...prev.items,
        [itemId]: {
          ...(prev.items[itemId] || {}),
          ...updates,
          id: itemId
        }
      }
    };
    console.log('📋 Updated queue (items):', newQueue.items);
    return newQueue;
  });
  
  setHasPendingChanges(true);
};

const handleServiceUpdate = (serviceId, updates) => {
  console.log('🔄 Queuing service update:', { serviceId, updates });
  
  // Update local state immediately
  setShopData(prev => ({
    ...prev,
    services: prev.services.map(service =>
      service.id === serviceId ? { ...service, ...updates } : service
    )
  }));
  
  // Add to change queue
  setChangeQueue(prev => {
    const newQueue = {
      ...prev,
      services: {
        ...prev.services,
        [serviceId]: {
          ...(prev.services[serviceId] || {}),
          ...updates,
          id: serviceId
        }
      }
    };
    console.log('📋 Updated queue (services):', newQueue.services);
    return newQueue;
  });
  
  setHasPendingChanges(true);
};

// Cards sharing the currently-edited card's category (used by the mobile edit overlay's swipe nav)
const getEditSiblings = (item) => {
  if (!item || item.isCommunityPost || item.isEvent) return [];
  const isService = !!item.isService;
  const list = isService ? (shopData?.services || []) : (shopData?.items || []);
  const cat = item.category || 'Other';
  return list.filter(x =>
    (x.category || 'Other') === cat &&
    (!isService || (x.serviceTab || 'offer') === (item.serviceTab || 'offer'))
  );
};

const navigateEditingCard = (direction) => {
  if (!editingItem) return;
  const siblings = getEditSiblings(editingItem);
  if (siblings.length < 2) return;
  const isService = !!editingItem.isService;
  const currentId = editingItem.id || editingItem.tempId;
  const idx = siblings.findIndex(x => (x.id || x.tempId) === currentId);
  if (idx === -1) return;
  const nextIdx = (idx + direction + siblings.length) % siblings.length;
  const next = siblings[nextIdx];
  setEditingItem({
    ...next,
    images: [...(next.images || [])],
    currentImageIndex: next.currentImageIndex || 0,
    isService,
  });
};

const handleUpdateShop = (updates) => {
  console.log('🔄 Queuing shop update:', updates);
  
  // Update local state immediately
  setShopData(prev => ({
    ...prev,
    ...updates
  }));
  
  // Add to change queue
  setChangeQueue(prev => {
    const newQueue = {
      ...prev,
      shopDetails: {
        ...(prev.shopDetails || {}),
        ...updates
      }
    };
    console.log('📋 Updated queue (shop details):', newQueue.shopDetails);
    return newQueue;
  });
  
  setHasPendingChanges(true);
};


// Load access data whenever the active shop changes (owners and shared admins)
useEffect(() => {
  if (!activeShopId || !canEditShopCards) { setShopAccessData(null); return; }
  let cancelled = false;
  const loadAccess = async () => {
    setLoadingShareAccess(true);
    try {
      const snap = await getDoc(doc(db, 'shops', activeShopId));
      if (!cancelled && snap.exists()) {
        const d = snap.data();
        setShopAccessData({ sharedUserMap: d.sharedUserMap || {}, pendingInvites: d.pendingInvites || [] });
      }
    } catch (e) { console.error('Error loading share access:', e); }
    finally { if (!cancelled) setLoadingShareAccess(false); }
  };
  loadAccess();
  return () => { cancelled = true; };
}, [activeShopId, canEditShopCards]); // eslint-disable-line react-hooks/exhaustive-deps

const handleShareInvite = async () => {
  const email = shareEmail.trim().toLowerCase();
  if (!email || !email.includes('@')) { setShareError('Enter a valid email address.'); return; }
  setShareLoading(true); setShareError(''); setShareSuccess('');
  try {
    const shopRef = doc(db, 'shops', activeShopId);
    const shopSnap = await getDoc(shopRef);
    if (!shopSnap.exists()) throw new Error('Shop not found.');
    const sd = shopSnap.data();
    if (Object.values(sd.sharedUserMap || {}).some(e => e.email === email) ||
        (sd.pendingInvites || []).some(i => i.email === email)) {
      setShareError('This email already has access or a pending invite.');
      return;
    }
    const inviteRecord = { email, role: shareRole, addedAt: new Date().toISOString(), addedBy: auth.currentUser.uid };
    const inviterName = sd.name || auth.currentUser?.displayName || 'A store owner';
    // Always write pending first (resolved on their next login if not found now)
    await updateDoc(shopRef, { pendingInvites: arrayUnion(inviteRecord), pendingInviteEmails: arrayUnion(email) });
    // Try to promote immediately if user already exists
    const usersSnap = await getDocs(query(collection(db, 'users'), where('email', '==', email)));
    if (!usersSnap.empty) {
      const targetUid = usersSnap.docs[0].id;
      await updateDoc(shopRef, {
        [`sharedUserMap.${targetUid}`]: { email, role: shareRole, addedAt: inviteRecord.addedAt, addedBy: auth.currentUser.uid },
        pendingInvites: arrayRemove(inviteRecord),
        pendingInviteEmails: arrayRemove(email)
      });
      await updateDoc(doc(db, 'users', targetUid), {
        shopAccess: arrayUnion({ shopId: activeShopId, shopName: sd.name || 'Shop' })
      });
      // Send in-app notification + email (existing user)
      try {
        const { default: NS } = await import('../../services/NotificationService');
        await NS.createNotification(targetUid, {
          type: 'shop_access', subType: 'access_granted',
          title: `You've been added to ${sd.name || 'a shop'}`,
          message: `You can now manage ${sd.name || 'this shop'} from your shop tab.`,
          actionUrl: `/shop/${auth.currentUser.uid}`, priority: 'high',
          sendEmail: true,
          shopName: sd.name || 'Shop',
          inviterName,
          role: shareRole
        });
      } catch (_) {}
      setShareSuccess(`✅ ${email} now has access to this shop.`);
    } else {
      // No account yet — send invitation email directly to the address
      try {
        await fetch('/api/send-notification', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            directEmail: email,
            notification: {
              subType: 'access_granted',
              shopName: sd.name || 'Shop',
              inviterName,
              role: shareRole,
              isNewUser: true
            }
          })
        });
      } catch (_) {}
      setShareSuccess(`📧 Invite sent to ${email}. They'll get access after signing in.`);
    }
    setShareEmail(''); setShareRole('staff');
    const updatedSnap = await getDoc(shopRef);
    if (updatedSnap.exists()) {
      const d = updatedSnap.data();
      setShopAccessData({ sharedUserMap: d.sharedUserMap || {}, pendingInvites: d.pendingInvites || [] });
    }
    reloadShopAccess();
  } catch (err) { setShareError('Failed: ' + err.message); }
  finally { setShareLoading(false); }
};

const handleRemoveShareUser = async (targetUid, targetEmail) => {
  if (!window.confirm(`Remove ${targetEmail}'s access?`)) return;
  try {
    const shopRef = doc(db, 'shops', activeShopId);
    const { deleteField } = await import('firebase/firestore');
    await updateDoc(shopRef, { [`sharedUserMap.${targetUid}`]: deleteField() });
    const targetSnap = await getDoc(doc(db, 'users', targetUid));
    if (targetSnap.exists()) {
      const entry = (targetSnap.data().shopAccess || []).find(a => a.shopId === activeShopId);
      if (entry) await updateDoc(doc(db, 'users', targetUid), { shopAccess: arrayRemove(entry) });
    }
    setShopAccessData(prev => { const m = { ...prev.sharedUserMap }; delete m[targetUid]; return { ...prev, sharedUserMap: m }; });
    reloadShopAccess();
  } catch (err) { alert('Failed to remove: ' + err.message); }
};

const handleCancelShareInvite = async (invite) => {
  if (!window.confirm(`Cancel invite for ${invite.email}?`)) return;
  try {
    await updateDoc(doc(db, 'shops', activeShopId), { pendingInvites: arrayRemove(invite), pendingInviteEmails: arrayRemove(invite.email) });
    setShopAccessData(prev => ({ ...prev, pendingInvites: prev.pendingInvites.filter(i => i.email !== invite.email) }));
  } catch (err) { alert('Failed to cancel: ' + err.message); }
};

const handleRemoveShop = async (shop, e) => {
  e.stopPropagation();
  const uid = auth.currentUser?.uid;
  if (!uid || removingShopId) return;

  // Primary shop (shopId === uid) cannot be deleted
  if (shop.isOwn && shop.shopId === uid) {
    alert('Your primary shop cannot be deleted.');
    return;
  }

  const isOwned = shop.isOwn === true;
  const shopLabel = shop.shopName || 'this shop';
  const msg = isOwned
    ? `Delete "${shopLabel}" permanently? All items, services, and shared access will be removed. This cannot be undone.`
    : `Leave "${shopLabel}"? You will lose access immediately.`;

  if (!window.confirm(msg)) return;
  setRemovingShopId(shop.shopId);

  try {
    if (isOwned) {
      // Clear the top-level items/services mirror before the shop doc goes
      // away — its delete rule checks ownerId against the shop doc, so this
      // has to happen first or it'd be denied once the doc no longer exists.
      // Without this, the deleted shop's items/services keep showing on the
      // welcome page forever (getFeaturedItemsFromCollection reads the mirror).
      try {
        await mirrorItemsFull(shop.shopId, [], {});
        await mirrorServicesFull(shop.shopId, [], {});
      } catch (_) {}

      // Delete the shop document and billing doc
      await deleteDoc(doc(db, 'shops', shop.shopId));
      try { await deleteDoc(doc(db, 'billing', shop.shopId)); } catch (_) {}

      // Remove from user's ownedShops (read first to get exact stored object)
      const userSnap = await getDoc(doc(db, 'users', uid));
      if (userSnap.exists()) {
        const owned = (userSnap.data().ownedShops || []).find(o => o.shopId === shop.shopId);
        if (owned) await updateDoc(doc(db, 'users', uid), { ownedShops: arrayRemove(owned) });
      }
    } else {
      // Remove this user's entry from the shop's sharedUserMap
      await updateDoc(doc(db, 'shops', shop.shopId), {
        [`sharedUserMap.${uid}`]: deleteField(),
      });

      // Remove from user's shopAccess reverse-lookup
      const userSnap = await getDoc(doc(db, 'users', uid));
      if (userSnap.exists()) {
        const entry = (userSnap.data().shopAccess || []).find(a => a.shopId === shop.shopId);
        if (entry) await updateDoc(doc(db, 'users', uid), { shopAccess: arrayRemove(entry) });
      }
    }

    // If the removed shop was active, fall back to primary shop
    if (activeShopId === shop.shopId) setActiveShop(uid);

    reloadShopAccess();
    setShowShopsDropdown(false);
  } catch (err) {
    console.error('Failed to remove shop:', err);
    alert('Failed to remove shop: ' + err.message);
  } finally {
    setRemovingShopId(null);
  }
};

const handleChangeShareRole = async (targetUid, newRole) => {
  try {
    await updateDoc(doc(db, 'shops', activeShopId), { [`sharedUserMap.${targetUid}.role`]: newRole });
    setShopAccessData(prev => ({
      ...prev,
      sharedUserMap: { ...prev.sharedUserMap, [targetUid]: { ...prev.sharedUserMap[targetUid], role: newRole } }
    }));
    reloadShopAccess();
  } catch (err) { alert('Failed to change role: ' + err.message); }
};

// Load todos in real-time for all users with active shop access
useEffect(() => {
  if (!activeShopId) { setTodoItems([]); return; }
  const unsub = onSnapshot(doc(db, 'shops', activeShopId), snap => {
    if (snap.exists()) setTodoItems(snap.data().shopTodos || []);
  });
  return () => unsub();
}, [activeShopId]);

const handleAddTodo = async () => {
  if (!newTodoText.trim() || !activeShopId || todoSaving) return;
  setTodoSaving(true);
  const newItem = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    text: newTodoText.trim(),
    done: false,
    claimedBy: null,
    createdAt: new Date().toISOString(),
  };
  try {
    await updateDoc(doc(db, 'shops', activeShopId), { shopTodos: [...todoItems, newItem] });
    setNewTodoText('');
  } catch (e) { console.error(e); }
  setTodoSaving(false);
};

const handleToggleTodo = async (item) => {
  if (!activeShopId) return;
  const updated = todoItems.map(t => t.id === item.id ? { ...t, done: !t.done } : t);
  await updateDoc(doc(db, 'shops', activeShopId), { shopTodos: updated });
};

const handleDeleteTodo = async (item) => {
  if (!activeShopId) return;
  const updated = todoItems.filter(t => t.id !== item.id);
  await updateDoc(doc(db, 'shops', activeShopId), { shopTodos: updated });
};

const handleClaimTodo = async (item) => {
  if (!activeShopId || !auth.currentUser) return;
  const me = auth.currentUser;
  const claimedBy = item.claimedBy?.uid === me.uid ? null : {
    uid: me.uid,
    displayName: me.displayName || me.email || 'Unknown',
  };
  const updated = todoItems.map(t => t.id === item.id ? { ...t, claimedBy } : t);
  await updateDoc(doc(db, 'shops', activeShopId), { shopTodos: updated });
};

const initNewShopCreation = async () => {
  if (!newShopName.trim() || isCreatingShop) return;
  setIsCreatingShop(true);
  try {
    const { collection, doc: fsDoc, setDoc: fsSetDoc, updateDoc: fsUpdateDoc, arrayUnion } = await import('firebase/firestore');
    const { db: fsDb } = await import('../../firebase/config');
    const { generateUsername } = await import('../../firebase/firebaseService');

    const newShopRef = fsDoc(collection(fsDb, 'shops'));
    const username = await generateUsername(newShopName.trim());
    const shopName = newShopName.trim();

    // Create the shop immediately as active — opening fee is tracked via billing
    await fsSetDoc(newShopRef, {
      name: shopName,
      username,
      ownerId: auth.currentUser.uid,
      items: [],
      services: [],
      createdAt: new Date().toISOString(),
      theme: shopData?.theme || DEFAULT_THEME,
      homeSections: [],
      storeStatus: 'active',
      isSubShop: true,
      // Explicit so the public page's plan gating doesn't treat this the
      // same as a legacy shop whose plan was never mirrored — new sub-shops
      // start Free until their own billing doc says otherwise.
      plan: 'free',
    });

    // Create billing doc — $50 opening fee shows as outstanding immediately
    await fsSetDoc(fsDoc(fsDb, 'billing', newShopRef.id), {
      userId: newShopRef.id,
      ownerId: auth.currentUser.uid,
      totalSales: 0,
      paymentHistory: { paidMilestoneFees: [], payments: [] },
      itemsHiddenDueToBalance: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });

    // Register shop in the user's ownedShops list
    await fsUpdateDoc(fsDoc(fsDb, 'users', auth.currentUser.uid), {
      ownedShops: arrayUnion({ shopId: newShopRef.id, shopName })
    });

    setShowNewShopModal(false);
    setNewShopName('');
    reloadShopAccess();
    setActiveShop(newShopRef.id);
  } catch (err) {
    console.error('Error creating shop:', err);
  } finally {
    setIsCreatingShop(false);
  }
};

// Add near the top of ShopPage component (around line 1000)
const checkShopNameAvailability = async (newName, currentUsername) => {
  try {
    const { generateUsername, usernameExists } = await import('../../firebase/firebaseService');
    // Exclude this shop's own doc from the "is it taken" check — otherwise
    // renaming "Issa Wrap" -> "issa wrap" (same normalized username) sees its
    // own existing username and wrongly thinks it's taken by someone else.
    const excludeShopId = activeShopId || auth.currentUser.uid;
    const proposedUsername = await generateUsername(newName, excludeShopId);

    console.log('🔍 Checking username availability:', {
      newName,
      currentUsername,
      proposedUsername
    });

    // If the proposed username is the same as current, it's available
    if (proposedUsername === currentUsername) {
      console.log('✅ Username unchanged');
      return {
        available: true,
        username: proposedUsername,
        changed: false
      };
    }

    // Check if the new username is taken
    const isTaken = await usernameExists(proposedUsername, excludeShopId);

    return {
      available: !isTaken,
      username: proposedUsername,
      isTaken,
      changed: proposedUsername !== currentUsername
    };
  } catch (error) {
    console.error('Error checking username availability:', error);
    return { available: false, error: error.message };
  }
};

const handleReset = () => {
  if (!originalShopData) return;
  
  console.log('🔄 Resetting to original data...');
  
  // Reset to original data
  setShopData(JSON.parse(JSON.stringify(originalShopData)));
  
  // Reset licenses separately
  setLicenses(originalShopData.licenses || []);
  
  // Reset home sections
  setHomeSections(originalShopData.homeSections || []);
  
  // Reset backgrounds
  setProfileBackgroundImages(originalShopData.profileBackgroundImages || []);
  
  // Reset store status
  setStoreOpen(originalShopData.storeOpen !== undefined ? originalShopData.storeOpen : true);
  
  // ✅ FIXED: Reset community posts and events
  setCommunityPosts(originalShopData.communityPosts || []);
  setEvents(originalShopData.events || []);
  
  // Clear change queue completely
  setChangeQueue({
    shopDetails: null,
    items: {},
    services: {},
    homeSections: null,
    communityPosts: {}, // ✅ ALREADY CORRECT
    events: {},         // ✅ ALREADY CORRECT
    licenses: null,
    backgrounds: null,
    storeStatus: null
  });
  
  setHasPendingChanges(false);
  setTempFileStorage({});
  
  console.log('✅ All changes discarded - queue cleared');
};

const getIPLocation = async () => {
  try {
    console.log('Getting IP-based location...');

    const geoDbResponse = await fetch('https://geolocation-db.com/json/');
    if (geoDbResponse.ok) {
      const data = await geoDbResponse.json();
      if (data.latitude && data.longitude) {
        setUserLocation({
          latitude: parseFloat(data.latitude),
          longitude: parseFloat(data.longitude),
          city: data.city,
          country_name: data.country_name,
          source: 'geolocation-db',
          accuracy: 100000
        });
        console.log('IP location from geolocation-db:', data);
        return;
      }
    }
    
    // Final fallback: Use default location
    console.log('All IP location services failed, using default location');
    setUserLocation({
      latitude: 29.7604, // Houston default
      longitude: -95.3698,
      source: 'default',
      accuracy: 999999
    });
    
  } catch (error) {
    console.error('Error getting IP location:', error);
    // Use default location
    setUserLocation({
      latitude: 29.7604,
      longitude: -95.3698,
      source: 'default-fallback',
      accuracy: 999999
    });
  }
};

const getHighAccuracyLocation = () => {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      setUserLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
        source: 'gps'
      });
      console.log('GPS location obtained:', {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        accuracy: position.coords.accuracy + 'm'
      });
    },
    (error) => {
      console.error('Error getting GPS location:', error);
      // Fallback to IP location
      getIPLocation();
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    }
  );
};

const handleMediaUpload = async (itemId, imageIndex, file, isPost = false, isEvent = false) => {
  try {
    const isVideo = file.type.startsWith('video/');
    const isImage = file.type.startsWith('image/');
    
    if (!isImage && !isVideo) {
      alert('Please upload an image or video file');
      return;
    }
    
    if (isEvent && isVideo) {
      alert('Events can only have images, not videos');
      return;
    }
    
    // Validate
    if (isVideo) {
      await validateVideoFile(file);
    } else {
      validateImageFile(file, 20);
    }
    
    setCompressionProgress({
      text: isVideo ? 'Processing video...' : 'Compressing image...',
      percent: 0
    });

    let compressedFile;
    if (isVideo) {
      compressedFile = await compressCommunityClip(file, (progress) => {
        setCompressionProgress({
          text: progress < 30 ? 'Processing video...' :
                progress < 80 ? 'Compressing...' : 'Almost done...',
          percent: progress
        });
      });
    } else {
      // Mirrors bulk upload: image compression is a size optimization, not a
      // hard requirement — a failure falls back to the original file instead
      // of blocking the upload with an error (video is left as a hard failure
      // above; an uncompressed clip risks blowing past Storage/size limits).
      try {
        compressedFile = await compressCommunityImage(file, (progress) => {
          setCompressionProgress({
            text: 'Compressing image...',
            percent: progress
          });
        });
      } catch (compressErr) {
        console.warn('⚠️ Compression failed, using original file uncompressed:', compressErr);
        compressedFile = file;
      }
    }

    setCompressionProgress(null);
    
    // Store file in tempFileStorage
    const storageKey = isPost ? `community-${itemId}-${imageIndex}` : 
                       isEvent ? `event-${itemId}-${imageIndex}` :
                       `${itemId}-${imageIndex}`;
    const metadataKey = `${storageKey}-metadata`;
    
    setTempFileStorage(prev => ({
      ...prev,
      [storageKey]: compressedFile,
      [metadataKey]: { isVideo, type: compressedFile.type }
    }));

    // Create preview
    const preview = await readFileAsDataURL(compressedFile);
    const mediaData = {
      preview,
      type: compressedFile.type,
      isVideo
    };

    if (isPost) {
        // Update local state
        setCommunityPosts(prev => 
          prev.map(p => {
            if (p.id === itemId) {
              const currentImages = p.images || [null, null, null];
              const newImages = [...currentImages];
              newImages[imageIndex] = mediaData;
              return {
                ...p,
                images: newImages,
                type: isVideo ? 'clip' : 'image'
              };
            }
            return p;
          })
        );

        // ✅ FIX: Update change queue with complete data
        setChangeQueue(prev => {
          const currentPost = communityPosts.find(p => p.id === itemId);
          const currentImages = currentPost?.images || [null, null, null];
          const newImages = [...currentImages];
          newImages[imageIndex] = mediaData;
          
          return {
            ...prev,
            communityPosts: {
              ...prev.communityPosts,
              [itemId]: {
                ...(prev.communityPosts[itemId] || currentPost || {}),
                id: itemId,
                images: newImages,
                type: isVideo ? 'clip' : 'image'
              }
            }
          };
        });
      } else if (isEvent) {
        // Update local state
        setEvents(prev =>
          prev.map(e => {
            if (e.id === itemId) {
              const currentImages = e.images || [null, null, null];
              const newImages = [...currentImages];
              newImages[imageIndex] = mediaData;
              return {
                ...e,
                images: newImages
              };
            }
            return e;
          })
        );

        // ✅ FIX: Update change queue with complete data
        setChangeQueue(prev => {
          const currentEvent = events.find(e => e.id === itemId);
          const currentImages = currentEvent?.images || [null, null, null];
          const newImages = [...currentImages];
          newImages[imageIndex] = mediaData;
          
          return {
            ...prev,
            events: {
              ...prev.events,
              [itemId]: {
                ...(prev.events[itemId] || currentEvent || {}),
                id: itemId,
                images: newImages
              }
            }
          };
        });
      }

      setHasPendingChanges(true);

    console.log('✅ Media preview set, will upload on save');
  } catch (error) {
    console.error('❌ Error handling media:', error);
    setCompressionProgress(null);
    setStatusMessage({ type: 'error', text: error.message || 'Failed to process media' });
    setTimeout(() => setStatusMessage(null), 5000);
  }
};

const handleCommunityPostUpdate = (postId, updates) => {
  console.log('🔄 Queuing community post update:', { postId, updates });
  
  // Update local state
  setCommunityPosts(prev =>
    prev.map(post =>
      post.id === postId ? { ...post, ...updates } : post
    )
  );
  
  // ✅ FIX: Get current post data to preserve all fields
  const currentPost = communityPosts.find(p => p.id === postId);
  
  // Add to change queue with all existing data
  setChangeQueue(prev => ({
    ...prev,
    communityPosts: {
      ...prev.communityPosts,
      [postId]: {
        ...(currentPost || {}),  // ✅ Preserve existing post data
        ...(prev.communityPosts[postId] || {}),  // ✅ Preserve queued changes
        ...updates,  // ✅ Apply new updates
        id: postId,
        type: (updates.type && updates.type !== 'post') ? updates.type : (prev.communityPosts[postId]?.type || currentPost?.type || 'image'),
        isCommunityPost: true  // ✅ ADD FLAG
      }
    }
  }));
  
  setHasPendingChanges(true);
};

// 4. UPDATE handleDeleteCommunityPost to use queue
const handleDeleteCommunityPost = (postId) => {
  // Remove from local state
  setCommunityPosts(prev => prev.filter(p => p.id !== postId));
  
  // Mark as deleted in queue
  setChangeQueue(prev => ({
    ...prev,
    communityPosts: {
      ...prev.communityPosts,
      [postId]: { id: postId, deleted: true }
    }
  }));
  
  setHasPendingChanges(true);
  console.log('🗑️ Community post marked for deletion');
};


// NEW: Single apply and save handler
const handleApplyAndSaveBackgrounds = async () => {
  const validImages = tempBackgroundImages.filter(img => img !== null);
  
  if (validImages.length === 0) {
    AlertCircle('Please add at least one background image');
    return;
  }

  try {
    setSaving(true);
    console.log('💾 Applying and saving background images...');

    // Step 1: Delete old Firebase Storage images that are being replaced
    const oldFirebaseUrls = profileBackgroundImages.filter(
      img => img && typeof img === 'string' && img.startsWith('https://firebasestorage.googleapis.com')
    );

    if (oldFirebaseUrls.length > 0) {
      console.log('🗑️ Deleting old background images from storage...');
      await Promise.all(
        oldFirebaseUrls.map(async (url) => {
          try {
            // Extract the file path from the URL
            const urlObj = new URL(url);
            const pathMatch = urlObj.pathname.match(/\/o\/(.+?)(\?|$)/);
            if (pathMatch) {
              const filePath = decodeURIComponent(pathMatch[1]);
              const fileRef = ref(storage, filePath);
              await deleteObject(fileRef);
              console.log('✅ Deleted old background:', filePath);
            }
          } catch (error) {
            console.warn('⚠️ Could not delete old background:', error);
            // Continue even if deletion fails
          }
        })
      );
    }

    // Step 2: Upload new backgrounds to Firebase
    const uploadedBackgrounds = await Promise.all(
      validImages.map(async (img, index) => {
        if (!img) return null;
        
        // If already a Firebase URL, keep it
        if (typeof img === 'string' && img.startsWith('https://firebasestorage.googleapis.com')) {
          console.log('✅ Keeping existing Firebase URL:', img.substring(0, 100) + '...');
          return img;
        }
        
        // If it's a data URL, upload it
        if (typeof img === 'string' && img.startsWith('data:')) {
          try {
            setCompressionProgress({ 
              text: `Compressing image ${index + 1}/${validImages.length}...`, 
              percent: 0 
            });
            
            // Convert to file
            const response = await fetch(img);
            const blob = await response.blob();
            const file = new File([blob], `bg-${Date.now()}-${index}.jpg`, { type: 'image/jpeg' });
            
            // CHANGED: Use compressProductImage instead of compressProfileImage
            // compressProductImage maintains rectangular aspect ratio
            const compressedFile = await compressProductImage(file, (progress) => {
              setCompressionProgress({ 
                text: `Compressing image ${index + 1}/${validImages.length}...`, 
                percent: progress 
              });
            });
            
            setCompressionProgress({ 
              text: `Uploading image ${index + 1}/${validImages.length}...`, 
              percent: 50 
            });
            
            // Upload to Firebase with timestamp to ensure uniqueness
            const storageRef = ref(
              storage,
              `shops/${activeShopId || auth.currentUser.uid}/backgrounds/bg-${Date.now()}-${index}`
            );
            
            const snapshot = await uploadBytes(storageRef, compressedFile, {
              contentType: compressedFile.type,
              cacheControl: 'public, max-age=31536000',
              customMetadata: { ownerId: auth.currentUser.uid }
            });
            
            const downloadUrl = await getDownloadURL(snapshot.ref);
            console.log('✅ Background uploaded:', downloadUrl.substring(0, 100) + '...');
            
            setCompressionProgress(null);
            return downloadUrl;
          } catch (error) {
            console.error('❌ Error uploading background:', error);
            setCompressionProgress(null);
            return img; // Keep original if upload fails
          }
        }
        
        return img;
      })
    );

    // Filter out nulls
    const finalBackgrounds = uploadedBackgrounds.filter(img => img !== null);

    console.log('💾 Saving to Firestore:', {
      old: profileBackgroundImages.length,
      new: finalBackgrounds.length
    });

    // Step 3: Update Firestore immediately
    const shopRef = doc(db, 'shops', activeShopId || auth.currentUser.uid);
    await updateDoc(shopRef, {
      profileBackgroundImages: finalBackgrounds,
      updatedAt: new Date().toISOString()
    });

    // Step 4: Update all local state
    setProfileBackgroundImages(finalBackgrounds);
    setCurrentBgIndex(0); // Reset to first image
    
    setShopData(prev => ({
      ...prev,
      profileBackgroundImages: finalBackgrounds
    }));

    // Update original data to match (no unsaved changes)
    setOriginalShopData(prev => ({
      ...prev,
      profileBackgroundImages: finalBackgrounds
    }));

    // Close drawer — keep the slots showing what was just applied instead of
    // reverting to empty placeholders (they'll reseed from profileBackgroundImages
    // next time the drawer opens anyway).
    setShowBgDrawer(false);
    setTempBackgroundImages(finalBackgrounds);

    console.log('✅ Backgrounds applied and saved successfully');
    console.log('📸 New backgrounds:', finalBackgrounds);
    
  } catch (error) {
    console.error('❌ Error saving backgrounds:', error);
    AlertCircle('Failed to save backgrounds. Please try again.');
  } finally {
    setSaving(false);
    setCompressionProgress(null);
  }
};

// UPDATE handleRemoveBackgroundImage
const handleRemoveBackgroundImage = (index) => {
  const newImages = [...tempBackgroundImages];
  newImages[index] = null;
  setTempBackgroundImages(newImages);
};

const handleAddBackgroundImage = (index) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.onchange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      validateImageFile(file, 20);
    } catch (err) {
      alert(err.message || 'Invalid image file.');
      return;
    }
    // Compress before generating the preview, same as every other image
    // upload path — was doing FileReader.readAsDataURL directly on the raw
    // file (no cap, no compression), then re-fetching that data URL back into
    // a blob to compress it at save time anyway (see handleApplyAndSaveBackgrounds).
    let compressedFile;
    try {
      compressedFile = await compressProductImage(file);
    } catch (err) {
      console.warn('⚠️ Compression failed, using original file uncompressed:', err);
      compressedFile = file;
    }
    try {
      const preview = await readFileAsDataURL(compressedFile);
      const newImages = [...tempBackgroundImages];
      newImages[index] = preview;
      setTempBackgroundImages(newImages);
    } catch (err) {
      console.error('Failed to read background image:', err);
      setStatusMessage({ type: 'error', text: err.message || 'Failed to process image. Please try again.' });
      setTimeout(() => setStatusMessage(null), 5000);
    }
  };
  input.click();
};

const manualCheckStripe = async () => {
  if (!auth.currentUser) return;
  
  try {
    setStripeLoading(true);
    console.log('🔄 Manual Stripe status check');
    
    const response = await fetch('/api/check-connect-account', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: auth.currentUser.uid })
    });
    
    if (response.ok) {
      const result = await response.json();
      console.log('✅ API check result:', result);
      
      if (result.found) {
        setStripeStatus({
          accountId: result.accountId,
          status: result.status,
          chargesEnabled: result.chargesEnabled,
          payoutsEnabled: result.payoutsEnabled,
          stripeReady: result.stripeReady
        });
        
        if (result.status === 'active') {
          setStatusMessage({ 
            type: 'success', 
            text: '✅ Stripe account is active!' 
          });
        } else if (result.status === 'pending_verification') {
          setStatusMessage({ 
            type: 'warning', 
            text: '⏳ Account under review (1-2 business days)' 
          });
        }
      } else {
        setStripeStatus(null);
        setStatusMessage({ 
          type: 'warning', 
          text: '⚠️ No Stripe account found' 
        });
      }
    }
  } catch (error) {
    console.error('❌ Manual check error:', error);
    setStatusMessage({ 
      type: 'error', 
      text: 'Failed to check status' 
    });
  } finally {
    setStripeLoading(false);
  }
};

const handleUseSolidColor = () => {
  // Use theme accent color as solid background
  const solidColor = shopData?.theme?.colors?.accentGradient || 
                     'linear-gradient(45deg, #800000, #4A0404)';
  setProfileBackgroundImages([solidColor]);
  setCurrentBgIndex(0);
};

// ADD save handler for community posts
const handleSaveCommunityPost = async (post) => {
  try {
    const postData = {
      type: post.type,
      contentUrl: post.contentUrl,
      caption: post.caption || '',
      coordinates: post.coordinates || null
    };
    
    const savedPost = await saveCommunityPost(auth.currentUser.uid, postData);
    
    // Update local state
    setCommunityPosts(prev => 
      prev.map(p => p.tempId === post.tempId ? savedPost : p)
    );
    
    setEditingItem(null);
    console.log('✅ Community post saved');
  } catch (error) {
    console.error('Error saving post:', error);
    AlertCircle('Failed to save post');
  }
};

useEffect(() => {
  if (shopData?.licenses) {
    setLicenses(shopData.licenses);
    setChangeQueue(prev => ({
  ...prev,
  licenses: shopData.licenses
}));
setHasPendingChanges(true);
  }
}, [shopData?.licenses]);

// Add this handler function (around line 1280, near other handlers)
const handleLicenseUpload = async (file) => {
  try {
    setUploadingLicense(true);
    
    // Validate file
    if (!file.type.startsWith('image/')) {
      AlertCircle('Please upload an image file');
      return;
    }
    
    validateImageFile(file, 20); // 20MB max

    // Show compression progress
    setCompressionProgress({
      text: 'Compressing license image...',
      percent: 0
    });

    // Mirrors bulk upload: compression is a size optimization, not a hard
    // requirement — a failure falls back to the original file instead of
    // blocking the upload with an error.
    let compressedFile;
    try {
      compressedFile = await compressProductImage(file, (progress) => {
        setCompressionProgress({
          text: 'Compressing license image...',
          percent: progress
        });
      });
    } catch (compressErr) {
      console.warn('⚠️ Compression failed, using original file uncompressed:', compressErr);
      compressedFile = file;
    }

    setCompressionProgress(null);

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      const newLicense = {
        id: `license-${Date.now()}`,
        file: compressedFile,
        preview: reader.result,
        name: file.name,
        uploadedAt: new Date().toISOString()
      };
      
      setLicenses(prev => [...prev, newLicense]);
      setChangeQueue(prev => ({
  ...prev,
  licenses: [...(licenses || []), newLicense]
}));
setHasPendingChanges(true);
      console.log('✅ License added, will upload on save');
    };
    reader.readAsDataURL(compressedFile);
    
  } catch (error) {
    console.error('❌ License upload error:', error);
    AlertCircle(error.message || 'Failed to process license image');
    setCompressionProgress(null);
  } finally {
    setUploadingLicense(false);
  }
};

const handleDeleteLicense = (licenseId) => {
  setLicenses(prev => prev.filter(license => license.id !== licenseId));
  setChangeQueue(prev => ({
  ...prev,
  licenses: prev.licenses || licenses.filter(license => license.id !== licenseId)
}));
setHasPendingChanges(true);
  console.log('🗑️ License deleted, changes will save on next save');
};

const [selectedLicense, setSelectedLicense] = useState(null);

const renderTabManager = () => {
  const accent = shopData?.theme?.colors?.accent || '#800000';
  const surface = shopData?.theme?.colors?.surface || '#1a1a1a';
  const text = shopData?.theme?.colors?.text || '#ffffff';
  const bg = shopData?.theme?.colors?.background || '#000000';

  const tabs = shopTabs;

  const updateTabs = (newTabs) => {
    const reindexed = newTabs.map((t, i) => ({ ...t, order: i }));
    setShopData(prev => ({ ...prev, tabs: reindexed }));
    setChangeQueue(prev => ({ ...prev, tabs: reindexed }));
    setHasPendingChanges(true);
  };

  const moveTab = (idx, dir) => {
    const arr = [...tabs];
    const target = idx + dir;
    if (target < 0 || target >= arr.length) return;
    [arr[idx], arr[target]] = [arr[target], arr[idx]];
    updateTabs(arr);
  };

  const toggleVisible = (id) => {
    const target = tabs.find(t => t.id === id);
    if (!target) return;
    const currentlyVisible = target.visible !== false;
    if (!currentlyVisible) {
      const visibleCount = tabs.filter(t => t.visible !== false).length;
      if (!canAddOrShowTab(billingData, visibleCount)) {
        setShowUnlockTabsModal(true);
        return;
      }
    }
    updateTabs(tabs.map(t => t.id === id ? { ...t, visible: !currentlyVisible } : t));
  };

  const renameTab = (id, label) =>
    updateTabs(tabs.map(t => t.id === id ? { ...t, label } : t));

  const changeIcon = (id, icon) =>
    updateTabs(tabs.map(t => t.id === id ? { ...t, icon } : t));

  const changeType = (id, type) =>
    updateTabs(tabs.map(t => t.id === id ? { ...t, type } : t));

  const addTab = () => {
    const visibleCount = tabs.filter(t => t.visible !== false).length;
    if (!canAddOrShowTab(billingData, visibleCount)) {
      setShowUnlockTabsModal(true);
      return;
    }
    updateTabs([...tabs, {
      id: `tab_${Date.now()}`,
      label: 'New Tab',
      icon: 'Grid',
      type: 'community',
      visible: true,
      order: tabs.length,
    }]);
  };

  const deleteTab = (id) => {
    if (CORE_TAB_IDS.includes(id)) return;
    updateTabs(tabs.filter(t => t.id !== id));
  };

  const TYPE_LABELS = { home: 'Home Page', catalog: 'Catalog', community: 'Profile' };

  return (
    <div style={{
      background: 'rgba(255,255,255,0.03)',
      border: `1px solid ${accent}22`,
      borderRadius: '10px',
      padding: '0.85rem',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <h3 style={{ margin: 0, color: accent, fontSize: '1rem', fontWeight: '700' }}>
          Navigation Tabs
        </h3>
        <button
          onClick={addTab}
          style={{
            background: accent, color: '#fff', border: 'none',
            padding: '0.4rem 0.9rem', borderRadius: '8px',
            cursor: 'pointer', fontSize: '0.8rem', fontWeight: '700',
            display: 'flex', alignItems: 'center', gap: '0.35rem',
          }}
        >
          <Plus size={13} /> Add Tab
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {tabs.map((tab, idx) => {
          const isCore = CORE_TAB_IDS.includes(tab.id);
          return (
            <div
              key={tab.id}
              style={{
                display: 'flex', flexDirection: 'column', gap: '0.4rem',
                background: `${bg}60`, borderRadius: '10px',
                padding: '0.6rem 0.75rem',
                border: `1px solid ${accent}18`,
                opacity: tab.visible === false ? 0.5 : 1,
              }}
            >
              {/* Row 1: reorder + icon + label */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {/* Reorder */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flexShrink: 0 }}>
                  <button onClick={() => moveTab(idx, -1)} disabled={idx === 0}
                    style={{ background: 'transparent', border: 'none', color: text, cursor: 'pointer', padding: '1px', opacity: idx === 0 ? 0.25 : 0.7, lineHeight: 1 }}>
                    <ChevronUp size={13} />
                  </button>
                  <button onClick={() => moveTab(idx, 1)} disabled={idx === tabs.length - 1}
                    style={{ background: 'transparent', border: 'none', color: text, cursor: 'pointer', padding: '1px', opacity: idx === tabs.length - 1 ? 0.25 : 0.7, lineHeight: 1 }}>
                    <ChevronDown size={13} />
                  </button>
                </div>

                {/* Icon picker */}
                <select
                  value={tab.icon || 'Store'}
                  onChange={e => changeIcon(tab.id, e.target.value)}
                  style={{
                    background: surface, border: `1px solid ${accent}30`,
                    color: text, borderRadius: '6px', padding: '0.25rem 0.3rem',
                    fontSize: '0.72rem', cursor: 'pointer', width: '80px', flexShrink: 0,
                  }}
                >
                  {TAB_ICON_OPTIONS.map(name => (
                    <option key={name} value={name}>{name}</option>
                  ))}
                </select>

                {/* Label */}
                <input
                  value={tab.label}
                  onChange={e => renameTab(tab.id, e.target.value)}
                  style={{
                    flex: 1, minWidth: 0, background: 'transparent', border: `1px solid ${accent}25`,
                    borderRadius: '6px', padding: '0.3rem 0.5rem',
                    color: text, fontSize: '0.85rem', outline: 'none',
                  }}
                />
              </div>

              {/* Row 2: type + visible toggle + delete */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', justifyContent: 'flex-end' }}>
                {/* Type badge / selector */}
                {isCore ? (
                  <span style={{
                    fontSize: '0.62rem', color: accent, fontWeight: '700',
                    padding: '0.12rem 0.45rem', borderRadius: '20px',
                    border: `1px solid ${accent}40`, whiteSpace: 'nowrap', opacity: 0.8,
                  }}>
                    {TYPE_LABELS[tab.type] || tab.type}
                  </span>
                ) : (
                  <select
                    value={tab.type}
                    onChange={e => changeType(tab.id, e.target.value)}
                    style={{
                      background: surface, border: `1px solid ${accent}40`,
                      color: accent, borderRadius: '6px',
                      padding: '0.12rem 0.3rem', fontSize: '0.62rem',
                      fontWeight: '700', cursor: 'pointer',
                    }}
                  >
                    <option value="home">Home</option>
                    <option value="catalog">Catalog</option>
                    <option value="community">Profile</option>
                  </select>
                )}

                {/* Visible toggle */}
                <button
                  onClick={() => toggleVisible(tab.id)}
                  title={tab.visible !== false ? 'Hide from public' : 'Show to public'}
                  style={{
                    background: tab.visible !== false ? `${accent}20` : 'transparent',
                    border: `1px solid ${accent}40`,
                    color: tab.visible !== false ? accent : `${text}40`,
                    borderRadius: '6px', padding: '0.25rem 0.5rem',
                    cursor: 'pointer', fontSize: '0.68rem', fontWeight: '700', whiteSpace: 'nowrap',
                  }}
                >
                  {tab.visible !== false ? 'Shown' : 'Hidden'}
                </button>

                {/* Delete (custom tabs only) */}
                {!isCore && (
                  <button
                    onClick={() => deleteTab(tab.id)}
                    style={{
                      background: 'transparent', border: `1px solid rgba(239,68,68,0.4)`,
                      color: '#ef4444', borderRadius: '6px',
                      padding: '0.25rem 0.4rem', cursor: 'pointer',
                    }}
                    title="Delete tab"
                  >
                    <Trash2 size={13} />
                  </button>
                )}
              </div>{/* end row 2 */}
            </div>
          );
        })}
      </div>

      <p style={{ margin: '0.75rem 0 0', fontSize: '0.72rem', color: `${text}50`, textAlign: 'center' }}>
        Changes save with the Save button above
      </p>
    </div>
  );
};

const renderProfileView = () => {
  const filteredPosts = communityPosts.filter(post => {
    if (post.deleted) return false;
    if (communityContentType === 'images') return post.type === 'image';
    if (communityContentType === 'clips') return post.type === 'clip';
    return false;
  });

  return (
    <>
      {/* Profile Header Section - Updated Layout with Left Shift */}
      <FadeInBlock style={{
        background: `${shopData?.theme?.colors?.surface}30`,
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        border: `1px solid ${shopData?.theme?.colors?.accent}30`,
        padding: '5rem 1rem',
        marginBottom: '2rem',
        maxWidth: '935px',
        margin: '0 auto 2rem',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'auto 1fr',
          gap: '2rem',
          alignItems: 'center'
        }}>
          {/* LEFT COLUMN: Profile Picture - Centered */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: window.innerWidth <= 768 ? 'auto' : '200px',
            padding: window.innerWidth <= 768 ? '0' : '1rem'
          }}>
            {/* Profile Picture */}
            <div style={{
              width: window.innerWidth <= 768 ? '120px' : '180px',
              height: window.innerWidth <= 768 ? '120px' : '180px',
              borderRadius: '50%',
              overflow: 'hidden',
              background: `${shopData?.theme?.colors?.background}50`,
              border: `3px solid ${shopData?.theme?.colors?.accent}`,
              boxShadow: `0 0 20px ${shopData?.theme?.colors?.accent}40`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onClick={openProfilePictureUpload}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
            >
              {shopData?.profile ? (
                typeof shopData.profile === 'string' ? (
                  <img 
                    src={shopData.profile} 
                    alt="Profile" 
                    style={{ 
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                ) : shopData.profile.preview ? (
                  <img 
                    src={shopData.profile.preview} 
                    alt="Profile Preview" 
                    style={{ 
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                ) : null
              ) : (
                <div style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: `${shopData?.theme?.colors?.accent}20`,
                  gap: '0.5rem'
                }}>
                  <Plus size={window.innerWidth <= 768 ? 30 : 40} color={shopData?.theme?.colors?.accent} />
                  <span style={{
                    fontSize: '0.7rem',
                    color: shopData?.theme?.colors?.accent,
                    fontWeight: '600'
                  }}>
                    Add Photo
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* RIGHT COLUMN: Profile Info & Stats - Shifted Left by 2 inches */}
          <div style={{
            flex: 1,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            gap: '1.5rem',
            marginLeft: window.innerWidth <= 768 ? '0' : '-55px',
            paddingRight: window.innerWidth <= 768 ? '0' : '100px'
          }}>
            {/* Username */}
            <h2 style={{
              fontSize: window.innerWidth <= 768 ? '1.5rem' : '2rem',
              fontWeight: '300',
              color: shopData?.theme?.colors?.text,
              fontFamily: shopData?.theme?.fonts?.body,
              margin: 0
            }}>
              {shopData?.name || 'username'}
            </h2>

            {/* Stats Row - Instagram Style */}
            <div style={{
              display: 'flex',
              gap: window.innerWidth <= 768 ? '2rem' : '3rem',
              justifyContent: 'center'
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  color: shopData?.theme?.colors?.text
                }}>
                  {communityPosts?.length || 0}
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: shopData?.theme?.colors?.text,
                  opacity: 0.7
                }}>
                  posts
                </div>
              </div>
              
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  color: shopData?.theme?.colors?.text
                }}>
                  {shopData?.followers?.length || 0}
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: shopData?.theme?.colors?.text,
                  opacity: 0.7
                }}>
                  followers
                </div>
              </div>

              <div style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  color: shopData?.theme?.colors?.text
                }}>
                  {shopData?.following?.length || 0}
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: shopData?.theme?.colors?.text,
                  opacity: 0.7
                }}>
                  following
                </div>
              </div>
            </div>

          </div>
        </div>
      </FadeInBlock>

      {/* Licenses & Permits Section - Collapsible & Mobile Friendly */}
      <div style={{
        maxWidth: '935px',
        margin: '0 auto 2rem',
        padding: '0 1rem'
      }}>
        <div style={{
          background: `${shopData?.theme?.colors?.surface}30`,
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
          border: `1px solid ${shopData?.theme?.colors?.accent}30`,
          overflow: 'hidden',
          transition: 'all 0.3s ease'
        }}>
          {/* Collapsible Header */}
          <div 
            onClick={() => setLicensesExpanded(!licensesExpanded)}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: 'clamp(1rem, 2vw, 1.5rem)',
              cursor: 'pointer',
              borderBottom: licensesExpanded ? `1px solid ${shopData?.theme?.colors?.accent}30` : 'none',
              transition: 'all 0.3s ease',
              background: licensesExpanded ? `${shopData?.theme?.colors?.accent}05` : 'transparent'
            }}
            onMouseEnter={(e) => {
              if (!licensesExpanded) {
                e.currentTarget.style.background = `${shopData?.theme?.colors?.accent}10`;
              }
            }}
            onMouseLeave={(e) => {
              if (!licensesExpanded) {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'clamp(0.5rem, 1vw, 1rem)'
            }}>
              <h3 style={{
                margin: 0,
                color: shopData?.theme?.colors?.accent,
                fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                fontWeight: '600'
              }}>
                📋 Licenses & Permits
              </h3>
              {licenses.length > 0 && (
                <span style={{
                  background: shopData?.theme?.colors?.accent,
                  color: 'white',
                  padding: '0.25rem 0.5rem',
                  borderRadius: '12px',
                  fontSize: 'clamp(0.7rem, 1.5vw, 0.75rem)',
                  fontWeight: '600',
                  minWidth: '24px',
                  textAlign: 'center'
                }}>
                  {licenses.length}
                </span>
              )}
            </div>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'clamp(0.5rem, 1vw, 1rem)'
            }}>
              {/* Add License Button */}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const input = document.createElement('input');
                  input.type = 'file';
                  input.accept = 'image/*';
                  input.onchange = (e) => {
                    if (e.target.files?.[0]) {
                      handleLicenseUpload(e.target.files[0]);
                    }
                  };
                  input.click();
                }}
                disabled={uploadingLicense}
                style={{
                  background: shopData?.theme?.colors?.accent,
                  color: 'white',
                  border: 'none',
                  padding: 'clamp(0.5rem, 1.5vw, 0.6rem) clamp(0.75rem, 2vw, 1.2rem)',
                  borderRadius: '8px',
                  cursor: uploadingLicense ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'clamp(0.25rem, 0.5vw, 0.5rem)',
                  fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)',
                  fontWeight: '600',
                  opacity: uploadingLicense ? 0.6 : 1,
                  transition: 'all 0.3s ease',
                  whiteSpace: 'nowrap'
                }}
                onMouseEnter={(e) => {
                  if (!uploadingLicense) {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = `0 4px 12px ${shopData?.theme?.colors?.accent}60`;
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                {uploadingLicense ? (
                  <>
                    <LoadingSpinner />
                    <span style={{ display: window.innerWidth <= 480 ? 'none' : 'inline' }}>Uploading...</span>
                  </>
                ) : (
                  <>
                    <Plus size={window.innerWidth <= 480 ? 14 : 16} />
                    <span style={{ display: window.innerWidth <= 480 ? 'none' : 'inline' }}>Add License</span>
                  </>
                )}
              </button>
              
              {/* Chevron Icon */}
              <div style={{
                color: shopData?.theme?.colors?.accent,
                transition: 'transform 0.3s ease',
                transform: licensesExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                display: 'flex',
                alignItems: 'center'
              }}>
                <ChevronDown size={window.innerWidth <= 480 ? 18 : 20} />
              </div>
            </div>
          </div>
          
          {/* Collapsible Content */}
          <div style={{
            maxHeight: licensesExpanded ? '2000px' : '0',
            opacity: licensesExpanded ? 1 : 0,
            overflow: 'hidden',
            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
          }}>
            <div style={{
              padding: 'clamp(1rem, 2vw, 1.5rem)'
            }}>
              {licenses.length > 0 ? (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: window.innerWidth <= 768 
                    ? 'repeat(3, 1fr)'
                    : 'repeat(auto-fill, minmax(200px, 1fr))',
                  gap: 'clamp(0.5rem, 1vw, 1rem)'
                }}>
                  {licenses.map((license) => (
                    <div
                      key={license.id}
                      style={{
                        position: 'relative',
                        aspectRatio: '1',
                        borderRadius: window.innerWidth <= 480 ? '6px' : '8px',
                        overflow: 'hidden',
                        border: `1px solid ${shopData?.theme?.colors?.accent}30`,
                        background: `${shopData?.theme?.colors?.surface}50`,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.02)';
                        e.currentTarget.style.borderColor = shopData?.theme?.colors?.accent;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.borderColor = `${shopData?.theme?.colors?.accent}30`;
                      }}
                      onClick={() => setSelectedLicense(license)}
                    >
                      <img
                        src={typeof license === 'string' ? license : 
                             license.url || license.preview}
                        alt="License"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                      
                      {/* Delete button */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          if (window.confirm('Delete this license?')) {
                            handleDeleteLicense(license.id);
                          }
                        }}
                        style={{
                          position: 'absolute',
                          top: 'clamp(0.25rem, 1vw, 0.5rem)',
                          right: 'clamp(0.25rem, 1vw, 0.5rem)',
                          background: 'rgba(0, 0, 0, 0.8)',
                          border: `1px solid ${shopData?.theme?.colors?.accent}`,
                          borderRadius: '50%',
                          width: 'clamp(22px, 5vw, 28px)',
                          height: 'clamp(22px, 5vw, 28px)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          color: '#ff4444',
                          transition: 'all 0.2s ease',
                          zIndex: 2
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#ff4444';
                          e.currentTarget.style.color = 'white';
                          e.currentTarget.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(0, 0, 0, 0.8)';
                          e.currentTarget.style.color = '#ff4444';
                          e.currentTarget.style.transform = 'scale(1)';
                        }}
                      >
                        <X size={window.innerWidth <= 480 ? 11 : 14} />
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{
                  textAlign: 'center',
                  padding: 'clamp(2rem, 4vw, 3rem) clamp(1rem, 2vw, 2rem)',
                  color: shopData?.theme?.colors?.text,
                  opacity: 0.6
                }}>
                  <div style={{
                    width: 'clamp(50px, 10vw, 60px)',
                    height: 'clamp(50px, 10vw, 60px)',
                    margin: '0 auto clamp(0.75rem, 1.5vw, 1rem)',
                    borderRadius: '50%',
                    background: `${shopData?.theme?.colors?.accent}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Package size={window.innerWidth <= 480 ? 24 : 30} style={{ color: shopData?.theme?.colors?.accent }} />
                  </div>
                  <p style={{ 
                    fontSize: 'clamp(0.85rem, 2vw, 0.95rem)', 
                    marginBottom: '0.5rem',
                    lineHeight: 1.5
                  }}>
                    No licenses or permits uploaded yet
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Replace the tabs and content section with: */}
      <div style={{ maxWidth: '935px', margin: '0 auto' }}>
        <ProfileContent
          theme={shopData?.theme}
          posts={(communityPosts || []).filter(p => !p.deleted)}
          events={(events || []).filter(e => !e.deleted)}
          onAddPost={handleAddPost}
          onAddEvent={handleAddEvent}
          onEditPost={(post) => {
            console.log('✏️ Edit post triggered:', post);
            setEditingPost({  // CHANGED from setEditingItem
              ...post,
              images: post.images || [null, null, null],
              currentImageIndex: post.currentImageIndex || 0,
              isCommunityPost: true
            });
          }}
          onEditEvent={(event) => {
            console.log('✏️ Edit event triggered:', event);
            setEditingEvent({  // CHANGED from setEditingItem
              ...event,
              images: event.images || [null, null, null],
              currentImageIndex: event.currentImageIndex || 0,
              isEvent: true
            });
          }}

          onDeletePost={handleDeleteCommunityPost}
          onDeleteEvent={handleDeleteEvent}
          onPostUpdate={handleCommunityPostUpdate}
          onEventUpdate={handleEventUpdate}
          expandedItems={expandedItems}
          toggleItemExpansion={toggleItemExpansion}
          handleMediaUpload={handleMediaUpload}
          MobileItemCard={MobileItemCard}
          MobileItemImageContainer={MobileItemImageContainer}
          MobileItemContent={MobileItemContent}
          MobileDeleteButton={MobileDeleteButton}
          DesktopItemCard={DesktopItemCard}
          ItemImageContainer={ItemImageContainer}
          ItemContent={ItemContent}
          DeleteButton={DeleteButton}
          ValidatedEditableText={ValidatedEditableText}
          AddressInput={AddressInput}
          CategorySelect={CategorySelect}
          handleOpenMapForSelection={handleOpenMapForSelection}
        />

      </div>

      {/* License Fullscreen Modal */}
      {selectedLicense && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.95)',
            backdropFilter: 'blur(10px)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            animation: 'fadeIn 0.3s ease'
          }}
          onClick={() => setSelectedLicense(null)}
        >
          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              
              @keyframes zoomIn {
                from { 
                  opacity: 0;
                  transform: scale(0.8);
                }
                to { 
                  opacity: 1;
                  transform: scale(1);
                }
              }
            `}
          </style>
          
          {/* Close button */}
          <button
            onClick={() => setSelectedLicense(null)}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              background: 'rgba(0, 0, 0, 0.8)',
              border: `2px solid ${shopData?.theme?.colors?.accent}`,
              borderRadius: '50%',
              width: '48px',
              height: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: shopData?.theme?.colors?.accent,
              transition: 'all 0.3s ease',
              zIndex: 10000
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = shopData?.theme?.colors?.accent;
              e.currentTarget.style.color = 'white';
              e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(0, 0, 0, 0.8)';
              e.currentTarget.style.color = shopData?.theme?.colors?.accent;
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <X size={24} />
          </button>
          
          {/* License Image */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              position: 'relative',
              animation: 'zoomIn 0.3s ease'
            }}
          >
            <img
              src={typeof selectedLicense === 'string' ? selectedLicense : 
                   selectedLicense.url || selectedLicense.preview}
              alt="License"
              style={{
                maxWidth: '100%',
                maxHeight: '90vh',
                objectFit: 'contain',
                borderRadius: '8px',
                border: `2px solid ${shopData?.theme?.colors?.accent}`,
                boxShadow: `0 0 40px ${shopData?.theme?.colors?.accent}60`
              }}
            />
            
            {/* License name */}
            {selectedLicense.name && (
              <div style={{
                position: 'absolute',
                bottom: '-3rem',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'rgba(0, 0, 0, 0.9)',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                color: shopData?.theme?.colors?.text,
                fontSize: '0.9rem',
                fontWeight: '600',
                whiteSpace: 'nowrap',
                border: `1px solid ${shopData?.theme?.colors?.accent}40`
              }}>
                {selectedLicense.name}
              </div>
            )}
          </div>
        </div>
      )}

      {/* POST EDIT MODAL - ADD HERE */}
{editingPost && (
  <EditModal onClick={() => setEditingPost(null)}>
    <EditModalContent
      theme={shopData?.theme}
      onClick={(e) => e.stopPropagation()}
    >
      <ImageActionButtons theme={shopData?.theme}>
        <ImageActionButton 
  className="check"
  onClick={() => {
    const processedImages = editingPost.images.map((img) => {
      if (typeof img === 'string') return img;
      if (!img) return null;
      if (img?.preview) return img.preview;
      if (img instanceof File) return URL.createObjectURL(img);
      return img;
    });

    const newTempStorage = { ...tempFileStorage };
    editingPost.images.forEach((img, index) => {
      const fileToStore = img instanceof File ? img : img?.file;
      if (fileToStore instanceof File) {
        const key = `community-${editingPost.id}-${index}`;
        newTempStorage[key] = fileToStore;

        // ✅ ADD: Store metadata for video detection
        const metadataKey = `${key}-metadata`;
        newTempStorage[metadataKey] = {
          isVideo: fileToStore.type.startsWith('video/'),
          type: fileToStore.type
        };
      }
    });
    setTempFileStorage(newTempStorage);

    handleCommunityPostUpdate(editingPost.id, {
      ...editingPost,
      images: processedImages,
      caption: editingPost.caption || editingPost.name || '',
      address: editingPost.address,
      coordinates: editingPost.coordinates,
      type: editingPost.type || 'image',
      isCommunityPost: true  // ✅ ADD THIS
    });

    setEditingPost(null);
  }}
  title="Save changes"
>
          <Check size={20} />
        </ImageActionButton>

        <ImageActionButton
          className="close"
          onClick={() => setEditingPost(null)}
          title="Discard changes"
        >
          <X size={20} />
        </ImageActionButton>
      </ImageActionButtons>
        
      <EditModalScrollContent theme={shopData?.theme}>
        <EditModalImageSection theme={shopData?.theme}>
          <ItemImageContainer theme={shopData?.theme} style={{ height: '100%', minHeight: '300px' }}>
            {uploading[editingPost.id] && (
              <UploadingOverlay>
                <LoadingSpinner />
              </UploadingOverlay>
            )}
            <div
              className="image-container"
              onClick={(e) => {
                // ✅ CHANGED: Allow click even if image exists to replace it
                if (!e.target.closest('.carousel-arrow') && !e.target.closest('.add-image')) {
                  document.getElementById(`modal-post-upload-${editingPost.id}-${editingPost.currentImageIndex}`).click();
                }
              }}
              style={{ cursor: 'pointer' }}
            >
              {editingPost.images[editingPost.currentImageIndex] ? (
                typeof editingPost.images[editingPost.currentImageIndex] === 'string' ? (
                  isVideoUrl(editingPost.images[editingPost.currentImageIndex]) ? (
                    <video
                      src={editingPost.images[editingPost.currentImageIndex]}
                      loop
                      muted
                      playsInline
                      autoPlay
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <img
                      src={editingPost.images[editingPost.currentImageIndex]}
                      alt="Post"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  )
                ) : editingPost.images[editingPost.currentImageIndex]?.preview ? (
                  editingPost.images[editingPost.currentImageIndex]?.isVideo ? (
                    <video
                      src={editingPost.images[editingPost.currentImageIndex].preview}
                      loop
                      muted
                      playsInline
                      autoPlay
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <img
                      src={editingPost.images[editingPost.currentImageIndex].preview}
                      alt="Post"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  )
                ) : null
              ) : (
                <div className="placeholder">
                  <Plus size={24} />
                  <span>Upload Image or Video</span>
                </div>
              )}
            </div>
            
            {/* ✅ ADD: Show carousel arrows if there are images */}
            {editingPost.images.filter(img => img).length > 0 && (
              <>
                <button 
                  className="carousel-arrow left"
                  onClick={(e) => {
                    e.stopPropagation();
                    const newIndex = ((editingPost.currentImageIndex - 1) + 3) % 3;
                    setEditingPost({ ...editingPost, currentImageIndex: newIndex });
                  }}
                >
                  <ChevronLeft size={16} />
                </button>
                <button 
                  className="carousel-arrow right"
                  onClick={(e) => {
                    e.stopPropagation();
                    const newIndex = (editingPost.currentImageIndex + 1) % 3;
                    setEditingPost({ ...editingPost, currentImageIndex: newIndex });
                  }}
                >
                  <ChevronRight size={16} />
                </button>
              </>
            )}

            {/* ✅ ADD: Delete current image button (X on top right) */}
            {editingPost.images[editingPost.currentImageIndex] && (
              <button 
                className="add-image"
                onClick={(e) => {
                  e.stopPropagation();
                  const newImages = [...editingPost.images];
                  newImages[editingPost.currentImageIndex] = null;
                  setEditingPost({ ...editingPost, images: newImages });
                }}
                title="Remove this image"
              >
                <X size={16} />
              </button>
            )}

            {/* ✅ ADD: Upload button (Plus icon on bottom right) - shows ALWAYS */}
            <button 
              className="add-image"
              onClick={(e) => {
                e.stopPropagation();
                document.getElementById(`modal-post-upload-${editingPost.id}-${editingPost.currentImageIndex}`).click();
              }}
              style={{
                bottom: '10px',
                right: '10px',
                top: 'auto'
              }}
              title="Add/Replace image"
            >
              <Plus size={16} />
            </button>

            <input
              type="file"
              id={`modal-post-upload-${editingPost.id}-${editingPost.currentImageIndex}`}
              accept="image/*,video/*"
              style={{ display: 'none' }}
              onChange={async (e) => {
                const file = e.target.files?.[0];
                // Reset immediately so re-selecting the same file (a very likely
                // retry on mobile, since it's usually the most recent camera roll
                // photo) reliably fires onChange again instead of silently no-op'ing.
                e.target.value = '';
                if (!file) return;
                const isVideo = file.type.startsWith('video/');
                let fileToUse = file;
                try {
                  if (isVideo) {
                    await validateVideoFile(file);
                  } else {
                    validateImageFile(file, 20);
                    // Mirrors bulk upload: compression is a size optimization, not
                    // a hard requirement — a failure falls back to the original file.
                    try {
                      fileToUse = await compressCommunityImage(file);
                    } catch (compressErr) {
                      console.warn('⚠️ Compression failed, using original file uncompressed:', compressErr);
                    }
                  }
                  const preview = await readFileAsDataURL(fileToUse);
                  const newImages = [...editingPost.images];
                  newImages[editingPost.currentImageIndex] = {
                    file: fileToUse,
                    preview,
                    type: fileToUse.type,
                    name: fileToUse.name,
                    isVideo
                  };
                  setEditingPost({ ...editingPost, images: newImages });
                } catch (err) {
                  console.error('❌ Error handling post media:', err);
                  alert(err.message || 'Invalid media file.');
                  return;
                }
              }}
            />
          </ItemImageContainer>
        </EditModalImageSection>

        <EditModalBody>
          <ValidatedEditableText
            value={editingPost.caption || editingPost.name || ''}
            onChange={(value) => setEditingPost({ ...editingPost, caption: value, name: value })}
            placeholder="Caption"
            multiline
            theme={shopData?.theme}
          />

          <AddressInput
            address={editingPost.address || ''}
            onAddressChange={(value) => setEditingPost({ 
              ...editingPost, 
              address: value
            })}
            onLocationSelect={(location) => {
              if (location?.coordinates) {
                setEditingPost({
                  ...editingPost,
                  address: location.address,
                  coordinates: location.coordinates
                });
              }
            }}
            onMapOpen={() => handleOpenMapForSelection(editingPost.id, false, false)}
          />
        </EditModalBody>
      </EditModalScrollContent>
    </EditModalContent>
  </EditModal>
)}

      {/* EVENT EDIT MODAL - ADD HERE */}
      {editingEvent && (
        <EditModal onClick={() => setEditingEvent(null)}>
          <EditModalContent
            theme={shopData?.theme}
            onClick={(e) => e.stopPropagation()}
          >
            <ImageActionButtons theme={shopData?.theme}>
              <ImageActionButton 
  className="check"
  onClick={() => {
    const processedImages = editingEvent.images.map((img) => {
      if (typeof img === 'string') return img;
      if (!img) return null;
      if (img?.preview) return img.preview;
      if (img instanceof File) return URL.createObjectURL(img);
      return img;
    });

    const newTempStorage = { ...tempFileStorage };
    editingEvent.images.forEach((img, index) => {
      const fileToStore = img instanceof File ? img : img?.file;
      if (fileToStore instanceof File) {
        const key = `event-${editingEvent.id}-${index}`;
        newTempStorage[key] = fileToStore;
      }
    });
    setTempFileStorage(newTempStorage);

    handleEventUpdate(editingEvent.id, {
      ...editingEvent,
      images: processedImages,
      name: editingEvent.name,
      price: editingEvent.price,
      description: editingEvent.description,
      category: editingEvent.category,
      eventDate: editingEvent.eventDate,
      eventTime: editingEvent.eventTime,
      address: editingEvent.address,
      coordinates: editingEvent.coordinates,
      slots: editingEvent.slots,
      isEvent: true,  // ✅ ADD THIS
      type: 'event'   // ✅ ADD THIS
    });
    
    setEditingEvent(null);
  }}
  title="Save changes"
>
  <Check size={20} />
</ImageActionButton>

              <ImageActionButton
                className="close"
                onClick={() => setEditingEvent(null)}
                title="Discard changes"
              >
                <X size={20} />
              </ImageActionButton>
            </ImageActionButtons>
              
            <EditModalScrollContent theme={shopData?.theme}>
              <EditModalImageSection theme={shopData?.theme}>
                <ItemImageContainer theme={shopData?.theme} style={{ height: '100%', minHeight: '300px' }}>
                  {uploading[editingEvent.id] && (
                    <UploadingOverlay>
                      <LoadingSpinner />
                    </UploadingOverlay>
                  )}
                  <div 
                    className="image-container"
                    onClick={(e) => {
                      if (!e.target.closest('.carousel-arrow')) {
                        document.getElementById(`modal-event-upload-${editingEvent.id}-${editingEvent.currentImageIndex}`).click();
                      }
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {editingEvent.images[editingEvent.currentImageIndex] ? (
                      typeof editingEvent.images[editingEvent.currentImageIndex] === 'string' ? (
                        <img
                          src={editingEvent.images[editingEvent.currentImageIndex]}
                          alt="Event"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : editingEvent.images[editingEvent.currentImageIndex]?.preview ? (
                        <img
                          src={editingEvent.images[editingEvent.currentImageIndex].preview}
                          alt="Event"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : null
                    ) : (
                      <div className="placeholder">
                        <Plus size={24} />
                        <span>Upload Image</span>
                      </div>
                    )}
                  </div>
                  
                  {editingEvent.images.filter(img => img).length > 0 && (
                    <>
                      <button 
                        className="carousel-arrow left"
                        onClick={(e) => {
                          e.stopPropagation();
                          const newIndex = ((editingEvent.currentImageIndex - 1) + 3) % 3;
                          setEditingEvent({ ...editingEvent, currentImageIndex: newIndex });
                        }}
                      >
                        <ChevronLeft size={16} />
                      </button>
                      <button 
                        className="carousel-arrow right"
                        onClick={(e) => {
                          e.stopPropagation();
                          const newIndex = (editingEvent.currentImageIndex + 1) % 3;
                          setEditingEvent({ ...editingEvent, currentImageIndex: newIndex });
                        }}
                      >
                        <ChevronRight size={16} />
                      </button>
                    </>
                  )}

                  {editingEvent.images[editingEvent.currentImageIndex] && (
                    <button 
                      className="add-image"
                      onClick={(e) => {
                        e.stopPropagation();
                        const newImages = [...editingEvent.images];
                        newImages[editingEvent.currentImageIndex] = null;
                        setEditingEvent({ ...editingEvent, images: newImages });
                      }}
                    >
                      <X size={16} />
                    </button>
                  )}

                  <input
                    type="file"
                    id={`modal-event-upload-${editingEvent.id}-${editingEvent.currentImageIndex}`}
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      // Reset immediately so re-selecting the same file reliably
                      // fires onChange again on mobile instead of silently no-op'ing.
                      e.target.value = '';
                      if (file) {
                        try {
                          validateImageFile(file, 20);
                        } catch (err) {
                          alert(err.message || 'Invalid image file.');
                          return;
                        }
                        // Mirrors bulk upload: compression is a size optimization,
                        // not a hard requirement — a failure falls back to the
                        // original file instead of blocking the upload.
                        let compressedFile = file;
                        try {
                          compressedFile = await compressProductImage(file);
                        } catch (compressErr) {
                          console.warn('⚠️ Compression failed, using original file uncompressed:', compressErr);
                        }
                        try {
                          const preview = await readFileAsDataURL(compressedFile);
                          const newImages = [...editingEvent.images];
                          newImages[editingEvent.currentImageIndex] = {
                            file: compressedFile,
                            preview,
                            type: compressedFile.type,
                            name: compressedFile.name
                          };
                          setEditingEvent({ ...editingEvent, images: newImages });
                        } catch (err) {
                          console.error('❌ Error handling event image:', err);
                          setStatusMessage({ type: 'error', text: err.message || 'Failed to process image. Please try again.' });
                          setTimeout(() => setStatusMessage(null), 5000);
                        }
                      }
                    }}
                  />
                </ItemImageContainer>
              </EditModalImageSection>
                
              <EditModalBody>
                <ValidatedEditableText
                  value={editingEvent.name}
                  onChange={(value) => setEditingEvent({ ...editingEvent, name: value })}
                  placeholder="Event Name"
                  theme={shopData?.theme}
                  showClearButton={true}
                />

                <ValidatedEditableText
                  value={editingEvent.price}
                  onChange={(value) => setEditingEvent({ ...editingEvent, price: value })}
                  placeholder="Price (optional)"
                  theme={shopData?.theme}
                  showClearButton={true}
                  showCurrencySelector={true}
                  currencyValue={shopData?.currency || 'USD'}
                  onCurrencyChange={(code) => handleUpdateShop({ currency: code })}
                />

                <ValidatedEditableText
                  value={editingEvent.description}
                  onChange={(value) => setEditingEvent({ ...editingEvent, description: value })}
                  placeholder="Event Description"
                  multiline
                  theme={shopData?.theme}
                  showClearButton={true}
                />

                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    color: shopData?.theme?.colors?.text,
                    fontSize: '0.85rem',
                    opacity: 0.8
                  }}>
                    Event Date
                  </label>
                  <input
                    type="date"
                    value={editingEvent.eventDate || ''}
                    onChange={(e) => setEditingEvent({ ...editingEvent, eventDate: e.target.value })}
                    style={{
                      width: '100%',
                      background: shopData?.theme?.colors?.background || '#1a1a1a',
                      border: `1px solid color-mix(in srgb, ${shopData?.theme?.colors?.accent} 40%, transparent)`,
                      borderRadius: '8px',
                      padding: '0.75rem',
                      color: shopData?.theme?.colors?.text || '#ffffff',
                      colorScheme: 'dark',
                      fontSize: '0.9rem'
                    }}
                  />
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    color: shopData?.theme?.colors?.text,
                    fontSize: '0.85rem',
                    opacity: 0.8
                  }}>
                    Event Time
                  </label>
                  <input
                    type="time"
                    value={editingEvent.eventTime || ''}
                    onChange={(e) => setEditingEvent({ ...editingEvent, eventTime: e.target.value })}
                    style={{
                      width: '100%',
                      background: shopData?.theme?.colors?.background || '#1a1a1a',
                      border: `1px solid color-mix(in srgb, ${shopData?.theme?.colors?.accent} 40%, transparent)`,
                      borderRadius: '8px',
                      padding: '0.75rem',
                      color: shopData?.theme?.colors?.text || '#ffffff',
                      colorScheme: 'dark',
                      fontSize: '0.9rem'
                    }}
                  />
                </div>

                <CategorySelect
                  value={editingEvent.category || 'Other'}
                  onChange={(e) => setEditingEvent({ ...editingEvent, category: e.target.value })}
                  theme={shopData?.theme}
                >
                  <option value="Concert">Concert</option>
                  <option value="Workshop">Workshop</option>
                  <option value="Meetup">Meetup</option>
                  <option value="Sale">Sale</option>
                  <option value="Launch">Launch</option>
                  <option value="Other">Other</option>
                </CategorySelect>

                <AddressInput
                  address={editingEvent.address || ''}
                  onAddressChange={(value) => setEditingEvent({ 
                    ...editingEvent, 
                    address: value
                  })}
                  onLocationSelect={(location) => {
                    if (location?.coordinates) {
                      setEditingEvent({
                        ...editingEvent,
                        address: location.address,
                        coordinates: location.coordinates
                      });
                    }
                  }}
                  onMapOpen={() => handleOpenMapForSelection(editingEvent.id, false, true)}
                />
              </EditModalBody>
            </EditModalScrollContent>
          </EditModalContent>
        </EditModal>
      )}
    </>
  );
};

// Add handler for requesting location
const handleRequestLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setUserLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      },
      (error) => {
        console.error('Error getting location:', error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  }
};

const handleOpenMapForSelection = (itemId, isService = false, isEvent = false, rideField = null) => {
  setSelectingLocationFor({ itemId, isService, isEvent, rideField });
  setMapOpen(true);
};

// In LiveShopCreation.js and ShopPage.js
// In handleMapLocationSelect function, update to:
const handleMapLocationSelect = async (coordinates) => {
  console.log('🎯 Map location selected:', coordinates);

  if (!selectingLocationFor) {
    console.warn('⚠️ No item selected for location');
    return;
  }

  const { getAddressFromCoordinates } = await import('../../firebase/firebaseService');
  const { city, address: reversedAddress } = await getAddressFromCoordinates(coordinates.lat, coordinates.lng);
  const coordFallback = `${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}`;
  const humanAddress = reversedAddress || coordFallback;

  const formattedCoords = {
    lat: coordinates.lat,
    lng: coordinates.lng,
    latitude: coordinates.lat,
    longitude: coordinates.lng
  };

  // Check if this is for a master address
  if (selectingLocationFor.isMasterAddress) {
    const updated = masterAddresses.map(a =>
      a.id === selectingLocationFor.masterAddrId
        ? { ...a, address: humanAddress, coordinates: formattedCoords }
        : a
    );
    setMasterAddresses(updated);
    handleUpdateShop({ masterAddresses: updated });
    propagateMasterAddressesToItems(updated);
    setMapOpen(false);
    setSelectingLocationFor(null);
    return;
  }

  // Check if this is for the overlay
  if (selectingLocationFor.isOverlay) {
    setOverlayAddress(humanAddress);
    setOverlayCoordinates(formattedCoords);
    setMapOpen(false);
    setSelectingLocationFor(null);
    setShowLocationOverlay(true); // Re-open the overlay
    return;
  }

  // Check if this is a mass update
  if (selectingLocationFor.isMassUpdate) {
    handleMassLocationSet({ address: humanAddress, coordinates: formattedCoords, city });
    setMapOpen(false);
    setSelectingLocationFor(null);
    setLocationUpdateMode(null);
    return;
  }

  const { itemId, isService, isEvent, rideField } = selectingLocationFor;

  // Handle ride pickup / destination separately
  if (rideField === 'pickup') {
    handleServiceUpdate(itemId, { pickupAddress: humanAddress, pickupCoordinates: formattedCoords });
    if (editingItem && (editingItem.id || editingItem.tempId) === itemId) {
      setEditingItem(prev => ({ ...prev, pickupAddress: humanAddress, pickupCoordinates: formattedCoords }));
    }
    setMapOpen(false);
    setSelectingLocationFor(null);
    return;
  }
  if (rideField === 'destination') {
    handleServiceUpdate(itemId, { destinationAddress: humanAddress, destinationCoordinates: formattedCoords });
    if (editingItem && (editingItem.id || editingItem.tempId) === itemId) {
      setEditingItem(prev => ({ ...prev, destinationAddress: humanAddress, destinationCoordinates: formattedCoords }));
    }
    setMapOpen(false);
    setSelectingLocationFor(null);
    return;
  }

  const updateData = {
    address: humanAddress,
    coordinates: formattedCoords,
    city: city
  };

  const isCommunityPost = communityPosts.some(p => (p.id || p.tempId) === itemId);
  const isEventItem = events.some(e => e.id === itemId);

  if (isCommunityPost) {
    setCommunityPosts(prev =>
      prev.map(p =>
        (p.id || p.tempId) === itemId
          ? { ...p, ...updateData }
          : p
      )
    );
  } else if (isEventItem) {
    setEvents(prev =>
      prev.map(e =>
        e.id === itemId
          ? { ...e, ...updateData }
          : e
      )
    );
  } else {
    if (isService) {
      handleServiceUpdate(itemId, updateData);
    } else {
      handleItemUpdate(itemId, updateData);
    }
  }
  
  if (editingItem && (editingItem.id || editingItem.tempId) === itemId) {
    setEditingItem(prev => ({
      ...prev,
      ...updateData
    }));
  }
  
  setMapOpen(false);
  setSelectingLocationFor(null);
};

// In handleMassLocationSet function, update to:
const handleMassLocationSet = (location) => {
  console.log('📍 Setting mass location:', location);
  const locFields = {
    address: location.address,
    coordinates: location.coordinates,
    city: location.city,
    state: location.state || null,
    country: location.country || null,
    locationSource: 'real',
  };
  if (shopContentType === 'services') {
    const updatedServices = shopData.services.map(service => ({ ...service, ...locFields }));
    setShopData(prev => ({ ...prev, services: updatedServices }));
  } else {
    const updatedItems = shopData.items.map(item => ({ ...item, ...locFields }));
    setShopData(prev => ({ ...prev, items: updatedItems }));
  }
  
  console.log(`✅ Updated location for all ${shopContentType}`);
};


const autoToggleVisibility = (items, isService = false) => {
  const sortedItems = [...items].sort((a, b) => {
    // Prioritize already visible items, then by creation date (newest first)
    if (a.visible && !b.visible) return -1;
    if (!a.visible && b.visible) return 1;
    return b.id.localeCompare(a.id); // Newer IDs tend to be larger
  });

  let visibleCount = 0;
  const updatedItems = sortedItems.map(item => {
    return { ...item, visible: false };
  });

  return updatedItems;
};

// Add this function near your other upload functions
const uploadHomeSectionImage = async (imageId, file) => {
  try {
    const { compressImage } = await import('../../utils/imageCompression');
    const compressedFile = await compressProductImage(file, (progress) => {
  setCompressionProgress({
    text: 'Compressing image...',
    percent: progress
  });
});
setCompressionProgress(null);

    const storageRef = ref(
      storage, 
      `shops/${auth.currentUser.uid}/home-sections/${imageId}-${Date.now()}`
    );

    const metadata = {
      contentType: compressedFile.type || 'image/jpeg',
      cacheControl: 'public, max-age=31536000'
    };

    const snapshot = await uploadBytes(storageRef, compressedFile, metadata);
    const imageUrl = await getDownloadURL(snapshot.ref);

    console.log('✅ Home section image uploaded:', imageUrl);
    return imageUrl;
  } catch (error) {
    console.error('❌ Home section image upload failed:', error);
    throw error;
  }
};


const handleCSVUpload = async (file) => {
  if (!file) return;
  
  try {
    console.log('📄 Processing CSV file:', file.name);
    
    const text = await file.text();
    const { parseCSV, mapCSVRowToItems } = await import('../../utils/csvParser');

    const csvData = parseCSV(text);
    console.log('📊 Parsed CSV rows:', csvData.length);

    if (csvData.length === 0) {
      alert('No data found in CSV file');
      return;
    }

    // Show progress
    setCompressionProgress({
      text: `Processing ${csvData.length} items...`,
      percent: 0
    });

    const isService = shopContentType === 'services';
    const shopLocked = billingData?.itemsHiddenDueToBalance === true;
    const validCategories = new Set(getAllCategories(isService));

    const newItems = csvData
      .flatMap((row, index) => {
        setCompressionProgress({
          text: `Processing item ${index + 1}/${csvData.length}...`,
          percent: Math.round(((index + 1) / csvData.length) * 100)
        });

        return mapCSVRowToItems(row, isService);
      })
      .map(item => ({
        ...item,
        category: validCategories.has(item.category) ? item.category : 'Other',
      }))
      .map(item => shopLocked ? { ...item, visible: false, hiddenDueToBalance: true, userSetVisibility: true } : item);
    
    setCompressionProgress(null);
    
    if (newItems.length === 0) {
      alert('No items with images found in CSV file');
      return;
    }
    
    console.log(`✅ Found ${newItems.length} items with images (out of ${csvData.length} total)`);
    
    // Add to state
    if (isService) {
      setShopData(prev => ({
        ...prev,
        services: [...newItems, ...(prev.services || [])]
      }));
      
      // Add to change queue
      const newServices = {};
      newItems.forEach(item => {
        newServices[item.id] = {
          ...item,
          isNew: true,
          status: 'pending_create'
        };
      });
      
      setChangeQueue(prev => ({
        ...prev,
        services: {
          ...prev.services,
          ...newServices
        }
      }));
    } else {
      setShopData(prev => ({
        ...prev,
        items: [...newItems, ...(prev.items || [])]
      }));
      
      // Add to change queue
      const newItemsObj = {};
      newItems.forEach(item => {
        newItemsObj[item.id] = {
          ...item,
          isNew: true,
          status: 'pending_create'
        };
      });
      
      setChangeQueue(prev => ({
        ...prev,
        items: {
          ...prev.items,
          ...newItemsObj
        }
      }));
    }
    
    setHasPendingChanges(true);
    
    // Expand all new items
    const newIds = newItems.map(item => item.id);
    setExpandedItems(new Set(newIds));
    
    console.log(`✅ Created ${newItems.length} ${shopContentType} from CSV`);
    
    setStatusMessage({
      type: 'success',
      text: `✓ Imported ${newItems.length} ${shopContentType} with images (ready to save)`
    });
    setTimeout(() => setStatusMessage(null), 5000);
    
  } catch (error) {
    console.error('❌ CSV import failed:', error);
    setCompressionProgress(null);
    alert(`Failed to import CSV: ${error.message}`);
  }
};

const renderHomeView = () => {
  // Each Home-type tab has its own independent section list, tagged by tabId.
  // Legacy sections predating this (no tabId) belong to the original 'home' tab.
  const currentHomeSections = (homeSections || []).filter(s => (s.tabId || 'home') === activeTab);

  console.log('🏠 Rendering home view with sections:', currentHomeSections.length);
  
  const renderSectionWithControls = (section, index) => {
    const sectionProps = {
      config: section.config,
      theme: shopData?.theme,
      shopData,
      shopItems: shopData?.items,
      shopServices: shopData?.services,
      editable: true,
      onUpdate: (newConfig) => handleUpdateSection(section.id, newConfig),
      onItemClick: (item) => {
        console.log('Item clicked:', item);
      },
      onServiceClick: (service) => {
        console.log('Service clicked:', service);
      },
      // Editor preview only — the owner is always "authenticated" here and
      // order/like taps are no-ops (real interactions happen on the live public page).
      onOrderClick: () => {},
      onLikeClick: () => {},
      isAuthenticated: true,
    };

  let SectionComponent;
  switch (section.type) {
    case 'hero-banner':
      SectionComponent = HeroBannerSection; // Use draggable version
      break;
    case 'featured-items':
      SectionComponent = FeaturedItemsSection;
      break;
    case 'featured-services': // ADD THIS CASE
      SectionComponent = FeaturedServicesSection;
      break;
    case 'photo-gallery':
      SectionComponent = PhotoGallerySection;
      break;
    case 'featured-video':
      SectionComponent = FeaturedVideoSection;
      break;
    case 'mission-statement':
      SectionComponent = MissionStatementSection;
      break;
    case 'calendar-events':
      SectionComponent = CalendarEventsSection;
      break;
    case 'services-grid':
      SectionComponent = ServicesGridSection;
      break;
    case 'contact':
      SectionComponent = ContactSection;
      break;
    case 'text-block':
      SectionComponent = TextBlockSection;
      break;
    case 'map':
      SectionComponent = MapSection;
      break;
    case 'faq':
      SectionComponent = FaqSection;
      break;
    case 'reviews':
      SectionComponent = ReviewsSection;
      break;
    default:
      return null;
  }

    return (
      <SectionWrapper
  key={section.id}
  theme={shopData?.theme}
  $isHero={section.type === 'hero-banner'}
  style={{
    opacity: 0,
    animation: 'fadeInUp 0.5s ease-out forwards',
    animationDelay: `${index * 0.1}s`,
    paddingTop: (index === 0 && heroLeadsActiveHomeTab) ? '0' : '3rem',
    marginBottom: '1rem',
  }}
>
        <style>
          {`
            @keyframes fadeInUp {
              from {
                opacity: 0;
                transform: translateY(20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
        </style>
        
        <SectionControls className="section-controls" $bottomRight={section.type === 'hero-banner'}>
          <SectionControlButton
            theme={shopData?.theme}
            onClick={() => handleMoveSection(section.id, 'up')}
            disabled={index === 0}
            title="Move up"
          >
            <ChevronUp size={16} />
          </SectionControlButton>
          
          <SectionControlButton
            theme={shopData?.theme}
            onClick={() => handleMoveSection(section.id, 'down')}
            disabled={index === currentHomeSections.length - 1}
            title="Move down"
          >
            <ChevronDown size={16} />
          </SectionControlButton>
          
          <SectionControlButton
            theme={shopData?.theme}
            className="delete"
            onClick={() => handleRemoveSection(section.id)}
            title="Delete section"
          >
            <Trash2 size={16} />
          </SectionControlButton>

          {/* Feature 3: AI Section Copywriter */}
          <SectionControlButton
            theme={shopData?.theme}
            onClick={() => handleAiSection(section)}
            disabled={aiSectionLoading === section.id}
            title="Rewrite copy with AI"
            style={{
              background: `${shopData?.theme?.colors?.accent}18`,
              borderColor: `${shopData?.theme?.colors?.accent}50`,
            }}
          >
            {aiSectionLoading === section.id
              ? <span style={{ fontSize:'0.6rem', fontWeight:700, letterSpacing:'0.03em' }}>…</span>
              : <Sparkles size={14} />}
          </SectionControlButton>
        </SectionControls>

        {SectionComponent && <SectionComponent {...sectionProps} />}
      </SectionWrapper>
    );
  };

  return (
    <>
        {currentHomeSections.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem 2rem',
            color: shopData?.theme?.colors?.text,
            opacity: 0.6,
            animation: 'fadeIn 0.5s ease-out'
          }}>
            <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
              No sections yet
            </p>
            <p style={{ fontSize: '0.9rem' }}>
              Click the + button below to add your first section
            </p>
          </div>
        ) : (
          currentHomeSections
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
            .map((section, index) => renderSectionWithControls(section, index))
        )}

        {/* Add Section Card */}
        <AddSectionCard
          theme={shopData?.theme}
          onClick={() => {
            console.log('➕ Add section clicked');
            setShowSectionTypeModal(true);
          }}
          style={{
            opacity: 0,
            animation: 'fadeInUp 0.5s ease-out forwards',
            animationDelay: `${currentHomeSections.length * 0.1}s`
          }}
        >
          <div className="plus-icon">
            <Plus size={24} />
          </div>
          <div className="add-text">Add New Section</div>
        </AddSectionCard>

      {/* Section Type Modal */}
      <ModalOverlay 
        show={showSectionTypeModal} 
        onClick={() => {
          console.log('❌ Closing modal from overlay');
          setShowSectionTypeModal(false);
        }}
      />
      {showSectionTypeModal && (
        <SectionTypeModal 
          theme={shopData?.theme}
          style={{
            opacity: 1,
            transform: 'translate(-50%, -50%) scale(1)',
            transition: 'all 0.3s ease'
          }}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1.5rem',
            borderBottom: `1px solid ${shopData?.theme?.colors?.accent}40`,
            paddingBottom: '1rem'
          }}>
            <h3 style={{
              margin: 0,
              color: shopData?.theme?.colors?.accent,
              fontSize: '1.3rem',
              fontWeight: '600'
            }}>
              Choose Section Type
            </h3>
            <button
              onClick={() => setShowSectionTypeModal(false)}
              style={{
                background: 'transparent',
                border: 'none',
                color: shopData?.theme?.colors?.text,
                fontSize: '1.5rem',
                cursor: 'pointer',
                padding: '0.25rem',
                borderRadius: '4px'
              }}
            >
              ×
            </button>
          </div>
          
          {SECTION_TYPES.map((type, index) => (
            <SectionTypeOption
              key={type.value}
              theme={shopData?.theme}
              onClick={() => {
                console.log('🎯 Selected section type:', type.value);
                handleAddSection(type.value);
                setShowSectionTypeModal(false);
              }}
              style={{
                opacity: 1,
                animation: `fadeInUp 0.3s ease-out ${index * 0.05}s both`
              }}
            >
              <span className="icon" style={{ fontSize: '1.5rem' }}>{type.icon}</span>
              <div className="info">
                <div className="label" style={{ 
                  color: shopData?.theme?.colors?.text,
                  fontSize: '1rem',
                  fontWeight: '600'
                }}>
                  {type.label}
                </div>
                <div style={{
                  fontSize: '0.8rem',
                  opacity: 0.7,
                  color: shopData?.theme?.colors?.text
                }}>
                  Add a {type.label.toLowerCase()} to your page
                </div>
              </div>
            </SectionTypeOption>
          ))}
        </SectionTypeModal>
      )}
    </>
  );
};


// Make sure your getDefaultSectionConfig function has these good defaults:
const getDefaultSectionConfig = (type) => {
  const defaults = {
    'hero-banner': {
      headline: shopData?.name || 'Welcome to Your Shop',
      subtitle: 'Discover top quality products and exceptional services',
      backgroundImage: null,
      height: '70vh'
    },
    'mission-statement': {
      title: 'Mission',
      content: 'We have top quality products ready to be delivered with exceptional customer service. Our commitment to quality  drives everything we do.'
    },
    'featured-items': {
      title: 'Featured Products',
      itemCount: 4
    },
    'photo-gallery': {
      title: 'Gallery',
      images: [],
      displayStyle: 'carousel'
    },
    'contact': {
      title: 'Get In Touch',
      subtitle: 'Connect with us through any of the channels below',
      // Carry over real shop-level contact info if it exists; otherwise leave
      // blank rather than seeding example text as if the owner had entered it —
      // the public page hides unfilled fields, but only if they're actually empty.
      email: shopData?.email || '',
      phone: shopData?.phone || '',
      address: shopData?.address || '',
      socialLinks: {
        facebook: '',
        instagram: '',
        twitter: '',
        youtube: '',
        linkedin: ''
      }
    },
    'featured-services': {
      title: 'Our Services',
      serviceCount: 4
    },
    'map': {
      title: 'Find Us'
    },
    'faq': {
      title: 'Frequently Asked Questions',
      items: [
        { question: 'How does ordering work?', answer: 'Browse our catalog, add items to your cart, and complete checkout. We\'ll confirm your order and keep you updated.' },
        { question: 'What is your return policy?', answer: 'We accept returns within 30 days of purchase. Items must be in original condition.' },
        { question: 'How long does delivery take?', answer: 'Delivery times vary by location, typically 3–7 business days.' }
      ]
    },
    'reviews': {
      title: 'Customer Reviews',
      googleMapsEmbedUrl: '',
      reviews: []
    }
  };

  return defaults[type] || {};
};

const getDefaultSectionsForTemplate = (templateId) => {
  console.log('🏗️ Creating default sections for template:', templateId);
  
  // Professional placeholder landscape images
  const placeholderImages = [
    'https://images.unsplash.com/photo-1522124624696-7ea32eb9592c?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
          'https://images.unsplash.com/photo-1444080748397-f442aa95c3e5?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
          'https://images.unsplash.com/photo-1520034475321-cbe63696469a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
        ];

  const baseSections = [
    {
      id: `hero-${Date.now()}`,
      type: 'hero-banner',
      order: 0,
      config: {
        headline: shopData?.name || 'Welcome',
        subtitle: 'Discover top quality products and exceptional services',
        backgroundImage: 'https://images.unsplash.com/photo-1520034475321-cbe63696469a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        height: '70vh',
        overlay: true,
        ctaText: 'Explore Now',
        ctaLink: '#shop'
      }
    },
    {
      id: `mission-${Date.now() + 1}`,
      type: 'mission-statement',
      order: 1,
      config: {
        title: 'Mission',
        content: 'We have top quality products ready to be delivered with exceptional customer service. Our commitment to quality  drives everything we do.',
        alignment: 'center'
      }
    },
    {
      id: `gallery-${Date.now() + 2}`,
      type: 'photo-gallery',
      order: 2,
      config: {
        title: 'Gallery',
        images: placeholderImages,
        displayStyle: 'grid',
        columns: 3,
        caption: 'Explore our work and products'
      }
    },
    {
      id: `contact-${Date.now() + 3}`,
      type: 'contact',
      order: 3,
      config: {
        title: 'Get In Touch',
        subtitle: 'Connect with us through any of the channels below',
        // Same reasoning as getSectionDefaultConfig above — real shop data if
        // it exists, otherwise blank (not example text saved as if it were real).
        email: shopData?.email || '',
        phone: shopData?.phone || '',
        address: shopData?.address || '',
        socialLinks: {
          facebook: '',
          instagram: '',
          twitter: '',
          youtube: '',
          linkedin: ''
        },
        hours: 'Mon-Fri: 9AM-6PM\nSat: 10AM-4PM\nSun: Closed'
      }
    }
  ];

  // Template-specific variations
  const templateVariations = {
    1: { // Streetwear
      mission: {
        content: 'Bringing you the latest urban fashion and streetwear trends. We believe in self-expression through style and quality craftsmanship.'
      },
      gallery: {
        title: 'Style Gallery'
      }
    },
    2: { // Organization
      mission: {
        content: 'Dedicated to building community through events and shared experiences. We organize and host activities that bring people together.'
      }
    },
    3: { // Tech
      mission: {
        content: 'Pushing the boundaries of technology and innovation. We provide cutting-edge tech solutions and the latest gadgets.'
      },
      gallery: {
        title: 'Tech Showcase'
      }
    },
    4: { // Minimalist
      mission: {
        content: 'Simplicity, quality, and purpose. We believe in less but better - carefully curated products that enhance your daily life.'
      }
    },
    5: { // Local Market
      mission: {
        content: 'Supporting local artisans and businesses. We bring the best of our community to your doorstep with authentic, locally-made products.'
      },
      contact: {
        subtitle: 'Visit our local store or get in touch below'
      }
    }
  };

  const variation = templateVariations[templateId] || {};
  
  // Apply template-specific customizations
  return baseSections.map(section => {
    const sectionType = section.type.split('-')[0]; // Get base type (hero, mission, etc.)
    if (variation[sectionType]) {
      return {
        ...section,
        config: { ...section.config, ...variation[sectionType] }
      };
    }
    return section;
  });
};


// ADD toggle function:
const toggleItemExpansion = (itemId) => {
  setExpandedItems(prev => {
    const newSet = new Set(prev);
    if (newSet.has(itemId)) {
      newSet.delete(itemId);
    } else {
      newSet.add(itemId);
    }
    return newSet;
  });
};

  // Store original shop name when shop loads
useEffect(() => {
  if (shopData?.name && !originalShopName) {
    setOriginalShopName(shopData.name);
  }
}, [shopData?.name, originalShopName]);

const isVideoUrl = (url) => {
  if (!url) return false;
  if (typeof url === 'object' && url.isVideo) return true;
  if (typeof url === 'string') {
    // Check file extensions
    if (url.includes('.mp4') || url.includes('.webm') || url.includes('.mov')) return true;
    // Check Firebase Storage video path
    if (url.includes('video-') || url.includes('%2Fvideo-')) return true;
  }
  return false;
};


  // Deep comparison utility
  const deepEqual = (obj1, obj2) => {
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;
    
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    
    if (keys1.length !== keys2.length) return false;
    
    for (let key of keys1) {
      if (!keys2.includes(key)) return false;
      if (!deepEqual(obj1[key], obj2[key])) return false;
    }
    
    return true;
  };


  // Theme management
  useEffect(() => {
    const pinnedStyleId = localStorage.getItem('pinnedStyleId');
    
    if (pinnedStyleId && shopData?.theme) {
      const pinnedStyle = Object.values(WELCOME_STYLES).find(
        style => style.id.toString() === pinnedStyleId
      );
      
      if (pinnedStyle) {
        setIsPinned(true);
      }
    }
  }, [shopData?.theme]);

  const refreshTheme = () => {
    if (isRefreshing) return;
    
    setIsRefreshing(true);
    
    const styles = Object.values(WELCOME_STYLES);
    const otherStyles = styles.filter(style => style.id !== shopData?.theme?.id);
    
    if (otherStyles.length > 0) {
      const randomStyle = otherStyles[Math.floor(Math.random() * otherStyles.length)];
      setShopData(prev => ({ ...prev, theme: randomStyle }));

      if (isPinned) {
        localStorage.removeItem('pinnedStyleId');
        setIsPinned(false);
      }
    }

    setTimeout(() => setIsRefreshing(false), 500);
  };

  const togglePinStyle = async () => {
    if (isPinned) {
      localStorage.removeItem('pinnedStyleId');
      setIsPinned(false);

      const styles = Object.values(WELCOME_STYLES).filter(
        style => style.id !== shopData?.theme?.id
      );

      if (styles.length > 0) {
        const randomStyle = styles[Math.floor(Math.random() * styles.length)];
        setShopData(prev => ({ ...prev, theme: randomStyle }));
      }
    } else {
      const themeToPin = shopData?.theme;
      localStorage.setItem('pinnedStyleId', themeToPin?.id?.toString() || '');
      setIsPinned(true);

      // Pinning is a deliberate "lock this in" action (unlike casually shuffling
      // with Refresh), so persist it to Firestore immediately — the public page
      // reads shopData.theme straight from Firestore, so without this the pinned
      // theme never actually reached visitors.
      try {
        await updateDoc(doc(db, 'shops', activeShopId || auth.currentUser.uid), {
          theme: themeToPin,
        });
        console.log('✅ Pinned theme saved — now live on public page');
      } catch (error) {
        console.error('❌ Failed to save pinned theme:', error);
        alert('Theme pinned, but saving it to your live shop failed. Please try again.');
      }
    }
  };

  const handleLogout = async () => {
    try {
      console.log('🔓 Logging out...');
      
      // Clear PWA session data if in PWA mode
      const isPWAMode = localStorage.getItem('pwa_mode') === 'true';
      if (isPWAMode) {
        localStorage.removeItem('pwa_user_id');
        localStorage.removeItem('pwa_login_timestamp');
        localStorage.removeItem('pwa_last_active');
        console.log('🔓 PWA session cleared');
      }
      
      
      // Sign out from Firebase
      await signOut(auth);
      
      console.log('✅ Logout successful');
      
      // Clear location to prevent cached data
      window.location.href = '/';
      
    } catch (error) {
      console.error('❌ Error signing out:', error);
      alert('Error logging out. Please try again.');
    }
  };

  useEffect(() => {
    if (shopData?.layout?.tabPosition) {
      setTabPosition(shopData.layout.tabPosition);
    }
  }, [shopData]);

useEffect(() => {
  const loadShopData = async (userId) => {
    try {
      const shopDoc = await getDoc(doc(db, 'shops', userId));
      if (shopDoc.exists()) {
        const data = shopDoc.data();
        
        // Filter out deleted items
        if (data.items) {
          data.items = data.items.filter(item => !item.deleted);
        }

        // ADD: Store original store status
        const originalStoreOpen = data.storeOpen !== undefined ? data.storeOpen : true;
        setOriginalStoreStatus(originalStoreOpen);
        
        // Filter out deleted services
        if (data.services) {
          data.services = data.services.filter(service => !service.deleted);
        } else {
          data.services = [];
        }
        
        // Load community posts
        const posts = await getCommunityPostsForShop(userId);
        data.communityPosts = posts;

        // ✅ FIXED: Load events properly
        const loadedEvents = await getShopEvents(userId);
        setEvents(loadedEvents);


        
        // Load profile backgrounds - with fallback to defaults
       if (data.profileBackgroundImages && data.profileBackgroundImages.length > 0) {
  console.log('📸 Loading saved backgrounds:', data.profileBackgroundImages);
  setProfileBackgroundImages(data.profileBackgroundImages);
  
  // Load focal point if saved
  if (data.profileBackgroundFocalPoint) {
    setProfileBgFocalPoint(data.profileBackgroundFocalPoint);
  }
} else {
          console.log('📸 Using default backgrounds');
          // Use default backgrounds if none exist
          const defaultBgs = [
            'https://images.unsplash.com/photo-1522124624696-7ea32eb9592c?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
          'https://images.unsplash.com/photo-1444080748397-f442aa95c3e5?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
          'https://images.unsplash.com/photo-1520034475321-cbe63696469a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
        ];
          setProfileBackgroundImages(defaultBgs);
          data.profileBackgroundImages = defaultBgs;
        }
        
        setCommunityPosts(posts);
        
        // Set template
        if (data.selectedHomeTemplate) {
          setSelectedHomeTemplate(data.selectedHomeTemplate);
        }
        
        setShopData(data);
        
        // Load or create home sections
        if (data.homeSections && data.homeSections.length > 0) {
          console.log('📥 Loading existing home sections:', data.homeSections.length);
          setHomeSections(data.homeSections);
        } else {
          console.log('🏗️ Creating default home sections for template:', data.selectedHomeTemplate || 1);
          const defaultSections = getDefaultSectionsForTemplate(data.selectedHomeTemplate || 1);
          setHomeSections(defaultSections);
          
          const updatedData = {
            ...data,
            homeSections: defaultSections,
            selectedHomeTemplate: data.selectedHomeTemplate || 1
          };
          setShopData(updatedData);
          
          try {
            const shopRef = doc(db, 'shops', userId);
            await updateDoc(shopRef, {
              homeSections: defaultSections,
              selectedHomeTemplate: data.selectedHomeTemplate || 1,
              updatedAt: new Date().toISOString()
            });
            console.log('✅ Default home sections saved to Firestore');
          } catch (error) {
            console.error('❌ Error saving default sections:', error);
          }
        }
        
        // Set original data INCLUDING backgrounds
        const originalData = {
          ...data,
          homeSections: data.homeSections || getDefaultSectionsForTemplate(data.selectedHomeTemplate || 1),
          selectedHomeTemplate: data.selectedHomeTemplate || 1,
          communityPosts: posts,
          events: loadedEvents,
          profileBackgroundImages: data.profileBackgroundImages || [],
          storeOpen: originalStoreOpen 
        };
        setOriginalShopData(JSON.parse(JSON.stringify(originalData)));
        
        console.log('✅ Shop data loaded:', {
          items: data.items?.length || 0,
          services: data.services?.length || 0,
          homeSections: (data.homeSections || []).length,
          communityPosts: posts.length,
          backgrounds: (data.profileBackgroundImages || []).length,
          storeOpen: originalStoreOpen  
        });
      }
      setIsReady(true);
    } catch (error) {
      console.error('Error loading shop data:', error);
      setIsReady(true);
    }
  };

  const unsubscribe = auth.onAuthStateChanged((user) => {
    if (!user) {
      navigate('/auth');
      return;
    }
    // Respect the previously selected shop (persisted in sessionStorage by ActiveShopContext)
    const savedShopId = sessionStorage.getItem('activeShopId');
    const shopToLoad = savedShopId || user.uid;
    // Prime prevActiveShopRef so the activeShopId effect doesn't re-load the same shop
    prevActiveShopRef.current = shopToLoad;
    loadShopData(shopToLoad);
  });

  return () => unsubscribe();
}, [navigate]);

// Reload shop data whenever activeShopId changes (sub-shop or shared shop switch)
useEffect(() => {
  if (!activeShopId || !auth.currentUser) return;

  const prev = prevActiveShopRef.current;
  prevActiveShopRef.current = activeShopId;

  // Skip first render — the auth state effect already loaded the primary shop
  if (prev === null) return;
  // Skip if shop hasn't actually changed
  if (prev === activeShopId) return;

  const loadActiveShop = async () => {
    try {
      setIsReady(false);
      const shopDoc = await getDoc(doc(db, 'shops', activeShopId));
      if (shopDoc.exists()) {
        const data = shopDoc.data();
        if (data.items) data.items = data.items.filter(i => !i.deleted);
        if (data.services) data.services = data.services.filter(s => !s.deleted);
        else data.services = [];

        const posts = await getCommunityPostsForShop(activeShopId);
        data.communityPosts = posts;
        setCommunityPosts(posts);

        const loadedEvents = await getShopEvents(activeShopId);
        setEvents(loadedEvents);

        if (data.profileBackgroundImages?.length) {
          setProfileBackgroundImages(data.profileBackgroundImages);
        }
        // Always reset — including to blank — so a newly created (or
        // just-switched-to) shop doesn't keep showing the previous shop's
        // Home tab sections leftover in local state.
        setHomeSections(data.homeSections || []);

        setOriginalStoreStatus(data.storeOpen !== undefined ? data.storeOpen : true);
        setShopData(data);
        setOriginalShopData(JSON.parse(JSON.stringify({ ...data, communityPosts: posts, events: loadedEvents })));
      }
    } catch (err) {
      console.error('Error loading active shop:', err);
    } finally {
      setIsReady(true);
    }
  };

  loadActiveShop();
}, [activeShopId]); // eslint-disable-line react-hooks/exhaustive-deps

const canAddMoreItems = (isService = false) => {
  if (!isService) {
    return (shopData?.items?.length || 0) < 200;
  }
  // Services and gig cards: always allowed to create (visibility capped separately at toggle time)
  return (shopData?.services?.length || 0) < 200;
};

const getItemLimitMessage = (isService = false) => {
  if (isService) {
    return '⚠️ Visible card limit reached. Upgrade your plan to add more.';
  }
  return '⚠️ Item storage limit reached.';
};

const handleAddSection = (sectionType) => {
  console.log('🔄 Adding section:', sectionType);

  const tabSectionsCount = homeSections.filter(s => (s.tabId || 'home') === activeTab).length;
  const newSection = {
    id: `section-${Date.now()}`,
    type: sectionType,
    tabId: activeTab,
    order: tabSectionsCount,
    config: getDefaultSectionConfig(sectionType)
  };

  const updatedSections = [...homeSections, newSection];
  console.log('📝 New sections array:', updatedSections);
  
  setHomeSections(updatedSections);
  setChangeQueue(prev => ({
  ...prev,
  homeSections: updatedSections
}));
setHasPendingChanges(true);
  setHasUnsavedChanges(true);
  
  // Force a re-render by updating state
  setTimeout(() => {
    console.log('✅ Section should be visible now');
  }, 100);
};


const handleUpdateSection = (sectionId, updates) => {
  console.log('🔄 Updating section:', sectionId, updates);

  const updatedSections = homeSections.map(section =>
    section.id === sectionId
      ? { ...section, config: { ...section.config, ...updates } }
      : section
  );
  
  setHomeSections(updatedSections);
  setChangeQueue(prev => ({
  ...prev,
  homeSections: updatedSections
}));
setHasPendingChanges(true);
  setHasUnsavedChanges(true);
};

// UPDATE handleRemoveSection to mark as changed (around line 1470)
const handleRemoveSection = (sectionId, updates) => {
  setHomeSections(homeSections.filter(section => section.id !== sectionId));
  const updatedSections = homeSections.map(section =>
    section.id === sectionId
      ? { ...section, config: { ...section.config, ...updates } }
      : section
  );

  setChangeQueue(prev => ({
  ...prev,
  homeSections: updatedSections
}));
setHasPendingChanges(true);
  // Changes will be detected automatically by the useEffect
};

// UPDATE handleMoveSection to mark as changed (around line 1490)
const handleMoveSection = (sectionId, direction) => {
  const section = homeSections.find(s => s.id === sectionId);
  if (!section) return;
  const sectionTabId = section.tabId || 'home';

  // Reorder only within the same tab's sections — other tabs' sections are untouched
  const tabSections = homeSections.filter(s => (s.tabId || 'home') === sectionTabId);
  const otherSections = homeSections.filter(s => (s.tabId || 'home') !== sectionTabId);

  const currentIndex = tabSections.findIndex(s => s.id === sectionId);
  if (currentIndex === -1) return;

  const newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
  if (newIndex < 0 || newIndex >= tabSections.length) return;

  const items = Array.from(tabSections);
  const [movedItem] = items.splice(currentIndex, 1);
  items.splice(newIndex, 0, movedItem);

  const reorderedTabItems = items.map((item, index) => ({
    ...item,
    order: index
  }));

  const reorderedItems = [...otherSections, ...reorderedTabItems];

  setHomeSections(reorderedItems);
  setChangeQueue(prev => ({
  ...prev,
  homeSections: reorderedItems
}));
setHasPendingChanges(true);
  // Changes will be detected automatically by the useEffect
};

// ── AI Section copywriter: rewrites a single section's copy via Claude
const handleAiSection = async (section) => {
  setAiSectionLoading(section.id);
  try {
    const res = await fetch('/api/compress-media?action=ai-section', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sectionType: section.type,
        currentConfig: section.config || {},
        shopName: shopData?.name || '',
        shopDescription: shopData?.description || '',
        storeType: shopData?.storeType || 'general',
      }),
    });
    if (!res.ok) throw new Error((await res.json()).error || 'AI failed');
    const { config: newConfig } = await res.json();
    handleUpdateSection(section.id, newConfig);
  } catch (err) {
    console.error('❌ AI section error:', err.message);
  } finally {
    setAiSectionLoading(null);
  }
};

  // Don't render anything until ready.
  // Also hold the spinner if shop access is still loading and we have no shop data yet —
  // this covers invited users who have no own shop and need ActiveShopContext to set
  // the correct shared shop as the active one before anything renders.
  if (!isReady || (loadingShopAccess && !shopData)) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#000'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid rgba(128, 0, 0, 0.3)',
        borderTop: '3px solid #800000',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}/>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

  const handleApplyTheme = (newTheme) => {
    setShopData(prev => ({ ...prev, theme: newTheme }));
  };


// Handles items imported from WebsiteScraper or MenuScanner
const handleProductsScraped = (scrapedItems) => {
  if (!scrapedItems || scrapedItems.length === 0) return;
  const newItems = scrapedItems.map((item, i) => ({
    id: `imported-${Date.now()}-${i}`,
    name: item.name || 'Imported Item',
    price: item.price || '',
    description: item.description || '',
    category: item.category || 'Other',
    images: item.images?.[0] ? item.images : [null, null, null],
    currentImageIndex: 0,
    quantity: item.quantity || 1,
    address: '',
    coordinates: null,
    visible: true,
    userSetVisibility: true,
    isDigital: false,
    digitalFile: null
  }));

  setShopData(prev => ({ ...prev, items: [...newItems, ...(prev.items || [])] }));
  setChangeQueue(prev => ({
    ...prev,
    items: {
      ...prev.items,
      ...Object.fromEntries(newItems.map(item => [item.id, item]))
    }
  }));
  setHasPendingChanges(true);
  setStatusMessage({ type: 'success', text: `${newItems.length} item${newItems.length !== 1 ? 's' : ''} imported — remember to save!` });
  setTimeout(() => setStatusMessage(null), 5000);
};

const handleAddItem = () => {
  // Check if user can add more items
  if (!canAddMoreItems(false)) {
    setStatusMessage({
      type: 'error',
      text: getItemLimitMessage(false)
    });
    setTimeout(() => setStatusMessage(null), 5000);
    
    // Optionally show Stripe wizard
    setShowStripeWizard(true);
    return;
  }
  
  const shopLocked = billingData?.itemsHiddenDueToBalance === true;
  const planPerms = getPlanPermissions(billingData);
  const { visibleTotal: curVisibleTotal } = countVisibleByType(shopData?.items || [], shopData?.services || []);
  const productVisible = !shopLocked && planPerms.maxVisible > 0 && curVisibleTotal < planPerms.maxVisible;
  const newItem = {
    id: Date.now().toString(),
    name: 'Item Name',
    price: '',
    description: '',
    category: 'Other',
    images: [null, null, null],
    currentImageIndex: 0,
    quantity: 1,
    address: '',
    coordinates: null,
    visible: productVisible,
    userSetVisibility: true,
    hiddenDueToBalance: !productVisible,
    isDigital: false,
    digitalFile: null
  };

  // Update local state
  const updatedItems = [newItem, ...(shopData.items || [])];
  setShopData(prev => ({ ...prev, items: updatedItems }));
  
  // Add to queue
  setChangeQueue(prev => ({
    ...prev,
    items: {
      ...prev.items,
      [newItem.id]: newItem
    }
  }));
  
  setHasPendingChanges(true);
  setExpandedItems(new Set([newItem.id]));
};

const handleAddService = () => {
  const shopLocked = billingData?.itemsHiddenDueToBalance === true;
  const servicePerms = getPlanPermissions(billingData);
  const { visibleTotal: curVisibleTotal } = countVisibleByType(shopData?.items || [], shopData?.services || []);
  const isNeedTab = (serviceSubTab || 'offer') === 'need';
  const serviceVisible = !shopLocked && (
    isNeedTab
      ? servicePerms.canPostGigs
      : servicePerms.maxVisible > 0 && curVisibleTotal < servicePerms.maxVisible
  );
  const newService = {
    id: Date.now().toString(),
    name: 'Service Name',
    price: '',
    description: '',
    category: 'Other',
    images: [null, null, null],
    currentImageIndex: 0,
    address: '',
    coordinates: null,
    slots: 1,
    isService: true,
    serviceTab: serviceSubTab,
    pricingType: 'hourly',
    visible: serviceVisible,
    userSetVisibility: true,
    hiddenDueToBalance: !serviceVisible
  };

  // Update local state
  const updatedServices = [newService, ...(shopData.services || [])];
  setShopData(prev => ({ ...prev, services: updatedServices }));
  
  // Add to queue
  setChangeQueue(prev => ({
    ...prev,
    services: {
      ...prev.services,
      [newService.id]: newService
    }
  }));
  
  setHasPendingChanges(true);
  setExpandedItems(new Set([newService.id]));
};

const handleAddCategory = (isService, name) => {
  const trimmed = name.trim();
  if (!trimmed) return;
  const key = isService ? 'serviceCategories' : 'productCategories';
  const current = shopData?.[key] || [];
  if (current.includes(trimmed)) return;
  const updated = [...current, trimmed];
  const updatedCategoryTypes = { ...(shopData?.categoryTypes || {}), [trimmed]: newCategoryType || 'other' };
  setShopData(prev => ({ ...prev, [key]: updated, categoryTypes: updatedCategoryTypes }));
  setChangeQueue(prev => ({ ...prev, [key]: updated, categoryTypes: updatedCategoryTypes }));
  setHasPendingChanges(true);
  setNewCategoryType(null);
};

const handleDeleteCategory = (isService, categoryName) => {
  const key = isService ? 'serviceCategories' : 'productCategories';
  const itemsKey = isService ? 'services' : 'items';
  const updatedCats = (shopData?.[key] || []).filter(c => c !== categoryName);
  const updatedItems = (shopData?.[itemsKey] || []).map(i => {
    if ((i.category || 'Other') !== categoryName) return i;
    // A custom category can also be selected as a service's "Service Type"
    // (see getAllServiceTypes); clear it too so nothing references the
    // deleted category once it's gone from the dropdown.
    const clearedJobType = isService && i.jobType === categoryName ? { jobType: null } : {};
    return { ...i, ...clearedJobType, category: 'Other', visible: false };
  });
  setShopData(prev => ({ ...prev, [key]: updatedCats, [itemsKey]: updatedItems }));
  setChangeQueue(prev => ({ ...prev, [key]: updatedCats, [itemsKey]: Object.fromEntries(updatedItems.map(i => [i.id, i])) }));
  setHasPendingChanges(true);
};

const handleSetCategoryType = (categoryName, storeTypeId) => {
  const updatedCategoryTypes = { ...(shopData?.categoryTypes || {}), [categoryName]: storeTypeId };
  const updatedItems = (shopData?.items || []).map(i =>
    (i.category || 'Other') === categoryName ? { ...i, categoryType: storeTypeId } : i
  );
  const updatedServices = (shopData?.services || []).map(s =>
    (s.category || 'Other') === categoryName ? { ...s, categoryType: storeTypeId } : s
  );
  setShopData(prev => ({ ...prev, categoryTypes: updatedCategoryTypes, items: updatedItems, services: updatedServices }));
  setChangeQueue(prev => ({
    ...prev,
    categoryTypes: updatedCategoryTypes,
    items: { ...(prev.items || {}), ...Object.fromEntries(updatedItems.map(i => [i.id, i])) },
    services: { ...(prev.services || {}), ...Object.fromEntries(updatedServices.map(s => [s.id, s])) },
  }));
  setHasPendingChanges(true);
  setOpenTypePicker(null);
};

// Full display order for a content type's categories (built-in + custom,
// deduped) — the same fallback the public page falls back to when the owner
// hasn't explicitly reordered anything yet.
const getFallbackCategoryOrder = (isService) => {
  const storedCats = shopData?.[isService ? 'serviceCategories' : 'productCategories'] || [];
  const fromItems = [...new Set((shopData?.[isService ? 'services' : 'items'] || []).map(i => i.category || 'Other'))];
  const order = [...new Set([...storedCats, ...fromItems])];
  return order.length ? order : ['Other'];
};

// Move a category up/down in display order — mirrors the Home tab's
// section move up/down controls. Persisted to shopData.productCategoryOrder /
// serviceCategoryOrder, which the public page reads as its default order.
const handleMoveCategory = (isService, categoryName, direction) => {
  const orderKey = isService ? 'serviceCategoryOrder' : 'productCategoryOrder';
  const fallbackOrder = getFallbackCategoryOrder(isService);
  const storedOrder = shopData?.[orderKey];
  const currentOrder = storedOrder?.length ? storedOrder : fallbackOrder;
  // Include any category not yet covered by a stored order (e.g. just added)
  const fullOrder = [...new Set([...currentOrder, ...fallbackOrder])];
  const idx = fullOrder.indexOf(categoryName);
  if (idx === -1) return;
  const swapWith = direction === 'up' ? idx - 1 : idx + 1;
  if (swapWith < 0 || swapWith >= fullOrder.length) return;
  const next = [...fullOrder];
  [next[idx], next[swapWith]] = [next[swapWith], next[idx]];
  setShopData(prev => ({ ...prev, [orderKey]: next }));
  setChangeQueue(prev => ({ ...prev, [orderKey]: next }));
  setHasPendingChanges(true);
};

// Cycle a category's public-page card density 1× → 2× → 3× → 1×. Persisted to
// shopData.categoryColumns, keyed by content type so a product category and a
// service category with the same name don't collide.
const handleCycleCategoryColumns = (isService, categoryName) => {
  const key = `${isService ? 's' : 'p'}:${categoryName}`;
  const current = shopData?.categoryColumns?.[key] ?? 1;
  const next = current === 1 ? 2 : current === 2 ? 3 : 1;
  const updated = { ...(shopData?.categoryColumns || {}), [key]: next };
  setShopData(prev => ({ ...prev, categoryColumns: updated }));
  setChangeQueue(prev => ({ ...prev, categoryColumns: updated }));
  setHasPendingChanges(true);
};

// "Add Card" placeholder in each category opens a multi-select file picker so
// the owner can drop in several photos at once — one new item/service per
// image, landing directly in that category — instead of one blank card at a time.
const openBulkUploadForCategory = (categoryName) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.multiple = true;
  input.onchange = (e) => handleBulkImageUpload(e.target.files, categoryName);
  input.click();
};

const handleAddJob = (jobType) => {
  setShowJobTypeMenu(false);
  const shopLocked = billingData?.itemsHiddenDueToBalance === true;
  // Falls back to a synthetic entry (not the generic "Other" job type) for
  // owner-defined custom service categories, so the category name is preserved
  // instead of being silently discarded.
  const jobMeta = JOB_TYPES.find(j => j.id === jobType) || { id: jobType, label: jobType, icon: '💼' };
  const TYPE_DEFAULTS = SERVICE_TYPE_DEFAULTS;
  const newJob = {
    id: Date.now().toString(),
    name: jobType === 'rides' ? 'Driver Needed' : `${jobMeta.label} ${serviceSubTab === 'need' ? 'Needed' : 'Available'}`,
    price: '',
    description: '',
    category: jobMeta.label,
    jobType,
    serviceTab: serviceSubTab,
    pricingType: 'hourly',
    images: [null, null, null],
    currentImageIndex: 0,
    slots: 1,
    visible: !shopLocked && getPlanPermissions(billingData).canPostGigs,
    userSetVisibility: true,
    hiddenDueToBalance: shopLocked || !getPlanPermissions(billingData).canPostGigs,
    ...(TYPE_DEFAULTS[jobType] || {}),
  };
  const updatedServices = [newJob, ...(shopData.services || [])];
  setShopData(prev => ({ ...prev, services: updatedServices }));
  setChangeQueue(prev => ({ ...prev, services: { ...prev.services, [newJob.id]: newJob } }));
  setHasPendingChanges(true);
  setExpandedItems(new Set([newJob.id]));
};

const handleDeleteItem = (itemId) => {
  const filteredItems = shopData.items.filter(item => item.id !== itemId);
  setShopData(prev => ({ ...prev, items: filteredItems }));
  
  // Mark item as deleted in queue
  setChangeQueue(prev => ({
    ...prev,
    items: {
      ...prev.items,
      [itemId]: { id: itemId, deleted: true }
    }
  }));
  
  setHasPendingChanges(true);
};

const handleServiceDelete = (serviceId) => {
  setShopData(prev => ({
    ...prev,
    services: prev.services.filter(service => service.id !== serviceId)
  }));
  
  // Mark service as deleted in queue
  setChangeQueue(prev => ({
    ...prev,
    services: {
      ...prev.services,
      [serviceId]: { id: serviceId, deleted: true }
    }
  }));
  
  setHasPendingChanges(true);
};

const handleToggleWelcomePage = async () => {
  const newValue = !hideFromWelcomePage;
  setHideFromWelcomePage(newValue);
  setShopData(prev => ({ ...prev, hideFromWelcomePage: newValue }));
  try {
    await updateSingleField(activeShopId, 'hideFromWelcomePage', newValue);

    // Re-sync the mirror so getFeaturedItemsFromCollection/…Services… (which
    // read the denormalized shopHideFromWelcomePage flag on each mirrored
    // doc, since that's a shop-level field, not an item field) reflect this
    // immediately instead of waiting for the next unrelated item/service save.
    const mirrorShopId = activeShopId || auth.currentUser.uid;
    const mirrorShopFields = buildShopFields(mirrorShopId, { ...shopData, hideFromWelcomePage: newValue });
    mirrorItemsFull(mirrorShopId, shopData?.items || [], mirrorShopFields);
    mirrorServicesFull(mirrorShopId, shopData?.services || [], mirrorShopFields);
  } catch (err) {
    console.error('Error toggling welcome page visibility:', err);
    setHideFromWelcomePage(!newValue);
    setShopData(prev => ({ ...prev, hideFromWelcomePage: !newValue }));
  }
};

const handleToggleStoreStatus = async () => {
  // If there's an outstanding balance, clicking always opens payment modal
  if (billingData && calculateOutstandingBalance(billingData) > 0) {
    setBillingDataForPayment(billingData);
    setShowPaymentModal(true);
    return;
  }

  const newStatus = !storeOpen;
  setStoreOpen(newStatus);
  
  // Immediately update all items and services visibility
  const updatedItems = (shopData?.items || []).map(item => ({
    ...item,
    visible: newStatus,
    userSetVisibility: newStatus
  }));
  
  const updatedServices = (shopData?.services || []).map(service => ({
    ...service,
    visible: newStatus,
    userSetVisibility: newStatus
  }));
  
  // Update local state
  setShopData(prev => ({
    ...prev,
    items: updatedItems,
    services: updatedServices,
    storeOpen: newStatus
  }));
  
  // Update Firestore immediately (no queue needed for this)
  try {
    const shopRef = doc(db, 'shops', activeShopId || auth.currentUser.uid);
    await updateDoc(shopRef, {
      storeOpen: newStatus,
      items: cleanDataForFirestore(updatedItems),
      services: cleanDataForFirestore(updatedServices),
      updatedAt: new Date().toISOString()
    });
    
    console.log(`🏪 Store ${newStatus ? 'OPENED' : 'CLOSED'} - all items ${newStatus ? 'visible' : 'hidden'}`);

    // Mirror into the top-level items/services collections — best-effort.
    {
      const mirrorShopId = activeShopId || auth.currentUser.uid;
      const mirrorShopFields = buildShopFields(mirrorShopId, { ...shopData, storeOpen: newStatus });
      mirrorItemsFull(mirrorShopId, updatedItems, mirrorShopFields);
      mirrorServicesFull(mirrorShopId, updatedServices, mirrorShopFields);
    }

    invalidateShopCache(activeShopId || auth.currentUser.uid);

    // Update original data to match
    setOriginalShopData(prev => ({
      ...prev,
      items: updatedItems,
      services: updatedServices,
      storeOpen: newStatus
    }));
    
    // Show confirmation message
    setStatusMessage({
      type: 'success',
      text: newStatus ? 
        '✅ Store opened - all items visible' : 
        '⚠️ Store closed - all items hidden'
    });
    setTimeout(() => setStatusMessage(null), 3000);
    
  } catch (error) {
    console.error('❌ Error toggling store status:', error);
    
    // Rollback on error
    setStoreOpen(!newStatus);
    setShopData(prev => ({
      ...prev,
      items: shopData?.items,
      services: shopData?.services,
      storeOpen: !newStatus
    }));
    
    setStatusMessage({
      type: 'error',
      text: '❌ Failed to update store status'
    });
    setTimeout(() => setStatusMessage(null), 3000);
  }
};

// Wherever you call setHomeSections, add:


const uploadImageToStorage = async (file, itemId) => {
  try {
    const storageRef = ref(
      storage,
      `shops/${auth.currentUser.uid}/items/${itemId}/${Date.now()}-${file.name}`
    );
    
    const snapshot = await uploadBytes(storageRef, file);
    const downloadUrl = await getDownloadURL(snapshot.ref);
    
    return downloadUrl;
  } catch (error) {
    console.error('Error uploading image:', error);
    return null;
  }
};

const handleSave = async () => {
  if (!auth.currentUser) return;

  try {
    setSaving(true);

    // Check for new items
    const newItems = Object.values(changeQueue.items || {}).filter(item => item.isNew);
    const newServices = Object.values(changeQueue.services || {}).filter(service => service.isNew);
    
    console.log('💾 Saving new items:', {
      newItems: newItems.length,
      newServices: newServices.length
    });
    
    // Upload images for new items first
    for (const item of newItems) {
      if (item.images && item.images[0]?.file) {
        // Upload the image file to storage
        const imageUrl = await uploadImageToStorage(item.images[0].file, item.id);
        // Update item with the actual URL
        item.images[0] = imageUrl;
      }
    }

    console.log('💾 Processing change queue:', changeQueue);

    const shopRef = doc(db, 'shops', activeShopId || auth.currentUser.uid);
    const updatePayload = {};

    // 1. SHOP DETAILS
    if (changeQueue.shopDetails) {
      console.log('📝 Saving shop details...');
        
      // Handle shop name change
      if (changeQueue.shopDetails.name && changeQueue.shopDetails.name !== originalShopName) {
        const result = await checkShopNameAvailability(
      changeQueue.shopDetails.name, 
      originalShopData?.username
        );
        
        if (!result.available) {
          alert(result.isTaken ? 
            'This shop name is already taken.' : 
            'Unable to verify shop name.'
          );
          setSaving(false);
          return;
        }
        
        if (result.changed) {
          updatePayload.username = result.username;
          console.log('✅ Username updated to:', result.username);
        }
      }
      
      // Handle profile image
      if (changeQueue.shopDetails.profile?.file instanceof File) {
        const compressedProfile = await compressProfileImage(changeQueue.shopDetails.profile.file);
        const profileRef = ref(storage, `shops/${activeShopId || auth.currentUser.uid}/profile/profile-${Date.now()}`);
        const snapshot = await uploadBytes(profileRef, compressedProfile, { customMetadata: { ownerId: auth.currentUser.uid } });
        updatePayload.profile = await getDownloadURL(snapshot.ref);
        console.log('✅ Profile uploaded');
      } else if (changeQueue.shopDetails.profile) {
        updatePayload.profile = changeQueue.shopDetails.profile;
      }
      
      // Add other shop details
      Object.entries(changeQueue.shopDetails).forEach(([key, value]) => {
    if (key !== 'profile' && key !== 'name') {
      updatePayload[key] = value;
    }
      });
      
      if (changeQueue.shopDetails.name) {
        updatePayload.name = changeQueue.shopDetails.name;
      }

  // 👇 ADD THIS RIGHT HERE - after processing other shop details
      // Handle store type and default category
  if (changeQueue.shopDetails?.storeType) {
    updatePayload.storeType = changeQueue.shopDetails.storeType;
        // Also save the default category for this store type
        updatePayload.defaultCategory = getDefaultCategoryForStore(changeQueue.shopDetails.storeType);
        console.log(`🏪 Store type updated to: ${changeQueue.shopDetails.storeType}, default category: ${updatePayload.defaultCategory}`);
      }
    }

    // 2. ITEMS
    if (Object.keys(changeQueue.items).length > 0) {
  console.log('📦 Saving items...');
  
  const currentItems = shopData.items || [];
  
  // ✅ FIX: Process items and keep track of uploaded URLs
  const processedItems = await Promise.all(
    currentItems.map(async (item) => {
      const queuedItem = changeQueue.items[item.id];
      if (!queuedItem) return item;
      
      if (queuedItem.deleted) return null;
      
      // Upload images and get URLs — each newly-uploaded image also gets a
      // small grid thumbnail + tiny blur placeholder generated alongside it
      // (see generateImageVariants); existing images keep whatever
      // thumb/blur they already have.
      const uploadedImageData = await Promise.all(
        (queuedItem.images || item.images || [null, null, null]).map(async (img, index) => {
          if (!img) return { url: null, thumb: null, blur: null };

          // Already a valid URL
          if (typeof img === 'string' && img.startsWith('http')) {
            return { url: img, thumb: item.thumbnails?.[index] || null, blur: item.imageBlur?.[index] || null };
          }

          // Check temp storage for file to upload
          const storageKey = `${item.id}-${index}`;
          const fileToUpload = tempFileStorage[storageKey];

          if (fileToUpload instanceof File) {
            console.log(`📤 Uploading item image ${index + 1} for ${item.id}`);
            const [url, variants] = await Promise.all([
              uploadProductMedia(activeShopId || auth.currentUser.uid, item.id, fileToUpload, false, auth.currentUser.uid),
              generateImageVariants(fileToUpload).catch(err => { console.warn('⚠️ Thumbnail generation failed:', err); return null; }),
            ]);
            let thumb = null;
            if (variants) {
              try {
                thumb = await uploadProductThumbnail(activeShopId || auth.currentUser.uid, item.id, variants.thumbnail, false, auth.currentUser.uid);
              } catch (err) {
                console.warn('⚠️ Thumbnail upload failed:', err);
              }
            }
            return { url, thumb, blur: variants?.blurDataURL || null };
          }

          // If it's an object with a URL, extract it
          if (typeof img === 'object' && img !== null) {
            if (img.url && img.url.startsWith('http')) {
              return { url: img.url, thumb: item.thumbnails?.[index] || null, blur: item.imageBlur?.[index] || null };
            }
            // Keep data URLs for local preview (will be filtered for Firestore)
            if (img.preview) return { url: img.preview, thumb: null, blur: null };
          }

          // Keep data URL for local preview
          if (typeof img === 'string' && img.startsWith('data:')) return { url: img, thumb: null, blur: null };

          return { url: null, thumb: null, blur: null };
        })
      );
      const uploadedImages = uploadedImageData.map(d => d.url);
      const uploadedThumbs = uploadedImageData.map(d => d.thumb);
      const uploadedBlurs = uploadedImageData.map(d => d.blur);

      // Upload digital product file if present
      let digitalFile = queuedItem.digitalFile !== undefined ? queuedItem.digitalFile : item.digitalFile;
      const isDigital = queuedItem.isDigital !== undefined ? queuedItem.isDigital : item.isDigital;
      if (isDigital && digitalFile?.file instanceof File) {
        try {
          const { uploadDigitalProduct } = await import('../../firebase/firebaseService');
          const storagePath = await uploadDigitalProduct(activeShopId || auth.currentUser.uid, item.id, digitalFile.file, auth.currentUser.uid);
          digitalFile = {
            name: digitalFile.name,
            size: digitalFile.size,
            type: digitalFile.type,
            storagePath
          };
        } catch (err) {
          console.error('Failed to upload digital product file:', err);
        }
      }

      // Return merged item with uploaded images
      const merged = {
        ...item,
        ...queuedItem,
        images: uploadedImages,
        thumbnails: uploadedThumbs,
        imageBlur: uploadedBlurs,
        isDigital: isDigital || false,
        digitalFile: isDigital ? digitalFile : null,
      };
      return merged;
    })
  );

  const filteredItems = processedItems.filter(Boolean);

  // ✅ UPDATE LOCAL STATE with preview URLs intact
  setShopData(prev => ({
    ...prev,
    items: filteredItems
  }));

  // ✅ CLEAN for Firestore (remove data URLs and File objects, keep only HTTP URLs).
  // thumbnails/imageBlur are compacted in lockstep with images, using the same
  // per-index validity test, so index i always lines up across all three arrays.
  updatePayload.items = filteredItems.map(item => {
    const isValidHttp = (img) => typeof img === 'string' && img.startsWith('http');
    const images = (item.images || []).map(img => (isValidHttp(img) ? img : null)).filter(Boolean);
    const thumbnails = (item.images || []).map((img, i) => (isValidHttp(img) ? (item.thumbnails?.[i] || null) : undefined)).filter(x => x !== undefined);
    const imageBlur = (item.images || []).map((img, i) => (isValidHttp(img) ? (item.imageBlur?.[i] || null) : undefined)).filter(x => x !== undefined);
    return {
      ...item,
      images,
      thumbnails,
      imageBlur,
      digitalFile: item.isDigital && item.digitalFile?.storagePath ? {
        name: item.digitalFile.name,
        size: item.digitalFile.size,
        type: item.digitalFile.type,
        storagePath: item.digitalFile.storagePath
      } : null
    };
  });
}

    // 3. SERVICES
    // Around line 2860 - SERVICES section - REPLACE ENTIRE SECTION
if (Object.keys(changeQueue.services).length > 0) {
  console.log('🛠️ Saving services...');
  
  const currentServices = shopData.services || [];
  
  const processedServices = await Promise.all(
    currentServices.map(async (service) => {
      const queuedService = changeQueue.services[service.id];
      if (!queuedService) return service;
      
      if (queuedService.deleted) return null;
      
      const uploadedImageData = await Promise.all(
        (queuedService.images || service.images || [null, null, null]).map(async (img, index) => {
          if (!img) return { url: null, thumb: null, blur: null };

          if (typeof img === 'string' && img.startsWith('http')) {
            return { url: img, thumb: service.thumbnails?.[index] || null, blur: service.imageBlur?.[index] || null };
          }

          const storageKey = `${service.id}-${index}`;
          const fileToUpload = tempFileStorage[storageKey];

          if (fileToUpload instanceof File) {
            console.log(`📤 Uploading service image ${index + 1} for ${service.id}`);
            const [url, variants] = await Promise.all([
              uploadProductMedia(activeShopId || auth.currentUser.uid, service.id, fileToUpload, true, auth.currentUser.uid),
              generateImageVariants(fileToUpload).catch(err => { console.warn('⚠️ Thumbnail generation failed:', err); return null; }),
            ]);
            let thumb = null;
            if (variants) {
              try {
                thumb = await uploadProductThumbnail(activeShopId || auth.currentUser.uid, service.id, variants.thumbnail, true, auth.currentUser.uid);
              } catch (err) {
                console.warn('⚠️ Thumbnail upload failed:', err);
              }
            }
            return { url, thumb, blur: variants?.blurDataURL || null };
          }

          if (typeof img === 'object' && img !== null) {
            if (img.url && img.url.startsWith('http')) {
              return { url: img.url, thumb: service.thumbnails?.[index] || null, blur: service.imageBlur?.[index] || null };
            }
            if (img.preview) return { url: img.preview, thumb: null, blur: null };
          }

          if (typeof img === 'string' && img.startsWith('data:')) return { url: img, thumb: null, blur: null };

          return { url: null, thumb: null, blur: null };
        })
      );
      const uploadedImages = uploadedImageData.map(d => d.url);
      const uploadedThumbs = uploadedImageData.map(d => d.thumb);
      const uploadedBlurs = uploadedImageData.map(d => d.blur);

      const mergedService = {
        ...service,
        ...queuedService,
        images: uploadedImages,
        thumbnails: uploadedThumbs,
        imageBlur: uploadedBlurs,
      };
      return mergedService;
    })
  );

  const filteredServices = processedServices.filter(Boolean);

  // ✅ UPDATE LOCAL STATE
  setShopData(prev => ({
    ...prev,
    services: filteredServices
  }));

  // ✅ CLEAN for Firestore — thumbnails/imageBlur compacted in lockstep with images
  updatePayload.services = filteredServices.map(service => {
    const isValidHttp = (img) => typeof img === 'string' && img.startsWith('http');
    const images = (service.images || []).map(img => (isValidHttp(img) ? img : null)).filter(Boolean);
    const thumbnails = (service.images || []).map((img, i) => (isValidHttp(img) ? (service.thumbnails?.[i] || null) : undefined)).filter(x => x !== undefined);
    const imageBlur = (service.images || []).map((img, i) => (isValidHttp(img) ? (service.imageBlur?.[i] || null) : undefined)).filter(x => x !== undefined);
    return {
      ...service,
      images,
      thumbnails,
      imageBlur,
    };
  });
}

    // 4. HOME SECTIONS
    if (changeQueue.homeSections) {
  console.log('🏠 Saving home sections...');
  
  // ✅ FIX: Process each section and upload images
  const processedSections = await Promise.all(
    changeQueue.homeSections.map(async (section) => {
      // Create a clean copy of the section
      const cleanSection = {
        id: section.id,
        type: section.type,
        tabId: section.tabId || 'home',
        order: section.order,
        config: {}
      };
      
      // Copy all config properties except images
      if (section.config) {
        Object.keys(section.config).forEach(key => {
          if (key !== 'images' && key !== 'backgroundImage' && key !== 'image') {  // ADD 'image' here
            cleanSection.config[key] = section.config[key];
          }
        });
      }
      
      // ✅ NEW: Handle mission statement image
      if (section.type === 'mission-statement' && section.config?.image) {
        const img = section.config.image;
        
        // Already a valid HTTP URL
        if (typeof img === 'string' && img.startsWith('http')) {
          cleanSection.config.image = img;
        }
        // Data URL or object - needs upload
        else if (typeof img === 'object' || (typeof img === 'string' && img.startsWith('data:'))) {
          try {
            console.log('📤 Uploading mission statement image...');
            
            let file;
            if (typeof img === 'object' && img.file instanceof File) {
              file = img.file;
            } else if (typeof img === 'string' && img.startsWith('data:')) {
              const response = await fetch(img);
              const blob = await response.blob();
              file = new File([blob], `mission-${Date.now()}.jpg`, { type: 'image/jpeg' });
            } else if (img.preview && img.preview.startsWith('data:')) {
              const response = await fetch(img.preview);
              const blob = await response.blob();
              file = new File([blob], `mission-${Date.now()}.jpg`, { type: 'image/jpeg' });
            }
            
            if (file) {
              const imageId = `section-mission-${section.id}-${Date.now()}`;
              const url = await uploadHomeSectionImage(imageId, file);
              cleanSection.config.image = url;
              console.log('✅ Mission image uploaded:', url);
            } else {
              cleanSection.config.image = null;
            }
          } catch (error) {
            console.error('❌ Failed to upload mission image:', error);
            cleanSection.config.image = null;
          }
        } else {
          cleanSection.config.image = null;
        }
      }
      
      // ✅ Handle gallery images array
      if (section.config?.images && Array.isArray(section.config.images)) {
        // Uploaded in parallel (was a sequential for-loop — each image's compress
        // + upload waited on the previous one, so an 6-photo gallery took 6x as
        // long as it needed to).
        const uploadResults = await Promise.all(section.config.images.map(async (img, idx) => {
          if (!img) return null;

          // Already a valid HTTP URL
          if (typeof img === 'string' && img.startsWith('http')) return img;

          // Resolve to a File to hand off to compression. Prefer the original
          // File captured on select (img.file) over img.preview — the preview
          // is a base64 data: URL of the FULL-SIZE original photo, and re-fetching
          // it here to turn it back into a Blob was the single biggest source of
          // slowness on mobile (parsing a multi-MB base64 string), and it was
          // pure waste since the real File was sitting right next to it unused.
          let file = null;
          if (typeof img === 'object' && img?.file instanceof File) {
            file = img.file;
          } else if (typeof img === 'string' && img.startsWith('data:')) {
            const response = await fetch(img);
            const blob = await response.blob();
            file = new File([blob], `gallery-${Date.now()}.jpg`, { type: 'image/jpeg' });
          } else if (typeof img === 'object' && img !== null) {
            if (img.url && typeof img.url === 'string' && img.url.startsWith('http')) return img.url;
            if (img.preview && typeof img.preview === 'string' && img.preview.startsWith('http')) return img.preview;
            if (img.preview && typeof img.preview === 'string' && img.preview.startsWith('data:')) {
              const response = await fetch(img.preview);
              const blob = await response.blob();
              file = new File([blob], `gallery-${Date.now()}.jpg`, { type: 'image/jpeg' });
            }
          }

          if (!file) return null;

          try {
            console.log('📤 Uploading home section gallery image...');
            const imageId = `section-${section.id}-gallery-${idx}-${Date.now()}`;
            return await uploadHomeSectionImage(imageId, file);
          } catch (error) {
            console.error('❌ Failed to upload gallery image:', error);
            return null;
          }
        }));

        cleanSection.config.images = uploadResults.filter(Boolean);
      } else {
        cleanSection.config.images = [];
      }
      
      // ✅ Handle background image (existing code continues...)
      if (section.config?.backgroundImage) {
        const bg = section.config.backgroundImage;
        
        // Already a valid HTTP URL
        if (typeof bg === 'string' && bg.startsWith('http')) {
          cleanSection.config.backgroundImage = bg;
        }
        // Data URL - needs upload
        else if (typeof bg === 'string' && bg.startsWith('data:')) {
          try {
            console.log('📤 Uploading home section background image...');
            const response = await fetch(bg);
            const blob = await response.blob();
            const file = new File([blob], `bg-${Date.now()}.jpg`, { type: 'image/jpeg' });
            
            const imageId = `section-bg-${section.id}-${Date.now()}`;
            const url = await uploadHomeSectionImage(imageId, file);
            cleanSection.config.backgroundImage = url;
          } catch (error) {
            console.error('❌ Failed to upload background:', error);
            cleanSection.config.backgroundImage = null;
          }
        }
        // Object with preview/url
        else if (typeof bg === 'object' && bg !== null) {
          if (bg.url && typeof bg.url === 'string' && bg.url.startsWith('http')) {
            cleanSection.config.backgroundImage = bg.url;
          } else if (bg.preview && typeof bg.preview === 'string' && bg.preview.startsWith('http')) {
            cleanSection.config.backgroundImage = bg.preview;
          } else if (bg.preview && typeof bg.preview === 'string' && bg.preview.startsWith('data:')) {
            try {
              console.log('📤 Uploading background from object...');
              const response = await fetch(bg.preview);
              const blob = await response.blob();
              const file = new File([blob], `bg-${Date.now()}.jpg`, { type: 'image/jpeg' });
              
              const imageId = `section-bg-${section.id}-${Date.now()}`;
              const url = await uploadHomeSectionImage(imageId, file);
              cleanSection.config.backgroundImage = url;
            } catch (error) {
              console.error('❌ Failed to upload background:', error);
              cleanSection.config.backgroundImage = null;
            }
          } else {
            cleanSection.config.backgroundImage = null;
          }
        } else {
          cleanSection.config.backgroundImage = null;
        }
      }
      
      return cleanSection;
    })
  );
  
  console.log('✅ Home sections processed:', processedSections);
  
  // ✅ UPDATE LOCAL STATE
  setHomeSections(processedSections);
  
  // ✅ Final cleanup for Firestore
  updatePayload.homeSections = processedSections.map(section => ({
    id: section.id,
    type: section.type,
    tabId: section.tabId || 'home',
    order: section.order,
    config: {
      ...section.config,
      // Ensure images is an array of strings only
      images: Array.isArray(section.config.images) 
        ? section.config.images.filter(img => typeof img === 'string' && img.startsWith('http'))
        : [],
      // Ensure backgroundImage is a string or null
      backgroundImage: (section.config.backgroundImage && 
                       typeof section.config.backgroundImage === 'string' && 
                       section.config.backgroundImage.startsWith('http'))
        ? section.config.backgroundImage
        : null,
      // ✅ NEW: Ensure mission image is a string or null
      image: (section.config.image && 
              typeof section.config.image === 'string' && 
              section.config.image.startsWith('http'))
        ? section.config.image
        : null
    }
  }));
  
  console.log('✅ Home sections ready for Firestore:', updatePayload.homeSections);
}

    // 5. LICENSES
    if (changeQueue.licenses) {
      console.log('📄 Saving licenses...');
      
      const uploadedLicenses = await Promise.all(
        changeQueue.licenses.map(async (license) => {
          if (typeof license === 'string' && license.startsWith('http')) {
            return license;
          }
          
          if (license.file instanceof File) {
            const storageRef = ref(storage, `shops/${auth.currentUser.uid}/licenses/${license.id}`);
            const snapshot = await uploadBytes(storageRef, license.file);
            const url = await getDownloadURL(snapshot.ref);
            return { id: license.id, url, name: license.name };
          }
          
          return license;
        })
      );
      
      updatePayload.licenses = uploadedLicenses.filter(Boolean);
    }

    

    // 6. COMMUNITY POSTS
if (Object.keys(changeQueue.communityPosts || {}).length > 0) {
  console.log('📸 Saving community posts...', changeQueue.communityPosts);
  
  for (const postId in changeQueue.communityPosts) {
    const queuedPost = changeQueue.communityPosts[postId];
    
    // Handle deleted posts
    if (queuedPost.deleted) {
      try {
        await deleteCommunityPost(activeShopId || auth.currentUser.uid, postId);
        console.log('🗑️ Post deleted:', postId);
      } catch (error) {
        console.error('❌ Failed to delete post:', error);
      }
      continue;
    }
    
    // ✅ FIX: Upload ALL images, not just the first one
    const uploadedImages = await Promise.all(
      (queuedPost.images || []).map(async (img, index) => {
        if (!img) return null;
        if (typeof img === 'string' && img.startsWith('http')) return img;
        
        const storageKey = `community-${postId}-${index}`;
        const file = tempFileStorage[storageKey];
        
        if (file instanceof File) {
          try {
            const postType = file.type.startsWith('video/') ? 'clip' : 'image';
            const url = await uploadCommunityMedia(activeShopId || auth.currentUser.uid, file, postType, auth.currentUser.uid);
            console.log(`✅ Community media ${index} uploaded:`, url);
            return url;
          } catch (error) {
            console.error(`❌ Failed to upload media ${index}:`, error);
            return img.preview || img;
          }
        }
        
        return typeof img === 'string' ? img : img.preview || img;
      })
    );

    // Generate a thumbnail + blur placeholder for the first image (the one
    // used as contentUrl in feed/grid cards) when it was freshly uploaded.
    // Falls back to whatever the post already had otherwise.
    let contentThumbUrl = queuedPost.contentThumbUrl || null;
    let contentBlurDataURL = queuedPost.contentBlurDataURL || null;
    const firstPostImageFile = tempFileStorage[`community-${postId}-0`];
    if (firstPostImageFile instanceof File && firstPostImageFile.type.startsWith('image/')) {
      try {
        const variants = await generateImageVariants(firstPostImageFile);
        contentThumbUrl = await uploadCommunityThumbnail(activeShopId || auth.currentUser.uid, variants.thumbnail, auth.currentUser.uid);
        contentBlurDataURL = variants.blurDataURL;
      } catch (err) {
        console.warn('⚠️ Post thumbnail generation failed:', err);
      }
    }

    // Check if post exists in Firestore
    const postRef = doc(db, 'shops', activeShopId || auth.currentUser.uid, 'communityPosts', postId);
    const postSnap = await getDoc(postRef);

    if (postSnap.exists()) {
      // ✅ UPDATE EXISTING POST
      const updates = {
        caption: queuedPost.caption || queuedPost.name || '',
        address: queuedPost.address || '',
        coordinates: queuedPost.coordinates || null,
        images: uploadedImages.filter(Boolean), // ✅ SAVE ALL IMAGES
        contentUrl: uploadedImages.filter(Boolean)[0] || '', // ✅ Keep contentUrl for backward compatibility
        contentThumbUrl,
        contentBlurDataURL,
        type: (queuedPost.type === 'post' || !queuedPost.type) ? 'image' : queuedPost.type,
        updatedAt: new Date().toISOString()
      };

      try {
        await updateCommunityPost(activeShopId || auth.currentUser.uid, postId, updates);
        console.log('✅ Post updated:', postId);
      } catch (error) {
        console.error('❌ Failed to update post:', error);
      }
    } else {
      // ✅ CREATE NEW POST
      const postData = {
        type: (queuedPost.type === 'post' || !queuedPost.type) ? 'image' : queuedPost.type,
        contentUrl: uploadedImages.filter(Boolean)[0] || '',
        contentThumbUrl,
        contentBlurDataURL,
        images: uploadedImages.filter(Boolean), // ✅ SAVE ALL IMAGES
        caption: queuedPost.caption || queuedPost.name || '',
        coordinates: queuedPost.coordinates || null,
        address: queuedPost.address || ''
      };
      
      try {
        await saveCommunityPost(activeShopId || auth.currentUser.uid, postData);
        console.log('✅ New post created:', postId);
      } catch (error) {
        console.error('❌ Failed to save new post:', error);
      }
    }
  }
  
  console.log('✅ Community posts saved');
}

// 7. EVENTS
if (Object.keys(changeQueue.events || {}).length > 0) {
  console.log('📅 Saving events...', changeQueue.events);
  
  for (const eventId in changeQueue.events) {
    const eventData = changeQueue.events[eventId];
    
    // ✅ ADD: Verify event has required fields
    if (!eventData.isEvent || eventData.type !== 'event') {
      console.error('❌ Event missing required flags:', eventId, eventData);
      // Fix it before saving
      eventData.isEvent = true;
      eventData.type = 'event';
    }
    
    // Handle deleted events
    if (eventData.deleted) {
      try {
        await deleteDoc(doc(db, 'shops', activeShopId || auth.currentUser.uid, 'communityPosts', eventId));
        console.log('🗑️ Event deleted:', eventId);
      } catch (error) {
        console.error('❌ Failed to delete event:', error);
      }
      continue;
    }
    
    // Upload images if needed
    const uploadedImages = await Promise.all(
      (eventData.images || []).map(async (img, index) => {
        if (!img) return null;
        if (typeof img === 'string' && img.startsWith('http')) return img;
        
        const storageKey = `event-${eventId}-${index}`;
        const file = tempFileStorage[storageKey];
        
        if (file instanceof File) {
          try {
            const url = await uploadCommunityMedia(activeShopId || auth.currentUser.uid, file, 'image', auth.currentUser.uid);
            console.log(`✅ Event image ${index} uploaded:`, url);
            return url;
          } catch (error) {
            console.error('❌ Failed to upload event image:', error);
            return img.preview || img;
          }
        }
        
        return typeof img === 'string' ? img : img.preview || img;
      })
    );

    // Generate a thumbnail + blur placeholder for the first image (the one
    // used as contentUrl in feed/grid cards) when it was freshly uploaded.
    let eventContentThumbUrl = eventData.contentThumbUrl || null;
    let eventContentBlurDataURL = eventData.contentBlurDataURL || null;
    const firstEventImageFile = tempFileStorage[`event-${eventId}-0`];
    if (firstEventImageFile instanceof File && firstEventImageFile.type.startsWith('image/')) {
      try {
        const variants = await generateImageVariants(firstEventImageFile);
        eventContentThumbUrl = await uploadCommunityThumbnail(activeShopId || auth.currentUser.uid, variants.thumbnail, auth.currentUser.uid);
        eventContentBlurDataURL = variants.blurDataURL;
      } catch (err) {
        console.warn('⚠️ Event thumbnail generation failed:', err);
      }
    }

    // Check if event exists
    const eventRef = doc(db, 'shops', activeShopId || auth.currentUser.uid, 'communityPosts', eventId);
    const eventSnap = await getDoc(eventRef);

    // ✅ FIX: Build complete event document with ALL required fields
    const eventDoc = {
      name: eventData.name || '',
      price: eventData.price || '',
      description: eventData.description || '',
      category: eventData.category || 'Other',
      eventDate: eventData.eventDate || '',
      eventTime: eventData.eventTime || '',
      slots: eventData.slots || 1,
      address: eventData.address || '',
      coordinates: eventData.coordinates || null,
      city: eventData.city || null,
      images: uploadedImages.filter(Boolean),
      contentUrl: uploadedImages.filter(Boolean)[0] || '',
      contentThumbUrl: eventContentThumbUrl,
      contentBlurDataURL: eventContentBlurDataURL,
      type: 'event',           // ✅ REQUIRED
      isEvent: true,           // ✅ REQUIRED - for getShopEvents query
      visible: eventData.visible !== undefined ? eventData.visible : true,
      userSetVisibility: eventData.userSetVisibility !== undefined ? eventData.userSetVisibility : true,
      shopId: activeShopId || auth.currentUser.uid,  // ✅ ADD: Shop ID reference
      updatedAt: new Date().toISOString()
    };

    // For new events only
    if (!eventSnap.exists()) {
      eventDoc.createdAt = new Date().toISOString();
      eventDoc.engagement = {
        likes: [],
        likeCount: 0,
        views: 0
      };
    }

    try {
      await setDoc(eventRef, eventDoc, { merge: true });
      console.log('✅ Event saved:', eventId);
    } catch (error) {
      console.error('❌ Failed to save event:', error);
    }
  }
  
  console.log('✅ All events saved');
}

    // 6. TABS
    if (changeQueue.tabs) {
      console.log('📑 Saving tabs...');
      updatePayload.tabs = changeQueue.tabs;
    }

    // 6b. BACKGROUNDS
    if (changeQueue.backgrounds) {
      console.log('🖼️ Saving backgrounds...');
      updatePayload.profileBackgroundImages = changeQueue.backgrounds;
    }

    // 6c. CUSTOM CATEGORIES (product/service category lists + their store-type classification)
    if (changeQueue.productCategories) {
      console.log('🏷️ Saving product categories...');
      updatePayload.productCategories = changeQueue.productCategories;
    }
    if (changeQueue.serviceCategories) {
      console.log('🏷️ Saving service categories...');
      updatePayload.serviceCategories = changeQueue.serviceCategories;
    }
    if (changeQueue.categoryTypes) {
      console.log('🏷️ Saving category types...');
      updatePayload.categoryTypes = changeQueue.categoryTypes;
    }
    if (changeQueue.productCategoryOrder) {
      updatePayload.productCategoryOrder = changeQueue.productCategoryOrder;
    }
    if (changeQueue.serviceCategoryOrder) {
      updatePayload.serviceCategoryOrder = changeQueue.serviceCategoryOrder;
    }
    if (changeQueue.categoryColumns) {
      updatePayload.categoryColumns = changeQueue.categoryColumns;
    }


    // 7. STORE STATUS
    if (changeQueue.storeStatus !== null) {
      updatePayload.storeOpen = changeQueue.storeStatus;
    }

    // 8. UPDATE FIRESTORE
    updatePayload.updatedAt = new Date().toISOString();
    
    // Around line 2950 - RIGHT BEFORE updateDoc
    console.log('📤 Updating Firestore with:', Object.keys(updatePayload));

    // ✅ FINAL CLEANUP: Remove any remaining nested objects
    const finalCleanedPayload = cleanDataForFirestore(updatePayload);

    console.log('✅ Cleaned payload ready for Firestore');
    await updateDoc(shopRef, finalCleanedPayload);

    // Mirror items/services into the top-level items/services collections
    // (see src/firebase/itemsCollectionSync.js) — best-effort, never blocks
    // or fails this save; the embedded arrays above are the source of truth.
    {
      const mirrorShopId = activeShopId || auth.currentUser.uid;
      const mirrorShopFields = buildShopFields(mirrorShopId, { ...shopData, ...finalCleanedPayload });
      if (finalCleanedPayload.items) mirrorItemsFull(mirrorShopId, finalCleanedPayload.items, mirrorShopFields);
      if (finalCleanedPayload.services) mirrorServicesFull(mirrorShopId, finalCleanedPayload.services, mirrorShopFields);
    }

    // The public page caches shop docs for 5 minutes — without this, a save
    // here wouldn't show up there until that cache expires.
    invalidateShopCache(activeShopId || auth.currentUser.uid);

    // 9. RELOAD POSTS AND EVENTS AFTER SAVE
    const reloadedPosts = await getCommunityPostsForShop(activeShopId || auth.currentUser.uid);

    // ✅ FIX: Map contentUrl to images array for display
    const postsWithImages = reloadedPosts.map(post => {
      // If post has contentUrl but no images array, create one
      if (post.contentUrl && (!post.images || post.images.every(img => !img))) {
        return {
          ...post,
          images: [post.contentUrl, null, null],
          currentImageIndex: 0
        };
      }
      // If post already has images, keep them
      return post;
    });
    
    setCommunityPosts(postsWithImages);

    const reloadedEvents = await getShopEvents(activeShopId || auth.currentUser.uid);
console.log('📅 Reloaded events after save:', reloadedEvents);

// ✅ FIX: Ensure events have proper image structure
const eventsWithImages = reloadedEvents.map(event => {
  // If event has contentUrl but no images array, create one
  if (event.contentUrl && (!event.images || event.images.every(img => !img))) {
    return {
      ...event,
      images: [event.contentUrl, null, null],
      currentImageIndex: 0
    };
  }
  // If event already has images, keep them
  return event;
});

setEvents(eventsWithImages);

    // 10. CLEAR QUEUE & UPDATE STATE
    setChangeQueue({
      shopDetails: null,
      items: {},
      services: {},
      homeSections: null,
      communityPosts: {},
      events: {},
      licenses: null,
      backgrounds: null,
      storeStatus: null
    });

    setHasPendingChanges(false);
    setTempFileStorage({});

    console.log('✅ All changes saved successfully!');

// ✅ FIX: Update original data to match current state (with preview URLs)
const updatedOriginalData = {
  ...shopData,
  items: shopData.items || [],
  services: shopData.services || [],
  homeSections: homeSections || [],
  communityPosts: postsWithImages,
  events: eventsWithImages
};
setOriginalShopData(JSON.parse(JSON.stringify(updatedOriginalData)));

    
    if (updatePayload.name) {
      setOriginalShopName(updatePayload.name);
    }

    console.log('✅ All changes saved successfully!');

  } catch (error) {
    console.error('❌ Save failed:', error);
    alert(`Failed to save: ${error.message}`);
  } finally {
    setSaving(false);
  }
};

const getTotalChanges = () => {
  let count = 0;
  
  if (changeQueue.shopDetails && Object.keys(changeQueue.shopDetails).length > 0) {
    count++;
  }
  
  const itemChanges = Object.keys(changeQueue.items).length;
  if (itemChanges > 0) count += itemChanges;
  
  const serviceChanges = Object.keys(changeQueue.services).length;
  if (serviceChanges > 0) count += serviceChanges;
  
  // ✅ ADD: Count community posts
  const postChanges = Object.keys(changeQueue.communityPosts || {}).length;
  if (postChanges > 0) count += postChanges;
  
  // ✅ ADD: Count events
  const eventChanges = Object.keys(changeQueue.events || {}).length;
  if (eventChanges > 0) count += eventChanges;
  
  if (changeQueue.homeSections && changeQueue.homeSections.length > 0) {
    count++;
  }
  
  if (changeQueue.licenses && changeQueue.licenses.length > 0) {
    count++;
  }
  
  if (changeQueue.backgrounds && changeQueue.backgrounds.length > 0) {
    count++;
  }
  
  if (changeQueue.storeStatus !== null && changeQueue.storeStatus !== undefined) {
    count++;
  }

  if (changeQueue.productCategories || changeQueue.serviceCategories || changeQueue.categoryTypes
    || changeQueue.productCategoryOrder || changeQueue.serviceCategoryOrder || changeQueue.categoryColumns) {
    count++;
  }

  return count;
};

  const handleImageUpload = async (itemId, imageIndex, file) => {
  try {
    // CHANGED: Only allow images, reject videos
    const isImage = file.type.startsWith('image/');
    
    if (!isImage) {
      alert('Only images are allowed for items and services');
      return;
    }
    
    // Validate image
    validateImageFile(file, 20);

    // Show compression progress
    setCompressionProgress({
      text: 'Compressing image...',
      percent: 0
    });

    // Mirrors bulk upload: compression is a size optimization, not a hard
    // requirement, so a decode/compression failure (which can happen
    // transiently on mobile) falls back to the original file instead of
    // blocking the whole upload with an error — the user always ends up with
    // their photo either way, just occasionally uncompressed.
    let compressedFile;
    try {
      compressedFile = await compressProductImage(file, (progress) => {
        setCompressionProgress({
          text: 'Compressing image...',
          percent: progress
        });
      });
    } catch (compressErr) {
      console.warn('⚠️ Compression failed, using original file uncompressed:', compressErr);
      compressedFile = file;
    }

    setCompressionProgress(null);

    // Store the file in tempFileStorage for later upload during save
    const storageKey = `${itemId}-${imageIndex}`;
    const metadataKey = `${itemId}-${imageIndex}-metadata`;
    
    setTempFileStorage(prev => ({
      ...prev,
      [storageKey]: compressedFile,
      [metadataKey]: { isVideo: false, type: compressedFile.type }
    }));

    // Create preview immediately
    const preview = await readFileAsDataURL(compressedFile);
    const currentItem = shopData.items?.find(item => item.id === itemId);
    const currentService = shopData.services?.find(service => service.id === itemId);

    const mediaData = {
      preview,
      type: compressedFile.type,
      isVideo: false
    };

    if (currentItem) {
      const newImages = [...currentItem.images];
      newImages[imageIndex] = mediaData;
      handleItemUpdate(itemId, { images: newImages });
    } else if (currentService) {
      const newImages = [...currentService.images];
      newImages[imageIndex] = mediaData;
      handleServiceUpdate(itemId, { images: newImages });
    }

    console.log('✅ Image preview set, will upload on save');
  } catch (error) {
    console.error('❌ Error handling image:', error);
    setStatusMessage({ type: 'error', text: error.message || 'Failed to process image. Please try again.' });
    setTimeout(() => setStatusMessage(null), 5000);
  }
};

  // Mobile browsers (especially in-app/WebView browsers) can fail to open the
  // native file picker for an <input> that was never attached to the DOM.
  // Attaching it (off-screen) before calling .click() makes it reliable on mobile.
  const openProfilePictureUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.style.position = 'fixed';
    input.style.top = '-9999px';
    input.style.left = '-9999px';
    input.style.opacity = '0';
    document.body.appendChild(input);

    const cleanup = () => {
      if (input.parentNode) input.parentNode.removeChild(input);
    };

    input.onchange = async (e) => {
      try {
        const file = e.target.files?.[0];
        if (file) {
          validateImageFile(file, 20);

          // Mirrors bulk upload: fall back to the original file if compression
          // fails instead of blocking the upload with an error.
          let compressedFile;
          try {
            compressedFile = await compressProductImage(file, (progress) => {
              setCompressionProgress({
                text: 'Compressing image...',
                percent: progress
              });
            });
          } catch (compressErr) {
            console.warn('⚠️ Compression failed, using original file uncompressed:', compressErr);
            compressedFile = file;
          }
          setCompressionProgress(null);

          const preview = await readFileAsDataURL(compressedFile);
          handleUpdateShop({
            profile: {
              file: compressedFile,
              preview,
              type: compressedFile.type,
              name: compressedFile.name
            }
          });
        }
      } catch (error) {
        console.error('Error uploading profile image:', error);
        setStatusMessage({ type: 'error', text: error.message || 'Failed to upload profile image' });
        setTimeout(() => setStatusMessage(null), 5000);
      } finally {
        cleanup();
      }
    };

    input.click();
  };

  return (
    <ThemeProvider theme={shopData?.theme || DEFAULT_THEME}>
      <PageContainer>
      <style>{`
        @keyframes visToastAnim {
          0%   { opacity: 0; transform: translateY(4px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes statusMsgEaseIn {
          0%   { opacity: 0; transform: translate(-50%, -12px); }
          100% { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
      {statusMessage && (
        <div
          onClick={() => setStatusMessage(null)}
          style={{
            position: 'fixed',
            top: '1rem',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10000,
            background: statusMessage.type === 'error' ? 'rgba(180,30,30,0.95)' : statusMessage.type === 'success' ? 'rgba(30,140,60,0.95)' : 'rgba(20,20,20,0.95)',
            color: '#fff',
            padding: '0.65rem 1.1rem',
            borderRadius: '10px',
            fontSize: '0.85rem',
            fontWeight: 600,
            boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
            maxWidth: '90vw',
            textAlign: 'center',
            cursor: 'pointer',
            animation: 'statusMsgEaseIn 0.3s ease',
          }}
        >
          {statusMessage.text}
        </div>
      )}
      <Header theme={shopData?.theme} $hidden={headerHidden} $expanded={hideHeaderTabButtons}>
  <HeaderLeft>
    <LogoImage
                src={shopData?.profile ? (typeof shopData.profile === 'string' ? shopData.profile : shopData.profile.preview) : logo}
                alt={shopData?.profile ? (shopData?.name || 'Shop Logo') : "KalKode Logo"}
                $isProfile={!!shopData?.profile}
                $expanded={hideHeaderTabButtons}
                onClick={() => navigate(`/shop/${activeShopId || auth.currentUser.uid}/view`)}
              />
    <div ref={shopsDropdownRef} style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
      <HeaderLogo onClick={() => setShowShopsDropdown(v => !v)} theme={shopData?.theme} $expanded={hideHeaderTabButtons}>
        {shopData?.name || accessibleShops.find(s => s.shopId === activeShopId)?.shopName || 'MY SHOP'}
      </HeaderLogo>
      <button
        onClick={() => setShowShopsDropdown(v => !v)}
        style={{
          background: 'transparent',
          border: 'none',
          color: shopData?.theme?.colors?.accent || '#800000',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          padding: '0.2rem',
          marginLeft: '-7px',
          borderRadius: '4px',
          flexShrink: 0,
        }}
        title="Switch shop"
      >
        {showShopsDropdown ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>

      {showShopsDropdown && (
          <div style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            left: 0,
            zIndex: 201,
            background: shopData?.theme?.colors?.background || '#0a0a0a',
            border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}33`,
            borderRadius: '14px',
            minWidth: '250px',
            overflow: 'hidden',
            boxShadow: '0 16px 48px rgba(0,0,0,0.6), 0 4px 16px rgba(0,0,0,0.3)'
          }}>
            {/* Header */}
            <div style={{
              padding: '0.75rem 1rem 0.5rem',
              borderBottom: '1px solid rgba(255,255,255,0.06)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
              <span style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.08em', opacity: 0.4, color: shopData?.theme?.colors?.text || '#fff', textTransform: 'uppercase' }}>
                My Stores
              </span>
              <span style={{ fontSize: '0.72rem', opacity: 0.35, color: shopData?.theme?.colors?.text || '#fff' }}>
                {accessibleShops.length} store{accessibleShops.length !== 1 ? 's' : ''}
              </span>
            </div>

            <div style={{
              maxHeight: '45vh',
              overflowY: 'auto',
              overscrollBehavior: 'contain',
              WebkitOverflowScrolling: 'touch',
            }}>
            {accessibleShops.map(shop => {
              const isActive = activeShopId === shop.shopId;
              const isLocked = shop.storeStatus === 'suspended' || shop.balanceDue;
              const isPrimary = shop.isOwn && shop.shopId === auth.currentUser?.uid;
              const isRemoving = removingShopId === shop.shopId;
              const accent = shopData?.theme?.colors?.accent || '#800000';
              const bg = shopData?.theme?.colors?.background || '#0a0a0a';
              const txt = shopData?.theme?.colors?.text || '#fff';
              return (
                <div
                  key={shop.shopId}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: '1px solid rgba(255,255,255,0.05)',
                    background: isActive ? `${accent}18` : 'transparent',
                    transition: 'background 0.15s',
                  }}
                >
                  {/* Main clickable area */}
                  <button
                    onClick={() => { setActiveShop(shop.shopId); setShowShopsDropdown(false); }}
                    style={{
                      flex: 1, minWidth: 0,
                      display: 'flex', alignItems: 'center', gap: '0.65rem',
                      padding: '0.75rem 0 0.75rem 1rem',
                      background: 'transparent', border: 'none',
                      color: txt, cursor: 'pointer',
                      fontSize: '0.85rem', textAlign: 'left',
                    }}
                  >
                    {/* Avatar */}
                    <div style={{ position: 'relative', flexShrink: 0 }}>
                      {shop.shopImage ? (
                        <img src={shop.shopImage} alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', opacity: isLocked ? 0.5 : 1 }} />
                      ) : (
                        <div style={{
                          width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                          background: isActive ? `${accent}33` : 'rgba(255,255,255,0.08)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          opacity: isLocked ? 0.5 : 1,
                        }}>
                          <Building2 size={14} style={{ opacity: 0.7 }} />
                        </div>
                      )}
                      <div style={{
                        position: 'absolute', bottom: -1, right: -1,
                        width: 9, height: 9, borderRadius: '50%',
                        background: isLocked ? '#f59e0b' : '#22c55e',
                        border: '1.5px solid ' + bg,
                      }} />
                    </div>

                    {/* Name + tag */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: isActive ? 700 : 500, fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', opacity: isLocked ? 0.6 : 1 }}>
                        {shop.shopName || (isPrimary ? 'My Shop' : 'Unnamed Store')}
                      </div>
                      <div style={{ fontSize: '0.7rem', opacity: 0.45, marginTop: '0.1rem' }}>
                        {!shop.isOwn ? 'Shared with you' : isLocked ? 'Needs attention' : 'Active & Open'}
                      </div>
                    </div>

                    {/* Badges */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', flexShrink: 0 }}>
                      {isLocked && (
                        <div style={{
                          display: 'flex', alignItems: 'center', gap: '0.2rem',
                          background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.3)',
                          borderRadius: '6px', padding: '0.15rem 0.4rem',
                          fontSize: '0.65rem', fontWeight: 700, color: '#f59e0b',
                        }}>
                          <Lock size={9} /> Locked
                        </div>
                      )}
                      {isActive && <Check size={14} style={{ color: accent }} />}
                    </div>
                  </button>

                  {/* Trash / Leave button */}
                  {!isPrimary && (
                    <button
                      onClick={(e) => handleRemoveShop(shop, e)}
                      disabled={isRemoving}
                      title={shop.isOwn ? 'Delete shop' : 'Leave shop'}
                      style={{
                        flexShrink: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        width: 32, height: 32,
                        marginRight: '0.5rem',
                        background: 'transparent',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: isRemoving ? 'not-allowed' : 'pointer',
                        color: isRemoving ? 'rgba(255,255,255,0.2)' : 'rgba(239,68,68,0.55)',
                        transition: 'color 0.15s, background 0.15s',
                        padding: 0,
                      }}
                      onMouseEnter={e => { if (!isRemoving) { e.currentTarget.style.color = '#ef4444'; e.currentTarget.style.background = 'rgba(239,68,68,0.1)'; }}}
                      onMouseLeave={e => { e.currentTarget.style.color = isRemoving ? 'rgba(255,255,255,0.2)' : 'rgba(239,68,68,0.55)'; e.currentTarget.style.background = 'transparent'; }}
                    >
                      {isRemoving
                        ? <span style={{ fontSize: '0.6rem', opacity: 0.5 }}>…</span>
                        : <Trash2 size={14} />
                      }
                    </button>
                  )}
                </div>
              );
            })}

            {accessibleShops.length === 0 && (
              <div style={{
                padding: '1rem',
                color: 'rgba(255,255,255,0.35)',
                fontSize: '0.8rem',
                fontStyle: 'italic',
              }}>
                No stores yet
              </div>
            )}
            </div>

            <div style={{ padding: '0.5rem', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
              <button
                onClick={() => { setShowShopsDropdown(false); setNewShopName(''); setShowNewShopModal(true); }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.6rem',
                  width: '100%',
                  padding: '0.65rem 0.75rem',
                  background: `${shopData?.theme?.colors?.accent || '#800000'}12`,
                  border: `1px dashed ${shopData?.theme?.colors?.accent || '#800000'}44`,
                  borderRadius: '10px',
                  color: shopData?.theme?.colors?.accent || '#800000',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  textAlign: 'left',
                  fontWeight: '600',
                  transition: 'background 0.15s',
                }}
              >
                <Plus size={15} />
                Create New Store
              </button>
            </div>
          </div>
      )}
    </div>
  </HeaderLeft>

  {/* Desktop center tabs — first 3 shown; burger handles the rest */}
  <HeaderCenter>
    {mainHeaderTabs.map(tab => {
      const IconComp = TAB_ICONS[tab.icon] || Store;
      return (
        <HeaderTabButton
          key={tab.id}
          theme={shopData?.theme}
          active={activeTab === tab.id}
          onClick={() => setActiveTab(tab.id)}
          title={tab.label}
          style={tab.visible === false ? { opacity: 0.4 } : undefined}
        >
          <IconComp size={18} />
          <span className="tab-label">{tab.label}</span>
        </HeaderTabButton>
      );
    })}
  </HeaderCenter>

  {/* Header right — burger when >3 tabs, otherwise theme controls */}
  <HeaderRight>
    {(canEditActiveShop || activeShopData) && (
      <HeaderButton
        onClick={() => setShowShopSettingsPanel(true)}
        theme={shopData?.theme}
        title="Shop settings"
      >
        <Settings size={18} />
      </HeaderButton>
    )}
    {(hideHeaderTabButtons || shopTabs.length > 3) ? (
      <HeaderButton
        onClick={() => setNavPanelOpen(true)}
        theme={shopData?.theme}
        title="Navigation & settings"
      >
        <Menu size={20} />
      </HeaderButton>
    ) : (
      <HeaderButton
        onClick={handleLogout}
        theme={shopData?.theme}
        title="Logout"
      >
        <LogOut size={16} />
      </HeaderButton>
    )}
  </HeaderRight>
{/* Mobile Tab Bar — first 3 shown; burger handles the rest.
    Omitted entirely (not just empty) when header tab buttons are hidden,
    so it doesn't leave an empty gap under the header. */}
{mainHeaderTabs.length > 0 && (
  <MobileTabBar theme={shopData?.theme} $hidden={headerHidden}>
    {mainHeaderTabs.map(tab => (
      <MinimalTabButton
        key={tab.id}
        theme={shopData?.theme}
        active={activeTab === tab.id}
        onClick={() => setActiveTab(tab.id)}
        style={tab.visible === false ? { opacity: 0.4 } : undefined}
      >
        {tab.label}
      </MinimalTabButton>
    ))}
  </MobileTabBar>
)}
      </Header>

      {/* Side nav panel — tabs + controls, appears when >3 tabs */}
      {navPanelOpen && (() => {
        const accent  = shopData?.theme?.colors?.accent  || '#800000';
        const surface = shopData?.theme?.colors?.surface || '#1a1a1a';
        const text    = shopData?.theme?.colors?.text    || '#ffffff';
        const bg      = shopData?.theme?.colors?.background || '#000000';
        return (
          <>
            {/* Overlay */}
            <div
              onClick={() => setNavPanelOpen(false)}
              style={{
                position: 'fixed', inset: 0,
                background: 'rgba(0,0,0,0.55)',
                backdropFilter: 'blur(4px)',
                WebkitBackdropFilter: 'blur(4px)',
                zIndex: 9998,
              }}
            />
            {/* Panel */}
            <div style={{
              position: 'fixed', top: 0, right: 0,
              height: '100%', width: 'fit-content', minWidth: '180px', maxWidth: 'min(240px, 75vw)',
              background: surface,
              borderLeft: `1px solid ${accent}30`,
              zIndex: 9999,
              display: 'flex', flexDirection: 'column',
              boxShadow: '-8px 0 48px rgba(0,0,0,0.55)',
              animation: 'navPanelIn 0.25s cubic-bezier(0.34,1.56,0.64,1)',
            }}>
              <style>{`@keyframes navPanelIn { from { transform: translateX(100%); opacity:0; } to { transform: translateX(0); opacity:1; } }`}</style>
              {/* Header */}
              <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '1.1rem 1.1rem 0.8rem',
                borderBottom: `1px solid ${accent}18`,
              }}>
                <span style={{ fontSize: '0.72rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '1.5px', color: accent }}>
                  Navigation
                </span>
                <button
                  onClick={() => setNavPanelOpen(false)}
                  style={{ background: 'transparent', border: 'none', color: text, cursor: 'pointer', padding: '0.3rem', borderRadius: '50%', display: 'flex', opacity: 0.6 }}
                >
                  <X size={18} />
                </button>
              </div>
              {/* Tab list */}
              <div style={{ flex: 1, overflowY: 'auto', padding: '0.65rem 0.6rem' }}>
                {shopTabs.map(tab => {
                  const IconComp = TAB_ICONS[tab.icon] || Store;
                  const isActive = activeTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      onClick={() => { setActiveTab(tab.id); setNavPanelOpen(false); }}
                      style={{
                        width: '100%', display: 'flex', alignItems: 'center', gap: '0.75rem',
                        padding: '0.75rem 0.85rem', border: 'none',
                        borderRadius: '12px',
                        borderLeft: `3px solid ${isActive ? accent : 'transparent'}`,
                        background: isActive ? `${accent}18` : 'transparent',
                        color: isActive ? accent : text,
                        fontSize: '0.88rem', fontWeight: isActive ? 700 : 500,
                        cursor: 'pointer', textAlign: 'left', marginBottom: '3px',
                        opacity: tab.visible === false ? 0.45 : 1,
                      }}
                    >
                      <IconComp size={17} />
                      {tab.label}
                      {tab.visible === false && (
                        <span style={{ marginLeft: 'auto', fontSize: '0.65rem', opacity: 0.5 }}>hidden</span>
                      )}
                    </button>
                  );
                })}
              </div>
              {/* Footer — theme controls */}
              <div style={{
                borderTop: `1px solid ${accent}18`,
                padding: '0.75rem 0.6rem',
                display: 'flex', flexDirection: 'column', gap: '4px',
              }}>
                <button
                  onClick={() => { refreshTheme(); }}
                  style={{
                    width: '100%', display: 'flex', alignItems: 'center', gap: '0.65rem',
                    padding: '0.6rem 0.85rem', border: `1px solid ${accent}25`,
                    borderRadius: '10px', background: 'transparent',
                    color: text, fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  <RefreshCw size={15} /> Random Theme
                </button>
                <button
                  onClick={togglePinStyle}
                  style={{
                    width: '100%', display: 'flex', alignItems: 'center', gap: '0.65rem',
                    padding: '0.6rem 0.85rem', border: `1px solid ${accent}25`,
                    borderRadius: '10px',
                    background: isPinned ? `${accent}18` : 'transparent',
                    color: isPinned ? accent : text,
                    fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  <ThumbsUp size={15} /> {isPinned ? 'Unpin Theme' : 'Pin Theme'}
                </button>
                <button
                  onClick={handleLogout}
                  style={{
                    width: '100%', display: 'flex', alignItems: 'center', gap: '0.65rem',
                    padding: '0.6rem 0.85rem', border: '1px solid rgba(239,68,68,0.3)',
                    borderRadius: '10px', background: 'transparent',
                    color: '#ef4444', fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  <LogOut size={15} /> Logout
                </button>
              </div>
            </div>
          </>
        );
      })()}

      {/* Shop Settings panel — store status, sharing, store type, locations. Same slide-in style as the nav panel. */}
      {showShopSettingsPanel && (() => {
        const accent  = shopData?.theme?.colors?.accent  || '#800000';
        const surface = shopData?.theme?.colors?.surface || '#1a1a1a';
        const text    = shopData?.theme?.colors?.text    || '#ffffff';
        const balanceDue = billingData && calculateOutstandingBalance(billingData) > 0;
        const currentPlan = getPlanFromBilling(billingData);
        const isFree = currentPlan === 'free';
        const isOpen = storeOpen && !balanceDue && !isFree;
        const amountDue = billingData ? calculateOutstandingBalance(billingData) : 0;
        return (
          <>
            {/* Overlay */}
            <div
              onClick={() => setShowShopSettingsPanel(false)}
              style={{
                position: 'fixed', inset: 0,
                background: 'rgba(0,0,0,0.55)',
                backdropFilter: 'blur(4px)',
                WebkitBackdropFilter: 'blur(4px)',
                zIndex: 9998,
              }}
            />
            {/* Panel */}
            <div style={{
              position: 'fixed', top: 0, right: 0,
              height: '100%', width: 'fit-content', minWidth: '260px', maxWidth: 'min(340px, 85vw)',
              background: surface,
              borderLeft: `1px solid ${accent}30`,
              zIndex: 9999,
              display: 'flex', flexDirection: 'column',
              boxShadow: '-8px 0 48px rgba(0,0,0,0.55)',
              animation: 'navPanelIn 0.25s cubic-bezier(0.34,1.56,0.64,1)',
              overflowY: 'auto',
            }}>
              {/* Header */}
              <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '1.1rem 1.1rem 0.8rem',
                borderBottom: `1px solid ${accent}18`,
              }}>
                <span style={{ fontSize: '0.72rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '1.5px', color: accent }}>
                  Shop Settings
                </span>
                <button
                  onClick={() => setShowShopSettingsPanel(false)}
                  style={{ background: 'transparent', border: 'none', color: text, cursor: 'pointer', padding: '0.3rem', borderRadius: '50%', display: 'flex', opacity: 0.6 }}
                >
                  <X size={18} />
                </button>
              </div>

              <div style={{ flex: 1, padding: '1rem 1.1rem', display: 'flex', flexDirection: 'column', gap: '0.9rem' }}>

                {/* Store Open/Closed Toggle — owners and shared admins */}
                {canEditShopCards && (
                  <div
                    onClick={handleToggleStoreStatus}
                    title={balanceDue ? `Pay ${formatCurrency(amountDue)} to unlock your store` : 'Click to open or close your store'}
                    style={{
                      display: 'flex', alignItems: 'center', gap: '0.65rem',
                      padding: '0.65rem 1rem',
                      background: balanceDue
                        ? 'rgba(245,158,11,0.08)'
                        : isOpen
                          ? 'linear-gradient(135deg, rgba(34,197,94,0.1), rgba(16,185,129,0.06))'
                          : 'rgba(255,255,255,0.04)',
                      border: `1px solid ${balanceDue ? 'rgba(245,158,11,0.3)' : isOpen ? 'rgba(34,197,94,0.25)' : 'rgba(255,255,255,0.1)'}`,
                      borderRadius: '10px',
                      cursor: 'pointer',
                      transition: 'all 0.25s ease',
                    }}
                  >
                    {balanceDue ? (
                      <Lock size={12} style={{ color: '#f59e0b', flexShrink: 0 }} />
                    ) : (
                      <div style={{
                        width: 8, height: 8, borderRadius: '50%',
                        background: isOpen ? '#22c55e' : 'rgba(255,255,255,0.25)',
                        boxShadow: isOpen ? '0 0 8px rgba(34,197,94,0.6)' : 'none',
                        flexShrink: 0,
                      }} />
                    )}
                    <span style={{
                      fontSize: '0.85rem', fontWeight: 600,
                      color: balanceDue ? '#f59e0b' : isOpen ? '#22c55e' : text,
                      opacity: balanceDue ? 1 : isOpen ? 1 : 0.5,
                      letterSpacing: '0.02em',
                    }}>
                      {balanceDue
                        ? `Locked · ${formatCurrency(amountDue)} to unlock`
                        : isFree
                          ? 'Free Plan · Items hidden'
                          : isOpen ? 'Store is Open' : 'Store is Closed'}
                    </span>
                  </div>
                )}

                {/* Header Tab Buttons Toggle — owners and shared admins */}
                {canEditShopCards && (
                  <div
                    onClick={() => handleUpdateShop({ hideHeaderTabs: !shopData?.hideHeaderTabs })}
                    title={shopData?.hideHeaderTabs
                      ? 'Tab buttons are hidden from the header — visitors use the burger menu. Click to show them again.'
                      : 'Tab buttons are shown in the header. Click to hide them so visitors only see the burger menu.'}
                    style={{
                      display: 'flex', alignItems: 'center', gap: '0.65rem',
                      padding: '0.65rem 1rem',
                      background: shopData?.hideHeaderTabs ? 'rgba(255,255,255,0.04)' : `${accent}10`,
                      border: `1px solid ${shopData?.hideHeaderTabs ? 'rgba(255,255,255,0.1)' : `${accent}30`}`,
                      borderRadius: '10px',
                      cursor: 'pointer',
                      transition: 'all 0.25s ease',
                    }}
                  >
                    <Menu size={14} style={{ color: shopData?.hideHeaderTabs ? text : accent, opacity: shopData?.hideHeaderTabs ? 0.5 : 1, flexShrink: 0 }} />
                    <span style={{ fontSize: '0.85rem', fontWeight: 600, color: shopData?.hideHeaderTabs ? text : accent, opacity: shopData?.hideHeaderTabs ? 0.65 : 1 }}>
                      {shopData?.hideHeaderTabs ? 'Tab buttons hidden — burger menu only' : 'Tab buttons shown in header'}
                    </span>
                    <div style={{
                      marginLeft: 'auto', width: '34px', height: '20px', borderRadius: '10px', flexShrink: 0,
                      background: shopData?.hideHeaderTabs ? 'rgba(255,255,255,0.15)' : accent,
                      position: 'relative', transition: 'background 0.2s ease',
                    }}>
                      <div style={{
                        position: 'absolute', top: '2px', left: shopData?.hideHeaderTabs ? '2px' : '16px',
                        width: '16px', height: '16px', borderRadius: '50%', background: '#fff',
                        transition: 'left 0.2s ease', boxShadow: '0 1px 3px rgba(0,0,0,0.4)',
                      }} />
                    </div>
                  </div>
                )}

                {/* To-Do List — collapsible accordion, for owners (when shared) and shared-access users */}
                {((canEditActiveShop && shopAccessData && Object.keys(shopAccessData.sharedUserMap).length > 0) || (!canEditActiveShop && activeShopData)) && (
                  <div>
                    <button
                      onClick={() => setTodoSectionExpanded(o => !o)}
                      style={{
                        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                        padding: '0.6rem 1.25rem', background: todoSectionExpanded ? `${accent}18` : 'transparent',
                        border: `1px solid ${accent}66`, borderRadius: '8px', color: accent,
                        fontSize: '0.85rem', fontWeight: '600', cursor: 'pointer', letterSpacing: '0.05em',
                      }}
                    >
                      <CheckSquare size={15} /> To-Do List
                      {todoItems.filter(t => !t.done).length > 0 && (
                        <span style={{
                          background: accent, color: '#fff', borderRadius: '50%',
                          width: '18px', height: '18px', fontSize: '0.7rem',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700',
                        }}>
                          {todoItems.filter(t => !t.done).length}
                        </span>
                      )}
                      <ChevronDown size={14} style={{ marginLeft: 'auto', transform: todoSectionExpanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }} />
                    </button>

                    {todoSectionExpanded && (
                      <div style={{ marginTop: '0.6rem', padding: '0.85rem', background: 'rgba(255,255,255,0.03)', border: `1px solid ${accent}22`, borderRadius: '10px' }}>
                        {/* Add new todo */}
                        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.85rem' }}>
                          <input
                            type="text"
                            placeholder="Add a new task..."
                            value={newTodoText}
                            onChange={e => setNewTodoText(e.target.value)}
                            onKeyDown={e => e.key === 'Enter' && handleAddTodo()}
                            style={{
                              flex: 1, padding: '0.55rem 0.75rem',
                              background: 'rgba(255,255,255,0.06)', border: `1px solid ${accent}44`,
                              borderRadius: '8px', color: '#fff', fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box'
                            }}
                          />
                          <button
                            onClick={handleAddTodo}
                            disabled={todoSaving || !newTodoText.trim()}
                            style={{
                              padding: '0.55rem 0.8rem', borderRadius: '8px', border: 'none',
                              background: newTodoText.trim() && !todoSaving ? accent : `${accent}4D`,
                              color: '#fff', cursor: newTodoText.trim() && !todoSaving ? 'pointer' : 'not-allowed',
                              fontSize: '0.85rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.3rem'
                            }}
                          >
                            <Plus size={15} />
                          </button>
                        </div>

                        {/* Todo items */}
                        {todoItems.length === 0 ? (
                          <div style={{ opacity: 0.35, fontSize: '0.82rem', color: text, padding: '0.4rem 0', textAlign: 'center' }}>
                            No tasks yet. Add one above.
                          </div>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxHeight: '260px', overflowY: 'auto' }}>
                            {todoItems.map(item => (
                              <div
                                key={item.id}
                                style={{
                                  display: 'flex', alignItems: 'flex-start', gap: '0.55rem',
                                  padding: '0.55rem 0.65rem',
                                  background: item.done ? 'rgba(255,255,255,0.02)' : 'rgba(255,255,255,0.05)',
                                  borderRadius: '8px',
                                  border: `1px solid ${item.done ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.1)'}`,
                                }}
                              >
                                <button
                                  onClick={() => handleToggleTodo(item)}
                                  style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '2px 0 0', color: item.done ? '#4CAF50' : accent, flexShrink: 0 }}
                                  title={item.done ? 'Mark undone' : 'Mark done'}
                                >
                                  {item.done ? <CheckSquare size={16} /> : <Square size={16} />}
                                </button>

                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div style={{
                                    fontSize: '0.82rem',
                                    color: text,
                                    textDecoration: item.done ? 'line-through' : 'none',
                                    opacity: item.done ? 0.45 : 1,
                                    wordBreak: 'break-word',
                                  }}>
                                    {item.text}
                                  </div>
                                  {item.claimedBy && (
                                    <div style={{ fontSize: '0.68rem', opacity: 0.55, color: accent, marginTop: '0.15rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                                      <Flag size={10} /> {item.claimedBy.displayName}
                                    </div>
                                  )}
                                </div>

                                <button
                                  onClick={() => handleClaimTodo(item)}
                                  title={item.claimedBy?.uid === auth.currentUser?.uid ? 'Unclaim' : 'Claim this task'}
                                  style={{
                                    background: item.claimedBy?.uid === auth.currentUser?.uid ? `${accent}33` : 'transparent',
                                    border: `1px solid ${accent}44`, borderRadius: '6px', color: accent,
                                    cursor: 'pointer', padding: '0.2rem 0.4rem', fontSize: '0.68rem', fontWeight: 600,
                                    display: 'flex', alignItems: 'center', gap: '0.2rem', flexShrink: 0, whiteSpace: 'nowrap',
                                  }}
                                >
                                  <Flag size={10} />
                                  {item.claimedBy?.uid === auth.currentUser?.uid ? 'Claimed' : 'Claim'}
                                </button>

                                <button
                                  onClick={() => handleDeleteTodo(item)}
                                  title="Delete task"
                                  style={{ background: 'transparent', border: 'none', color: '#f44336', cursor: 'pointer', padding: '0.15rem', display: 'flex', alignItems: 'center', flexShrink: 0 }}
                                >
                                  <Trash2 size={13} />
                                </button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Share Store — collapsible accordion, owners and shared admins */}
                {canEditShopCards && (
                  <div>
                    <button
                      onClick={() => setShareSectionExpanded(o => !o)}
                      style={{
                        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                        padding: '0.6rem 1.25rem', background: shareSectionExpanded ? `${accent}18` : 'transparent',
                        border: `1px solid ${accent}66`, borderRadius: '8px', color: accent,
                        fontSize: '0.85rem', fontWeight: '600', cursor: 'pointer', letterSpacing: '0.05em',
                      }}
                    >
                      <Users size={15} /> Share Store
                      <ChevronDown size={14} style={{ marginLeft: 'auto', transform: shareSectionExpanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }} />
                    </button>

                    {shareSectionExpanded && (
                      <div style={{ marginTop: '0.6rem', padding: '0.85rem', background: 'rgba(255,255,255,0.03)', border: `1px solid ${accent}22`, borderRadius: '10px' }}>
                        <p style={{ margin: '0 0 0.85rem', color: text, opacity: 0.65, fontSize: '0.8rem', lineHeight: 1.5 }}>
                          Give another user access to manage this store's orders and inventory.
                        </p>

                        {/* Invite form */}
                        <div style={{ marginBottom: '0.85rem' }}>
                          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
                            <input
                              type="email"
                              placeholder="user@gmail.com"
                              value={shareEmail}
                              onChange={e => setShareEmail(e.target.value)}
                              onKeyDown={e => e.key === 'Enter' && handleShareInvite()}
                              style={{
                                flex: 1, padding: '0.55rem 0.75rem',
                                background: 'rgba(255,255,255,0.06)', border: `1px solid ${accent}44`,
                                borderRadius: '8px', color: '#fff', fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box'
                              }}
                            />
                            <select
                              value={shareRole}
                              onChange={e => setShareRole(e.target.value)}
                              style={{
                                padding: '0.55rem 0.6rem', background: 'rgba(20,20,20,0.95)',
                                border: `1px solid ${accent}44`, borderRadius: '8px', color: '#fff',
                                fontSize: '0.82rem', cursor: 'pointer'
                              }}
                            >
                              <option value="staff">Staff</option>
                              <option value="admin">Admin</option>
                            </select>
                          </div>
                          {shareError && <div style={{ color: '#f44336', fontSize: '0.78rem', marginBottom: '0.5rem' }}>{shareError}</div>}
                          {shareSuccess && <div style={{ color: '#4CAF50', fontSize: '0.78rem', marginBottom: '0.5rem' }}>{shareSuccess}</div>}
                          <button
                            onClick={handleShareInvite}
                            disabled={shareLoading || !shareEmail.trim()}
                            style={{
                              width: '100%', padding: '0.6rem', borderRadius: '8px', border: 'none',
                              background: shareEmail.trim() && !shareLoading ? accent : `${accent}4D`,
                              color: '#fff', cursor: shareEmail.trim() && !shareLoading ? 'pointer' : 'not-allowed',
                              fontSize: '0.85rem', fontWeight: 600
                            }}
                          >
                            {shareLoading ? 'Sending...' : 'Send Invite'}
                          </button>
                        </div>

                        <div style={{ borderTop: `1px solid ${accent}22`, margin: '0.75rem 0' }} />

                        <div style={{ fontSize: '0.75rem', opacity: 0.55, marginBottom: '0.5rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: text }}>
                          Current Access
                        </div>
                        {loadingShareAccess ? (
                          <div style={{ opacity: 0.45, fontSize: '0.82rem', color: text }}>Loading...</div>
                        ) : shopAccessData && (
                          Object.entries(shopAccessData.sharedUserMap).length === 0 && shopAccessData.pendingInvites.length === 0 ? (
                            <div style={{ opacity: 0.35, fontSize: '0.82rem', color: text, padding: '0.4rem 0' }}>
                              No users have been given access yet.
                            </div>
                          ) : (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem', maxHeight: '220px', overflowY: 'auto' }}>
                              {Object.entries(shopAccessData.sharedUserMap).map(([uid, entry]) => (
                                <div key={uid} style={{
                                  display: 'flex', alignItems: 'center', gap: '0.5rem',
                                  padding: '0.5rem 0.65rem', background: 'rgba(255,255,255,0.04)',
                                  borderRadius: '8px', border: '1px solid rgba(255,255,255,0.08)'
                                }}>
                                  <User size={14} style={{ opacity: 0.45, flexShrink: 0 }} />
                                  <span style={{ flex: 1, fontSize: '0.82rem', color: text, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{entry.email}</span>
                                  <select
                                    value={entry.role}
                                    onChange={e => handleChangeShareRole(uid, e.target.value)}
                                    style={{
                                      background: 'rgba(20,20,20,0.95)', border: '1px solid rgba(255,255,255,0.15)',
                                      borderRadius: '6px', color: '#fff', fontSize: '0.72rem', padding: '0.15rem 0.3rem', cursor: 'pointer'
                                    }}
                                  >
                                    <option value="staff">Staff</option>
                                    <option value="admin">Admin</option>
                                  </select>
                                  <button
                                    onClick={() => handleRemoveShareUser(uid, entry.email)}
                                    style={{ background: 'transparent', border: 'none', color: '#f44336', cursor: 'pointer', padding: '0.15rem', display: 'flex', alignItems: 'center', flexShrink: 0 }}
                                    title="Remove access"
                                  >
                                    <Trash2 size={13} />
                                  </button>
                                </div>
                              ))}
                              {shopAccessData.pendingInvites.map((invite, i) => (
                                <div key={i} style={{
                                  display: 'flex', alignItems: 'center', gap: '0.5rem',
                                  padding: '0.5rem 0.65rem', background: 'rgba(255,193,7,0.04)',
                                  borderRadius: '8px', border: '1px solid rgba(255,193,7,0.18)'
                                }}>
                                  <Clock size={14} style={{ color: '#FFC107', flexShrink: 0 }} />
                                  <span style={{ flex: 1, fontSize: '0.82rem', color: text, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{invite.email}</span>
                                  <span style={{ fontSize: '0.68rem', color: '#FFC107', opacity: 0.85, flexShrink: 0 }}>pending</span>
                                  <button
                                    onClick={() => handleCancelShareInvite(invite)}
                                    style={{ background: 'transparent', border: 'none', color: '#f44336', cursor: 'pointer', padding: '0.15rem', display: 'flex', alignItems: 'center', flexShrink: 0 }}
                                    title="Cancel invite"
                                  >
                                    <Trash2 size={13} />
                                  </button>
                                </div>
                              ))}
                            </div>
                          )
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Store Type — collapsible accordion, same style as To-Do/Share */}
                {canEditShopCards && (
                  <div>
                    <button
                      onClick={() => setShowStoreTypeDropdown(o => !o)}
                      style={{
                        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                        padding: '0.6rem 1.25rem', background: showStoreTypeDropdown ? `${accent}18` : 'transparent',
                        border: `1px solid ${accent}66`, borderRadius: '8px', color: accent,
                        fontSize: '0.85rem', fontWeight: '600', cursor: 'pointer', letterSpacing: '0.05em',
                      }}
                    >
                      <Package size={15} />
                      <span style={{ flex: 1, textAlign: 'left' }}>{getStoreTypeById(storeType)?.label || 'Select Store Type'}</span>
                      <ChevronDown size={14} style={{ transform: showStoreTypeDropdown ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }} />
                    </button>

                    {showStoreTypeDropdown && (
                      <div style={{ marginTop: '0.6rem', padding: '0.4rem', background: 'rgba(255,255,255,0.03)', border: `1px solid ${accent}22`, borderRadius: '10px', maxHeight: '260px', overflowY: 'auto' }}>
                        {STORE_TYPES.map((type) => (
                          <button
                            key={type.id}
                            onClick={() => {
                              setStoreType(type.id);
                              handleUpdateShop({ storeType: type.id, defaultCategory: type.defaultCategory });
                            }}
                            style={{
                              width: '100%',
                              background: storeType === type.id ? `${accent}25` : 'transparent',
                              border: 'none', borderRadius: '6px',
                              padding: '0.55rem 0.65rem', color: accent, fontSize: '0.85rem',
                              fontWeight: storeType === type.id ? '700' : '600', cursor: 'pointer',
                              textAlign: 'left', display: 'flex', alignItems: 'center', gap: '0.6rem',
                            }}
                          >
                            <span>{type.label}</span>
                            {storeType === type.id && <Check size={14} style={{ marginLeft: 'auto' }} />}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Tab Settings — collapsible accordion; add/reorder/rename/hide nav tabs */}
                {canEditShopCards && (
                  <div>
                    <button
                      onClick={() => setTabSettingsExpanded(o => !o)}
                      style={{
                        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                        padding: '0.6rem 1.25rem', background: tabSettingsExpanded ? `${accent}18` : 'transparent',
                        border: `1px solid ${accent}66`, borderRadius: '8px', color: accent,
                        fontSize: '0.85rem', fontWeight: '600', cursor: 'pointer', letterSpacing: '0.05em',
                      }}
                    >
                      <Grid size={15} /> Tab Settings
                      <ChevronDown size={14} style={{ marginLeft: 'auto', transform: tabSettingsExpanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }} />
                    </button>

                    {tabSettingsExpanded && (
                      <div style={{ marginTop: '0.6rem' }}>
                        {renderTabManager()}
                      </div>
                    )}
                  </div>
                )}

                {/* Guest Checkout — which contact fields a non-logged-in buyer must fill in to order */}
                {canEditShopCards && (
                  <div>
                    <button
                      onClick={() => setGuestFieldsExpanded(o => !o)}
                      style={{
                        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                        padding: '0.6rem 1.25rem', background: guestFieldsExpanded ? `${accent}18` : 'transparent',
                        border: `1px solid ${accent}66`, borderRadius: '8px', color: accent,
                        fontSize: '0.85rem', fontWeight: '600', cursor: 'pointer', letterSpacing: '0.05em',
                      }}
                    >
                      <User size={15} /> Guest Checkout
                      <ChevronDown size={14} style={{ marginLeft: 'auto', transform: guestFieldsExpanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }} />
                    </button>

                    {guestFieldsExpanded && (
                      <div style={{ marginTop: '0.6rem' }}>
                        <p style={{ margin: '0 0 0.75rem', color: text, opacity: 0.65, fontSize: '0.78rem', lineHeight: 1.5 }}>
                          Buyers who order without signing in always give their name. Choose what else to collect — they'll get an email confirmation with their order details; you'll see the order (and their contact info) in your Messages.
                        </p>
                        {[
                          { key: 'phone', label: 'Phone Number' },
                          { key: 'email', label: 'Email Address' },
                          { key: 'address', label: 'Delivery/Service Address' },
                          { key: 'notes', label: 'Order Notes' },
                        ].map(({ key, label }) => {
                          const cfg = shopData?.guestCheckoutFields?.[key] || {};
                          return (
                            <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem', background: '#111114', border: `1.5px solid ${accent}40`, borderRadius: '10px', padding: '0.45rem 0.6rem' }}>
                              <span style={{ flex: 1, fontSize: '0.78rem', fontWeight: '600', color: text }}>{label}</span>
                              <button
                                onClick={() => handleUpdateShop({
                                  guestCheckoutFields: {
                                    ...(shopData?.guestCheckoutFields || {}),
                                    [key]: { enabled: !cfg.enabled, required: cfg.enabled ? false : !!cfg.required },
                                  },
                                })}
                                title={cfg.enabled ? 'Click to hide from the guest order form' : 'Click to show on the guest order form'}
                                style={{ background: cfg.enabled ? `${accent}20` : 'transparent', border: `1px solid ${accent}60`, color: accent, borderRadius: '6px', padding: '0.25rem 0.5rem', cursor: 'pointer', fontSize: '0.68rem', fontWeight: '700', whiteSpace: 'nowrap' }}
                              >
                                {cfg.enabled ? 'Shown' : 'Hidden'}
                              </button>
                              {cfg.enabled && (
                                <button
                                  onClick={() => handleUpdateShop({
                                    guestCheckoutFields: {
                                      ...(shopData?.guestCheckoutFields || {}),
                                      [key]: { ...cfg, required: !cfg.required },
                                    },
                                  })}
                                  title={cfg.required ? 'Click to make optional' : 'Click to require before ordering'}
                                  style={{ background: cfg.required ? accent : 'transparent', border: `1px solid ${accent}60`, color: cfg.required ? '#fff' : accent, borderRadius: '6px', padding: '0.25rem 0.5rem', cursor: 'pointer', fontSize: '0.68rem', fontWeight: '700', whiteSpace: 'nowrap' }}
                                >
                                  {cfg.required ? 'Required' : 'Optional'}
                                </button>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}

                {shopData?.isRestaurant && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ background: accent, color: 'white', padding: '0.25rem 0.75rem', borderRadius: '20px', fontSize: '0.8rem', fontWeight: '600' }}>
                      🍴 Restaurant
                    </span>
                  </div>
                )}

                {/* Shop Locations */}
                {canEditShopCards && (
                  <div>
                    <div style={{ fontSize: '0.72rem', fontWeight: '700', color: accent, marginBottom: '0.5rem', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                      📍 Shop Locations
                    </div>
                    {masterAddresses.map((addr, idx) => (
                      <div key={addr.id} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.5rem', background: '#111114', border: `1.5px solid ${accent}40`, borderRadius: '10px', padding: '0.45rem 0.6rem' }}>
                        <span style={{ fontSize: '0.7rem', color: accent, fontWeight: '700', minWidth: '1.1rem' }}>{idx + 1}</span>
                        <input
                          value={addr.address || ''}
                          onChange={e => handleMasterAddressTextChange(addr.id, e.target.value)}
                          onBlur={e => { if (e.target.value.trim() && !addr.coordinates) handleGeocodeMasterAddress(addr.id, e.target.value); }}
                          onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleGeocodeMasterAddress(addr.id, e.target.value))}
                          placeholder="Type address..."
                          style={{ flex: 1, background: 'transparent', border: 'none', outline: 'none', color: addr.geocodeFailed ? '#ef4444' : addr.coordinates ? text : `${text}70`, fontSize: '0.72rem', fontWeight: '600' }}
                        />
                        {addr.coordinates && (
                          <span title="Location set" style={{ fontSize: '0.68rem', color: '#10b981', flexShrink: 0 }}>✓</span>
                        )}
                        <button onClick={() => handleOpenMapForMasterAddress(addr.id)} title="Pick on map" style={{ background: 'none', border: 'none', cursor: 'pointer', color: accent, padding: '2px', display: 'flex', alignItems: 'center' }}>
                          <MapPin size={14} />
                        </button>
                        <button onClick={() => handleRemoveMasterAddress(addr.id)} title="Remove" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ff5555', padding: '2px', display: 'flex', alignItems: 'center' }}>
                          <X size={12} />
                        </button>
                      </div>
                    ))}
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                      {masterAddresses.length < 5 && (
                        <button onClick={handleAddMasterAddress} style={{ background: 'transparent', border: `1.5px solid ${accent}`, borderRadius: '8px', padding: '0.35rem 0.75rem', color: accent, fontSize: '0.73rem', fontWeight: '700', cursor: 'pointer' }}>
                          + Add Location
                        </button>
                      )}
                      {masterAddresses.length > 0 && (
                        <button onClick={handleApplyPrimaryAddressToAllItems} title="Push shop addresses to all items" style={{ background: addressesJustApplied ? '#2e7d32' : `${accent}18`, border: `1.5px solid ${addressesJustApplied ? '#2e7d32' : accent}`, borderRadius: '8px', padding: '0.35rem 0.75rem', color: addressesJustApplied ? '#fff' : accent, fontSize: '0.73rem', fontWeight: '700', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.3rem', transition: 'all 0.2s ease' }}>
                          {addressesJustApplied ? <Check size={14} /> : 'Apply to all items'}
                        </button>
                      )}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </>
        );
      })()}

        {/* Floating theme picker — bottom left */}
        <FloatingThemeWrap>
          <FloatingThemeMenu theme={shopData?.theme} $isOpen={themeMenuOpen}>
            {Object.values(WELCOME_STYLES).map(style => (
              <FloatingThemeListItem
                key={style.id}
                theme={shopData?.theme}
                $active={shopData?.theme?.id === style.id}
                onClick={() => { handleApplyTheme(style); setThemeMenuOpen(false); }}
              >
                <span className="style-number">{style.id}</span>
                <span className="style-name">{style.name}</span>
                <div className="active-indicator" />
              </FloatingThemeListItem>
            ))}
          </FloatingThemeMenu>

          <FloatingThemeBtn
            theme={shopData?.theme}
            $isPinned={isPinned}
            onClick={() => setThemeMenuOpen(o => !o)}
          >
            <span
              className="refresh-btn"
              onClick={e => { e.stopPropagation(); refreshTheme(); }}
              title="Shuffle theme"
            >
              <RefreshCw size={14} className={isRefreshing ? 'spinning' : ''} />
            </span>
            <span className="theme-name">
              {shopData?.theme?.name || 'Theme'}
            </span>
            <ChevronDown
              size={13}
              style={{ transform: themeMenuOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
            />
            <span
              className="pin-btn"
              onClick={e => { e.stopPropagation(); togglePinStyle(); }}
              title={isPinned ? 'Unpin theme' : 'Pin theme'}
            >
              <ThumbsUp size={13} fill={isPinned ? (shopData?.theme?.colors?.accent || '#800000') : 'none'} />
            </span>
          </FloatingThemeBtn>
        </FloatingThemeWrap>

        {/* Floating theme controls for mobile */}


<style>
  {`
    @keyframes fadeIn {
      from { opacity: 0; transform: translate(-50%, 10px); }
      to { opacity: 1; transform: translate(-50%, 0); }
    }
  `}
</style>

{/* Save Controls */}
{!editingItem && !editingPost && !editingEvent && (
  <SaveControlsContainer
  show={true} // ALWAYS VISIBLE NOW
  theme={shopData?.theme}
  $aboveSettingsPanel={showShopSettingsPanel}
>
  <SaveButton
    onClick={handleSave}
    disabled={saving || !hasPendingChanges} // Disabled when no changes
    theme={shopData?.theme}
    style={{
      opacity: hasPendingChanges ? 1 : 0.5, // Visual feedback
      cursor: hasPendingChanges ? 'pointer' : 'not-allowed'
    }}
  >
    {saving ? <LoadingSpinner /> : <Save size={16} />}
    {saving ? 'Saving...' : hasPendingChanges ? `Save (${getTotalChanges()} changes)` : 'No Changes'}
  </SaveButton>       

  <ResetButton
    onClick={handleReset}
    disabled={!hasPendingChanges}
    theme={shopData?.theme}
    style={{
      opacity: hasPendingChanges ? 1 : 0.5
    }}
  >
    <RotateCcw size={16} />
    Reset
  </ResetButton>
</SaveControlsContainer>
)}

        {newlyAddedShops.length > 0 && (
          <div style={{
            position: 'fixed', top: '1rem', left: '50%', transform: 'translateX(-50%)',
            zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '0.5rem',
            pointerEvents: 'none'
          }}>
            <style>{`@keyframes fadeInDown{from{opacity:0;transform:translateY(-12px)}to{opacity:1;transform:translateY(0)}}`}</style>
            {newlyAddedShops.map((s, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: '0.75rem',
                background: 'linear-gradient(135deg, rgba(34,197,94,0.15), rgba(16,185,129,0.1))',
                border: '1px solid rgba(34,197,94,0.35)',
                borderRadius: '12px',
                padding: '0.75rem 1.25rem',
                backdropFilter: 'blur(12px)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                color: '#fff',
                fontSize: '0.9rem',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                animation: 'fadeInDown 0.4s ease',
                pointerEvents: 'auto',
                cursor: 'pointer'
              }} onClick={clearNewlyAddedShops}>
                <span style={{ fontSize: '1.2rem' }}>🏪</span>
                <span><strong>{s.shopName}</strong> has been added to your stores</span>
                <span style={{ opacity: 0.5, fontSize: '1rem', marginLeft: '0.25rem' }}>✕</span>
              </div>
            ))}
          </div>
        )}

        <MainContent $noTopPad={activeTab === 'shop' || heroLeadsActiveHomeTab} $expanded={hideHeaderTabButtons}>
          {activeTab === 'shop' && (
  <>
    <style>{profileBgFadeAnimation}</style>
    
    <div style={{ position: 'relative', marginBottom: '2rem' }}>
  <ShopProfileSection
    fontSize={shopData?.layout?.nameSize || 2.5}
    style={{
      maxWidth: '100%',
      margin: '0 0 1.25rem 0',
      padding: window.innerWidth <= 768
        ? (hideHeaderTabButtons ? 'calc(124px + 0.5rem) 1.25rem 1.1rem' : 'calc(78px + 52px + 0.85rem) 1.25rem 1.1rem')
        : 'calc(140px + 1.25rem) 1.25rem 1.25rem',
      borderRadius: '0',
      minHeight: 'auto'
    }}
  >
    {/* High-Quality Background with Focal Point */}
    <div 
      ref={profileBgRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        overflow: 'hidden',
        // Hard paint-clip guarantee — the translateZ(0) hint below on each
        // slide promotes it to its own compositing layer, which mobile
        // Safari/WebKit can fail to actually clip with overflow:hidden alone,
        // letting the background bleed past this wrapper's edges.
        contain: 'paint',
        borderRadius: '16px',
        cursor: profileBgDragMode ? 'move' : 'default'
      }}
      onMouseDown={handleProfileBgMouseDown}
    >
      {profileBackgroundImages.map((image, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            opacity: currentBgIndex === index ? 1 : 0,
            transition: 'opacity 2s ease-in-out',
            backgroundImage: image.startsWith('http') || image.startsWith('data:') ? 
              `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5)), url(${image})` : image,
            backgroundSize: 'cover',
            backgroundPosition: `${profileBgFocalPoint.x}% ${profileBgFocalPoint.y}%`,
            backgroundRepeat: 'no-repeat',
            imageRendering: '-webkit-optimize-contrast', // Better quality
            WebkitBackfaceVisibility: 'hidden',
            backfaceVisibility: 'hidden',
            transform: 'translateZ(0)', // Hardware acceleration
            willChange: currentBgIndex === index ? 'opacity' : 'auto'
          }}
        />
      ))}

    </div>

        {/* Profile Content — compact vertical stack (avatar, name, description), OG structure */}
        <div className="profile-image" style={{ position: 'relative', zIndex: 3, width: 'clamp(72px, 14vw, 96px)', height: 'clamp(72px, 14vw, 96px)', marginBottom: '0.65rem' }}>
  {shopData?.profile ? (
    typeof shopData.profile === 'string' ? (
      // If profile is a URL string
      <img 
        src={shopData.profile} 
        alt="Profile" 
        style={{ 
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          cursor: 'pointer'
        }}
        onClick={openProfilePictureUpload}
      />
    ) : shopData.profile.preview ? (
      // If profile has a preview (object with file data)
      <img
        src={shopData.profile.preview}
        alt="Profile Preview"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          cursor: 'pointer'
        }}
        onClick={openProfilePictureUpload}
      />
    ) : null
  ) : (
    // No profile image - show blurred placeholder
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `${shopData?.theme?.colors?.accent}20`, // Light accent color
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: `3px solid ${shopData?.theme?.colors?.accent}40`,
        borderRadius: '50%',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        overflow: 'hidden',
        position: 'relative'
      }}
      onClick={openProfilePictureUpload}
    >
      {/* Subtle gradient overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(135deg, ${shopData?.theme?.colors?.accent}10 0%, transparent 100%)`,
      }} />
      
      {/* Plus icon */}
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        background: `${shopData?.theme?.colors?.accent}40`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: shopData?.theme?.colors?.accent,
        transition: 'all 0.3s ease',
        zIndex: 1
      }}>
        <Plus size={24} />
      </div>
      
      {/* Hint text (only show on hover) */}
      <div style={{
        position: 'absolute',
        bottom: '10px',
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: '0.7rem',
        color: shopData?.theme?.colors?.accent,
        opacity: 0,
        transition: 'opacity 0.3s ease',
        fontWeight: '600',
        zIndex: 1
      }}>
        Add Photo
      </div>
    </div>
  )}
</div>

        <div className="shop-name-container" style={{ position: 'relative', zIndex: 5, margin: 0 }}>
  <ShopNameInputContainer>
    <ShopNameInput
  value={shopData?.name || ''}
  onChange={async (e) => {
    const newName = e.target.value;
    handleUpdateShop({ name: newName });
    
    // Check availability in real-time (debounced)
    if (newName && newName.length > 2) {
      clearTimeout(window.shopNameCheckTimeout);
      window.shopNameCheckTimeout = setTimeout(async () => {
        // CHANGED: Check if name reverted to original
        if (newName === originalShopName) {
          console.log('✅ Name reverted to original, keeping original username');
          
          // Restore original username
          handleUpdateShop({ 
            name: newName, 
            username: originalShopData?.username 
          });
          
          // Clear any errors
          setValidationErrors(prev => {
            const { shopName, ...rest } = prev;
            return rest;
          });
          
          return;
        }
        
        const result = await checkShopNameAvailability(
          newName, 
          shopData?.username
        );
        
        if (!result.available) {
          setValidationErrors(prev => ({
            ...prev,
            shopName: result.isTaken ? 
              `"${result.username}.kalkode.com" is already taken` :
              result.error || 'Unable to check availability'
          }));
        } else {
          // Clear error and update with new username
          setValidationErrors(prev => {
            const { shopName, ...rest } = prev;
            return rest;
          });
          
          // CHANGED: Update username in shopData for preview
          if (result.username !== shopData?.username) {
            handleUpdateShop({ username: result.username });
            console.log('✅ Available subdomain:', `${result.username}.kalkode.com`);
          }
        }
      }, 500);
    }
  }}
  placeholder="Brand Name"
  fontSize={5.5}
  theme={shopData?.theme}
  WebkitBackdropFilter='blur(2330px)'
  style={{
    fontSize: 'clamp(1.5rem, 5vw, 2.25rem)',
    textAlign: 'center',
    borderBottom: validationErrors.shopName ?
      '2px solid #ff4444' :
      'none'
  }}
/>
    
    {/* Show validation error or success message */}
    {validationErrors.shopName ? (
      <ShopNameError theme={shopData?.theme}>
        {validationErrors.shopName}
      </ShopNameError>
    ) : shopData?.name && shopData?.username && shopData.name !== originalShopName ? (
      <ShopNameSuccess theme={shopData?.theme}>
        ✓ Available: {shopData.username}.kalkode.com
      </ShopNameSuccess>
    ) : null}
  </ShopNameInputContainer>
</div>

        <FadingUnderline theme={shopData?.theme} />

<div className="shop-description-container" style={{
  position: 'relative',
  zIndex: 3,
  maxWidth: '600px',
  margin: '0 auto'
}}>
  <ValidatedEditableText
    value={shopData?.description}
    onChange={(value) => handleUpdateShop({ description: value })}
    placeholder="Shop Description"
    validationRules={VALIDATION_RULES.shop.description}
    multiline={false}
    WebkitBackdropFilter='blur(10px)'
    style={{
      fontSize: 'clamp(0.85rem, 2.6vw, 1.05rem)',
      textAlign: 'center',
      opacity: 0.8
    }}
  />
</div>

{/* Store Status & Payment Section */}
<div style={{
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.6rem',
  marginTop: '0.85rem',
  position: 'relative',
  zIndex: 3
}}>
  {/* Plan Upgrade Button — only for shop owners (primary + sub-shops), not shared shop staff */}
  {canEditActiveShop && (() => {
    const plan = getPlanFromBilling(billingData);
    // Hide button on the highest plan
    if (plan === PLAN_ORDER[PLAN_ORDER.length - 1]) return null;
    const isPaid = plan !== 'free';
    return (
      <button
        onClick={() => {
          setBillingDataForPayment({ ...billingData, openFrom: isPaid ? 'upgrade' : 'start' });
          setShowPaymentModal(true);
        }}
        style={{
          display: window.innerWidth <= 768 ? 'flex' : 'none',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.55rem 1.35rem',
          background: isPaid
            ? 'linear-gradient(135deg, #8b5cf6, #7c3aed)'
            : 'linear-gradient(135deg, #3b82f6, #2563eb)',
          border: 'none',
          borderRadius: '50px',
          cursor: 'pointer',
          color: 'white',
          fontWeight: 700,
          fontSize: '0.82rem',
          letterSpacing: '0.03em',
          boxShadow: isPaid
            ? '0 3px 12px rgba(139,92,246,0.4)'
            : '0 3px 12px rgba(59,130,246,0.4)',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.04)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="17 11 12 6 7 11" /><line x1="12" y1="6" x2="12" y2="18" />
        </svg>
        {PLANS[plan]?.label || 'Free'}
      </button>
    );
  })()}
</div>

{billingData && canEditActiveShop && (
  <div style={{
    position: 'relative',
    zIndex: 3,
    width: '100%',
    maxWidth: window.innerWidth <= 768 ? '100%' : '400px',
    margin: '0 auto',
    display: window.innerWidth <= 768 ? 'none' : 'block',
  }}>
    <AccountBalanceButton
      userId={activeShopId || auth.currentUser?.uid}
      shopData={shopData}
      billingData={billingData}
      onOpenPayment={(data) => {
        setBillingDataForPayment(data);
        setShowPaymentModal(true);
      }}
      theme={shopData?.theme}
    />
    {shopData?.storeStatus === 'suspended' && billingData?.itemsHiddenDueToBalance && (
      <div style={{ marginTop: '0.5rem', padding: '0.5rem 0.75rem', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.25)', borderRadius: '8px', fontSize: '0.78rem', color: '#ef4444', textAlign: 'center', lineHeight: 1.4 }}>
        Make this payment to unlock your store
      </div>
    )}
  </div>
)}

        {/* Chevron Button */}
        <ChevronButton
          theme={shopData?.theme}
          isOpen={showBgDrawer}
          onClick={() => {
            const opening = !showBgDrawer;
            setShowBgDrawer(opening);
            // Seed the drawer's slots from the currently-applied backgrounds
            // every time it opens, so previously-set images show up instead
            // of empty placeholders (padded/sliced to the 3 fixed slots).
            if (opening) {
              const seeded = [0, 1, 2].map(i => profileBackgroundImages[i] || null);
              setTempBackgroundImages(seeded);
            }
          }}
          title={showBgDrawer ? "Hide backgrounds" : "Edit backgrounds"}
        >
          <ChevronDown size={20} />
        </ChevronButton>
      </ShopProfileSection>


      {/* Background Drawer - Slides down */}
      <BackgroundDrawer isOpen={showBgDrawer} theme={shopData?.theme}>
  <DrawerHeader theme={shopData?.theme}>
    <h3>Background Images</h3>
    <DrawerCloseButton
      theme={shopData?.theme}
      onClick={() => {
        setShowBgDrawer(false);
        setTempBackgroundImages([]); // Clear temp on close
      }}
    >
      <X size={16} />
    </DrawerCloseButton>
  </DrawerHeader>

  <BackgroundImagesGrid>
    {[0, 1, 2].map((index) => (
      <BackgroundImageSlot
        key={index}
        theme={shopData?.theme}
        onClick={() => !tempBackgroundImages[index] && handleAddBackgroundImage(index)}
      >
        {tempBackgroundImages[index] ? (
          <>
            <img 
              src={tempBackgroundImages[index]} 
              alt={`Background ${index + 1}`}
            />
            <RemoveImageButton
              theme={shopData?.theme}
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveBackgroundImage(index);
              }}
            >
              <X size={12} />
            </RemoveImageButton>
          </>
        ) : (
          <div className="placeholder">
            <Plus size={20} />
            <span>Image {index + 1}</span>
          </div>
        )}
      </BackgroundImageSlot>
    ))}
  </BackgroundImagesGrid>

  <DrawerActions>
    <button
      onClick={handleApplyAndSaveBackgrounds}
      disabled={saving}
      style={{
        background: shopData?.theme?.colors?.accent || '#800000',
        color: 'white',
        border: 'none',
        padding: '0.75rem 2rem',
        borderRadius: '8px',
        cursor: saving ? 'not-allowed' : 'pointer',
        fontWeight: '600',
        fontSize: '0.9rem',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        opacity: saving ? 0.6 : 1,
        minWidth: '160px'
      }}
    >
      {saving ? (
        <>
          <LoadingSpinner />
          <span>Saving...</span>
        </>
      ) : (
        <>
          <Check size={18} />
          <span>Apply & Save</span>
        </>
      )}
    </button>
  </DrawerActions>
</BackgroundDrawer>
    </div>

{/* When acting as a shared shop (staff-role access): read-only view */}
{!canEditShopCards && (
  activeShopData ? (
    <>
      {/* Products / Services tabs (read-only) */}
      <ShopTabContainer style={{ flexWrap: 'wrap', rowGap: '0.5rem' }}>
        <ShopTab active={shopContentType === 'products'} onClick={() => setShopContentType('products')} theme={shopData?.theme}>
          <Package size={18} /> Products
        </ShopTab>
        <ShopTab active={shopContentType === 'services'} onClick={() => { setShopContentType('services'); setServiceSubTab('offer'); }} theme={shopData?.theme}>
          <Store size={18} /> Services
        </ShopTab>
        {shopContentType === 'services' && (
          <ServiceSubTabInline>
            <div style={{ width: '1px', height: '1.5rem', background: 'rgba(255,255,255,0.15)', alignSelf: 'center' }} />
            <ShopTab active={serviceSubTab === 'offer'} onClick={() => setServiceSubTab('offer')} theme={shopData?.theme} style={{ padding: '0.4rem 1rem', fontSize: '0.8rem' }}>
              Sell Service
            </ShopTab>
            <ShopTab active={serviceSubTab === 'need'} onClick={() => setServiceSubTab('need')} theme={shopData?.theme} style={{ padding: '0.4rem 1rem', fontSize: '0.8rem' }}>
              Buy Service
            </ShopTab>
          </ServiceSubTabInline>
        )}
      </ShopTabContainer>

      {shopContentType === 'services' && (
        <ServiceSubTabRow>
          <ShopTab active={serviceSubTab === 'offer'} onClick={() => setServiceSubTab('offer')} theme={shopData?.theme} style={{ padding: '0.3rem 0.75rem', fontSize: '0.68rem' }}>
            Sell Service
          </ShopTab>
          <ShopTab active={serviceSubTab === 'need'} onClick={() => setServiceSubTab('need')} theme={shopData?.theme} style={{ padding: '0.3rem 0.75rem', fontSize: '0.68rem' }}>
            Buy Service
          </ShopTab>
        </ServiceSubTabRow>
      )}

      {/* Read-only item cards */}
      <ItemGrid>
        {(shopContentType === 'services'
          ? (activeShopData.services || []).filter(s => (s.serviceTab || 'offer') === serviceSubTab)
          : (activeShopData.items || [])
        ).map(item => (
          <MobileItemCard key={item.id} theme={shopData?.theme} style={{ cursor: 'default' }}>
            <MobileItemImageContainer theme={shopData?.theme}>
              {item.images?.[0] ? (
                <img
                  src={typeof item.images[0] === 'string' ? item.images[0] : item.images[0].url || item.images[0].preview}
                  alt={item.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', opacity: 0.3 }}>
                  <Package size={32} />
                </div>
              )}
            </MobileItemImageContainer>
            <MobileItemContent theme={shopData?.theme}>
              <div className="item-name">{item.name}</div>
              <div className="item-price">${item.unitPrice?.toFixed(2)}</div>
              {item.category && <div style={{ fontSize: '0.7rem', opacity: 0.5, marginTop: '0.2rem' }}>{item.category}</div>}
            </MobileItemContent>
          </MobileItemCard>
        ))}
        {(shopContentType === 'services'
          ? (activeShopData.services || []).filter(s => (s.serviceTab || 'offer') === serviceSubTab)
          : (activeShopData.items || [])
        ).length === 0 && (
          <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '3rem', opacity: 0.4, color: shopData?.theme?.colors?.text || '#fff' }}>
            No {shopContentType} in this shop yet.
          </div>
        )}
      </ItemGrid>
    </>
  ) : (
    <div style={{ padding: '2rem', textAlign: 'center', opacity: 0.4, fontSize: '0.85rem', color: shopData?.theme?.colors?.text || '#fff' }}>
      Loading shared shop…
    </div>
  )
)}

{/* Full edit view: shown for primary shop, sub-shops, and shared-shop admins */}
{canEditShopCards && <>

            {/* Shop Content Type Tabs with Utility Buttons */}
<ShopTabContainer style={{ flexWrap: 'wrap', rowGap: '0.5rem' }}>
  <ShopTab
    active={shopContentType === 'products'}
    onClick={() => { setShopContentType('products'); setShowAddCategoryInput(false); setNewCategoryName(''); }}
    theme={shopData?.theme}
  >
    <Package size={18} />
    Products
  </ShopTab>
  <ShopTab
    active={shopContentType === 'services'}
    onClick={() => { setShopContentType('services'); setServiceSubTab('offer'); setShowAddCategoryInput(false); setNewCategoryName(''); }}
    theme={shopData?.theme}
  >
    <Store size={18} />
    Services
  </ShopTab>
  {shopContentType === 'services' && (
    <ServiceSubTabInline>
      <div style={{ width: '1px', height: '1.5rem', background: 'rgba(255,255,255,0.15)', alignSelf: 'center' }} />
      <ShopTab active={serviceSubTab === 'offer'} onClick={() => setServiceSubTab('offer')} theme={shopData?.theme} style={{ padding: '0.4rem 1rem', fontSize: '0.8rem' }}>
        Sell Service
      </ShopTab>
      <ShopTab active={serviceSubTab === 'need'} onClick={() => setServiceSubTab('need')} theme={shopData?.theme} style={{ padding: '0.4rem 1rem', fontSize: '0.8rem' }}>
        Buy Service
      </ShopTab>
    </ServiceSubTabInline>
  )}
</ShopTabContainer>

{shopContentType === 'services' && (
  <ServiceSubTabRow>
    <ShopTab active={serviceSubTab === 'offer'} onClick={() => setServiceSubTab('offer')} theme={shopData?.theme} style={{ padding: '0.3rem 0.75rem', fontSize: '0.68rem' }}>
      Sell Service
    </ShopTab>
    <ShopTab active={serviceSubTab === 'need'} onClick={() => setServiceSubTab('need')} theme={shopData?.theme} style={{ padding: '0.3rem 0.75rem', fontSize: '0.68rem' }}>
      Buy Service
    </ShopTab>
  </ServiceSubTabRow>
)}

{/* Utility Buttons Row — most-used stay inline, rest live under "More" */}
<UtilityButtonsRow>

  <UtilityButton
    theme={shopData?.theme}
    onClick={() => setShopMobileColumns(c => c === 1 ? 2 : c === 2 ? 3 : 1)}
    title="Toggle mobile column layout"
    style={{ fontWeight: '700', minWidth: '48px', textAlign: 'center' }}
  >
    {shopMobileColumns}×
  </UtilityButton>
  <UtilityButton
    theme={shopData?.theme}
    onClick={() => {
      setBulkEditMode(!bulkEditMode);
      if (bulkEditMode) {
        setSelectedItemsForBulk(new Set());
      }
    }}
    style={{
      background: bulkEditMode ? shopData?.theme?.colors?.accent : 'transparent',
      color: bulkEditMode ? 'white' : shopData?.theme?.colors?.accent,
      border: `1px solid ${shopData?.theme?.colors?.accent}`
    }}
  >
    <Check size={16} />
    {bulkEditMode ? 'Exit Bulk Edit' : 'Bulk Edit'}
  </UtilityButton>
  <UtilityButton
    theme={shopData?.theme}
    onClick={() => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.multiple = true;
      input.onchange = (e) => handleBulkImageUpload(e.target.files);
      input.click();
    }}
    title="Upload multiple images - unlimited"
  >
    <Download size={16} />
    Bulk Upload
  </UtilityButton>
  {/* Extra utility buttons — shown inline, same style as the defaults, once "More" is toggled */}
  {showMoreUtilities && (
    <>
      <UtilityButton
        theme={shopData?.theme}
        onClick={handleToggleWelcomePage}
        title={hideFromWelcomePage ? 'Shop content hidden from home feed — click to show' : 'Shop content visible in home feed — click to hide'}
        style={{
          background: hideFromWelcomePage ? shopData?.theme?.colors?.accent : 'transparent',
          color: hideFromWelcomePage ? 'white' : shopData?.theme?.colors?.accent,
          border: `1px solid ${shopData?.theme?.colors?.accent}`
        }}
      >
        <Power size={16} />
        {hideFromWelcomePage ? 'Feed: Off' : 'Feed: On'}
      </UtilityButton>
      <UtilityButton
        theme={shopData?.theme}
        onClick={() => setShowWebsiteScraper(true)}
        title="Import products from any website or Shopify store"
      >
        <Globe size={16} />
        Import Website
      </UtilityButton>
      <UtilityButton
        theme={shopData?.theme}
        onClick={() => setShowMenuScanner(true)}
        title="Scan a menu image and extract items automatically"
      >
        <ScanLine size={16} />
        Scan Menu
      </UtilityButton>
      <UtilityButton
        theme={shopData?.theme}
        onClick={() => {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = '.csv';
          input.onchange = (e) => handleCSVUpload(e.target.files[0]);
          input.click();
        }}
        title="Import items from CSV file"
      >
        <Download size={16} />
        Import CSV
      </UtilityButton>
      <UtilityButton
        theme={shopData?.theme}
        onClick={openAddFromStore}
        title="Import products from nearby stores"
      >
        <Store size={16} />
        Add From Store
      </UtilityButton>
      <UtilityButton
        theme={shopData?.theme}
        onClick={() => {
          if (featuredSelectMode) {
            setFeaturedSelectMode(false);
          } else {
            const sourceArray = shopContentType === 'services' ? (shopData?.services || []) : (shopData?.items || []);
            const currentFeatured = new Set(sourceArray.filter(i => i.isFeatured).map(i => i.id));
            setSelectedFeatured(currentFeatured);
            setFeaturedSelectMode(true);
            setBulkEditMode(false);
          }
        }}
        style={{
          background: featuredSelectMode ? shopData?.theme?.colors?.accent : 'transparent',
          color: featuredSelectMode ? 'white' : shopData?.theme?.colors?.accent,
          border: `1px solid ${shopData?.theme?.colors?.accent}`
        }}
      >
        ★ {featuredSelectMode ? 'Exit Featured' : 'Set Featured'}
      </UtilityButton>
    </>
  )}

  {/* More/Less — toggles the extra utility buttons above */}
  <UtilityButton
    theme={shopData?.theme}
    onClick={() => setShowMoreUtilities(o => !o)}
  >
    <MoreHorizontal size={16} />
    {showMoreUtilities ? 'Less' : 'More'}
  </UtilityButton>
</UtilityButtonsRow>
</>} {/* end own-shop tabs + utility buttons */}
{bulkEditMode && canEditActiveShop && (
  <BulkModeBar theme={shopData?.theme}>
    <BulkModeInfo>
      <div className="selected-count">
        {selectedItemsForBulk.size} Selected
      </div>
    </BulkModeInfo>
    
    <BulkModeActions>
      <BulkActionButton
        className="select-all"
        theme={shopData?.theme}
        onClick={selectAllForBulk}
      >
        Select All ({shopContentType === 'services' ? 
          shopData?.services?.length : 
          shopData?.items?.length})
      </BulkActionButton>
      
      <BulkActionButton
        className="deselect-all"
        theme={shopData?.theme}
        onClick={deselectAllBulk}
      >
        Deselect All
      </BulkActionButton>
      
      {/* ADD: Location Button */}
      <BulkActionButton
        style={{
          background: '#2196F3',
          color: 'white',
          border: 'none'
        }}
        theme={shopData?.theme}
        onClick={() => {
          if (selectedItemsForBulk.size === 0) {
            alert('Please select at least one item');
            return;
          }
          // Convert Set to compatible format
          setSelectedItemsForUpdate(new Set(selectedItemsForBulk));
          setShowLocationOverlay(true);
        }}
        disabled={selectedItemsForBulk.size === 0}
      >
        <MapPin size={16} />
        Set Location
      </BulkActionButton>
      
      {/* ADD: Category Button */}
      <BulkActionButton
        style={{
          background: '#9C27B0',
          color: 'white',
          border: 'none'
        }}
        theme={shopData?.theme}
        onClick={() => {
          if (selectedItemsForBulk.size === 0) {
            alert('Please select at least one item');
            return;
          }
          // Convert Set to compatible format
          setSelectedItemsForUpdate(new Set(selectedItemsForBulk));
          setShowCategoryOverlay(true);
        }}
        disabled={selectedItemsForBulk.size === 0}
      >
        <Package size={16} />
        Set Category
      </BulkActionButton>
      
      <BulkActionButton
        className="edit-price"
        theme={shopData?.theme}
        onClick={() => setShowBulkEditModal(true)}
        disabled={selectedItemsForBulk.size === 0}
      >
        <DollarSign size={16} />
        Edit Price
      </BulkActionButton>
      
      <BulkActionButton
        className="delete"
        theme={shopData?.theme}
        onClick={handleBulkDelete}
        disabled={selectedItemsForBulk.size === 0}
      >
        <Trash2 size={16} />
        Delete
      </BulkActionButton>
      
      <BulkActionButton
        className="cancel"
        theme={shopData?.theme}
        onClick={() => {
          setBulkEditMode(false);
          setSelectedItemsForBulk(new Set());
        }}
      >
        <X size={16} />
        Cancel
      </BulkActionButton>
    </BulkModeActions>
  </BulkModeBar>
)}

{featuredSelectMode && canEditActiveShop && (
  <BulkModeBar theme={shopData?.theme}>
    <BulkModeInfo>
      <div className="selected-count">
        ★ {selectedFeatured.size} / 10 Featured
      </div>
    </BulkModeInfo>
    <BulkModeActions>
      <BulkActionButton
        style={{ background: '#4CAF50', color: 'white', border: 'none' }}
        onClick={handleSaveFeatured}
      >
        Save Featured
      </BulkActionButton>
      <BulkActionButton
        className="deselect-all"
        theme={shopData?.theme}
        onClick={() => setSelectedFeatured(new Set())}
      >
        Clear All
      </BulkActionButton>
      <BulkActionButton
        className="cancel"
        theme={shopData?.theme}
        onClick={() => setFeaturedSelectMode(false)}
      >
        Cancel
      </BulkActionButton>
    </BulkModeActions>
  </BulkModeBar>
)}

<FadingUnderline theme={shopData?.theme} />

{/* Total Items Count - REPLACE THE OLD VERSION */}
<div style={{
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.75rem',
  marginBottom: '1rem',
  marginTop: '1rem'
}}>
  {/* Total Items Count */}
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.75rem 1.5rem',
    background: `${shopData?.theme?.colors?.surface}60`,
    backdropFilter: 'blur(10px)',
    borderRadius: '25px',
    border: `1px solid ${shopData?.theme?.colors?.accent}40`
  }}>
    <Package size={18} style={{ color: shopData?.theme?.colors?.accent }} />
    <span style={{
      color: shopData?.theme?.colors?.text,
      fontSize: '0.95rem',
      fontWeight: '600'
    }}>
      {(shopData?.items?.length || 0) + (shopData?.services?.length || 0)} Items 
    </span>
  </div>

</div>

{billingData?.itemsHidden && (
  <div style={{
    background: 'linear-gradient(135deg, rgba(251,191,36,0.07), rgba(245,158,11,0.03))',
    border: '1px solid rgba(251,191,36,0.18)',
    borderRadius: '16px',
    padding: '1.1rem 1.4rem',
    maxWidth: '600px',
    margin: '0 auto 2rem',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    backdropFilter: 'blur(12px)',
    boxShadow: '0 2px 16px rgba(251,191,36,0.04)',
  }}>
    <div style={{
      width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
      background: 'rgba(251,191,36,0.12)',
      border: '1px solid rgba(251,191,36,0.2)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <Lock size={16} style={{ color: '#f59e0b' }} />
    </div>

    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{
        color: '#f59e0b',
        fontWeight: '600',
        fontSize: '0.88rem',
        marginBottom: '0.2rem',
      }}>
        Your items are temporarily hidden
      </div>
      <div style={{
        color: shopData?.theme?.colors?.text,
        fontSize: '0.78rem',
        lineHeight: 1.5,
        opacity: 0.55,
      }}>
        You've hit a sales milestone — {formatCurrency(billingData.amountOwed)} keeps your storefront live and visible to shoppers.
      </div>
    </div>

    <button
      onClick={() => {
        setBillingDataForPayment(billingData);
        setShowPaymentModal(true);
      }}
      style={{
        background: 'linear-gradient(135deg, #f59e0b, #d97706)',
        color: '#fff',
        border: 'none',
        padding: '0.55rem 1.1rem',
        borderRadius: '10px',
        fontWeight: '700',
        fontSize: '0.8rem',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 10px rgba(245,158,11,0.2)',
        flexShrink: 0,
      }}
    >
      Restore Visibility
    </button>
  </div>
)}

            {/* Conditional rendering based on shopContentType */}
            {shopContentType === 'products' ? (
  <>
    
    <div style={{ padding: '0 0.5rem', marginTop: '1.5rem' }}>
      {/* Category-grouped product rows */}
      {(() => {
        const fallbackOrder = getFallbackCategoryOrder(false);
        const categoryOrder = shopData?.productCategoryOrder?.length
          ? [...new Set([...shopData.productCategoryOrder, ...fallbackOrder])]
          : fallbackOrder;
        const accent = shopData?.theme?.colors?.accent || '#800000';
        return categoryOrder.map((categoryName, catIdx) => {
          const catItems = (shopData?.items || []).filter(i => (i.category || 'Other') === categoryName);
          const cardCols = shopData?.categoryColumns?.[`p:${categoryName}`] ?? 1;
          return (
            <div key={`pcat-${categoryName}`} style={{ marginBottom: '1.5rem' }}>
              {(() => {
                const pickerKey = `p-${categoryName}`;
                const currentTypeId = shopData?.categoryTypes?.[categoryName] || 'other';
                const currentStoreType = STORE_TYPES.find(t => t.id === currentTypeId);
                const isPickerOpen = openTypePicker === pickerKey;
                return (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '0.4rem 0.25rem', borderBottom: isPickerOpen ? 'none' : `1px solid ${accent}25`, marginBottom: isPickerOpen ? 0 : '0.5rem', flexWrap: 'wrap', gap: '0.3rem' }}>
                      <span style={{ fontWeight: '700', color: accent, fontSize: '0.9rem' }}>{categoryName}<span style={{ fontWeight: '400', opacity: 0.5, marginLeft: '0.4rem', fontSize: '0.75rem' }}>({catItems.length})</span></span>
                      <button onClick={() => handleMoveCategory(false, categoryName, 'up')} disabled={catIdx === 0} style={{ marginLeft: '0.5rem', background: 'transparent', border: `1px solid ${accent}30`, borderRadius: '6px', color: accent, padding: '0.15rem', cursor: catIdx === 0 ? 'default' : 'pointer', opacity: catIdx === 0 ? 0.3 : 0.75, display: 'flex', alignItems: 'center' }} title="Move category up">
                        <ChevronUp size={14} />
                      </button>
                      <button onClick={() => handleMoveCategory(false, categoryName, 'down')} disabled={catIdx === categoryOrder.length - 1} style={{ background: 'transparent', border: `1px solid ${accent}30`, borderRadius: '6px', color: accent, padding: '0.15rem', cursor: catIdx === categoryOrder.length - 1 ? 'default' : 'pointer', opacity: catIdx === categoryOrder.length - 1 ? 0.3 : 0.75, display: 'flex', alignItems: 'center' }} title="Move category down">
                        <ChevronDown size={14} />
                      </button>
                      <button onClick={() => handleCycleCategoryColumns(false, categoryName)} style={{ background: 'transparent', border: `1px solid ${accent}30`, borderRadius: '6px', color: accent, fontSize: '0.68rem', fontWeight: 800, padding: '0.15rem 0.4rem', cursor: 'pointer', opacity: 0.75, display: 'flex', alignItems: 'center', gap: '0.15rem' }} title="Public page card layout for this category">
                        {cardCols}×<Grid size={12} />
                      </button>
                      <button onClick={() => setOpenTypePicker(isPickerOpen ? null : pickerKey)} style={{ background: 'transparent', border: `1px solid ${accent}30`, borderRadius: '6px', color: accent, fontSize: '0.68rem', padding: '0.1rem 0.4rem', cursor: 'pointer', opacity: 0.75, lineHeight: 1.4 }} title="Set welcome page category">
                        {currentStoreType?.label?.split(' ')[0] || '📦'}
                      </button>
                      <button onClick={() => handleDeleteCategory(false, categoryName)} style={{ marginLeft: 'auto', background: 'transparent', border: 'none', color: accent, opacity: 0.4, cursor: 'pointer', padding: '0.2rem', display: 'flex', alignItems: 'center' }} title={`Delete ${categoryName}`}>
                        <Trash2 size={14} />
                      </button>
                    </div>
                    {isPickerOpen && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', padding: '0.4rem 0.25rem 0.5rem', borderBottom: `1px solid ${accent}25`, marginBottom: '0.5rem' }}>
                        {STORE_TYPES.map(t => (
                          <button key={t.id} onClick={() => handleSetCategoryType(categoryName, t.id)} style={{ background: currentTypeId === t.id ? `${accent}25` : 'transparent', border: `1px solid ${currentTypeId === t.id ? accent : `${accent}30`}`, borderRadius: '6px', color: currentTypeId === t.id ? accent : `${shopData?.theme?.colors?.text || '#fff'}80`, fontSize: '0.72rem', padding: '0.2rem 0.5rem', cursor: 'pointer', fontWeight: currentTypeId === t.id ? '600' : '400' }}>
                            {t.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                );
              })()}
              <ShopCategoryGrid $cols={shopMobileColumns} $accent={accent} $rows={catItems.length + 1 > 5 ? 2 : 1} $mobileRows={shopMobileColumns === 1 ? 1 : (catItems.length + 1 > shopMobileColumns ? 2 : 1)}>
                <MobileItemCard
                  theme={shopData?.theme}
                  onClick={() => openBulkUploadForCategory(categoryName)}
                  style={{ cursor: 'pointer', border: `2px dashed ${accent}40`, background: `${accent}08` }}
                >
                  <MobileItemImageContainer theme={shopData?.theme}>
                    <div className="placeholder">
                      <Plus size={28} />
                      <span>Add Card</span>
                    </div>
                  </MobileItemImageContainer>
                  <MobileItemContent theme={shopData?.theme}>
                    <div className="item-name" style={{ opacity: 0.5, textAlign: 'center', justifyContent: 'center' }}>Tap to add</div>
                  </MobileItemContent>
                </MobileItemCard>
                <DesktopItemCard
                  theme={shopData?.theme}
                  onClick={() => openBulkUploadForCategory(categoryName)}
                  style={{ cursor: 'pointer', border: `2px dashed ${accent}40`, background: `${accent}08` }}
                >
                  <ItemImageContainer theme={shopData?.theme}>
                    <div className="placeholder">
                      <Plus size={32} />
                      <span>Add Card</span>
                    </div>
                  </ItemImageContainer>
                  <ItemContent>
                    <ItemHeader>
                      <h3 style={{ opacity: 0.5, textAlign: 'center', width: '100%' }}>Tap to add</h3>
                    </ItemHeader>
                  </ItemContent>
                </DesktopItemCard>
              {catItems.map(item => {
                const isExpanded = expandedItems.has(item.id);
                const validImages = item.images.filter(Boolean);
                const currentImageIndex = item.currentImageIndex || 0;
                const currentImage = validImages[currentImageIndex] || null;

                return (
                  <React.Fragment key={item.id}>
                      <MobileItemCard
                        theme={shopData?.theme}
                        onClick={() => {
                          setEditingItem({
                            ...item,
                            images: [...item.images],
                            currentImageIndex: item.currentImageIndex || 0,
                            isService: false
                          });
                        }}
                      >
                        <MobileItemImageContainer 
  theme={shopData?.theme}
  $bgImage={(() => {
    const validImages = item.images.filter(Boolean);
    const currentImageIndex = item.currentImageIndex || 0;
    const currentMedia = validImages[currentImageIndex] || null;
    
    if (!currentMedia) return null;
    
    const mediaIsVideo = isVideoUrl(currentMedia);
    if (mediaIsVideo) return null; // Don't blur for videos
    
    return typeof currentMedia === 'string' ? currentMedia : 
           currentMedia.url || currentMedia.preview || currentMedia;
  })()}
>
  {(() => {
    const validImages = item.images.filter(Boolean);
    const currentImageIndex = item.currentImageIndex || 0;
    const currentMedia = validImages[currentImageIndex] || null;

    if (currentMedia) {
      const mediaIsVideo = isVideoUrl(currentMedia);
      
      if (mediaIsVideo) {
        const videoSrc = typeof currentMedia === 'string' ? currentMedia : 
                        currentMedia.url || currentMedia.preview;
        return (
          <video 
            src={videoSrc}
            loop 
            muted 
            playsInline
            autoPlay
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain', // CHANGED from cover
              position: 'relative',
              zIndex: 1
            }}
          />
        );
      }
      
      const imgSrc = typeof currentMedia === 'string' ? currentMedia : 
                    currentMedia.url || currentMedia.preview || currentMedia;
      return <img src={imgSrc} alt={item.name || 'Item'} />;
    }
    
    return (
      <div className="placeholder">
        <Package size={24} />
        <span>Add Photo or Video</span>
      </div>
    );
  })()}
          
                          {validImages.length > 1 && (
                            <>
                              <button
                                className="mobile-carousel-arrow left"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const newIndex = ((currentImageIndex - 1) + validImages.length) % validImages.length;
                                  handleItemUpdate(item.id, { currentImageIndex: newIndex });
                                }}
                              >
                                <ChevronLeft size={12} />
                              </button>
                              <button
                                className="mobile-carousel-arrow right"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const newIndex = (currentImageIndex + 1) % validImages.length;
                                  handleItemUpdate(item.id, { currentImageIndex: newIndex });
                                }}
                              >
                                <ChevronRight size={12} />
                              </button>
                              <div className="image-dots">
                                {validImages.map((_, index) => (
                                  <div
                                    key={index}
                                    className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                                  />
                                ))}
                              </div>
                            </>
                          )}
          
                          <MobileDeleteButton
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteItem(item.id);
                            }}
                          >
                            <X size={12} />
                          </MobileDeleteButton>


                        </MobileItemImageContainer>

                        {bulkEditMode && (
  <SelectionCheckbox
    theme={shopData?.theme}
    checked={selectedItemsForBulk.has(item.id)}
    onClick={(e) => {
      e.stopPropagation();
      toggleBulkSelection(item.id);
    }}
  >
    <Check size={20} />
  </SelectionCheckbox>
)}
                        {featuredSelectMode && (
  <SelectionCheckbox
    theme={shopData?.theme}
    checked={selectedFeatured.has(item.id)}
    onClick={(e) => {
      e.stopPropagation();
      setSelectedFeatured(prev => {
        const next = new Set(prev);
        if (next.has(item.id)) {
          next.delete(item.id);
        } else if (next.size < 10) {
          next.add(item.id);
        }
        return next;
      });
    }}
    style={{ background: selectedFeatured.has(item.id) ? '#f5a623' : undefined, borderColor: '#f5a623' }}
  >
    ★
  </SelectionCheckbox>
)}
                          
                        <MobileItemContent theme={shopData?.theme}>
                          <div className="item-name" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {item.isFeatured && <span style={{ color: '#f5a623', fontSize: '12px' }}>★</span>}
                            {item.name && item.name !== 'Item Name' ?
                              item.name :
                              <span style={{ opacity: 0.5 }}>Item Name</span>
                            }
                          </div>
                          <div className="item-price">
                            {item.price ? formatShopPrice(item.price, shopData?.currency) :
                              <span className="empty-text">{formatShopPrice(0, shopData?.currency)}</span>}
                          </div>

                          <button
  onClick={(e) => {
    e.stopPropagation();
    handleToggleItemVisibility(item.id, false);
  }}
  style={{
    position: 'absolute',
    top: '0.25rem',
    left: '.2rem',
    background: item.visible === false 
      ? 'rgba(255, 68, 68, 0.9)' 
      : 'rgba(76, 175, 80, 0.9)',
    border: `2px solid ${item.visible === false ? '#ff4444' : '#4CAF50'}`,
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    cursor: 'pointer',
    zIndex: 4,
    transition: 'all 0.3s ease',
    boxShadow: item.visible === false 
      ? '0 0 10px rgba(255, 68, 68, 0.5)' 
      : '0 0 10px rgba(76, 175, 80, 0.5)',
  }}
  title={
    item.visible === false && (!stripeStatus?.stripeReady || stripeStatus?.status !== 'active')
      ? 'Stripe required to publish'
      : item.visible === false 
        ? 'Hidden - Click to show' 
        : 'Visible - Click to hide'
  }
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.1)';
    e.currentTarget.style.boxShadow = item.visible === false 
      ? '0 0 15px rgba(255, 68, 68, 0.8)' 
      : '0 0 15px rgba(76, 175, 80, 0.8)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = item.visible === false 
      ? '0 0 10px rgba(255, 68, 68, 0.5)' 
      : '0 0 10px rgba(76, 175, 80, 0.5)';
  }}
>
  {item.visible === false ? (
    // Eye-off icon (hidden)
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" strokeWidth="2.5" />
    </svg>
  ) : (
    // Eye icon (visible)
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" fill="currentColor" />
    </svg>
  )}
</button>
{visibilityToast?.id === item.id && (
  <div style={{ position: 'absolute', top: '2.4rem', left: '0.2rem', zIndex: 20, background: 'rgba(0,0,0,0.92)', color: '#fff', fontSize: '0.68rem', padding: '0.35rem 1.4rem 0.35rem 0.55rem', borderRadius: '8px', maxWidth: '150px', lineHeight: 1.35, animation: 'visToastAnim 0.25s ease forwards', whiteSpace: 'normal', boxShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
    <button onClick={(e) => { e.stopPropagation(); setVisibilityToast(null); }} style={{ position: 'absolute', top: '2px', right: '3px', background: 'transparent', border: 'none', color: '#fff', opacity: 0.6, cursor: 'pointer', padding: '1px', lineHeight: 1, fontSize: '0.7rem' }}>✕</button>
    <span onClick={(e) => { e.stopPropagation(); setBillingDataForPayment(visibilityToast.billingPayload); setShowPaymentModal(true); setVisibilityToast(null); }} style={{ cursor: 'pointer', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>{visibilityToast.msg}</span>
  </div>
)}
                        </MobileItemContent>
                      </MobileItemCard>

                      <DesktopItemCard theme={shopData?.theme}>
                        <ItemImageContainer 
  theme={shopData?.theme}
  $bgImage={(() => {
    const currentMedia = item.images[item.currentImageIndex];
    if (!currentMedia) return null;
    
    const mediaIsVideo = isVideoUrl(currentMedia);
    if (mediaIsVideo) return null; // Don't blur for videos
    
    // Extract URL for background blur
    return typeof currentMedia === 'string' ? currentMedia : 
           currentMedia.url || currentMedia.preview || currentMedia;
  })()}
>
  {uploading[item.id] && (
    <UploadingOverlay>
      <LoadingSpinner />
    </UploadingOverlay>
  )}
  <div 
    className="image-container"
    onClick={(e) => {
      if (!e.target.closest('.carousel-arrow')) {
        document.getElementById(`image-upload-${item.id}-${item.currentImageIndex}`).click();
      }
    }}
    style={{ cursor: 'pointer' }}
  >
    {item.images[item.currentImageIndex] ? (
      (() => {
        const media = item.images[item.currentImageIndex];
        const mediaIsVideo = isVideoUrl(media);
        
        if (mediaIsVideo) {
          const videoSrc = typeof media === 'string' ? media : 
                          media.url || media.preview;
          return (
            <video 
              src={videoSrc}
              loop 
              muted 
              playsInline
              autoPlay
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'contain', // CHANGED from cover
                position: 'relative',
                zIndex: 1
              }}
            />
          );
        }
        
        const imgSrc = typeof media === 'string' ? media : 
                      media.url || media.preview || media;
        return (
          <img 
            src={imgSrc}
            alt={item.name}
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain', // CHANGED from cover
              position: 'relative',
              zIndex: 1
            }}
          />
        );
      })()
    ) : (
      <div className="placeholder">
        <Plus size={24} />
        <span>Upload Image</span>
      </div>
    )}
  </div>
                          
                          {item.images.some(img => img) && (
                            <>
                              <button 
                                className="carousel-arrow left"
                                onClick={(e) => {
                                  e.stopPropagation(); // ADD: Prevent event bubbling
                                  const newIndex = ((item.currentImageIndex - 1) + 3) % 3;
                                  handleItemUpdate(item.id, { currentImageIndex: newIndex });
                                }}
                              >
                                <ChevronLeft size={16} />
                              </button>
                              <button 
                                className="carousel-arrow right"
                                onClick={(e) => {
                                  e.stopPropagation(); // ADD: Prevent event bubbling
                                  const newIndex = (item.currentImageIndex + 1) % 3;
                                  handleItemUpdate(item.id, { currentImageIndex: newIndex });
                                }}
                              >
                                <ChevronRight size={16} />
                              </button>
                            </>
                          )}

                          {/* REPLACE the "add-image" button with delete image button */}
                          {item.images[item.currentImageIndex] && (
                            <button 
                              className="add-image"
                              onClick={(e) => {
                                e.stopPropagation();
                                const newImages = [...item.images];
                                newImages[item.currentImageIndex] = null;
                                handleItemUpdate(item.id, { images: newImages });
                              }}
                            >
                              <X size={16} />
                            </button>
                          )}

                          <input
                            type="file"
                            id={`image-upload-${item.id}-${item.currentImageIndex}`}
                            accept="image/*" // CHANGED: Added video/*
                            style={{ display: 'none' }}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              // Reset immediately so re-selecting the same file reliably
                              // fires onChange again on mobile instead of silently no-op'ing.
                              e.target.value = '';
                              if (file) {
                                handleImageUpload(item.id, item.currentImageIndex, file);
                              }
                            }}
                          />

                          {bulkEditMode && (
  <SelectionCheckbox
    theme={shopData?.theme}
    checked={selectedItemsForBulk.has(item.id)}
    onClick={(e) => {
      e.stopPropagation();
      toggleBulkSelection(item.id);
    }}
    style={{ top: '50px' }}
  >
    <Check size={20} />
  </SelectionCheckbox>
)}
                          {featuredSelectMode && (
  <SelectionCheckbox
    theme={shopData?.theme}
    checked={selectedFeatured.has(item.id)}
    onClick={(e) => {
      e.stopPropagation();
      setSelectedFeatured(prev => {
        const next = new Set(prev);
        if (next.has(item.id)) {
          next.delete(item.id);
        } else if (next.size < 10) {
          next.add(item.id);
        }
        return next;
      });
    }}
    style={{ top: '50px', background: selectedFeatured.has(item.id) ? '#f5a623' : undefined, borderColor: '#f5a623' }}
  >
    ★
  </SelectionCheckbox>
)}
                        </ItemImageContainer>
                          
                        <ItemContent>
                          <ItemHeader onClick={() => toggleItemExpansion(item.id)}>
                            <h3>
                              {item.name && item.name !== 'Item Name' ? 
                                item.name : 
                                <span style={{ opacity: 0.5 }}>Item Name</span>
                              }
                            </h3>
                            <ExpandButton>
                              {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                            </ExpandButton>
                          </ItemHeader>
                            
                          <ItemDetails expanded={isExpanded}>
                            <div className="details-content">
                              <ValidatedEditableText
                                value={item.name}
                                onChange={(value) => handleItemUpdate(item.id, { name: value })}
                                placeholder="Item Name"
                                theme={shopData?.theme}
                                showClearButton={true}
                              />
                               
                              <ValidatedEditableText
                                value={item.price}
                                onChange={(value) => handleItemUpdate(item.id, { price: value })}
                                placeholder="Price"
                                theme={shopData?.theme}
                                showClearButton={true}
                                showCurrencySelector={true}
                                currencyValue={shopData?.currency || 'USD'}
                                onCurrencyChange={(code) => handleUpdateShop({ currency: code })}
                              />
                              
                              <ValidatedEditableText
                                value={item.description}
                                onChange={(value) => handleItemUpdate(item.id, { description: value })}
                                placeholder="Item Description"
                                multiline
                                theme={shopData?.theme}
                                showClearButton={true}
                              />
                              
                              <CategorySelect
  value={item.category || (getStoreTypeById(storeType)?.categories[0] || 'Other')}
  onChange={(e) => handleItemUpdate(item.id, {
    category: e.target.value,
    // Preserve the default category for broader classification
    defaultCategory: getStoreTypeById(storeType)?.defaultCategory
  })}
  theme={shopData?.theme}
>
  {getAllCategories(false).map(category => (
    <option key={category} value={category}>
      {category}
    </option>
  ))}
</CategorySelect>

                              {/* Item Attributes — desktop inline */}
                              {(() => {
                                const accent = shopData?.theme?.colors?.accent || '#800000';
                                const isRestaurantStore = shopData?.isRestaurant || storeType === 'restaurant';
                                const PRESETS = {
                                  clothing: ['Size', 'Color', 'Material', 'Style'],
                                  shoes:    ['Size', 'Color', 'Width'],
                                  electronics: ['Storage', 'Color', 'Connectivity'],
                                  sports:   ['Size', 'Color'],
                                  home:     ['Color', 'Material', 'Size'],
                                  beauty:   ['Variant', 'Size'],
                                  toys:     ['Size', 'Color'],
                                  automotive: ['Color', 'Compatibility'],
                                  art:      ['Size', 'Material'],
                                  books:    ['Format', 'Edition'],
                                  restaurant: ['Size', 'Spice Level', 'Protein', 'Side'],
                                  other:    ['Size', 'Color', 'Material'],
                                };
                                const SIZE_SUGGESTIONS = {
                                  Size: isRestaurantStore ? ['Small', 'Medium', 'Large', 'XL'] : ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
                                  Color: ['Black', 'White', 'Red', 'Blue', 'Green', 'Yellow', 'Pink', 'Grey', 'Brown'],
                                  Storage: ['64GB', '128GB', '256GB', '512GB', '1TB'],
                                  Material: ['Cotton', 'Polyester', 'Leather', 'Wool', 'Silk', 'Denim'],
                                  Format: ['Hardcover', 'Paperback', 'eBook', 'Audiobook'],
                                  Width: ['Narrow', 'Regular', 'Wide'],
                                  Connectivity: ['WiFi', 'Bluetooth', 'Wired', 'Wireless'],
                                  Variant: ['Original', 'Travel Size', 'Bundle'],
                                  'Spice Level': ['Mild', 'Medium', 'Hot', 'Extra Hot'],
                                  Protein: ['Chicken', 'Beef', 'Shrimp', 'Tofu', 'Pork', 'Lamb'],
                                  Side: ['Fries', 'Salad', 'Rice', 'Coleslaw', 'Soup'],
                                  Style: ['Casual', 'Formal', 'Sport'],
                                  Edition: ['1st', '2nd', '3rd', 'Latest'],
                                  Compatibility: ['Universal', 'Specific Model'],
                                };
                                const suggestedNames = PRESETS[storeType] || PRESETS.other;
                                const attrs = item.attributes || [];

                                const updateAttrs = (newAttrs) =>
                                  handleItemUpdate(item.id, { attributes: newAttrs });

                                const addAttr = (name) => {
                                  if (attrs.length >= 4) return;
                                  if (attrs.find(a => a.name.toLowerCase() === name.toLowerCase())) return;
                                  updateAttrs([...attrs, { name, values: [] }]);
                                };

                                const removeAttr = (idx) =>
                                  updateAttrs(attrs.filter((_, i) => i !== idx));

                                const updateAttrName = (idx, name) =>
                                  updateAttrs(attrs.map((a, i) => i === idx ? { ...a, name } : a));

                                const addValue = (idx, val) => {
                                  const trimmed = val.trim();
                                  if (!trimmed) return;
                                  const attr = attrs[idx];
                                  if (attr.values.includes(trimmed)) return;
                                  updateAttrs(attrs.map((a, i) => i === idx ? { ...a, values: [...a.values, trimmed] } : a));
                                };

                                const removeValue = (attrIdx, valIdx) =>
                                  updateAttrs(attrs.map((a, i) => i === attrIdx
                                    ? { ...a, values: a.values.filter((_, vi) => vi !== valIdx) }
                                    : a));

                                const inputStyle = {
                                  background: 'rgba(0,0,0,0.3)',
                                  border: `1px solid ${accent}40`,
                                  borderRadius: '6px',
                                  padding: '0.35rem 0.6rem',
                                  color: '#fff',
                                  fontSize: '0.82rem',
                                  outline: 'none',
                                  boxSizing: 'border-box',
                                };

                                return (
                                  <div style={{ marginBottom: '1rem', padding: '0.75rem', border: `1px solid ${accent}40`, borderRadius: '8px' }}>
                                    <div style={{ fontSize: '0.85rem', fontWeight: '700', color: accent, marginBottom: '0.5rem' }}>
                                      {isRestaurantStore ? 'Item Options' : 'Item Attributes'}
                                      <span style={{ fontWeight: '400', opacity: 0.6, marginLeft: '0.4rem' }}>
                                        {isRestaurantStore ? '(e.g. Size, Spice Level)' : '(up to 4 — e.g. Size, Color)'}
                                      </span>
                                    </div>

                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginBottom: '0.6rem' }}>
                                      {suggestedNames
                                        .filter(n => !attrs.find(a => a.name.toLowerCase() === n.toLowerCase()))
                                        .map(n => (
                                          <button
                                            key={n}
                                            onClick={() => addAttr(n)}
                                            disabled={attrs.length >= 4}
                                            style={{
                                              background: `${accent}22`,
                                              border: `1px solid ${accent}55`,
                                              color: accent,
                                              borderRadius: '20px',
                                              padding: '0.2rem 0.7rem',
                                              fontSize: '0.75rem',
                                              cursor: attrs.length >= 4 ? 'default' : 'pointer',
                                              opacity: attrs.length >= 4 ? 0.4 : 1,
                                            }}
                                          >+ {n}</button>
                                        ))}
                                      {attrs.length < 4 && (
                                        <button
                                          onClick={() => addAttr('Custom')}
                                          style={{
                                            background: 'rgba(255,255,255,0.06)',
                                            border: '1px solid rgba(255,255,255,0.2)',
                                            color: 'rgba(255,255,255,0.6)',
                                            borderRadius: '20px',
                                            padding: '0.2rem 0.7rem',
                                            fontSize: '0.75rem',
                                            cursor: 'pointer',
                                          }}
                                        >+ Custom</button>
                                      )}
                                    </div>

                                    {attrs.map((attr, ai) => (
                                      <div key={ai} style={{ background: 'rgba(0,0,0,0.2)', borderRadius: '6px', padding: '0.5rem 0.6rem', marginBottom: '0.45rem' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.4rem' }}>
                                          <input
                                            value={attr.name}
                                            onChange={e => updateAttrName(ai, e.target.value)}
                                            maxLength={20}
                                            style={{ ...inputStyle, flex: 1, fontWeight: '600' }}
                                          />
                                          <button
                                            onClick={() => removeAttr(ai)}
                                            style={{ background: 'none', border: 'none', color: '#ff6666', cursor: 'pointer', fontSize: '1rem', lineHeight: 1, padding: '0 0.2rem' }}
                                          >✕</button>
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginBottom: '0.35rem' }}>
                                          {attr.values.map((v, vi) => (
                                            <span
                                              key={vi}
                                              style={{
                                                display: 'inline-flex', alignItems: 'center', gap: '0.25rem',
                                                background: `${accent}30`, border: `1px solid ${accent}55`,
                                                color: '#fff', borderRadius: '20px',
                                                padding: '0.18rem 0.5rem', fontSize: '0.75rem'
                                              }}
                                            >
                                              {v}
                                              <span
                                                onClick={() => removeValue(ai, vi)}
                                                style={{ cursor: 'pointer', opacity: 0.6, fontSize: '0.7rem', lineHeight: 1 }}
                                              >✕</span>
                                            </span>
                                          ))}
                                          {(SIZE_SUGGESTIONS[attr.name] || [])
                                            .filter(sv => !attr.values.includes(sv))
                                            .slice(0, 6)
                                            .map(sv => (
                                              <span
                                                key={sv}
                                                onClick={() => addValue(ai, sv)}
                                                style={{
                                                  display: 'inline-block',
                                                  background: 'rgba(255,255,255,0.05)',
                                                  border: '1px dashed rgba(255,255,255,0.2)',
                                                  color: 'rgba(255,255,255,0.5)',
                                                  borderRadius: '20px',
                                                  padding: '0.18rem 0.5rem',
                                                  fontSize: '0.75rem',
                                                  cursor: 'pointer',
                                                }}
                                              >+{sv}</span>
                                            ))}
                                        </div>
                                        <form
                                          onSubmit={e => {
                                            e.preventDefault();
                                            const inp = e.target.elements[`desk-attr-val-${item.id}-${ai}`];
                                            addValue(ai, inp.value);
                                            inp.value = '';
                                          }}
                                          style={{ display: 'flex', gap: '0.35rem' }}
                                        >
                                          <input
                                            name={`desk-attr-val-${item.id}-${ai}`}
                                            placeholder="Add value…"
                                            maxLength={30}
                                            style={{ ...inputStyle, flex: 1 }}
                                          />
                                          <button
                                            type="submit"
                                            style={{
                                              background: `${accent}33`, border: `1px solid ${accent}66`,
                                              color: '#fff', borderRadius: '6px',
                                              padding: '0.35rem 0.7rem', fontSize: '0.8rem', cursor: 'pointer'
                                            }}
                                          >Add</button>
                                        </form>
                                      </div>
                                    ))}
                                  </div>
                                );
                              })()}

                              {/* Digital Product Toggle */}
                              <div style={{ margin: '0.5rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.9rem', color: shopData?.theme?.colors?.text || '#fff' }}>
                                  <input
                                    type="checkbox"
                                    checked={!!item.isDigital}
                                    onChange={e => handleItemUpdate(item.id, { isDigital: e.target.checked, digitalFile: null })}
                                    style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                  />
                                  Digital Product (instant download after purchase)
                                </label>
                              </div>

                              {/* Digital File Upload (inline) */}
                              {item.isDigital && (
                                <div style={{ margin: '0.5rem 0', padding: '0.75rem', border: `1px dashed ${shopData?.theme?.colors?.primary || '#666'}`, borderRadius: '8px' }}>
                                  {item.digitalFile ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem', color: shopData?.theme?.colors?.text || '#fff' }}>
                                      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.digitalFile.name}
                                      </span>
                                      <span style={{ opacity: 0.6, whiteSpace: 'nowrap' }}>
                                        {item.digitalFile.size ? `${(item.digitalFile.size / 1024 / 1024).toFixed(2)} MB` : ''}
                                      </span>
                                      <button
                                        onClick={() => handleItemUpdate(item.id, { digitalFile: null })}
                                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: shopData?.theme?.colors?.text || '#fff', padding: '0 4px' }}
                                      >
                                        <X size={14} />
                                      </button>
                                    </div>
                                  ) : (
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.85rem', color: shopData?.theme?.colors?.text || '#fff' }}>
                                      <Upload size={16} />
                                      <span>Upload digital file (PDF, ZIP, MP3, etc.)</span>
                                      <input
                                        type="file"
                                        style={{ display: 'none' }}
                                        onChange={e => {
                                          const file = e.target.files?.[0];
                                          if (file) {
                                            handleItemUpdate(item.id, { digitalFile: { file, name: file.name, size: file.size, type: file.type } });
                                          }
                                        }}
                                      />
                                    </label>
                                  )}
                                </div>
                              )}

                              <QuantitySelector
                                value={parseInt(item.quantity) || 1}
                                onChange={(value) => handleItemUpdate(item.id, { quantity: value })}
                                theme={shopData?.theme}
                                min={0}
                                max={9999}
                              />
                              {!item.isDigital && (
                              <AddressInput
  address={item.address || ''}
  onAddressChange={(value) => handleItemUpdate(item.id, {
    address: value
  })}
  onLocationSelect={(location) => {
    if (location?.coordinates) {
      handleItemUpdate(item.id, {
        address: location.address,
        coordinates: location.coordinates,
        city: location.city,
        state: location.state || null,
        country: location.country || null,
        locationSource: 'real',
      });
    } else if (!location?.address) {
      handleItemUpdate(item.id, {
        address: '',
        coordinates: null,
        city: null,
        state: null,
        country: null,
        locationSource: null,
      });
    }
  }}
  onMapOpen={() => handleOpenMapForSelection(item.id, false)}
/>
                              )}
                            </div>
                          </ItemDetails>

                          <div style={{
                            borderTop: `1px solid ${shopData?.theme?.colors?.accent}20`,
                            paddingTop: '1rem',
                            marginTop: '1rem',
                            display: 'flex',
                            justifyContent: 'center'
                          }}>
                            <button
                              onClick={() => handleDeleteItem(item.id)}
                              style={{
                                background: 'transparent',
                                border: `1px solid #ff444440`,
                                color: '#ff4444',
                                padding: '0.6rem 1.5rem',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                fontSize: '0.85rem',
                                fontWeight: '600',
                                transition: 'all 0.3s ease'
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.background = '#ff444420';
                                e.currentTarget.style.borderColor = '#ff4444';
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.borderColor = '#ff444440';
                              }}
                            >
                              <Trash2 size={16} />
                              Remove
                            </button>
                          </div>

<button
  onClick={(e) => {
    e.stopPropagation();
    handleToggleItemVisibility(item.id, false);
  }}
  style={{
    position: 'absolute',
    top: '10px',
    left: '12px',
    background: item.visible === false 
      ? 'rgba(255, 68, 68, 0.9)' 
      : 'rgba(76, 175, 80, 0.9)',
    border: `2px solid ${item.visible === false ? '#ff4444' : '#4CAF50'}`,
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    cursor: 'pointer',
    zIndex: 10,
    transition: 'all 0.3s ease',
    boxShadow: item.visible === false 
      ? '0 2px 8px rgba(255, 68, 68, 0.4)' 
      : '0 2px 8px rgba(76, 175, 80, 0.4)',
  }}
  title={
    item.visible === false && (!stripeStatus?.stripeReady || stripeStatus?.status !== 'active')
      ? 'Stripe required to publish'
      : item.visible === false 
        ? 'Hidden - Click to show' 
        : 'Visible - Click to hide'
  }
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.1)';
    e.currentTarget.style.boxShadow = item.visible === false 
      ? '0 0 15px rgba(255, 68, 68, 0.8)' 
      : '0 0 15px rgba(76, 175, 80, 0.8)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = item.visible === false 
      ? '0 0 10px rgba(255, 68, 68, 0.5)' 
      : '0 0 10px rgba(76, 175, 80, 0.5)';
  }}
>
  {item.visible === false ? (
    // Eye-off icon (hidden)
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" strokeWidth="2.5" />
    </svg>
  ) : (
    // Eye icon (visible)
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" fill="currentColor" />
    </svg>
  )}
</button>
{visibilityToast?.id === item.id && (
  <div style={{ position: 'absolute', top: '3rem', left: '12px', zIndex: 20, background: 'rgba(0,0,0,0.92)', color: '#fff', fontSize: '0.72rem', padding: '0.4rem 1.6rem 0.4rem 0.65rem', borderRadius: '8px', maxWidth: '170px', lineHeight: 1.35, animation: 'visToastAnim 0.25s ease forwards', whiteSpace: 'normal', boxShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
    <button onClick={(e) => { e.stopPropagation(); setVisibilityToast(null); }} style={{ position: 'absolute', top: '3px', right: '5px', background: 'transparent', border: 'none', color: '#fff', opacity: 0.6, cursor: 'pointer', padding: '1px', lineHeight: 1, fontSize: '0.75rem' }}>✕</button>
    <span onClick={(e) => { e.stopPropagation(); setBillingDataForPayment(visibilityToast.billingPayload); setShowPaymentModal(true); setVisibilityToast(null); }} style={{ cursor: 'pointer', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>{visibilityToast.msg}</span>
  </div>
)}
                        </ItemContent>
                      </DesktopItemCard>
                  </React.Fragment>
                );
              })}
              </ShopCategoryGrid>
            </div>
          );
        });
      })()}
      <div style={{ marginTop: '1rem', marginBottom: '2rem' }}>
        {showAddCategoryInput ? (
          <div style={{ padding: '0.5rem', background: `${shopData?.theme?.colors?.surface}20`, borderRadius: '12px', border: `1px dashed ${shopData?.theme?.colors?.accent}40` }}>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' }}>
              <input autoFocus value={newCategoryName} onChange={e => setNewCategoryName(e.target.value)} onKeyDown={e => { if (e.key === 'Enter' && newCategoryName.trim()) { handleAddCategory(false, newCategoryName); setNewCategoryName(''); setShowAddCategoryInput(false); } else if (e.key === 'Escape') { setShowAddCategoryInput(false); setNewCategoryName(''); setNewCategoryType(null); }}} placeholder="Category name..." style={{ flex: 1, background: 'rgba(0,0,0,0.3)', border: `1px solid ${shopData?.theme?.colors?.accent}40`, borderRadius: '8px', padding: '0.4rem 0.7rem', color: shopData?.theme?.colors?.text || '#fff', fontSize: '0.85rem', outline: 'none' }} />
              <button onClick={() => { if (newCategoryName.trim()) { handleAddCategory(false, newCategoryName); setNewCategoryName(''); setShowAddCategoryInput(false); }}} style={{ background: shopData?.theme?.colors?.accent, color: 'white', border: 'none', borderRadius: '8px', padding: '0.4rem 0.9rem', cursor: 'pointer', fontSize: '0.82rem', fontWeight: '600' }}>Add</button>
              <button onClick={() => { setShowAddCategoryInput(false); setNewCategoryName(''); setNewCategoryType(null); }} style={{ background: 'transparent', color: shopData?.theme?.colors?.text || '#fff', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', padding: '0.4rem 0.7rem', cursor: 'pointer', fontSize: '0.82rem', opacity: 0.6 }}>Cancel</button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem' }}>
              {STORE_TYPES.map(t => (
                <button key={t.id} onClick={() => setNewCategoryType(newCategoryType === t.id ? null : t.id)} style={{ background: newCategoryType === t.id ? `${shopData?.theme?.colors?.accent}25` : 'transparent', border: `1px solid ${newCategoryType === t.id ? shopData?.theme?.colors?.accent : `${shopData?.theme?.colors?.accent}30`}`, borderRadius: '6px', color: newCategoryType === t.id ? shopData?.theme?.colors?.accent : `${shopData?.theme?.colors?.text || '#fff'}70`, fontSize: '0.72rem', padding: '0.2rem 0.5rem', cursor: 'pointer', fontWeight: newCategoryType === t.id ? '600' : '400' }}>
                  {t.label}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <button onClick={() => { setShowAddCategoryInput(true); setNewCategoryName(''); }} style={{ width: '100%', background: 'transparent', border: `2px dashed ${shopData?.theme?.colors?.accent}30`, borderRadius: '12px', padding: '0.75rem', color: shopData?.theme?.colors?.accent, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', fontSize: '0.88rem', fontWeight: '600', opacity: 0.7 }}>
            <Plus size={16} /> Add Category
          </button>
        )}
      </div>
    </div>


            </>
          ) : (
              <>
              <div style={{ padding: '0 0.5rem', marginTop: '1.5rem' }}>
      {/* Services: Category-grouped rows */}
      {(() => {
        const tabServices = (shopData?.services || []).filter(s => (s.serviceTab || 'offer') === serviceSubTab);
        const fallbackOrder = getFallbackCategoryOrder(true);
        const categoryOrder = shopData?.serviceCategoryOrder?.length
          ? [...new Set([...shopData.serviceCategoryOrder, ...fallbackOrder])]
          : fallbackOrder;
        const accent = shopData?.theme?.colors?.accent || '#800000';
        return categoryOrder.map((categoryName, catIdx) => {
          const catServices = tabServices.filter(s => (s.category || 'Other') === categoryName);
          const cardCols = shopData?.categoryColumns?.[`s:${categoryName}`] ?? 1;
          return (
            <div key={`scat-${categoryName}`} style={{ marginBottom: '1.5rem' }}>
              {(() => {
                const pickerKey = `s-${categoryName}`;
                const currentTypeId = shopData?.categoryTypes?.[categoryName] || 'other';
                const currentStoreType = STORE_TYPES.find(t => t.id === currentTypeId);
                const isPickerOpen = openTypePicker === pickerKey;
                return (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '0.4rem 0.25rem', borderBottom: isPickerOpen ? 'none' : `1px solid ${accent}25`, marginBottom: isPickerOpen ? 0 : '0.5rem', flexWrap: 'wrap', gap: '0.3rem' }}>
                      <span style={{ fontWeight: '700', color: accent, fontSize: '0.9rem' }}>{categoryName}<span style={{ fontWeight: '400', opacity: 0.5, marginLeft: '0.4rem', fontSize: '0.75rem' }}>({catServices.length})</span></span>
                      <button onClick={() => handleMoveCategory(true, categoryName, 'up')} disabled={catIdx === 0} style={{ marginLeft: '0.5rem', background: 'transparent', border: `1px solid ${accent}30`, borderRadius: '6px', color: accent, padding: '0.15rem', cursor: catIdx === 0 ? 'default' : 'pointer', opacity: catIdx === 0 ? 0.3 : 0.75, display: 'flex', alignItems: 'center' }} title="Move category up">
                        <ChevronUp size={14} />
                      </button>
                      <button onClick={() => handleMoveCategory(true, categoryName, 'down')} disabled={catIdx === categoryOrder.length - 1} style={{ background: 'transparent', border: `1px solid ${accent}30`, borderRadius: '6px', color: accent, padding: '0.15rem', cursor: catIdx === categoryOrder.length - 1 ? 'default' : 'pointer', opacity: catIdx === categoryOrder.length - 1 ? 0.3 : 0.75, display: 'flex', alignItems: 'center' }} title="Move category down">
                        <ChevronDown size={14} />
                      </button>
                      <button onClick={() => handleCycleCategoryColumns(true, categoryName)} style={{ background: 'transparent', border: `1px solid ${accent}30`, borderRadius: '6px', color: accent, fontSize: '0.68rem', fontWeight: 800, padding: '0.15rem 0.4rem', cursor: 'pointer', opacity: 0.75, display: 'flex', alignItems: 'center', gap: '0.15rem' }} title="Public page card layout for this category">
                        {cardCols}×<Grid size={12} />
                      </button>
                      <button onClick={() => setOpenTypePicker(isPickerOpen ? null : pickerKey)} style={{ background: 'transparent', border: `1px solid ${accent}30`, borderRadius: '6px', color: accent, fontSize: '0.68rem', padding: '0.1rem 0.4rem', cursor: 'pointer', opacity: 0.75, lineHeight: 1.4 }} title="Set welcome page category">
                        {currentStoreType?.label?.split(' ')[0] || '📦'}
                      </button>
                      <button onClick={() => handleDeleteCategory(true, categoryName)} style={{ marginLeft: 'auto', background: 'transparent', border: 'none', color: accent, opacity: 0.4, cursor: 'pointer', padding: '0.2rem', display: 'flex', alignItems: 'center' }} title={`Delete ${categoryName}`}>
                        <Trash2 size={14} />
                      </button>
                    </div>
                    {isPickerOpen && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', padding: '0.4rem 0.25rem 0.5rem', borderBottom: `1px solid ${accent}25`, marginBottom: '0.5rem' }}>
                        {STORE_TYPES.map(t => (
                          <button key={t.id} onClick={() => handleSetCategoryType(categoryName, t.id)} style={{ background: currentTypeId === t.id ? `${accent}25` : 'transparent', border: `1px solid ${currentTypeId === t.id ? accent : `${accent}30`}`, borderRadius: '6px', color: currentTypeId === t.id ? accent : `${shopData?.theme?.colors?.text || '#fff'}80`, fontSize: '0.72rem', padding: '0.2rem 0.5rem', cursor: 'pointer', fontWeight: currentTypeId === t.id ? '600' : '400' }}>
                            {t.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                );
              })()}
              <ShopCategoryGrid $cols={shopMobileColumns} $accent={accent} $rows={catServices.length + 1 > 5 ? 2 : 1} $mobileRows={shopMobileColumns === 1 ? 1 : (catServices.length + 1 > shopMobileColumns ? 2 : 1)}>
                <MobileItemCard
                  theme={shopData?.theme}
                  onClick={() => openBulkUploadForCategory(categoryName)}
                  style={{ cursor: 'pointer', border: `2px dashed ${accent}40`, background: `${accent}08` }}
                >
                  <MobileItemImageContainer theme={shopData?.theme}>
                    <div className="placeholder">
                      <Plus size={28} />
                      <span>Add Card</span>
                    </div>
                  </MobileItemImageContainer>
                  <MobileItemContent theme={shopData?.theme}>
                    <div className="item-name" style={{ opacity: 0.5, textAlign: 'center', justifyContent: 'center' }}>Tap to add</div>
                  </MobileItemContent>
                </MobileItemCard>
                <DesktopItemCard
                  theme={shopData?.theme}
                  onClick={() => openBulkUploadForCategory(categoryName)}
                  style={{ cursor: 'pointer', border: `2px dashed ${accent}40`, background: `${accent}08` }}
                >
                  <ItemImageContainer theme={shopData?.theme}>
                    <div className="placeholder">
                      <Plus size={32} />
                      <span>Add Card</span>
                    </div>
                  </ItemImageContainer>
                  <ItemContent>
                    <ItemHeader>
                      <h3 style={{ opacity: 0.5, textAlign: 'center', width: '100%' }}>Tap to add</h3>
                    </ItemHeader>
                  </ItemContent>
                </DesktopItemCard>
              {catServices.map(service => {
                const isExpanded = expandedItems.has(service.id);
                const validImages = service.images.filter(Boolean);
                const currentImageIndex = service.currentImageIndex || 0;
                const currentImage = validImages[currentImageIndex] || null;

                return (
                    <React.Fragment key={service.id}>
                      <MobileItemCard
  theme={shopData?.theme}
  onClick={() => {
    setEditingItem({
      ...service,
      images: [...service.images],
      currentImageIndex: service.currentImageIndex || 0,
      isService: true
    });
  }}
>
  <MobileItemImageContainer
    theme={shopData?.theme}
    $bgImage={(() => {
      // Toggle on → route image always wins over any uploaded photo, so skip
      // the blurred-photo backdrop too (the route canvas fills the container).
      if (service.jobType === 'rides' && service.useRouteMapImage && service.pickupCoordinates && service.destinationCoordinates) return null;
      const validImages = service.images.filter(Boolean);
      const currentImageIndex = service.currentImageIndex || 0;
      const currentMedia = validImages[currentImageIndex] || null;

      if (!currentMedia) return null;

      const mediaIsVideo = isVideoUrl(currentMedia);
      if (mediaIsVideo) return null; // Don't blur for videos

      return typeof currentMedia === 'string' ? currentMedia :
             currentMedia.url || currentMedia.preview || currentMedia;
    })()}
  >
    {(() => {
      const routeOverride = service.jobType === 'rides' && service.useRouteMapImage && service.pickupCoordinates && service.destinationCoordinates;
      const validImages = service.images.filter(Boolean);
      const currentImageIndex = service.currentImageIndex || 0;
      const currentMedia = routeOverride ? null : (validImages[currentImageIndex] || null);

      if (currentMedia) {
        const mediaIsVideo = isVideoUrl(currentMedia);
        
        if (mediaIsVideo) {
          const videoSrc = typeof currentMedia === 'string' ? currentMedia : 
                          currentMedia.url || currentMedia.preview;
          return (
            <video 
              src={videoSrc}
              loop 
              muted 
              playsInline
              autoPlay
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'contain', // CHANGED from cover
                position: 'relative',
                zIndex: 1
              }}
            />
          );
        }
        
        const imgSrc = typeof currentMedia === 'string' ? currentMedia : 
                      currentMedia.url || currentMedia.preview || currentMedia;
        return <img src={imgSrc} alt={service.name || 'Service'} />;
      }
      
      if ((service.jobType === 'moving' || (service.jobType === 'rides' && service.useRouteMapImage)) && service.pickupCoordinates && service.destinationCoordinates) {
        return (
          <div style={{ position: 'absolute', inset: 0, zIndex: 1 }}>
            <RideRoutePreview
              pickupCoords={service.pickupCoordinates}
              destCoords={service.destinationCoordinates}
              onRouteLoaded={(dist, dur) => handleServiceUpdate(service.id, { estimatedDistance: dist, estimatedDuration: dur })}
              onImageCapture={(blob) => {
                // Toggle on → always overwrite slot 0, even over an uploaded photo.
                // 'moving' has no toggle, so it keeps the old don't-clobber behavior.
                const forceOverride = service.jobType === 'rides' && service.useRouteMapImage;
                if (!forceOverride && service.images?.some(img => img && typeof img === 'string' && img.startsWith('http'))) return;
                const previewUrl = URL.createObjectURL(blob);
                const file = new File([blob], 'route-preview.png', { type: 'image/png' });
                setTempFileStorage(prev => ({ ...prev, [`${service.id}-0`]: file }));
                handleServiceUpdate(service.id, { images: [previewUrl, null, null] });
              }}
            />
          </div>
        );
      }

      return (
        <div className="placeholder" style={{ flexDirection: 'column', gap: '0.5rem' }}>
          {service.jobType === 'rides' ? (
            <>
              <span style={{ fontSize: '2rem' }}>🚗</span>
              {(service.pickupAddress || service.destinationAddress) ? (
                <div style={{ fontSize: '0.65rem', opacity: 0.8, textAlign: 'center', padding: '0 0.5rem', lineHeight: 1.4 }}>
                  {service.pickupAddress && <div>📍 {service.pickupAddress.split(',')[0]}</div>}
                  {service.destinationAddress && <div>🏁 {service.destinationAddress.split(',')[0]}</div>}
                </div>
              ) : <span style={{ fontSize: '0.7rem', opacity: 0.6 }}>Add pickup & destination</span>}
            </>
          ) : service.jobType === 'moving' ? (
            <>
              <span style={{ fontSize: '2rem' }}>📦</span>
              {(service.pickupAddress || service.destinationAddress) ? (
                <div style={{ fontSize: '0.65rem', opacity: 0.8, textAlign: 'center', padding: '0 0.5rem', lineHeight: 1.4 }}>
                  {service.pickupAddress && <div>📦 {service.pickupAddress.split(',')[0]}</div>}
                  {service.destinationAddress && <div>🏁 {service.destinationAddress.split(',')[0]}</div>}
                </div>
              ) : <span style={{ fontSize: '0.7rem', opacity: 0.6 }}>Add from & to addresses</span>}
            </>
          ) : service.jobType ? (
            <>
              <span style={{ fontSize: '2rem' }}>
                {({ home_repair:'🔧', cleaning:'🧹', moving:'📦', delivery:'🚚', tutoring:'📚', pet_care:'🐾', handyman:'🛠️', beauty:'💇', tech:'💻', events:'🎉', other:'💼' })[service.jobType] || '💼'}
              </span>
              <span style={{ fontSize: '0.7rem', opacity: 0.6 }}>Add Photo or Video</span>
            </>
          ) : (
            <>
              <Store size={24} />
              <span>Add Photo or Video</span>
            </>
          )}
        </div>
      );
    })()}

    {validImages.length > 1 && (
      <>
        <button
          className="mobile-carousel-arrow left"
          onClick={(e) => {
            e.stopPropagation();
            const newIndex = ((currentImageIndex - 1) + validImages.length) % validImages.length;
            handleServiceUpdate(service.id, { currentImageIndex: newIndex });
          }}
        >
          <ChevronLeft size={12} />
        </button>
        <button
          className="mobile-carousel-arrow right"
          onClick={(e) => {
            e.stopPropagation();
            const newIndex = (currentImageIndex + 1) % validImages.length;
            handleServiceUpdate(service.id, { currentImageIndex: newIndex });
          }}
        >
          <ChevronRight size={12} />
        </button>
        <div className="image-dots">
          {validImages.map((_, index) => (
            <div
              key={index}
              className={`dot ${index === currentImageIndex ? 'active' : ''}`}
            />
          ))}
        </div>
      </>
    )}

    <MobileDeleteButton
      onClick={(e) => {
        e.stopPropagation();
        handleServiceDelete(service.id);
      }}
    >
      <X size={12} />
    </MobileDeleteButton>

    {/* Ride/Move overlay: addresses + nav button + distance/time pills on the image */}
    {['rides','moving'].includes(service.jobType) && (service.pickupAddress || service.destinationAddress) && (() => {
      const enc = encodeURIComponent;
      const from = service.pickupCoordinates?.lat
        ? `${service.pickupCoordinates.lat},${service.pickupCoordinates.lng}`
        : enc(service.pickupAddress || '');
      const to = service.destinationCoordinates?.lat
        ? `${service.destinationCoordinates.lat},${service.destinationCoordinates.lng}`
        : enc(service.destinationAddress || '');
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const mapsUrl = isIOS
        ? `maps://maps.apple.com/?saddr=${from}&daddr=${to}&dirflg=d`
        : `https://www.google.com/maps/dir/?api=1&origin=${from}&destination=${to}&travelmode=driving`;
      return (
        <>
          <a href={mapsUrl} target="_blank" rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
            style={{ position: 'absolute', bottom: 5, left: 5, zIndex: 4, width: 24, height: 24, borderRadius: '50%', background: 'rgba(0,0,0,0.72)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textDecoration: 'none' }}
          >
            <Navigation size={11} />
          </a>
          {(service.estimatedDistance || service.estimatedDuration) && (
            <div style={{ position: 'absolute', bottom: 5, left: '50%', transform: 'translateX(-50%)', zIndex: 4, display: 'flex', gap: 4, pointerEvents: 'none', whiteSpace: 'nowrap', width: 'max-content' }}>
              {service.estimatedDistance && (
                <div style={{ background: 'rgba(0,0,0,0.72)', backdropFilter: 'blur(6px)', borderRadius: 20, padding: '1px 6px', fontSize: '0.52rem', fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>🛣 {service.estimatedDistance} mi</div>
              )}
              {service.estimatedDuration && (
                <div style={{ background: 'rgba(0,0,0,0.72)', backdropFilter: 'blur(6px)', borderRadius: 20, padding: '1px 6px', fontSize: '0.52rem', fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>⏱ {service.estimatedDuration} min</div>
              )}
            </div>
          )}
        </>
      );
    })()}


  </MobileItemImageContainer>

  {bulkEditMode && (
  <SelectionCheckbox
    theme={shopData?.theme}
    checked={selectedItemsForBulk.has(service.id)}
    onClick={(e) => {
      e.stopPropagation();
      toggleBulkSelection(service.id);
    }}
  >
    <Check size={20} />
  </SelectionCheckbox>
)}
  {featuredSelectMode && (
  <SelectionCheckbox
    theme={shopData?.theme}
    checked={selectedFeatured.has(service.id)}
    onClick={(e) => {
      e.stopPropagation();
      setSelectedFeatured(prev => {
        const next = new Set(prev);
        if (next.has(service.id)) {
          next.delete(service.id);
        } else if (next.size < 10) {
          next.add(service.id);
        }
        return next;
      });
    }}
    style={{ background: selectedFeatured.has(service.id) ? '#f5a623' : undefined, borderColor: '#f5a623' }}
  >
    ★
  </SelectionCheckbox>
)}

  <MobileItemContent theme={shopData?.theme}>
    <div className="item-name" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {service.isFeatured && <span style={{ color: '#f5a623', fontSize: '12px' }}>★</span>}
      {service.jobType && <span style={{ fontSize: '0.85rem' }}>{({rides:'🚗',home_repair:'🔧',cleaning:'🧹',moving:'📦',delivery:'🚚',tutoring:'📚',pet_care:'🐾',handyman:'🛠️',beauty:'💇',tech:'💻',events:'🎉',other:'💼'})[service.jobType] || '💼'}</span>}
      {service.name && service.name !== 'Service Name' ?
        service.name :
        <span style={{ opacity: 0.5 }}>Service Name</span>
      }
    </div>
    {(service.jobType === 'rides' || service.jobType === 'moving') && (
      <div style={{ fontSize: '0.5rem', fontWeight: 600, opacity: 0.55, textTransform: 'uppercase', letterSpacing: '0.3px', color: shopData?.theme?.colors?.text || '#fff', marginBottom: '1px' }}>{service.jobType === 'moving' ? 'Move Request' : 'Trip Request'}</div>
    )}
    <div className="item-price">
      {service.price ? `$${parseFloat(service.price).toFixed(2)}` :
        <span className="empty-text">$0.00</span>}
    </div>
    <button
  onClick={(e) => {
    e.stopPropagation();
    handleToggleItemVisibility(service.id, true); // true = isService
  }}
  style={{
    position: 'absolute',
    top: '0.25rem',
    left: '.5rem',
    background: service.visible === false 
      ? 'rgba(255, 68, 68, 0.9)' 
      : 'rgba(76, 175, 80, 0.9)',
    border: `2px solid ${service.visible === false ? '#ff4444' : '#4CAF50'}`,
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    cursor: 'pointer',
    zIndex: 4,
    transition: 'all 0.3s ease',
    boxShadow: service.visible === false 
      ? '0 0 10px rgba(255, 68, 68, 0.5)' 
      : '0 0 10px rgba(76, 175, 80, 0.5)',
  }}
  title={
    service.visible === false && (!stripeStatus?.stripeReady || stripeStatus?.status !== 'active')
      ? 'Stripe required - Click to set up'
      : service.visible === false 
        ? 'Hidden - Click to show' 
        : 'Visible - Click to hide'
  }
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.1)';
    e.currentTarget.style.boxShadow = service.visible === false 
      ? '0 0 15px rgba(255, 68, 68, 0.8)' 
      : '0 0 15px rgba(76, 175, 80, 0.8)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = service.visible === false 
      ? '0 0 10px rgba(255, 68, 68, 0.5)' 
      : '0 0 10px rgba(76, 175, 80, 0.5)';
  }}
>
  {service.visible === false ? (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" strokeWidth="2.5" />
    </svg>
  ) : (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" fill="currentColor" />
    </svg>
  )}
</button>
{visibilityToast?.id === service.id && (
  <div style={{ position: 'absolute', top: '2.4rem', left: '0.5rem', zIndex: 20, background: 'rgba(0,0,0,0.88)', color: '#fff', fontSize: '0.68rem', padding: '0.3rem 0.55rem', borderRadius: '8px', maxWidth: '140px', lineHeight: 1.35, pointerEvents: 'none', animation: 'visToastAnim 2.5s ease forwards', whiteSpace: 'normal' }}>
    {visibilityToast.msg}
  </div>
)}
  </MobileItemContent>
</MobileItemCard>
                          
                      {/* Desktop Service Card */}
                      <DesktopItemCard theme={shopData?.theme}>
  <DeleteButton 
    onClick={() => handleServiceDelete(service.id)}
    theme={shopData?.theme}
  >
    <X size={16} />
  </DeleteButton>

  <button
  onClick={(e) => {
    e.stopPropagation();
    handleToggleItemVisibility(service.id, true); // true = isService
  }}
  style={{
    position: 'absolute',
    top: '10px',
    left: '12px',
    background: service.visible === false 
      ? 'rgba(255, 68, 68, 0.9)' 
      : 'rgba(76, 175, 80, 0.9)',
    border: `2px solid ${service.visible === false ? '#ff4444' : '#4CAF50'}`,
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    cursor: 'pointer',
    zIndex: 10,
    transition: 'all 0.3s ease',
    boxShadow: service.visible === false 
      ? '0 2px 8px rgba(255, 68, 68, 0.4)' 
      : '0 2px 8px rgba(76, 175, 80, 0.4)',
    // ✅ ADDED: Show warning border if trying to toggle without Stripe
    ...(service.visible === false && (!stripeStatus?.stripeReady || stripeStatus?.status !== 'active') ? {
      border: '2px solid #FFC107',
      boxShadow: '0 0 10px rgba(255, 193, 7, 0.5)'
    } : {})
  }}
  title={
    service.visible === false && (!stripeStatus?.stripeReady || stripeStatus?.status !== 'active')
      ? 'Stripe required to publish'
      : service.visible === false 
        ? 'Hidden - Click to show' 
        : 'Visible - Click to hide'
  }
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.1)';
    e.currentTarget.style.boxShadow = service.visible === false 
      ? '0 0 15px rgba(255, 68, 68, 0.8)' 
      : '0 0 15px rgba(76, 175, 80, 0.8)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = service.visible === false 
      ? '0 0 10px rgba(255, 68, 68, 0.5)' 
      : '0 0 10px rgba(76, 175, 80, 0.5)';
  }}
>
  {service.visible === false ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" strokeWidth="2.5" />
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" fill="currentColor" />
    </svg>
  )}
</button>
{visibilityToast?.id === service.id && (
  <div style={{ position: 'absolute', top: '3rem', left: '12px', zIndex: 20, background: 'rgba(0,0,0,0.92)', color: '#fff', fontSize: '0.72rem', padding: '0.4rem 1.6rem 0.4rem 0.65rem', borderRadius: '8px', maxWidth: '170px', lineHeight: 1.35, animation: 'visToastAnim 0.25s ease forwards', whiteSpace: 'normal', boxShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
    <button onClick={(e) => { e.stopPropagation(); setVisibilityToast(null); }} style={{ position: 'absolute', top: '3px', right: '5px', background: 'transparent', border: 'none', color: '#fff', opacity: 0.6, cursor: 'pointer', padding: '1px', lineHeight: 1, fontSize: '0.75rem' }}>✕</button>
    <span onClick={(e) => { e.stopPropagation(); setBillingDataForPayment(visibilityToast.billingPayload); setShowPaymentModal(true); setVisibilityToast(null); }} style={{ cursor: 'pointer', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>{visibilityToast.msg}</span>
  </div>
)}

  <ItemImageContainer
    theme={shopData?.theme}
    $bgImage={(() => {
      const currentMedia = service.images[service.currentImageIndex];
      if (!currentMedia) return null;

      const mediaIsVideo = isVideoUrl(currentMedia);
      if (mediaIsVideo) return null; // Don't blur for videos

      // Extract URL for background blur
      return typeof currentMedia === 'string' ? currentMedia :
             currentMedia.url || currentMedia.preview || currentMedia;
    })()}
  >
    {uploading[service.id] && (
      <UploadingOverlay>
        <LoadingSpinner />
      </UploadingOverlay>
    )}
    <div 
      className="image-container"
      onClick={() => {
        if (!service.images[service.currentImageIndex]) {
          document.getElementById(`service-image-upload-${service.id}-${service.currentImageIndex}`).click();
        }
      }}
    >
      {service.images[service.currentImageIndex] ? (
        (() => {
          const media = service.images[service.currentImageIndex];
          const mediaIsVideo = isVideoUrl(media);
          
          if (mediaIsVideo) {
            const videoSrc = typeof media === 'string' ? media : 
                            media.url || media.preview;
            return (
              <video 
                src={videoSrc}
                loop 
                muted 
                playsInline
                autoPlay
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'contain', // CHANGED from cover
                  position: 'relative',
                  zIndex: 1
                }}
              />
            );
          }
          
          const imgSrc = typeof media === 'string' ? media : 
                        media.url || media.preview || media;
          return (
            <img 
              src={imgSrc}
              alt={service.name}
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'contain', // CHANGED from cover
                position: 'relative',
                zIndex: 1
              }}
            />
          );
        })()
      ) : (
        <div className="placeholder" style={{ flexDirection: 'column', gap: '0.5rem' }}>
          {service.jobType === 'rides' ? (
            <><span style={{ fontSize: '3rem' }}>🚗</span><span style={{ fontSize: '0.8rem', opacity: 0.6 }}>Click to add photo</span></>
          ) : service.jobType ? (
            <><span style={{ fontSize: '3rem' }}>
              {({ home_repair:'🔧', cleaning:'🧹', moving:'📦', delivery:'🚚', tutoring:'📚', pet_care:'🐾', handyman:'🛠️', beauty:'💇', tech:'💻', events:'🎉', other:'💼' })[service.jobType] || '💼'}
            </span><span style={{ fontSize: '0.8rem', opacity: 0.6 }}>Click to add photo</span></>
          ) : (
            <><Store size={24} /><span>Upload Image</span></>
          )}
        </div>
      )}
    </div>
    
    {service.images.some(img => img) && (
      <>
        <button 
          className="carousel-arrow left"
          onClick={() => {
            const newIndex = ((service.currentImageIndex - 1) + 3) % 3;
            handleServiceUpdate(service.id, { currentImageIndex: newIndex });
          }}
        >
          <ChevronLeft size={16} />
        </button>
        <button 
          className="carousel-arrow right"
          onClick={() => {
            const newIndex = (service.currentImageIndex + 1) % 3;
            handleServiceUpdate(service.id, { currentImageIndex: newIndex });
          }}
        >
          <ChevronRight size={16} />
        </button>
      </>
    )}

    {service.images[service.currentImageIndex] && (
      <button 
        className="add-image"
        onClick={() => {
          const newImages = [...service.images];
          newImages[service.currentImageIndex] = null;
          handleServiceUpdate(service.id, { images: newImages });
        }}
      >
        <X size={16} />
      </button>
    )}

    <input
      type="file"
      id={`service-image-upload-${service.id}-${service.currentImageIndex}`}
      accept="image/*"
      style={{ display: 'none' }}
      onChange={(e) => {
        const file = e.target.files?.[0];
        // Reset immediately so re-selecting the same file reliably fires
        // onChange again on mobile instead of silently no-op'ing.
        e.target.value = '';
        if (file) {
          handleImageUpload(service.id, service.currentImageIndex, file);
        }
      }}
    />

    {bulkEditMode && (
  <SelectionCheckbox
    theme={shopData?.theme}
    checked={selectedItemsForBulk.has(service.id)}
    onClick={(e) => {
      e.stopPropagation();
      toggleBulkSelection(service.id);
    }}
    style={{ top: '50px' }} // Below delete button
  >
    <Check size={20} />
  </SelectionCheckbox>
)}
    {featuredSelectMode && (
  <SelectionCheckbox
    theme={shopData?.theme}
    checked={selectedFeatured.has(service.id)}
    onClick={(e) => {
      e.stopPropagation();
      setSelectedFeatured(prev => {
        const next = new Set(prev);
        if (next.has(service.id)) {
          next.delete(service.id);
        } else if (next.size < 10) {
          next.add(service.id);
        }
        return next;
      });
    }}
    style={{ top: '50px', background: selectedFeatured.has(service.id) ? '#f5a623' : undefined, borderColor: '#f5a623' }}
  >
    ★
  </SelectionCheckbox>
)}
    {['rides','moving'].includes(service.jobType) && (service.pickupAddress || service.destinationAddress) && (() => {
      const isApple = /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);
      const destQ = service.destinationCoordinates
        ? `${service.destinationCoordinates.lat},${service.destinationCoordinates.lng}`
        : encodeURIComponent(service.destinationAddress || '');
      const pickQ = service.pickupCoordinates
        ? `${service.pickupCoordinates.lat},${service.pickupCoordinates.lng}`
        : encodeURIComponent(service.pickupAddress || '');
      const mapsUrl = isApple
        ? `maps://maps.apple.com/?saddr=${pickQ}&daddr=${destQ}&dirflg=d`
        : `https://www.google.com/maps/dir/?api=1&origin=${pickQ}&destination=${destQ}&travelmode=driving`;
      const distMi = service.pickupCoordinates && service.destinationCoordinates
        ? haversineDistanceMiles(service.pickupCoordinates.lat, service.pickupCoordinates.lng, service.destinationCoordinates.lat, service.destinationCoordinates.lng)
        : null;
      const durMin = service.estimatedDuration ? Math.round(service.estimatedDuration / 60) : null;
      const pillBase = { display: 'inline-flex', alignItems: 'center', gap: '4px', background: 'rgba(0,0,0,0.62)', backdropFilter: 'blur(6px)', borderRadius: '20px', padding: '3px 8px', fontSize: '0.6rem', color: '#fff', whiteSpace: 'nowrap' };
      return (
        <>
          {/* Navigate button — bottom-left */}
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
            style={{ position: 'absolute', bottom: 8, left: 8, zIndex: 5, width: 30, height: 30, borderRadius: '50%', background: 'rgba(0,0,0,0.62)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textDecoration: 'none' }}
          >
            <Navigation size={14} />
          </a>
          {/* Bottom-center distance + duration */}
          {(distMi || durMin) && (
            <div style={{ position: 'absolute', bottom: 8, left: '50%', transform: 'translateX(-50%)', zIndex: 5, display: 'flex', gap: '6px', whiteSpace: 'nowrap', width: 'max-content' }}>
              {distMi && <div style={pillBase}>🛣 {distMi} mi</div>}
              {durMin && <div style={pillBase}>⏱ {durMin} min</div>}
            </div>
          )}
        </>
      );
    })()}
  </ItemImageContainer>

  <ItemContent>
    <ItemHeader onClick={() => toggleItemExpansion(service.id)}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h3 style={{ display: 'flex', alignItems: 'center', gap: '4px', margin: 0 }}>
          {service.isFeatured && <span style={{ color: '#f5a623', fontSize: '14px' }}>★</span>}
          {service.jobType && <span style={{ fontSize: '1rem' }}>{JOB_TYPES.find(j => j.id === service.jobType)?.icon || '💼'}</span>}
          {service.name && service.name !== 'Service Name' ?
            service.name :
            <span style={{ opacity: 0.5 }}>Service Name</span>
          }
        </h3>
        {(service.jobType === 'rides' || service.jobType === 'moving') && (
          <div style={{ fontSize: '0.55rem', textTransform: 'uppercase', opacity: 0.7, marginTop: '0.1rem', letterSpacing: '0.05em' }}>{service.jobType === 'moving' ? 'Move Request' : 'Trip Request'}</div>
        )}
        {service.price && <div style={{ fontSize: '0.8rem', fontWeight: '700', opacity: 0.85, marginTop: '0.15rem', color: shopData?.theme?.colors?.accent || '#800000' }}>${service.price}</div>}
      </div>
      <ExpandButton>
        {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </ExpandButton>
    </ItemHeader>
      
    <ItemDetails expanded={isExpanded}>
      <div className="details-content">
        <select
          value={service.jobType || ''}
          onChange={(e) => {
            const newType = e.target.value;
            const jobMeta = getAllServiceTypes().find(j => j.id === newType);
            const isDefaultName = !service.name || service.name === 'Service Name' ||
              JOB_TYPES.some(j => service.name === (j.id === 'rides' ? 'Driver Needed' : `${j.label} ${(service.serviceTab || serviceSubTab) === 'need' ? 'Needed' : 'Available'}`));
            const newName = isDefaultName
              ? (newType ? (newType === 'rides' ? 'Driver Needed' : `${jobMeta?.label || ''} ${(service.serviceTab || serviceSubTab) === 'need' ? 'Needed' : 'Available'}`) : 'Service Name')
              : service.name;
            handleServiceUpdate(service.id, {
              jobType: newType || null,
              name: newName,
              category: newType ? (jobMeta?.label || newType) : (service.category || 'Other'),
              bookingForm: { fields: [] },
              ...(newType ? (SERVICE_TYPE_DEFAULTS[newType] || {}) : {}),
            });
          }}
          style={{ width: '100%', background: 'rgba(0,0,0,0.3)', border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}40`, borderRadius: '8px', padding: '0.6rem 0.8rem', color: shopData?.theme?.colors?.text || '#fff', fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box', marginBottom: '0.5rem', cursor: 'pointer' }}
        >
          <option value="">— General Service —</option>
          {getAllServiceTypes().map(jt => (
            <option key={jt.id} value={jt.id}>{jt.icon} {jt.label}</option>
          ))}
        </select>
        <ValidatedEditableText
          value={service.name}
          onChange={(value) => handleServiceUpdate(service.id, { name: value })}
          placeholder="Service Name"
          theme={shopData?.theme}
          showClearButton={true}
        />
        <ValidatedEditableText
          value={service.price}
          onChange={(value) => handleServiceUpdate(service.id, { price: value })}
          placeholder="Price (leave empty for 'Request a Quote')"
          theme={shopData?.theme}
          showClearButton={true}
          showCurrencySelector={true}
          currencyValue={shopData?.currency || 'USD'}
          onCurrencyChange={(code) => handleUpdateShop({ currency: code })}
        />
        {(service.serviceTab || 'offer') !== 'need' && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.75rem' }}>
            <span style={{ fontSize: '0.72rem', fontWeight: '600', opacity: 0.7, color: shopData?.theme?.colors?.text || '#fff' }}>Price is</span>
            <div style={{ display: 'flex', borderRadius: '8px', overflow: 'hidden', border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}40` }}>
              {[['hourly', 'Per Hour'], ['daily', 'Per Day'], ['total', 'Flat Total']].map(([val, label]) => (
                <button
                  key={val}
                  onClick={() => handleServiceUpdate(service.id, { pricingType: val })}
                  style={{
                    padding: '0.32rem 0.7rem',
                    fontSize: '0.7rem',
                    fontWeight: '700',
                    border: 'none',
                    cursor: 'pointer',
                    background: (service.pricingType || 'hourly') === val ? (shopData?.theme?.colors?.accent || '#800000') : 'transparent',
                    color: (service.pricingType || 'hourly') === val ? '#fff' : (shopData?.theme?.colors?.text || '#fff'),
                  }}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        )}
        <ValidatedEditableText
          value={service.description}
          onChange={(value) => handleServiceUpdate(service.id, { description: value })}
          placeholder="Service Description"
          multiline
          theme={shopData?.theme}
          showClearButton={true}
        />
        {!service.jobType && (
        <CategorySelect
          value={service.category || 'Other'}
          onChange={(e) => handleServiceUpdate(service.id, { category: e.target.value })}
          theme={shopData?.theme}
        >
          {getAllCategories(true).map(category => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </CategorySelect>
        )}
        {!service.jobType && (
        <div style={{ marginBottom: '1rem' }}>
          <QuantitySelector
            value={parseInt(service.slots) || 1}
            onChange={(value) => handleServiceUpdate(service.id, { slots: value })}
            theme={shopData?.theme}
            min={0}
            max={9999}
          />
        </div>
        )}
        {!service.jobType && (
        <AddressInput
  address={service.address || ''}
  onAddressChange={(value) => handleServiceUpdate(service.id, { address: value })}
  onLocationSelect={(location) => {
    if (location?.coordinates) {
      handleServiceUpdate(service.id, {
        address: location.address,
        coordinates: location.coordinates,
        city: location.city,
        state: location.state || null,
        country: location.country || null,
        locationSource: 'real',
      });
    } else if (!location?.address) {
      handleServiceUpdate(service.id, { address: '', coordinates: null, city: null, state: null, country: null, locationSource: null });
    }
  }}
  onMapOpen={() => handleOpenMapForSelection(service.id, true)}
/>
        )}

        {/* Job-type-specific fields */}
        {service.jobType && (() => {
          const accent = shopData?.theme?.colors?.accent || '#800000';
          const textCol = shopData?.theme?.colors?.text || '#fff';
          const inputStyle = { width: '100%', background: 'rgba(0,0,0,0.3)', border: `1px solid ${accent}40`, borderRadius: '8px', padding: '0.6rem 0.8rem', color: textCol, fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box' };
          const labelStyle = { fontSize: '0.75rem', fontWeight: '600', opacity: 0.7, marginBottom: '0.3rem', color: textCol };
          const wrap = { display: 'flex', flexDirection: 'column', gap: '0.75rem', marginTop: '0.5rem', padding: '0.75rem', background: `${accent}08`, borderRadius: '10px', border: `1px solid ${accent}20` };
          const upd = (patch) => handleServiceUpdate(service.id, patch);
          const jt = service.jobType;

          const fld = (label, el) => <div><div style={labelStyle}>{label}</div>{el}</div>;
          const txt = (key, placeholder, type = 'text') => <input type={type} style={inputStyle} value={service[key] || ''} onChange={e => upd({ [key]: e.target.value })} placeholder={placeholder} />;
          const sel = (key, opts, def) => <select style={inputStyle} value={service[key] || def || opts[0][0]} onChange={e => upd({ [key]: e.target.value })}>{opts.map(([v,l]) => <option key={v} value={v}>{l}</option>)}</select>;
          const chk = (label, key) => <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.8rem', color: textCol, opacity: 0.85 }}><input type="checkbox" checked={!!service[key]} onChange={e => upd({ [key]: e.target.checked })} />{label}</label>;
          const num = (key, min, max, label) => <div><div style={labelStyle}>{label}</div><input type="number" min={min} max={max} style={inputStyle} value={service[key] ?? min} onChange={e => upd({ [key]: parseInt(e.target.value) || min })} /></div>;
          const grid2 = (children) => <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>{children}</div>;

          // ── Offer tab: booking form builder (customers fill this when ordering) ──
          if (service.serviceTab === 'offer') {
            const template = getJobTypeBookingTemplate(jt);
            const saved = service.bookingForm?.fields;
            const formFields = saved?.length > 0 ? saved : template.map(f => ({ ...f, enabled: true, isCustom: false }));
            const updForm = (fields) => handleServiceUpdate(service.id, { bookingForm: { fields } });
            const typeOptsBase = [['text','Text'],['textarea','Long Text'],['stepper','Number'],['toggle','Yes/No'],['location','Location'],['date','Date'],['datetime-local','Date & Time']];
            return (
              <div style={wrap}>
                <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>📋 Customer Booking Form</div>
                <div style={{ fontSize: '0.72rem', color: textCol, opacity: 0.55, marginTop: '-0.3rem' }}>Fields customers fill when booking</div>
                {formFields.map(field => {
                  const typeOpts = ((field.type === 'select' || field.type === 'chip-select') && !field.isCustom)
                    ? [[field.type, field.type === 'chip-select' ? 'Choice Chips' : 'Choice List'], ...typeOptsBase]
                    : typeOptsBase;
                  return (
                  <div key={field.key} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flexWrap: 'wrap', padding: '0.35rem 0.5rem', borderRadius: '6px', background: `${accent}10`, border: `1px solid ${accent}28`, transition: 'all 0.15s' }}>
                    <input value={field.label} onChange={e => updForm(formFields.map(f => f.key === field.key ? { ...f, label: e.target.value } : f))} placeholder="Question label…" style={{ flex: '1 1 90px', minWidth: 0, background: 'rgba(255,255,255,0.07)', border: `1px solid ${accent}40`, borderRadius: '4px', padding: '0.15rem 0.35rem', color: textCol, fontSize: '0.7rem', outline: 'none' }} />
                    <select value={field.type} onChange={e => updForm(formFields.map(f => f.key === field.key ? { ...f, type: e.target.value } : f))} style={{ fontSize: '0.62rem', padding: '0.1rem 0.3rem', borderRadius: '4px', border: `1px solid ${accent}60`, background: shopData?.theme?.colors?.background || '#141414', color: textCol, outline: 'none', cursor: 'pointer', flexShrink: 0 }}>
                      {typeOpts.map(([v,l]) => <option key={v} value={v} style={{ background: shopData?.theme?.colors?.background || '#141414', color: textCol }}>{l}</option>)}
                    </select>
                    <button onClick={() => updForm(formFields.filter(f => f.key !== field.key))} title="Delete field" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,90,90,0.7)', padding: '0.1rem', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                      <Trash2 size={13} />
                    </button>
                  </div>
                  );
                })}
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.15rem' }}>
                  <button onClick={() => updForm([...formFields, { key: `custom_${Date.now()}`, label: '', type: 'text', placeholder: '', required: false, enabled: true, isCustom: true }])} style={{ fontSize: '0.72rem', background: 'none', border: `1px dashed ${accent}60`, borderRadius: '6px', padding: '0.28rem 0.65rem', cursor: 'pointer', color: accent, alignSelf: 'flex-start' }}>+ Add Custom Question</button>
                  <button
                    onClick={() => {
                      const cat = service.category || 'Other';
                      const targets = (shopData?.services || []).filter(s => s.id !== service.id && (s.category || 'Other') === cat && (s.serviceTab || 'offer') === (service.serviceTab || 'offer'));
                      targets.forEach(s => handleServiceUpdate(s.id, { bookingForm: { fields: formFields } }));
                      setCategoryApplyFlash(service.id);
                      setTimeout(() => setCategoryApplyFlash(prev => prev === service.id ? null : prev), 1600);
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', fontSize: '0.72rem', background: 'none', border: `1px solid ${accent}60`, borderRadius: '6px', padding: '0.28rem 0.65rem', cursor: 'pointer', color: accent, alignSelf: 'flex-start', fontWeight: 600 }}
                  >⤴ Apply to Category{categoryApplyFlash === service.id && <Check size={12} />}</button>
                </div>

                <div style={{ height: '1px', background: `${accent}20`, margin: '0.2rem 0' }} />
                <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🔘 Card Button</div>
                {fld('Button Style', sel('ctaStyle', [['order','Order'],['book','Book'],['signup','Sign Up']], 'order'))}
                {service.ctaStyle === 'signup' && (
                  <>
                    {fld('Sign-up Link', txt('externalLink', 'https://…', 'url'))}
                    <div style={{ fontSize: '0.7rem', color: textCol, opacity: 0.55 }}>Clicking "Sign Up" sends buyers to this link instead of opening chat/checkout.</div>
                  </>
                )}
              </div>
            );
          }

          if (jt === 'rides') {
            const dist = (service.pickupCoordinates && service.destinationCoordinates)
              ? haversineDistanceMiles(service.pickupCoordinates.lat, service.pickupCoordinates.lng, service.destinationCoordinates.lat, service.destinationCoordinates.lng) : null;
            return (
              <div style={wrap}>
                <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🚗 Ride Details</div>
                {fld('📍 Pickup Location', <AddressInput address={service.pickupAddress || ''} onAddressChange={v => upd({ pickupAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ pickupAddress: loc.address, pickupCoordinates: loc.coordinates }) : upd({ pickupAddress: '', pickupCoordinates: null })} placeholder="Pickup address" onMapOpen={() => handleOpenMapForSelection(service.id, true, false, 'pickup')} />)}
                {fld('🏁 Destination', <AddressInput address={service.destinationAddress || ''} onAddressChange={v => upd({ destinationAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ destinationAddress: loc.address, destinationCoordinates: loc.coordinates }) : upd({ destinationAddress: '', destinationCoordinates: null })} placeholder="Destination address" onMapOpen={() => handleOpenMapForSelection(service.id, true, false, 'destination')} />)}
                {dist && <div style={{ fontSize: '0.8rem', color: accent }}>🛣️ Estimated distance: <strong>{dist} miles</strong></div>}
                {grid2(<>{fld('📅 Date & Time', <input type="datetime-local" style={inputStyle} value={service.rideDateTime || ''} onChange={e => upd({ rideDateTime: e.target.value })} />)}{num('passengers', 1, 20, '👥 Passengers')}</>)}
                {fld('🚗 Vehicle Type', sel('vehicleType', [['any','Any Vehicle'],['sedan','Sedan'],['suv','SUV'],['van','Van / Minivan'],['limo','Limousine'],['luxury','Luxury Car'],['truck','Pickup Truck']], 'any'))}
                {chk('🗺️ Use route map as card image', 'useRouteMapImage')}
              </div>
            );
          }

          if (jt === 'home_repair') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🔧 Home Repair Details</div>
              {fld('📍 Service Address', <AddressInput address={service.serviceAddress || ''} onAddressChange={v => upd({ serviceAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ serviceAddress: loc.address, serviceCoordinates: loc.coordinates }) : upd({ serviceAddress: '' })} placeholder="Job location" />)}
              {fld('📅 Preferred Date & Time', txt('serviceDateTime', '', 'datetime-local'))}
              {grid2(<>{fld('🔨 Job Scope', sel('jobScope', [['minor','Minor fix'],['moderate','Moderate'],['major','Major work']]))} {fld('⚡ Urgency', sel('urgency', [['flexible','Flexible'],['within-week','Within a week'],['asap','ASAP']]))}</>)}
              {fld('📝 Access Instructions', txt('accessInstructions', 'e.g. gate code, key under mat…'))}
              {chk('Materials / supplies included in price', 'materialsIncluded')}
            </div>
          );

          if (jt === 'cleaning') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🧹 Cleaning Details</div>
              {fld('📍 Service Address', <AddressInput address={service.serviceAddress || ''} onAddressChange={v => upd({ serviceAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ serviceAddress: loc.address, serviceCoordinates: loc.coordinates }) : upd({ serviceAddress: '' })} placeholder="Property address" />)}
              {fld('📅 Preferred Date & Time', txt('serviceDateTime', '', 'datetime-local'))}
              {grid2(<>{fld('🏠 Property Type', sel('propertyType', [['house','House'],['apartment','Apartment'],['office','Office'],['commercial','Commercial']]))} {fld('🔁 Frequency', sel('frequency', [['one-time','One-time'],['weekly','Weekly'],['bi-weekly','Bi-weekly'],['monthly','Monthly']]))}</>)}
              {grid2(<>{num('bedrooms', 1, 20, '🛏️ Bedrooms')} {num('bathrooms', 1, 10, '🚿 Bathrooms')}</>)}
              {fld('🧴 Cleaning Supplies', sel('suppliesProvided', [['provider','Provider brings supplies'],['client','Client provides supplies'],['both','Both']]))}
            </div>
          );

          if (jt === 'moving') {
            const dist = (service.pickupCoordinates && service.destinationCoordinates)
              ? haversineDistanceMiles(service.pickupCoordinates.lat, service.pickupCoordinates.lng, service.destinationCoordinates.lat, service.destinationCoordinates.lng) : null;
            return (
              <div style={wrap}>
                <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>📦 Moving Details</div>
                {fld('📍 Moving From', <AddressInput address={service.pickupAddress || ''} onAddressChange={v => upd({ pickupAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ pickupAddress: loc.address, pickupCoordinates: loc.coordinates }) : upd({ pickupAddress: '', pickupCoordinates: null })} placeholder="Current address" onMapOpen={() => handleOpenMapForSelection(service.id, true, false, 'pickup')} />)}
                {fld('🏁 Moving To', <AddressInput address={service.destinationAddress || ''} onAddressChange={v => upd({ destinationAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ destinationAddress: loc.address, destinationCoordinates: loc.coordinates }) : upd({ destinationAddress: '', destinationCoordinates: null })} placeholder="Destination address" onMapOpen={() => handleOpenMapForSelection(service.id, true, false, 'destination')} />)}
                {dist && <div style={{ fontSize: '0.8rem', color: accent }}>🛣️ Distance: <strong>{dist} miles</strong></div>}
                {grid2(<>{fld('📅 Move Date', txt('moveDate', '', 'date'))} {fld('📦 Load Size', sel('estimatedLoad', [['small','Small (few boxes)'],['moderate','Moderate (1-BR)'],['large','Large (2-3 BR)'],['full-house','Full house']]))}</>)}
                {chk('Has heavy/special items (piano, safe, etc.)', 'hasHeavyItems')}
                {chk('Need packing / unpacking help', 'packingHelp')}
              </div>
            );
          }

          if (jt === 'delivery') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🚚 Delivery Details</div>
              {fld('📍 Pickup From', <AddressInput address={service.pickupAddress || ''} onAddressChange={v => upd({ pickupAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ pickupAddress: loc.address, pickupCoordinates: loc.coordinates }) : upd({ pickupAddress: '', pickupCoordinates: null })} placeholder="Pickup address" />)}
              {fld('🏁 Deliver To', <AddressInput address={service.deliveryAddress || ''} onAddressChange={v => upd({ deliveryAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ deliveryAddress: loc.address, deliveryCoordinates: loc.coordinates }) : upd({ deliveryAddress: '', deliveryCoordinates: null })} placeholder="Delivery address" />)}
              {fld('📦 Item Description', txt('itemDescription', 'What needs to be delivered?'))}
              {grid2(<>{fld('📏 Item Size', sel('itemSize', [['small','Small (fits in bag)'],['medium','Medium (box)'],['large','Large (furniture)'],['oversized','Oversized']]))} {fld('⏰ Deliver By', txt('deliveryByDateTime', '', 'datetime-local'))}</>)}
              {chk('Fragile — handle with care', 'fragile')}
            </div>
          );

          if (jt === 'tutoring') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>📚 Tutoring Details</div>
              {fld('📖 Subject', txt('subject', 'e.g. Algebra, SAT Prep, Python…'))}
              {grid2(<>{fld('🎓 Grade / Level', sel('gradeLevel', [['elementary','Elementary (K-5)'],['middle','Middle School'],['high','High School'],['college','College'],['adult','Adult / Professional']]))} {fld('⏱️ Session Length', sel('sessionDuration', [['30min','30 minutes'],['1hr','1 hour'],['2hr','2 hours'],['custom','Custom']]))}</>)}
              {fld('💻 Session Mode', sel('sessionMode', [['in-person','In-person'],['online','Online / Remote'],['either','Either works']]))}
              {fld('🗓️ Preferred Schedule', txt('preferredSchedule', 'e.g. Weekends 2-4 PM, weekday evenings…'))}
            </div>
          );

          if (jt === 'pet_care') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🐾 Pet Care Details</div>
              {grid2(<>{fld('🐶 Pet Type', sel('petType', [['dog','Dog'],['cat','Cat'],['bird','Bird'],['reptile','Reptile'],['other','Other']]))} {fld('🏷️ Breed / Name', txt('petBreed', 'e.g. Labrador, Max…'))}</>)}
              {fld('🛠️ Service Type', sel('petServiceType', [['walking','Dog Walking'],['sitting','Pet Sitting'],['boarding','Boarding'],['grooming','Grooming'],['training','Training'],['vet-transport','Vet Transport']]))}
              {grid2(<>{fld('📅 Date & Time', txt('serviceDateTime', '', 'datetime-local'))} {num('serviceDuration', 1, 24, '⏱️ Duration (hours)')}</>)}
              {fld('⚠️ Special Needs / Notes', txt('specialNeeds', 'Allergies, behavior notes, medications…'))}
            </div>
          );

          if (jt === 'handyman') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🛠️ Handyman Details</div>
              {fld('📍 Service Address', <AddressInput address={service.serviceAddress || ''} onAddressChange={v => upd({ serviceAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ serviceAddress: loc.address, serviceCoordinates: loc.coordinates }) : upd({ serviceAddress: '' })} placeholder="Job location" />)}
              {fld('📅 Preferred Date & Time', txt('serviceDateTime', '', 'datetime-local'))}
              {grid2(<>{fld('⚡ Urgency', sel('urgency', [['flexible','Flexible'],['within-week','Within a week'],['asap','ASAP']]))} {num('estimatedHours', 1, 48, '⏱️ Est. Hours')}</>)}
              {chk('Provider brings own tools', 'toolsProvided')}
            </div>
          );

          if (jt === 'beauty') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>💇 Beauty Details</div>
              {fld('✂️ Service Type', sel('beautyServiceType', [['haircut','Haircut / Trim'],['coloring','Hair Coloring'],['styling','Hair Styling'],['nails','Nails / Manicure'],['pedicure','Pedicure'],['makeup','Makeup'],['waxing','Waxing'],['lashes','Lashes / Brows'],['other','Other']]))}
              {fld('📍 Location', sel('serviceLocation', [['home-visit','Home Visit (I come to you)'],['studio','My Studio / Salon'],['client-home','Client provides location']]))}
              {service.serviceLocation === 'home-visit' && fld('🏠 Your Address', <AddressInput address={service.serviceAddress || ''} onAddressChange={v => upd({ serviceAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ serviceAddress: loc.address, serviceCoordinates: loc.coordinates }) : upd({ serviceAddress: '' })} placeholder="Studio / travel-from address" />)}
              {grid2(<>{fld('📅 Date & Time', txt('serviceDateTime', '', 'datetime-local'))} {num('duration', 1, 8, '⏱️ Duration (hours)')}</>)}
            </div>
          );

          if (jt === 'tech') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>💻 Tech Support Details</div>
              {grid2(<>{fld('📱 Device Type', sel('deviceType', [['laptop','Laptop'],['desktop','Desktop PC'],['phone','Smartphone'],['tablet','Tablet'],['smart-home','Smart Home'],['network','Network / Router'],['other','Other']]))} {fld('💾 OS / Platform', sel('os', [['windows','Windows'],['macos','macOS'],['linux','Linux'],['ios','iOS'],['android','Android'],['other','Other']]))}</>)}
              {fld('🔧 Service Mode', sel('serviceMode', [['in-person','In-person'],['remote','Remote / Online'],['either','Either works']]))}
              {service.serviceMode !== 'remote' && fld('📍 Service Address', <AddressInput address={service.serviceAddress || ''} onAddressChange={v => upd({ serviceAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ serviceAddress: loc.address, serviceCoordinates: loc.coordinates }) : upd({ serviceAddress: '' })} placeholder="Service location" />)}
              {fld('⚡ Urgency', sel('urgency', [['flexible','Flexible'],['within-week','Within a week'],['asap','ASAP']]))}
            </div>
          );

          if (jt === 'events') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🎉 Event Details</div>
              {grid2(<>{fld('🎊 Event Type', sel('eventType', [['birthday','Birthday'],['wedding','Wedding'],['corporate','Corporate'],['graduation','Graduation'],['babyshower','Baby Shower'],['other','Other']]))} {fld('📅 Event Date', txt('eventDate', '', 'date'))}</>)}
              {fld('📍 Event Address', <AddressInput address={service.eventAddress || ''} onAddressChange={v => upd({ eventAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ eventAddress: loc.address, eventCoordinates: loc.coordinates }) : upd({ eventAddress: '' })} placeholder="Venue address" />)}
              {grid2(<>{num('guestCount', 1, 5000, '👥 Expected Guests')} {num('eventDuration', 1, 24, '⏱️ Duration (hours)')}</>)}
              {fld('🛎️ Services Offered', (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                  {[['catering','🍽️ Catering'],['photography','📷 Photography'],['videography','🎥 Videography'],['setup','🪑 Setup'],['cleanup','🧹 Cleanup'],['entertainment','🎵 Entertainment'],['decoration','🎀 Decoration'],['security','🔒 Security']].map(([v,l]) => {
                    const sel = (service.servicesNeeded || []).includes(v);
                    return <button key={v} onClick={() => { const cur = service.servicesNeeded || []; upd({ servicesNeeded: sel ? cur.filter(x => x !== v) : [...cur, v] }); }} style={{ padding: '0.3rem 0.6rem', borderRadius: '20px', border: `1px solid ${accent}${sel ? 'ff' : '40'}`, background: sel ? `${accent}30` : 'transparent', color: textCol, fontSize: '0.75rem', cursor: 'pointer' }}>{l}</button>;
                  })}
                </div>
              ))}
            </div>
          );

          if (jt === 'other') return (
            <div style={wrap}>
              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>💼 Job Details</div>
              {fld('📍 Location', <AddressInput address={service.serviceAddress || ''} onAddressChange={v => upd({ serviceAddress: v })} onLocationSelect={loc => loc?.coordinates ? upd({ serviceAddress: loc.address, serviceCoordinates: loc.coordinates }) : upd({ serviceAddress: '' })} placeholder="Job location (optional)" />)}
              {fld('📅 Preferred Date & Time', txt('serviceDateTime', '', 'datetime-local'))}
              {grid2(<>{fld('⚡ Urgency', sel('urgency', [['flexible','Flexible'],['within-week','Within a week'],['asap','ASAP']]))} {fld('⏱️ Est. Duration', txt('estimatedDuration', 'e.g. 2 hours, 1 day…'))}</>)}
            </div>
          );

          return null;
        })()}
      </div>
    </ItemDetails>

    {/* ✅ NEW: Remove button shown when UNEXPANDED */}
    {!isExpanded && (
      <div style={{
        borderTop: `1px solid ${shopData?.theme?.colors?.accent}20`,
        paddingTop: '1rem',
        marginTop: '1rem',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <button
          onClick={(e) => {
            e.stopPropagation(); // Prevent expanding the card
            handleServiceDelete(service.id);
          }}
          style={{
            background: 'transparent',
            border: `1px solid #ff444440`,
            color: '#ff4444',
            padding: '0.6rem 1.5rem',
            borderRadius: '8px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.85rem',
            fontWeight: '600',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#ff444420';
            e.currentTarget.style.borderColor = '#ff4444';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.borderColor = '#ff444440';
          }}
        >
          <Trash2 size={16} />
          Remove
        </button>
      </div>
    )}
  </ItemContent>
</DesktopItemCard>
                    </React.Fragment>
                  );
                })}
              </ShopCategoryGrid>
            </div>
          );
        });
      })()}
      <div style={{ marginTop: '1rem', marginBottom: '2rem' }}>
        {showAddCategoryInput ? (
          <div style={{ padding: '0.5rem', background: `${shopData?.theme?.colors?.surface}20`, borderRadius: '12px', border: `1px dashed ${shopData?.theme?.colors?.accent}40` }}>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' }}>
              <input autoFocus value={newCategoryName} onChange={e => setNewCategoryName(e.target.value)} onKeyDown={e => { if (e.key === 'Enter' && newCategoryName.trim()) { handleAddCategory(true, newCategoryName); setNewCategoryName(''); setShowAddCategoryInput(false); } else if (e.key === 'Escape') { setShowAddCategoryInput(false); setNewCategoryName(''); setNewCategoryType(null); }}} placeholder="Category name..." style={{ flex: 1, background: 'rgba(0,0,0,0.3)', border: `1px solid ${shopData?.theme?.colors?.accent}40`, borderRadius: '8px', padding: '0.4rem 0.7rem', color: shopData?.theme?.colors?.text || '#fff', fontSize: '0.85rem', outline: 'none' }} />
              <button onClick={() => { if (newCategoryName.trim()) { handleAddCategory(true, newCategoryName); setNewCategoryName(''); setShowAddCategoryInput(false); }}} style={{ background: shopData?.theme?.colors?.accent, color: 'white', border: 'none', borderRadius: '8px', padding: '0.4rem 0.9rem', cursor: 'pointer', fontSize: '0.82rem', fontWeight: '600' }}>Add</button>
              <button onClick={() => { setShowAddCategoryInput(false); setNewCategoryName(''); setNewCategoryType(null); }} style={{ background: 'transparent', color: shopData?.theme?.colors?.text || '#fff', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', padding: '0.4rem 0.7rem', cursor: 'pointer', fontSize: '0.82rem', opacity: 0.6 }}>Cancel</button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem' }}>
              {STORE_TYPES.map(t => (
                <button key={t.id} onClick={() => setNewCategoryType(newCategoryType === t.id ? null : t.id)} style={{ background: newCategoryType === t.id ? `${shopData?.theme?.colors?.accent}25` : 'transparent', border: `1px solid ${newCategoryType === t.id ? shopData?.theme?.colors?.accent : `${shopData?.theme?.colors?.accent}30`}`, borderRadius: '6px', color: newCategoryType === t.id ? shopData?.theme?.colors?.accent : `${shopData?.theme?.colors?.text || '#fff'}70`, fontSize: '0.72rem', padding: '0.2rem 0.5rem', cursor: 'pointer', fontWeight: newCategoryType === t.id ? '600' : '400' }}>
                  {t.label}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <button onClick={() => { setShowAddCategoryInput(true); setNewCategoryName(''); }} style={{ width: '100%', background: 'transparent', border: `2px dashed ${shopData?.theme?.colors?.accent}30`, borderRadius: '12px', padding: '0.75rem', color: shopData?.theme?.colors?.accent, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', fontSize: '0.88rem', fontWeight: '600', opacity: 0.7 }}>
            <Plus size={16} /> Add Category
          </button>
        )}
      </div>
              </div>


              </>
            )}

            {/* Job Type Picker Modal */}
            {showJobTypeMenu && (
              <div
                onClick={() => setShowJobTypeMenu(false)}
                style={{
                  position: 'fixed', inset: 0,
                  background: 'rgba(0,0,0,0.7)',
                  backdropFilter: 'blur(6px)',
                  WebkitBackdropFilter: 'blur(6px)',
                  zIndex: 10000,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '1rem',
                }}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    background: shopData?.theme?.colors?.background || '#111',
                    border: `2px solid ${shopData?.theme?.colors?.accent || '#800000'}60`,
                    borderRadius: '16px',
                    width: '100%',
                    maxWidth: '560px',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
                  }}
                >
                  <div style={{ padding: '1.5rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.25rem' }}>
                      <div>
                        <div style={{ fontSize: '1.1rem', fontWeight: '700', color: shopData?.theme?.colors?.text || '#fff' }}>
                          {serviceSubTab === 'need' ? '🙋 What job do you need done?' : '💼 What service do you offer?'}
                        </div>
                        <div style={{ fontSize: '0.8rem', opacity: 0.6, color: shopData?.theme?.colors?.text || '#fff', marginTop: '0.25rem' }}>
                          {serviceSubTab === 'need' ? 'Post a job request — pros will see it and apply' : 'Post your availability — clients will book you'}
                        </div>
                      </div>
                      <button
                        onClick={() => setShowJobTypeMenu(false)}
                        style={{ background: 'transparent', border: 'none', color: shopData?.theme?.colors?.text || '#fff', cursor: 'pointer', opacity: 0.7, padding: '0.25rem', flexShrink: 0 }}
                      >
                        <X size={20} />
                      </button>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '0.75rem' }}>
                      {getAllServiceTypes().map(jt => (
                        <button
                          key={jt.id}
                          onClick={() => handleAddJob(jt.id)}
                          style={{
                            background: `${shopData?.theme?.colors?.accent || '#800000'}12`,
                            border: `1.5px solid ${shopData?.theme?.colors?.accent || '#800000'}30`,
                            borderRadius: '12px',
                            padding: '0.9rem 0.5rem',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '0.4rem',
                            transition: 'all 0.2s ease',
                            color: shopData?.theme?.colors?.text || '#fff',
                          }}
                          onMouseOver={(e) => { e.currentTarget.style.background = `${shopData?.theme?.colors?.accent || '#800000'}25`; e.currentTarget.style.borderColor = shopData?.theme?.colors?.accent || '#800000'; }}
                          onMouseOut={(e) => { e.currentTarget.style.background = `${shopData?.theme?.colors?.accent || '#800000'}12`; e.currentTarget.style.borderColor = `${shopData?.theme?.colors?.accent || '#800000'}30`; }}
                        >
                          <span style={{ fontSize: '1.8rem', lineHeight: 1 }}>{jt.icon}</span>
                          <span style={{ fontSize: '0.78rem', fontWeight: '700' }}>{jt.label}</span>
                          <span style={{ fontSize: '0.67rem', opacity: 0.6, textAlign: 'center', lineHeight: 1.3 }}>{jt.description}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {editingItem && (
              <EditModal onClick={() => setEditingItem(null)}>
                <EditModalContent
                  theme={shopData?.theme}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={(e) => {
                    const t = e.touches[0];
                    editSwipeRef.current = { x: t.clientX, y: t.clientY };
                  }}
                  onTouchEnd={(e) => {
                    const start = editSwipeRef.current;
                    editSwipeRef.current = null;
                    if (!start) return;
                    const t = e.changedTouches[0];
                    const dx = t.clientX - start.x;
                    const dy = t.clientY - start.y;
                    if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                      navigateEditingCard(dx < 0 ? 1 : -1);
                    }
                  }}
                >
                  {(() => {
                    const siblings = getEditSiblings(editingItem);
                    if (siblings.length < 2) return null;
                    const currentId = editingItem.id || editingItem.tempId;
                    const idx = siblings.findIndex(x => (x.id || x.tempId) === currentId);
                    return (
                      <div style={{ position: 'absolute', top: '3.5rem', left: '50%', transform: 'translateX(-50%)', zIndex: 9, background: `${shopData?.theme?.colors?.background || '#000000'}D0`, border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}60`, borderRadius: '10px', padding: '0.15rem 0.55rem', fontSize: '0.62rem', fontWeight: 700, color: shopData?.theme?.colors?.accent || '#800000', pointerEvents: 'none' }}>
                        ‹ {idx + 1} / {siblings.length} ›
                      </div>
                    );
                  })()}
                  <ImageActionButtons theme={shopData?.theme}>
                    <ImageActionButton 
  className="check"
  onClick={async () => {
    // Process images to preview URLs
    const processedImages = editingItem.images.map((img) => {
      if (typeof img === 'string') return img;
      if (!img) return null;
      if (img?.preview) return img.preview;
      if (img instanceof File) return URL.createObjectURL(img);
      return img;
    });

    // Store File objects separately for later upload
    const newTempStorage = { ...tempFileStorage };
    editingItem.images.forEach((img, index) => {
      const fileToStore = img instanceof File ? img : img?.file;
      if (fileToStore instanceof File) {
        // ✅ FIX: Use correct storage key based on item type
        const key = editingItem.isCommunityPost ? 
          `community-${editingItem.id}-${index}` :
          editingItem.isEvent ?
          `event-${editingItem.id}-${index}` :
          `${editingItem.id}-${index}`;
        newTempStorage[key] = fileToStore;
      }
    });
    setTempFileStorage(newTempStorage);

    const updatedItem = {
      ...editingItem,
      images: processedImages,
      name: editingItem.name,
      price: editingItem.price,
      description: editingItem.description,
      category: editingItem.category,
      address: editingItem.address,
      coordinates: editingItem.coordinates,
      currentImageIndex: editingItem.currentImageIndex
    };

    // ✅ FIX: Handle different item types correctly
    if (editingItem.isCommunityPost) {
      updatedItem.caption = editingItem.caption || editingItem.name || '';
      handleCommunityPostUpdate(editingItem.id, updatedItem);
    } else if (editingItem.isEvent) {
      updatedItem.eventDate = editingItem.eventDate;
      updatedItem.eventTime = editingItem.eventTime;
      updatedItem.slots = editingItem.slots;
      updatedItem.isEvent = true;  // ✅ ADD THIS
      updatedItem.type = 'event';  // ✅ ADD THIS
      handleEventUpdate(editingItem.id, updatedItem);
    } else if (editingItem.isService) {
      updatedItem.slots = editingItem.slots;
      updatedItem.jobType = editingItem.jobType;
      updatedItem.serviceTab = editingItem.serviceTab;
      updatedItem.pricingType = editingItem.pricingType || 'hourly';
      const JT_FIELDS = {
        rides:       ['pickupAddress','pickupCoordinates','destinationAddress','destinationCoordinates','rideDateTime','passengers','vehicleType','estimatedDistance','estimatedDuration'],
        home_repair: ['serviceAddress','serviceCoordinates','serviceDateTime','jobScope','urgency','materialsIncluded','accessInstructions'],
        cleaning:    ['serviceAddress','serviceCoordinates','serviceDateTime','propertyType','bedrooms','bathrooms','frequency','suppliesProvided'],
        moving:      ['pickupAddress','pickupCoordinates','destinationAddress','destinationCoordinates','moveDate','estimatedLoad','hasHeavyItems','packingHelp'],
        delivery:    ['pickupAddress','pickupCoordinates','deliveryAddress','deliveryCoordinates','itemDescription','itemSize','deliveryByDateTime','fragile'],
        tutoring:    ['subject','gradeLevel','sessionDuration','sessionMode','preferredSchedule'],
        pet_care:    ['petType','petBreed','petServiceType','serviceDateTime','serviceDuration','specialNeeds'],
        handyman:    ['serviceAddress','serviceCoordinates','serviceDateTime','urgency','estimatedHours','toolsProvided'],
        beauty:      ['beautyServiceType','serviceLocation','serviceAddress','serviceCoordinates','serviceDateTime','duration'],
        tech:        ['deviceType','os','serviceMode','serviceAddress','serviceCoordinates','urgency'],
        events:      ['eventType','eventDate','eventAddress','eventCoordinates','guestCount','servicesNeeded','eventDuration'],
        other:       ['serviceAddress','serviceCoordinates','serviceDateTime','urgency','estimatedDuration'],
      };
      (JT_FIELDS[editingItem.jobType] || []).forEach(f => { updatedItem[f] = editingItem[f] ?? null; });
      handleServiceUpdate(editingItem.id, updatedItem);
    } else {
      updatedItem.quantity = editingItem.quantity;
      handleItemUpdate(editingItem.id, updatedItem);
    }
    
    setEditingItem(null);
    console.log('✅ Changes queued - click "Save" to upload');
  }}
  title="Save changes"
>
  <Check size={20} />
</ImageActionButton>

                    <ImageActionButton
                      className="close"
                      onClick={() => setEditingItem(null)}
                      title="Discard changes"
                    >
                      <X size={20} />
                    </ImageActionButton>
                  </ImageActionButtons>
                    
                  <EditModalScrollContent theme={shopData?.theme}>
                    <EditModalImageSection theme={shopData?.theme}>
                      <ItemImageContainer theme={shopData?.theme} style={{ height: '100%', minHeight: '300px' }}>
                        {uploading[editingItem.id] && (
                          <UploadingOverlay>
                            <LoadingSpinner />
                          </UploadingOverlay>
                        )}
                        <div
                          className="image-container"
                          onClick={(e) => {
                            if (!e.target.closest('.carousel-arrow')) {
                              document.getElementById(`modal-image-upload-${editingItem.id}-${editingItem.currentImageIndex}`).click();
                            }
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          {(() => {
                            // Toggle on → route image always wins over any uploaded photo.
                            const routeOverride = editingItem.isService && editingItem.jobType === 'rides' && editingItem.useRouteMapImage && editingItem.pickupCoordinates && editingItem.destinationCoordinates;
                            const movingRoute = editingItem.isService && editingItem.jobType === 'moving' && !editingItem.images[editingItem.currentImageIndex] && editingItem.pickupCoordinates && editingItem.destinationCoordinates;
                            if (!routeOverride && editingItem.images[editingItem.currentImageIndex]) {
                              return typeof editingItem.images[editingItem.currentImageIndex] === 'string' ? (
                                <img
                                  src={editingItem.images[editingItem.currentImageIndex]}
                                  alt={editingItem.name}
                                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                              ) : editingItem.images[editingItem.currentImageIndex]?.preview ? (
                                <img
                                  src={editingItem.images[editingItem.currentImageIndex].preview}
                                  alt={editingItem.name}
                                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                              ) : null;
                            }
                            if (routeOverride || movingRoute) {
                              return (
                                <div style={{ position: 'absolute', inset: 0, zIndex: 1 }}>
                                  <RideRoutePreview
                                    pickupCoords={editingItem.pickupCoordinates}
                                    destCoords={editingItem.destinationCoordinates}
                                    onImageCapture={(blob) => {
                                      if (!routeOverride && editingItem.images?.some(img => img && typeof img === 'string' && img.startsWith('http'))) return;
                                      const previewUrl = URL.createObjectURL(blob);
                                      const file = new File([blob], 'route-preview.png', { type: 'image/png' });
                                      const id = editingItem.id || editingItem.tempId;
                                      setTempFileStorage(prev => ({ ...prev, [`${id}-0`]: file }));
                                      setEditingItem(prev => ({ ...prev, images: [previewUrl, null, null] }));
                                    }}
                                  />
                                </div>
                              );
                            }
                            return null;
                          })()}
                          {!(editingItem.isService && editingItem.jobType === 'rides' && editingItem.useRouteMapImage && editingItem.pickupCoordinates && editingItem.destinationCoordinates) && !editingItem.images[editingItem.currentImageIndex] && !(editingItem.isService && editingItem.jobType === 'moving' && editingItem.pickupCoordinates && editingItem.destinationCoordinates) && (
                            <div className="placeholder">
                              <Plus size={24} />
                              <span>{editingItem.isService && editingItem.jobType === 'rides' && editingItem.useRouteMapImage ? 'Enter pickup & destination to preview route' : editingItem.isService && editingItem.jobType === 'moving' ? 'Enter from & to addresses to preview route' : 'Upload Image'}</span>
                            </div>
                          )}
                        </div>
                        
                        {editingItem.images.filter(img => img).length > 0 && (
                          <>
                            <button
                              className="carousel-arrow left"
                              onClick={(e) => {
                                e.stopPropagation();
                                const newIndex = ((editingItem.currentImageIndex - 1) + 3) % 3;
                                setEditingItem({ ...editingItem, currentImageIndex: newIndex });
                              }}
                            >
                              <ChevronLeft size={16} />
                            </button>
                            <button
                              className="carousel-arrow right"
                              onClick={(e) => {
                                e.stopPropagation();
                                const newIndex = (editingItem.currentImageIndex + 1) % 3;
                                setEditingItem({ ...editingItem, currentImageIndex: newIndex });
                              }}
                            >
                              <ChevronRight size={16} />
                            </button>
                          </>
                        )}

                        {/* ADD: Remove Image Button - Bottom Right */}
    {editingItem.images[editingItem.currentImageIndex] && (
      <button
        className="remove-modal-image"
        onClick={(e) => {
          e.stopPropagation();
          const newImages = [...editingItem.images];
          newImages[editingItem.currentImageIndex] = null;
          setEditingItem({ ...editingItem, images: newImages });
        }}
        style={{
          position: 'absolute',
          top: '0.5rem',
          right: '0.5rem',
          background: `${shopData?.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`,
          border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}`,
          color: '#ff4444',
          borderRadius: '50%',
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 10,
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#ff4444';
          e.currentTarget.style.color = 'white';
          e.currentTarget.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = `${shopData?.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`;
          e.currentTarget.style.color = '#ff4444';
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <X size={16} />
      </button>
    )}


                        <input
                          type="file"
                          id={`modal-image-upload-${editingItem.id}-${editingItem.currentImageIndex}`}
                          accept="image/*" // CHANGED: Removed video/*
                          style={{ display: 'none' }}
                          onChange={async (e) => {
                            const file = e.target.files?.[0];
                            // Reset immediately so re-selecting the same file reliably
                            // fires onChange again on mobile instead of silently no-op'ing.
                            e.target.value = '';
                            if (!file) return;
                            try {
                              validateImageFile(file, 20);
                              // Compress before generating the preview, instead of storing the
                              // raw file and only compressing at save time — a raw 20-48MP phone
                              // photo held as a base64 preview (and later uploaded uncompressed by
                              // uploadProductMedia, which assumes images arrive pre-compressed) is
                              // what made this hang/upload huge files from this modal specifically.
                              // Mirrors bulk upload: fall back to the original file if compression
                              // fails instead of blocking the upload with an error.
                              setCompressionProgress({ text: 'Compressing image...', percent: 0 });
                              let compressedFile;
                              try {
                                compressedFile = await compressProductImage(file, (progress) => {
                                  setCompressionProgress({ text: 'Compressing image...', percent: progress });
                                });
                              } catch (compressErr) {
                                console.warn('⚠️ Compression failed, using original file uncompressed:', compressErr);
                                compressedFile = file;
                              }
                              setCompressionProgress(null);

                              const preview = await readFileAsDataURL(compressedFile);
                              const newImages = [...editingItem.images];
                              newImages[editingItem.currentImageIndex] = {
                                file: compressedFile,
                                preview,
                                type: compressedFile.type,
                                name: compressedFile.name,
                                isVideo: false
                              };
                              setEditingItem({ ...editingItem, images: newImages });
                            } catch (error) {
                              console.error('❌ Error handling modal image:', error);
                              setCompressionProgress(null);
                              setStatusMessage({ type: 'error', text: error.message || 'Failed to process image. Please try again.' });
                              setTimeout(() => setStatusMessage(null), 5000);
                            }
                          }}
                        />
                      </ItemImageContainer>
                    </EditModalImageSection>
                        
                    <EditModalBody>
                      {editingItem.isService && (
                        <select
                          value={editingItem.jobType || ''}
                          onChange={(e) => {
                            const newType = e.target.value;
                            const jobMeta = getAllServiceTypes().find(j => j.id === newType);
                            const isDefaultName = !editingItem.name || editingItem.name === 'Service Name' ||
                              JOB_TYPES.some(j => editingItem.name === (j.id === 'rides' ? 'Driver Needed' : `${j.label} ${(editingItem.serviceTab || 'offer') === 'need' ? 'Needed' : 'Available'}`));
                            const newName = isDefaultName
                              ? (newType ? (newType === 'rides' ? 'Driver Needed' : `${jobMeta?.label || ''} ${(editingItem.serviceTab || 'offer') === 'need' ? 'Needed' : 'Available'}`) : 'Service Name')
                              : editingItem.name;
                            setEditingItem(prev => ({
                              ...prev,
                              jobType: newType || undefined,
                              name: newName,
                              category: newType ? (jobMeta?.label || newType) : (prev.category || 'Other'),
                              bookingForm: { fields: [] },
                              ...(newType ? (SERVICE_TYPE_DEFAULTS[newType] || {}) : {}),
                            }));
                          }}
                          style={{ width: '100%', background: 'rgba(0,0,0,0.3)', border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}40`, borderRadius: '8px', padding: '0.6rem 0.8rem', color: shopData?.theme?.colors?.text || '#fff', fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box', marginBottom: '0.75rem', cursor: 'pointer' }}
                        >
                          <option value="">— General Service —</option>
                          {getAllServiceTypes().map(jt => (
                            <option key={jt.id} value={jt.id}>{jt.icon} {jt.label}</option>
                          ))}
                        </select>
                      )}
                      {/* Job-specific fields — shown first so the card's core details are set before name/price/notes */}
                      {editingItem.isService && editingItem.jobType && (() => {
                        const accent = shopData?.theme?.colors?.accent || '#800000';
                        const textCol = shopData?.theme?.colors?.text || '#fff';
                        const inputStyle = { width: '100%', background: 'rgba(0,0,0,0.3)', border: `1px solid ${accent}40`, borderRadius: '8px', padding: '0.6rem 0.8rem', color: textCol, fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box' };
                        const labelStyle = { fontSize: '0.75rem', fontWeight: '600', opacity: 0.7, marginBottom: '0.3rem', color: textCol, display: 'block' };
                        const wrap = { display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1rem', padding: '1rem', background: `${accent}08`, borderRadius: '10px', border: `1px solid ${accent}20` };
                        const upd = (patch) => setEditingItem(prev => ({ ...prev, ...patch }));
                        const jt = editingItem.jobType;
                        const fld = (label, el) => <div><label style={labelStyle}>{label}</label>{el}</div>;
                        const txt = (key, placeholder, type = 'text') => <input type={type} style={inputStyle} value={editingItem[key] || ''} onChange={e => upd({ [key]: e.target.value })} placeholder={placeholder} />;
                        const sel = (key, opts, def) => <select style={{ ...inputStyle, colorScheme: 'dark', appearance: 'none', WebkitAppearance: 'none', backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23aaa' d='M6 8L0 0h12z'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.75rem center', paddingRight: '2.2rem' }} value={editingItem[key] || def || opts[0][0]} onChange={e => upd({ [key]: e.target.value })}>{opts.map(([v,l]) => <option key={v} value={v} style={{ background: '#0f1117', color: '#e2e8f0' }}>{l}</option>)}</select>;
                        const chk = (label, key) => <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.8rem', color: textCol, opacity: 0.85 }}><input type="checkbox" checked={!!editingItem[key]} onChange={e => upd({ [key]: e.target.checked })} />{label}</label>;
                        const num = (key, min, max, label) => <div><label style={labelStyle}>{label}</label><input type="number" min={min} max={max} style={inputStyle} value={editingItem[key] ?? min} onChange={e => upd({ [key]: parseInt(e.target.value) || min })} /></div>;
                        const grid2 = (children) => <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>{children}</div>;
                        const addr = (key, coordKey, placeholder, mapField = null) => <AddressInput address={editingItem[key] || ''} onAddressChange={v => upd({ [key]: v })} onLocationSelect={loc => loc?.coordinates ? upd({ [key]: loc.address, [coordKey]: loc.coordinates }) : upd({ [key]: '', [coordKey]: null })} placeholder={placeholder} onMapOpen={mapField ? () => handleOpenMapForSelection(editingItem.id || editingItem.tempId, true, false, mapField) : undefined} />;

                        // ── Offer tab: booking form builder ──────────────────────────────────
                        if (editingItem.serviceTab === 'offer') {
                          const template = getJobTypeBookingTemplate(jt);
                          const saved = editingItem.bookingForm?.fields;
                          const formFields = saved?.length > 0 ? saved : template.map(f => ({ ...f, enabled: true, isCustom: false }));
                          const updForm = (fields) => upd({ bookingForm: { fields } });
                          const typeOptsBase = [['text','Text'],['textarea','Long Text'],['stepper','Number'],['toggle','Yes/No'],['location','Location'],['date','Date'],['datetime-local','Date & Time']];
                          return (
                            <div style={wrap}>
                              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>📋 Customer Booking Form</div>
                              <div style={{ fontSize: '0.78rem', color: textCol, opacity: 0.6, marginTop: '-0.3rem' }}>Fields customers fill when booking this service</div>
                              {formFields.map(field => {
                                const typeOpts = ((field.type === 'select' || field.type === 'chip-select') && !field.isCustom)
                                  ? [[field.type, field.type === 'chip-select' ? 'Choice Chips' : 'Choice List'], ...typeOptsBase]
                                  : typeOptsBase;
                                return (
                                <div key={field.key} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap', padding: '0.45rem 0.6rem', borderRadius: '8px', background: `${accent}10`, border: `1px solid ${accent}30`, transition: 'all 0.15s' }}>
                                  <input value={field.label} onChange={e => updForm(formFields.map(f => f.key === field.key ? { ...f, label: e.target.value } : f))} placeholder="Question label…" style={{ flex: '1 1 100px', minWidth: 0, background: 'rgba(255,255,255,0.08)', border: `1px solid ${accent}40`, borderRadius: '5px', padding: '0.2rem 0.45rem', color: textCol, fontSize: '0.78rem', outline: 'none' }} />
                                  <select value={field.type} onChange={e => updForm(formFields.map(f => f.key === field.key ? { ...f, type: e.target.value } : f))} style={{ fontSize: '0.68rem', padding: '0.12rem 0.35rem', borderRadius: '4px', border: `1px solid ${accent}60`, background: shopData?.theme?.colors?.background || '#141414', color: textCol, outline: 'none', cursor: 'pointer', flexShrink: 0 }}>
                                    {typeOpts.map(([v,l]) => <option key={v} value={v} style={{ background: shopData?.theme?.colors?.background || '#141414', color: textCol }}>{l}</option>)}
                                  </select>
                                  <button onClick={() => updForm(formFields.filter(f => f.key !== field.key))} title="Delete field" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,90,90,0.7)', padding: '0.15rem', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                                    <Trash2 size={14} />
                                  </button>
                                </div>
                                );
                              })}
                              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.2rem' }}>
                                <button onClick={() => updForm([...formFields, { key: `custom_${Date.now()}`, label: '', type: 'text', placeholder: '', required: false, enabled: true, isCustom: true }])} style={{ fontSize: '0.78rem', background: 'none', border: `1px dashed ${accent}60`, borderRadius: '6px', padding: '0.3rem 0.75rem', cursor: 'pointer', color: accent, alignSelf: 'flex-start' }}>+ Add Custom Question</button>
                                <button
                                  onClick={() => {
                                    const cat = editingItem.category || 'Other';
                                    const currentId = editingItem.id || editingItem.tempId;
                                    const targets = (shopData?.services || []).filter(s => (s.id || s.tempId) !== currentId && (s.category || 'Other') === cat && (s.serviceTab || 'offer') === (editingItem.serviceTab || 'offer'));
                                    // Persist this card's edit too — the modal only saves to the shop on
                                    // the checkmark button, so without this the current card's form would
                                    // stay an unsaved draft while its siblings got the update.
                                    if (editingItem.id) handleServiceUpdate(editingItem.id, { bookingForm: { fields: formFields } });
                                    targets.forEach(s => handleServiceUpdate(s.id, { bookingForm: { fields: formFields } }));
                                    setCategoryApplyFlash(currentId);
                                    setTimeout(() => setCategoryApplyFlash(prev => prev === currentId ? null : prev), 1600);
                                  }}
                                  style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.78rem', background: 'none', border: `1px solid ${accent}60`, borderRadius: '6px', padding: '0.3rem 0.75rem', cursor: 'pointer', color: accent, alignSelf: 'flex-start', fontWeight: 600 }}
                                >⤴ Apply to Category{categoryApplyFlash === (editingItem.id || editingItem.tempId) && <Check size={13} />}</button>
                              </div>

                              <div style={{ height: '1px', background: `${accent}20`, margin: '0.2rem 0' }} />
                              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🔘 Card Button</div>
                              {fld('Button Style', sel('ctaStyle', [['order','Order'],['book','Book'],['signup','Sign Up']], 'order'))}
                              {editingItem.ctaStyle === 'signup' && (
                                <>
                                  {fld('Sign-up Link', txt('externalLink', 'https://…', 'url'))}
                                  <div style={{ fontSize: '0.72rem', color: textCol, opacity: 0.55 }}>Clicking "Sign Up" sends buyers to this link instead of opening chat/checkout.</div>
                                </>
                              )}
                            </div>
                          );
                        }

                        if (jt === 'rides') {
                          const dist = (editingItem.pickupCoordinates && editingItem.destinationCoordinates)
                            ? haversineDistanceMiles(editingItem.pickupCoordinates.lat, editingItem.pickupCoordinates.lng, editingItem.destinationCoordinates.lat, editingItem.destinationCoordinates.lng) : null;
                          return (
                            <div style={wrap}>
                              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🚗 Ride Details</div>
                              {fld('📍 Pickup Location', addr('pickupAddress','pickupCoordinates','Pickup address','pickup'))}
                              {fld('🏁 Destination', addr('destinationAddress','destinationCoordinates','Destination address','destination'))}
                              {dist && <div style={{ fontSize: '0.82rem', color: accent, fontWeight: '600' }}>🛣️ Estimated distance: {dist} miles</div>}
                              {grid2(<>{fld('📅 Date & Time', txt('rideDateTime','','datetime-local'))} {fld('👥 Passengers', <input type="number" min={1} max={20} inputMode="numeric" style={{ ...inputStyle, MozAppearance:'textfield', WebkitAppearance:'none' }} value={editingItem.passengers ?? 1} onChange={e => upd({ passengers: parseInt(e.target.value) || 1 })} />)}</>)}
                              {fld('🚗 Vehicle Type', sel('vehicleType',[['any','Any Vehicle'],['sedan','Sedan'],['suv','SUV'],['van','Van / Minivan'],['limo','Limousine'],['luxury','Luxury Car'],['truck','Pickup Truck']],'any'))}
                              {chk('🗺️ Use route map as card image', 'useRouteMapImage')}
                            </div>
                          );
                        }
                        if (jt === 'home_repair') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🔧 Home Repair Details</div>
                            {fld('📍 Service Address', addr('serviceAddress','serviceCoordinates','Job location'))}
                            {fld('📅 Preferred Date & Time', txt('serviceDateTime','','datetime-local'))}
                            {grid2(<>{fld('🔨 Job Scope', sel('jobScope',[['minor','Minor fix'],['moderate','Moderate'],['major','Major work']]))} {fld('⚡ Urgency', sel('urgency',[['flexible','Flexible'],['within-week','Within a week'],['asap','ASAP']]))}</>)}
                            {fld('📝 Access Instructions', txt('accessInstructions','e.g. gate code, key under mat…'))}
                            {chk('Materials / supplies included in price','materialsIncluded')}
                          </div>
                        );
                        if (jt === 'cleaning') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🧹 Cleaning Details</div>
                            {fld('📍 Service Address', addr('serviceAddress','serviceCoordinates','Property address'))}
                            {fld('📅 Preferred Date & Time', txt('serviceDateTime','','datetime-local'))}
                            {grid2(<>{fld('🏠 Property Type', sel('propertyType',[['house','House'],['apartment','Apartment'],['office','Office'],['commercial','Commercial']]))} {fld('🔁 Frequency', sel('frequency',[['one-time','One-time'],['weekly','Weekly'],['bi-weekly','Bi-weekly'],['monthly','Monthly']]))}</>)}
                            {grid2(<>{num('bedrooms',1,20,'🛏️ Bedrooms')} {num('bathrooms',1,10,'🚿 Bathrooms')}</>)}
                            {fld('🧴 Cleaning Supplies', sel('suppliesProvided',[['provider','Provider brings supplies'],['client','Client provides supplies'],['both','Both']]))}
                          </div>
                        );
                        if (jt === 'moving') {
                          const dist = (editingItem.pickupCoordinates && editingItem.destinationCoordinates)
                            ? haversineDistanceMiles(editingItem.pickupCoordinates.lat, editingItem.pickupCoordinates.lng, editingItem.destinationCoordinates.lat, editingItem.destinationCoordinates.lng) : null;
                          return (
                            <div style={wrap}>
                              <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>📦 Moving Details</div>
                              {fld('📍 Moving From', addr('pickupAddress','pickupCoordinates','Current address','pickup'))}
                              {fld('🏁 Moving To', addr('destinationAddress','destinationCoordinates','Destination address','destination'))}
                              {dist && <div style={{ fontSize: '0.82rem', color: accent, fontWeight: '600' }}>🛣️ Distance: {dist} miles</div>}
                              {grid2(<>{fld('📅 Move Date', txt('moveDate','','date'))} {fld('📦 Load Size', sel('estimatedLoad',[['small','Small (few boxes)'],['moderate','Moderate (1-BR)'],['large','Large (2-3 BR)'],['full-house','Full house']]))}</>)}
                              {chk('Has heavy/special items (piano, safe, etc.)','hasHeavyItems')}
                              {chk('Need packing / unpacking help','packingHelp')}
                            </div>
                          );
                        }
                        if (jt === 'delivery') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🚚 Delivery Details</div>
                            {fld('📍 Pickup From', addr('pickupAddress','pickupCoordinates','Pickup address'))}
                            {fld('🏁 Deliver To', addr('deliveryAddress','deliveryCoordinates','Delivery address'))}
                            {fld('📦 Item Description', txt('itemDescription','What needs to be delivered?'))}
                            {grid2(<>{fld('📏 Item Size', sel('itemSize',[['small','Small (fits in bag)'],['medium','Medium (box)'],['large','Large (furniture)'],['oversized','Oversized']]))} {fld('⏰ Deliver By', txt('deliveryByDateTime','','datetime-local'))}</>)}
                            {chk('Fragile — handle with care','fragile')}
                          </div>
                        );
                        if (jt === 'tutoring') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>📚 Tutoring Details</div>
                            {fld('📖 Subject', txt('subject','e.g. Algebra, SAT Prep, Python…'))}
                            {grid2(<>{fld('🎓 Grade / Level', sel('gradeLevel',[['elementary','Elementary (K-5)'],['middle','Middle School'],['high','High School'],['college','College'],['adult','Adult / Professional']]))} {fld('⏱️ Session Length', sel('sessionDuration',[['30min','30 minutes'],['1hr','1 hour'],['2hr','2 hours'],['custom','Custom']]))}</>)}
                            {fld('💻 Session Mode', sel('sessionMode',[['in-person','In-person'],['online','Online / Remote'],['either','Either works']]))}
                            {fld('🗓️ Preferred Schedule', txt('preferredSchedule','e.g. Weekends 2-4 PM, weekday evenings…'))}
                          </div>
                        );
                        if (jt === 'pet_care') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🐾 Pet Care Details</div>
                            {grid2(<>{fld('🐶 Pet Type', sel('petType',[['dog','Dog'],['cat','Cat'],['bird','Bird'],['reptile','Reptile'],['other','Other']]))} {fld('🏷️ Breed / Name', txt('petBreed','e.g. Labrador, Max…'))}</>)}
                            {fld('🛠️ Service Type', sel('petServiceType',[['walking','Dog Walking'],['sitting','Pet Sitting'],['boarding','Boarding'],['grooming','Grooming'],['training','Training'],['vet-transport','Vet Transport']]))}
                            {grid2(<>{fld('📅 Date & Time', txt('serviceDateTime','','datetime-local'))} {num('serviceDuration',1,24,'⏱️ Duration (hours)')}</>)}
                            {fld('⚠️ Special Needs / Notes', txt('specialNeeds','Allergies, behavior notes, medications…'))}
                          </div>
                        );
                        if (jt === 'handyman') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🛠️ Handyman Details</div>
                            {fld('📍 Service Address', addr('serviceAddress','serviceCoordinates','Job location'))}
                            {fld('📅 Preferred Date & Time', txt('serviceDateTime','','datetime-local'))}
                            {grid2(<>{fld('⚡ Urgency', sel('urgency',[['flexible','Flexible'],['within-week','Within a week'],['asap','ASAP']]))} {num('estimatedHours',1,48,'⏱️ Est. Hours')}</>)}
                            {chk('Provider brings own tools','toolsProvided')}
                          </div>
                        );
                        if (jt === 'beauty') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>💇 Beauty Details</div>
                            {fld('✂️ Service Type', sel('beautyServiceType',[['haircut','Haircut / Trim'],['coloring','Hair Coloring'],['styling','Hair Styling'],['nails','Nails / Manicure'],['pedicure','Pedicure'],['makeup','Makeup'],['waxing','Waxing'],['lashes','Lashes / Brows'],['other','Other']]))}
                            {fld('📍 Location', sel('serviceLocation',[['home-visit','Home Visit (I come to you)'],['studio','My Studio / Salon'],['client-home','Client provides location']]))}
                            {editingItem.serviceLocation === 'home-visit' && fld('🏠 Your Address', addr('serviceAddress','serviceCoordinates','Studio / travel-from address'))}
                            {grid2(<>{fld('📅 Date & Time', txt('serviceDateTime','','datetime-local'))} {num('duration',1,8,'⏱️ Duration (hours)')}</>)}
                          </div>
                        );
                        if (jt === 'tech') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>💻 Tech Support Details</div>
                            {grid2(<>{fld('📱 Device Type', sel('deviceType',[['laptop','Laptop'],['desktop','Desktop PC'],['phone','Smartphone'],['tablet','Tablet'],['smart-home','Smart Home'],['network','Network / Router'],['other','Other']]))} {fld('💾 OS / Platform', sel('os',[['windows','Windows'],['macos','macOS'],['linux','Linux'],['ios','iOS'],['android','Android'],['other','Other']]))}</>)}
                            {fld('🔧 Service Mode', sel('serviceMode',[['in-person','In-person'],['remote','Remote / Online'],['either','Either works']]))}
                            {editingItem.serviceMode !== 'remote' && fld('📍 Service Address', addr('serviceAddress','serviceCoordinates','Service location'))}
                            {fld('⚡ Urgency', sel('urgency',[['flexible','Flexible'],['within-week','Within a week'],['asap','ASAP']]))}
                          </div>
                        );
                        if (jt === 'events') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>🎉 Event Details</div>
                            {grid2(<>{fld('🎊 Event Type', sel('eventType',[['birthday','Birthday'],['wedding','Wedding'],['corporate','Corporate'],['graduation','Graduation'],['babyshower','Baby Shower'],['other','Other']]))} {fld('📅 Event Date', txt('eventDate','','date'))}</>)}
                            {fld('📍 Event Address', addr('eventAddress','eventCoordinates','Venue address'))}
                            {grid2(<>{num('guestCount',1,5000,'👥 Expected Guests')} {num('eventDuration',1,24,'⏱️ Duration (hours)')}</>)}
                            {fld('🛎️ Services Offered', (
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                                {[['catering','🍽️ Catering'],['photography','📷 Photography'],['videography','🎥 Videography'],['setup','🪑 Setup'],['cleanup','🧹 Cleanup'],['entertainment','🎵 Entertainment'],['decoration','🎀 Decoration'],['security','🔒 Security']].map(([v,l]) => {
                                  const isSel = (editingItem.servicesNeeded || []).includes(v);
                                  return <button key={v} onClick={() => { const cur = editingItem.servicesNeeded || []; upd({ servicesNeeded: isSel ? cur.filter(x => x !== v) : [...cur, v] }); }} style={{ padding: '0.3rem 0.6rem', borderRadius: '20px', border: `1px solid ${accent}${isSel ? 'ff' : '40'}`, background: isSel ? `${accent}30` : 'transparent', color: textCol, fontSize: '0.75rem', cursor: 'pointer' }}>{l}</button>;
                                })}
                              </div>
                            ))}
                          </div>
                        );
                        if (jt === 'other') return (
                          <div style={wrap}>
                            <div style={{ fontSize: '0.8rem', fontWeight: '700', color: accent }}>💼 Job Details</div>
                            {fld('📍 Location', addr('serviceAddress','serviceCoordinates','Job location (optional)'))}
                            {fld('📅 Preferred Date & Time', txt('serviceDateTime','','datetime-local'))}
                            {grid2(<>{fld('⚡ Urgency', sel('urgency',[['flexible','Flexible'],['within-week','Within a week'],['asap','ASAP']]))} {fld('⏱️ Est. Duration', txt('estimatedDuration','e.g. 2 hours, 1 day…'))}</>)}
                          </div>
                        );
                        return null;
                      })()}

                      <ValidatedEditableText
                        value={editingItem.name}
                        onChange={(value) => setEditingItem({ ...editingItem, name: value })}
                        placeholder={editingItem.isService ? "Service Name" : "Item Name"}
                        theme={shopData?.theme}
                        showClearButton={true}
                      />

                      <ValidatedEditableText
                        value={editingItem.price}
                        onChange={(value) => setEditingItem({ ...editingItem, price: value })}
                        placeholder="Price"
                        theme={shopData?.theme}
                        showClearButton={true}
                        showCurrencySelector={true}
                        currencyValue={shopData?.currency || 'USD'}
                        onCurrencyChange={(code) => handleUpdateShop({ currency: code })}
                      />
                      {editingItem.isService && (editingItem.serviceTab || 'offer') !== 'need' && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.75rem' }}>
                          <span style={{ fontSize: '0.72rem', fontWeight: '600', opacity: 0.7, color: shopData?.theme?.colors?.text || '#fff' }}>Price is</span>
                          <div style={{ display: 'flex', borderRadius: '8px', overflow: 'hidden', border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}40` }}>
                            {[['hourly', 'Per Hour'], ['daily', 'Per Day'], ['total', 'Flat Total']].map(([val, label]) => (
                              <button
                                key={val}
                                onClick={() => setEditingItem(prev => ({ ...prev, pricingType: val }))}
                                style={{
                                  padding: '0.32rem 0.7rem',
                                  fontSize: '0.7rem',
                                  fontWeight: '700',
                                  border: 'none',
                                  cursor: 'pointer',
                                  background: (editingItem.pricingType || 'hourly') === val ? (shopData?.theme?.colors?.accent || '#800000') : 'transparent',
                                  color: (editingItem.pricingType || 'hourly') === val ? '#fff' : (shopData?.theme?.colors?.text || '#fff'),
                                }}
                              >
                                {label}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                      <ValidatedEditableText
                        value={editingItem.description}
                        onChange={(value) => setEditingItem({ ...editingItem, description: value })}
                        placeholder={editingItem.isService ? "Additional notes (optional)" : "Item Description"}
                        multiline
                        theme={shopData?.theme}
                        showClearButton={true}
                      />

                      {/* Category only shown for regular items, not for job cards (their jobType IS the category) */}
                      {!editingItem.jobType && (
                        <CategorySelect
                          value={editingItem.category || 'Other'}
                          onChange={(e) => setEditingItem({ ...editingItem, category: e.target.value })}
                          theme={shopData?.theme}
                        >
                          {getAllCategories(editingItem.isService).map(category => (
                            <option key={category} value={category}>{category}</option>
                          ))}
                        </CategorySelect>
                      )}

                      {!editingItem.jobType && (
                      <div style={{ marginBottom: '1rem' }}>
                        <QuantitySelector
                          value={parseInt(editingItem.isService ? editingItem.slots : editingItem.quantity) || 1}
                          onChange={(value) => setEditingItem({
                            ...editingItem,
                            [editingItem.isService ? 'slots' : 'quantity']: value
                          })}
                          theme={shopData?.theme}
                          min={0}
                          max={9999}
                        />
                      </div>
                      )}

                      {/* Item Attributes — not shown for services */}
                      {!editingItem.isService && (() => {
                        const accent = shopData?.theme?.colors?.accent || '#800000';
                        const isRestaurantStore = shopData?.isRestaurant || storeType === 'restaurant';
                        const PRESETS = {
                          clothing: ['Size', 'Color', 'Material', 'Style'],
                          shoes:    ['Size', 'Color', 'Width'],
                          electronics: ['Storage', 'Color', 'Connectivity'],
                          sports:   ['Size', 'Color'],
                          home:     ['Color', 'Material', 'Size'],
                          beauty:   ['Variant', 'Size'],
                          toys:     ['Size', 'Color'],
                          automotive: ['Color', 'Compatibility'],
                          art:      ['Size', 'Material'],
                          books:    ['Format', 'Edition'],
                          restaurant: ['Size', 'Spice Level', 'Protein', 'Side'],
                          other:    ['Size', 'Color', 'Material'],
                        };
                        const SIZE_SUGGESTIONS = {
                          Size: isRestaurantStore ? ['Small', 'Medium', 'Large', 'XL'] : ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
                          Color: ['Black', 'White', 'Red', 'Blue', 'Green', 'Yellow', 'Pink', 'Grey', 'Brown'],
                          Storage: ['64GB', '128GB', '256GB', '512GB', '1TB'],
                          Material: ['Cotton', 'Polyester', 'Leather', 'Wool', 'Silk', 'Denim'],
                          Format: ['Hardcover', 'Paperback', 'eBook', 'Audiobook'],
                          Width: ['Narrow', 'Regular', 'Wide'],
                          Connectivity: ['WiFi', 'Bluetooth', 'Wired', 'Wireless'],
                          Variant: ['Original', 'Travel Size', 'Bundle'],
                          'Spice Level': ['Mild', 'Medium', 'Hot', 'Extra Hot'],
                          Protein: ['Chicken', 'Beef', 'Shrimp', 'Tofu', 'Pork', 'Lamb'],
                          Side: ['Fries', 'Salad', 'Rice', 'Coleslaw', 'Soup'],
                          Style: ['Casual', 'Formal', 'Sport'],
                          Edition: ['1st', '2nd', '3rd', 'Latest'],
                          Compatibility: ['Universal', 'Specific Model'],
                        };
                        const suggestedNames = PRESETS[storeType] || PRESETS.other;
                        const attrs = editingItem.attributes || [];

                        const updateAttrs = (newAttrs) =>
                          setEditingItem({ ...editingItem, attributes: newAttrs });

                        const addAttr = (name) => {
                          if (attrs.length >= 4) return;
                          if (attrs.find(a => a.name.toLowerCase() === name.toLowerCase())) return;
                          updateAttrs([...attrs, { name, values: [] }]);
                        };

                        const removeAttr = (idx) =>
                          updateAttrs(attrs.filter((_, i) => i !== idx));

                        const updateAttrName = (idx, name) =>
                          updateAttrs(attrs.map((a, i) => i === idx ? { ...a, name } : a));

                        const addValue = (idx, val) => {
                          const trimmed = val.trim();
                          if (!trimmed) return;
                          const attr = attrs[idx];
                          if (attr.values.includes(trimmed)) return;
                          updateAttrs(attrs.map((a, i) => i === idx ? { ...a, values: [...a.values, trimmed] } : a));
                        };

                        const removeValue = (attrIdx, valIdx) =>
                          updateAttrs(attrs.map((a, i) => i === attrIdx
                            ? { ...a, values: a.values.filter((_, vi) => vi !== valIdx) }
                            : a));

                        const inputStyle = {
                          background: 'rgba(0,0,0,0.3)',
                          border: `1px solid ${accent}40`,
                          borderRadius: '6px',
                          padding: '0.35rem 0.6rem',
                          color: '#fff',
                          fontSize: '0.82rem',
                          outline: 'none',
                          boxSizing: 'border-box',
                        };

                        return (
                          <div style={{ marginBottom: '1rem', padding: '0.75rem', border: `1px solid ${accent}40`, borderRadius: '8px' }}>
                            <div style={{ fontSize: '0.85rem', fontWeight: '700', color: accent, marginBottom: '0.5rem' }}>
                              {isRestaurantStore ? 'Item Options' : 'Item Attributes'}
                              <span style={{ fontWeight: '400', opacity: 0.6, marginLeft: '0.4rem' }}>
                                {isRestaurantStore ? '(e.g. Size, Spice Level)' : '(up to 4 — e.g. Size, Color)'}
                              </span>
                            </div>

                            {/* Quick-add chips */}
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginBottom: '0.6rem' }}>
                              {suggestedNames
                                .filter(n => !attrs.find(a => a.name.toLowerCase() === n.toLowerCase()))
                                .map(n => (
                                  <button
                                    key={n}
                                    onClick={() => addAttr(n)}
                                    disabled={attrs.length >= 4}
                                    style={{
                                      background: `${accent}22`,
                                      border: `1px solid ${accent}55`,
                                      color: accent,
                                      borderRadius: '20px',
                                      padding: '0.2rem 0.7rem',
                                      fontSize: '0.75rem',
                                      cursor: attrs.length >= 4 ? 'default' : 'pointer',
                                      opacity: attrs.length >= 4 ? 0.4 : 1,
                                    }}
                                  >+ {n}</button>
                                ))}
                              {attrs.length < 4 && (
                                <button
                                  onClick={() => addAttr('Custom')}
                                  style={{
                                    background: 'rgba(255,255,255,0.06)',
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    color: 'rgba(255,255,255,0.6)',
                                    borderRadius: '20px',
                                    padding: '0.2rem 0.7rem',
                                    fontSize: '0.75rem',
                                    cursor: 'pointer',
                                  }}
                                >+ Custom</button>
                              )}
                            </div>

                            {/* Attribute rows */}
                            {attrs.map((attr, ai) => (
                              <div key={ai} style={{ background: 'rgba(0,0,0,0.2)', borderRadius: '6px', padding: '0.5rem 0.6rem', marginBottom: '0.45rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.4rem' }}>
                                  <input
                                    value={attr.name}
                                    onChange={e => updateAttrName(ai, e.target.value)}
                                    maxLength={20}
                                    style={{ ...inputStyle, flex: 1, fontWeight: '600' }}
                                  />
                                  <button
                                    onClick={() => removeAttr(ai)}
                                    style={{ background: 'none', border: 'none', color: '#ff6666', cursor: 'pointer', fontSize: '1rem', lineHeight: 1, padding: '0 0.2rem' }}
                                  >✕</button>
                                </div>
                                {/* Value chips */}
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginBottom: '0.35rem' }}>
                                  {attr.values.map((v, vi) => (
                                    <span
                                      key={vi}
                                      style={{
                                        display: 'inline-flex', alignItems: 'center', gap: '0.25rem',
                                        background: `${accent}30`, border: `1px solid ${accent}55`,
                                        color: '#fff', borderRadius: '20px',
                                        padding: '0.18rem 0.5rem', fontSize: '0.75rem'
                                      }}
                                    >
                                      {v}
                                      <span
                                        onClick={() => removeValue(ai, vi)}
                                        style={{ cursor: 'pointer', opacity: 0.6, fontSize: '0.7rem', lineHeight: 1 }}
                                      >✕</span>
                                    </span>
                                  ))}
                                  {/* Suggestion chips */}
                                  {(SIZE_SUGGESTIONS[attr.name] || [])
                                    .filter(sv => !attr.values.includes(sv))
                                    .slice(0, 6)
                                    .map(sv => (
                                      <span
                                        key={sv}
                                        onClick={() => addValue(ai, sv)}
                                        style={{
                                          display: 'inline-block',
                                          background: 'rgba(255,255,255,0.05)',
                                          border: '1px dashed rgba(255,255,255,0.2)',
                                          color: 'rgba(255,255,255,0.5)',
                                          borderRadius: '20px',
                                          padding: '0.18rem 0.5rem',
                                          fontSize: '0.75rem',
                                          cursor: 'pointer',
                                        }}
                                      >+{sv}</span>
                                    ))}
                                </div>
                                {/* Custom value input */}
                                <form
                                  onSubmit={e => {
                                    e.preventDefault();
                                    const inp = e.target.elements[`attr-val-${ai}`];
                                    addValue(ai, inp.value);
                                    inp.value = '';
                                  }}
                                  style={{ display: 'flex', gap: '0.35rem' }}
                                >
                                  <input
                                    name={`attr-val-${ai}`}
                                    placeholder="Add value…"
                                    maxLength={30}
                                    style={{ ...inputStyle, flex: 1 }}
                                  />
                                  <button
                                    type="submit"
                                    style={{
                                      background: `${accent}33`, border: `1px solid ${accent}66`,
                                      color: '#fff', borderRadius: '6px',
                                      padding: '0.35rem 0.7rem', fontSize: '0.8rem', cursor: 'pointer'
                                    }}
                                  >Add</button>
                                </form>
                              </div>
                            ))}
                          </div>
                        );
                      })()}

                      {/* Digital Product Toggle */}
                      {!editingItem.isService && (
                        <div style={{ margin: '0.5rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.9rem', color: shopData?.theme?.colors?.text || '#fff' }}>
                            <input
                              type="checkbox"
                              checked={!!editingItem.isDigital}
                              onChange={e => setEditingItem({ ...editingItem, isDigital: e.target.checked, digitalFile: null })}
                              style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                            />
                            Digital Product (instant download after purchase)
                          </label>
                        </div>
                      )}

                      {/* Digital File Upload */}
                      {!editingItem.isService && editingItem.isDigital && (
                        <div style={{ margin: '0.5rem 0', padding: '0.75rem', border: `1px dashed ${shopData?.theme?.colors?.primary || '#666'}`, borderRadius: '8px' }}>
                          {editingItem.digitalFile ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem', color: shopData?.theme?.colors?.text || '#fff' }}>
                              <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {editingItem.digitalFile.name}
                              </span>
                              <span style={{ opacity: 0.6, whiteSpace: 'nowrap' }}>
                                {editingItem.digitalFile.size ? `${(editingItem.digitalFile.size / 1024 / 1024).toFixed(2)} MB` : ''}
                              </span>
                              <button
                                onClick={() => setEditingItem({ ...editingItem, digitalFile: null })}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: shopData?.theme?.colors?.text || '#fff', padding: '0 4px' }}
                              >
                                <X size={14} />
                              </button>
                            </div>
                          ) : (
                            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.85rem', color: shopData?.theme?.colors?.text || '#fff' }}>
                              <Upload size={16} />
                              <span>Upload digital file (PDF, ZIP, MP3, etc.)</span>
                              <input
                                type="file"
                                style={{ display: 'none' }}
                                onChange={e => {
                                  const file = e.target.files?.[0];
                                  if (file) {
                                    setEditingItem({ ...editingItem, digitalFile: { file, name: file.name, size: file.size, type: file.type } });
                                  }
                                }}
                              />
                            </label>
                          )}
                        </div>
                      )}

                      {!editingItem.isDigital && !editingItem.jobType && (
                      <AddressInput
  address={editingItem.address || ''}
  onAddressChange={(value) => setEditingItem({
    ...editingItem,
    address: value
  })}
  onLocationSelect={(location) => {
    if (location?.coordinates) {
      setEditingItem({
        ...editingItem,
        address: location.address,
        coordinates: location.coordinates
      });
    } else if (!location?.address) {
      setEditingItem({
        ...editingItem,
        address: '',
        coordinates: null
      });
    }
  }}
  onMapOpen={() => handleOpenMapForSelection(editingItem.id, editingItem.isService)}
/>
                      )}
                    </EditModalBody>
                  </EditModalScrollContent>
                </EditModalContent>
              </EditModal>
            )}

            
          </>
        )}

          {shopTabs.map(tab => {
            if (activeTab !== tab.id) return null;
            if (tab.type === 'home') {
              const isFreePlanHome = getPlanFromBilling(billingData) === 'free';
              return (
                <React.Fragment key={tab.id}>
                  {isFreePlanHome ? (
                    <div style={{ position: 'relative' }}>
                      <div style={{ filter: 'blur(6px)', pointerEvents: 'none', userSelect: 'none' }}>
                        {renderHomeView()}
                      </div>
                      <FreePlanHomeOverlay
                        theme={shopData?.theme}
                        onSelectPlan={() => {
                          setBillingDataForPayment({ ...billingData, openFrom: 'upgrade' });
                          setShowPaymentModal(true);
                        }}
                      />
                    </div>
                  ) : renderHomeView()}
                </React.Fragment>
              );
            }
            if (tab.type === 'community') return <React.Fragment key={tab.id}>{renderProfileView()}</React.Fragment>;
            return null;
          })}

          {/* Site-wide contact footer — same scroll container as the active tab's
              own content, so it never introduces a nested scroll area. Still
              editable in place; add/remove/reorder stays on its home Home tab. */}
          {globalContactSection && !activeTabHasOwnContactSection && (
            <ContactSection
              config={globalContactSection.config}
              theme={shopData?.theme}
              shopData={shopData}
              editable={true}
              onUpdate={(newConfig) => handleUpdateSection(globalContactSection.id, newConfig)}
            />
          )}

        </MainContent>

        {/* Payment Modal — rendered above the tab content regardless of which
            tab is active, so upgrade CTAs on Home/Profile/etc. still open it. */}
        {showPaymentModal && (billingDataForPayment || billingData) && (
          <PaymentModal
            billingData={{
              ...(billingDataForPayment || billingData),
              userId: activeShopId || auth.currentUser?.uid,
              // For sub-shops the billing doc lives under the sub-shop ID, but the
              // Stripe customer should be looked up via the real owner's auth uid.
              ownerUserId: auth.currentUser?.uid,
              userName: shopData?.shopName || 'Shop Owner'
            }}
            onClose={() => { setShowPaymentModal(false); setBillingDataForPayment(null); }}
            onSuccess={handlePaymentSuccess}
            theme={shopData?.theme}
          />
        )}

        {/* New sub-shop name modal — same reasoning: must float above every
            tab, not just Shop, since the "Create New Store" trigger lives in
            the always-visible header shops dropdown. */}
        {showNewShopModal && (
          <div style={{
            position: 'fixed', inset: 0, zIndex: 10000,
            background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem'
          }}>
            <div style={{
              background: shopData?.theme?.colors?.surface || '#1a1a1a',
              border: `2px solid ${shopData?.theme?.colors?.accent || '#800000'}`,
              borderRadius: '16px', padding: '2rem', width: '100%', maxWidth: '420px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <h2 style={{ margin: 0, color: shopData?.theme?.colors?.accent || '#800000', fontSize: '1.3rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Plus size={20} /> Create New Store
                </h2>
                <button onClick={() => setShowNewShopModal(false)} style={{ background: 'transparent', border: 'none', color: shopData?.theme?.colors?.text || '#fff', cursor: 'pointer', padding: '0.25rem' }}>
                  <X size={20} />
                </button>
              </div>
              <p style={{ margin: '0 0 1.25rem', color: shopData?.theme?.colors?.text || '#fff', opacity: 0.7, fontSize: '0.9rem', lineHeight: 1.5 }}>
                Your new shop opens immediately. A one-time <strong style={{ color: shopData?.theme?.colors?.accent || '#800000' }}>$50 activation fee</strong> is due before items become visible to customers.
              </p>
              <label style={{ display: 'block', marginBottom: '0.5rem', color: shopData?.theme?.colors?.text || '#fff', fontSize: '0.9rem', fontWeight: 600 }}>
                Store Name
              </label>
              <input
                type="text"
                value={newShopName}
                onChange={e => setNewShopName(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && !isCreatingShop && initNewShopCreation()}
                placeholder="Enter store name..."
                maxLength={40}
                autoFocus
                style={{
                  width: '100%', padding: '0.75rem 1rem', borderRadius: '8px',
                  background: 'rgba(255,255,255,0.06)', border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}44`,
                  color: shopData?.theme?.colors?.text || '#fff', fontSize: '1rem', outline: 'none',
                  boxSizing: 'border-box', marginBottom: '1.5rem'
                }}
              />
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                <button
                  onClick={() => setShowNewShopModal(false)}
                  style={{
                    flex: 1, padding: '0.75rem', borderRadius: '8px', border: `1px solid ${shopData?.theme?.colors?.accent || '#800000'}44`,
                    background: 'transparent', color: shopData?.theme?.colors?.text || '#fff', cursor: 'pointer', fontSize: '0.9rem'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={initNewShopCreation}
                  disabled={!newShopName.trim() || isCreatingShop}
                  style={{
                    flex: 2, padding: '0.75rem', borderRadius: '8px', border: 'none',
                    background: newShopName.trim() && !isCreatingShop ? (shopData?.theme?.colors?.accent || '#800000') : 'rgba(128,0,0,0.3)',
                    color: '#fff', cursor: newShopName.trim() && !isCreatingShop ? 'pointer' : 'not-allowed',
                    fontSize: '0.9rem', fontWeight: 600
                  }}
                >
                  {isCreatingShop ? 'Creating...' : 'Create Store'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* "Unlock More Tabs" upgrade menu — replaces the old alert()-based
            prompt everywhere a free-plan tab limit is hit. Floats above every
            tab for the same reason as the modals above. */}
        {showUnlockTabsModal && (
          <FreePlanHomeOverlay
            asModal
            theme={shopData?.theme}
            onClose={() => setShowUnlockTabsModal(false)}
            onSelectPlan={() => {
              setShowUnlockTabsModal(false);
              setBillingDataForPayment({ ...billingData, openFrom: 'upgrade' });
              setShowPaymentModal(true);
            }}
          />
        )}

        {showLocationOverlay && (
  <UtilityOverlay onClick={() => setShowLocationOverlay(false)}>
    <UtilityOverlayContent 
      theme={shopData?.theme}
      onClick={(e) => e.stopPropagation()}
    >
      <OverlayHeader theme={shopData?.theme}>
        <h3>Set Location</h3>
        <button
          onClick={() => setShowLocationOverlay(false)}
          style={{
            background: 'transparent',
            border: 'none',
            color: shopData?.theme?.colors?.text,
            cursor: 'pointer',
            padding: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <X size={20} />
        </button>
      </OverlayHeader>
      
      <OverlayBody>
        {/* Address Input */}
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{
            display: 'block',
            marginBottom: '0.5rem',
            color: shopData?.theme?.colors?.text,
            fontSize: '0.9rem',
            fontWeight: '600'
          }}>
            Location
          </label>
          <AddressInput
            address={overlayAddress}
            onAddressChange={(value) => setOverlayAddress(value)}
            onLocationSelect={(location) => {
              if (location?.coordinates) {
                setOverlayAddress(location.address);
                setOverlayCoordinates(location.coordinates);
              }
            }}
            onMapOpen={() => {
              // Open map for overlay
              setShowLocationOverlay(false);
              setSelectingLocationFor({ isOverlay: true });
              setMapOpen(true);
            }}
          />
        </div>
        
        {/* Selection Actions */}
        <SelectionActions>
          <SelectionButton
            theme={shopData?.theme}
            onClick={selectAllItems}
          >
            Select All ({shopContentType === 'services' ? 
              shopData?.services?.length : 
              shopData?.items?.length})
          </SelectionButton>
          <SelectionButton
            theme={shopData?.theme}
            onClick={deselectAllItems}
          >
            Deselect All
          </SelectionButton>
        </SelectionActions>
        
        {/* Item Selection List */}
        <label style={{
          display: 'block',
          marginBottom: '0.75rem',
          color: shopData?.theme?.colors?.text,
          fontSize: '0.9rem',
          fontWeight: '600'
        }}>
          Select Items ({selectedItemsForUpdate.size} selected)
        </label>
        
        <ItemSelectionList theme={shopData?.theme}>
  {(shopContentType === 'services' ? 
    shopData?.services : 
    shopData?.items)?.map(item => (
    <ItemSelectionCard
      key={item.id}
      theme={shopData?.theme}
      selected={selectedItemsForUpdate.has(item.id)}
      onClick={() => toggleItemSelection(item.id)}
    >
      <ItemCheckbox 
        theme={shopData?.theme}
        checked={selectedItemsForUpdate.has(item.id)}
      >
        <Check size={14} />
      </ItemCheckbox>
      
      <ItemInfo theme={shopData?.theme}>
        <div className="item-name">
          {item.name || (shopContentType === 'services' ? 'Service Name' : 'Item Name')}
        </div>
        <div className="item-details">
          {formatShopPrice(item.price, shopData?.currency)}
          {item.category && ` • ${item.category}`}
        </div>
      </ItemInfo>
    </ItemSelectionCard>
  ))}
</ItemSelectionList>
      </OverlayBody>
      
      <OverlayFooter theme={shopData?.theme}>
        <ResetButton
          theme={shopData?.theme}
          onClick={() => setShowLocationOverlay(false)}
        >
          Cancel
        </ResetButton>
        <SaveButton
          theme={shopData?.theme}
          onClick={handleApplyLocationToSelected}
          disabled={selectedItemsForUpdate.size === 0 || (!overlayAddress && !overlayCoordinates)}
        >
          <Check size={16} />
          Apply to {selectedItemsForUpdate.size} {shopContentType}
        </SaveButton>
      </OverlayFooter>
    </UtilityOverlayContent>
  </UtilityOverlay>
)}

{/* Category Overlay */}
{showCategoryOverlay && (
  <UtilityOverlay onClick={() => setShowCategoryOverlay(false)}>
    <UtilityOverlayContent 
      theme={shopData?.theme}
      onClick={(e) => e.stopPropagation()}
    >
      <OverlayHeader theme={shopData?.theme}>
        <h3>Set Category</h3>
        <button
          onClick={() => setShowCategoryOverlay(false)}
          style={{
            background: 'transparent',
            border: 'none',
            color: shopData?.theme?.colors?.text,
            cursor: 'pointer',
            padding: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <X size={20} />
        </button>
      </OverlayHeader>
      
      <OverlayBody>
        {/* Category Select */}
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{
            display: 'block',
            marginBottom: '0.5rem',
            color: shopData?.theme?.colors?.text,
            fontSize: '0.9rem',
            fontWeight: '600'
          }}>
            Category
          </label>
          <CategorySelect
            value={overlayCategory}
            onChange={(e) => setOverlayCategory(e.target.value)}
            theme={shopData?.theme}
          >
            <option value="">Select a category</option>
            {getAllCategories(shopContentType === 'services').map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </CategorySelect>
        </div>
        
        {/* Selection Actions */}
        <SelectionActions>
          <SelectionButton
            theme={shopData?.theme}
            onClick={selectAllItems}
          >
            Select All ({shopContentType === 'services' ? 
              shopData?.services?.length : 
              shopData?.items?.length})
          </SelectionButton>
          <SelectionButton
            theme={shopData?.theme}
            onClick={deselectAllItems}
          >
            Deselect All
          </SelectionButton>
        </SelectionActions>
        
        {/* Item Selection List */}
        <label style={{
          display: 'block',
          marginBottom: '0.75rem',
          color: shopData?.theme?.colors?.text,
          fontSize: '0.9rem',
          fontWeight: '600'
        }}>
          Select Items ({selectedItemsForUpdate.size} selected)
        </label>
        
        <ItemSelectionList theme={shopData?.theme}>
          {(shopContentType === 'services' ? 
            shopData?.services : 
            shopData?.items)?.map(item => (
            <ItemSelectionCard
              key={item.id}
              theme={shopData?.theme}
              selected={selectedItemsForUpdate.has(item.id)}
              onClick={() => toggleItemSelection(item.id)}
            >
              <ItemCheckbox 
                theme={shopData?.theme}
                checked={selectedItemsForUpdate.has(item.id)}
              >
                <Check size={14} />
              </ItemCheckbox>
              
              <ItemInfo theme={shopData?.theme}>
                <div className="item-name">
                  {item.name || (shopContentType === 'services' ? 'Service Name' : 'Item Name')}
                </div>
                <div className="item-details">
                  {formatShopPrice(item.price, shopData?.currency)}
                  {item.category && ` • ${item.category}`}
                </div>
              </ItemInfo>
            </ItemSelectionCard>
          ))}
        </ItemSelectionList>
      </OverlayBody>
      
      <OverlayFooter theme={shopData?.theme}>
        <ResetButton
          theme={shopData?.theme}
          onClick={() => setShowCategoryOverlay(false)}
        >
          Cancel
        </ResetButton>
        <SaveButton
          theme={shopData?.theme}
          onClick={handleApplyCategoryToSelected}
          disabled={selectedItemsForUpdate.size === 0 || !overlayCategory}
        >
          <Check size={16} />
          Apply to {selectedItemsForUpdate.size} {shopContentType}
        </SaveButton>
      </OverlayFooter>
    </UtilityOverlayContent>
  </UtilityOverlay>
)}



      {mapOpen && userLocation && (
  <TreasureMap
    isOpen={mapOpen}
    onClose={() => {
      setMapOpen(false);
      setSelectingLocationFor(null);
    }}
    items={[]}
    services={[]}
    userLocation={userLocation}
    theme={shopData?.theme}
    selectionMode={true}
    onLocationSelect={handleMapLocationSelect}
    onRequestLocation={handleRequestLocation}
  />
)}

{compressionProgress && (
  <CompressionProgress theme={shopData?.theme}>
    <div className="progress-text">{compressionProgress.text}</div>
    <div className="progress-bar">
      <div 
        className="progress-fill" 
        style={{ width: `${compressionProgress.percent}%` }}
      />
    </div>
  </CompressionProgress>
)}

{/* Mass Location Updater Modal */}
{showLocationUpdater && (
  <MassLocationUpdater
    onClose={() => setShowLocationUpdater(false)}
    onLocationSet={handleMassLocationSet}
    theme={shopData?.theme}
    itemCount={shopContentType === 'services' ? 
      shopData?.services?.length || 0 : 
      shopData?.items?.length || 0
    }
    isService={shopContentType === 'services'}
    onMapOpen={() => {
      setShowLocationUpdater(false);
      setLocationUpdateMode(shopContentType);
      setSelectingLocationFor({ isMassUpdate: true });
      setMapOpen(true);
    }}
  />
)}

{showAddFromStore && (() => {
  const tc = shopData?.theme?.colors || {};
  const bg = tc.background || '#1a1a1a';
  const text = tc.text || '#ffffff';
  const accent = tc.accent || '#00c6ff';
  const surface = tc.surface || 'rgba(255,255,255,0.08)';
  const rowBg = surface;
  const rowBgChecked = `color-mix(in srgb, ${accent} 18%, transparent)`;
  const borderMuted = `color-mix(in srgb, ${accent} 25%, transparent)`;
  const borderActive = accent;
  const iconBg = `color-mix(in srgb, ${accent} 18%, transparent)`;

  return (
  <BulkEditModalOverlay onClick={() => setShowAddFromStore(false)}>
    <BulkEditModalContent
      theme={shopData?.theme}
      onClick={e => e.stopPropagation()}
      style={{ maxWidth: addFromStoreStep === 'items' ? '540px' : '420px', background: bg }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.25rem' }}>
        <h3 style={{ margin: 0, color: accent, fontSize: '1.25rem' }}>
          {addFromStoreStep === 'stores' ? 'Nearby Stores' : `Products — ${selectedSourceShop?.name}`}
        </h3>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          {addFromStoreStep === 'items' && (
            <button
              onClick={() => { setAddFromStoreStep('stores'); setSelectedImportItems(new Set()); }}
              style={{ background: 'transparent', border: 'none', color: text, cursor: 'pointer', opacity: 0.75, fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
            >
              ← Back
            </button>
          )}
          <button
            onClick={() => setShowAddFromStore(false)}
            style={{ background: 'transparent', border: 'none', color: text, cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '0.25rem' }}
          >
            <X size={18} />
          </button>
        </div>
      </div>

      {/* Step 1: Store list */}
      {addFromStoreStep === 'stores' && (
        loadingNearbyShops ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: text, opacity: 0.6 }}>
            Loading nearby stores…
          </div>
        ) : nearbyShops.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: text, opacity: 0.6 }}>
            No nearby stores found.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {nearbyShops.map(shop => (
              <button
                key={shop.id}
                onClick={() => handleSelectSourceShop(shop)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '0.75rem',
                  background: rowBg,
                  border: `1px solid ${borderMuted}`,
                  borderRadius: '10px', padding: '0.75rem 1rem',
                  cursor: 'pointer', color: text,
                  textAlign: 'left', transition: 'border-color 0.2s, background 0.2s',
                  width: '100%',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = borderActive; e.currentTarget.style.background = rowBgChecked; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = borderMuted; e.currentTarget.style.background = rowBg; }}
              >
                {shop.profile ? (
                  <img src={shop.profile} alt={shop.name} style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                ) : (
                  <div style={{ width: 40, height: 40, borderRadius: '50%', background: iconBg, border: `1px solid ${borderMuted}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: accent }}>
                    <Store size={18} />
                  </div>
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: '0.95rem', color: text }}>{shop.name}</div>
                  <div style={{ fontSize: '0.8rem', color: text, opacity: 0.6, marginTop: '0.1rem' }}>
                    {shop.items.length} product{shop.items.length !== 1 ? 's' : ''}
                    {shop.distanceMiles !== null ? ` · ${shop.distanceMiles} mi away` : ''}
                  </div>
                </div>
                <ChevronRight size={16} style={{ color: accent, opacity: 0.6, flexShrink: 0 }} />
              </button>
            ))}
          </div>
        )
      )}

      {/* Step 2: Product list */}
      {addFromStoreStep === 'items' && selectedSourceShop && (
        <>
          <div style={{ fontSize: '0.8rem', color: text, opacity: 0.65, marginBottom: '0.75rem' }}>
            {selectedImportItems.size > 0 ? `${selectedImportItems.size} selected` : 'Select products to add to your shop'}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', maxHeight: '50vh', overflowY: 'auto', paddingRight: '0.2rem' }}>
            {selectedSourceShop.items.map(item => {
              const checked = selectedImportItems.has(item.id);
              const thumb = item.images?.find(Boolean);
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    setSelectedImportItems(prev => {
                      const next = new Set(prev);
                      checked ? next.delete(item.id) : next.add(item.id);
                      return next;
                    });
                  }}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '0.75rem',
                    background: checked ? rowBgChecked : rowBg,
                    border: `1px solid ${checked ? borderActive : borderMuted}`,
                    borderRadius: '10px', padding: '0.6rem 0.9rem',
                    cursor: 'pointer', color: text,
                    textAlign: 'left', transition: 'all 0.15s',
                    width: '100%',
                  }}
                >
                  {thumb ? (
                    <img src={thumb} alt={item.name} style={{ width: 44, height: 44, borderRadius: '6px', objectFit: 'cover', flexShrink: 0 }} />
                  ) : (
                    <div style={{ width: 44, height: 44, borderRadius: '6px', background: iconBg, border: `1px solid ${borderMuted}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: accent }}>
                      <Package size={18} />
                    </div>
                  )}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: '0.9rem', color: text }}>{item.name}</div>
                    <div style={{ fontSize: '0.8rem', color: text, opacity: 0.6, marginTop: '0.1rem' }}>
                      {item.price ? formatShopPrice(item.price, shopData?.currency) : 'No price'}{item.category ? ` · ${item.category}` : ''}
                    </div>
                  </div>
                  <div style={{
                    width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                    background: checked ? accent : 'transparent',
                    border: `2px solid ${checked ? accent : borderMuted}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    {checked && <Check size={11} color={bg} />}
                  </div>
                </button>
              );
            })}
          </div>

          <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.25rem', justifyContent: 'flex-end' }}>
            <BulkActionButton className="cancel" theme={shopData?.theme} onClick={() => setShowAddFromStore(false)}>
              Cancel
            </BulkActionButton>
            <BulkActionButton
              className="edit-price"
              theme={shopData?.theme}
              onClick={handleImportItems}
              disabled={selectedImportItems.size === 0 || importingItems}
            >
              <Check size={15} />
              Add {selectedImportItems.size > 0 ? `${selectedImportItems.size} ` : ''}Product{selectedImportItems.size !== 1 ? 's' : ''}
            </BulkActionButton>
          </div>
        </>
      )}
    </BulkEditModalContent>
  </BulkEditModalOverlay>
  );
})()}

{showBulkEditModal && (() => {
  const accent = shopData?.theme?.colors?.accent || '#800000';
  const storeType = shopData?.storeType;
  const isRestaurant = shopData?.isRestaurant || storeType === 'restaurant';
  const PRESETS = {
    clothing: ['Size', 'Color', 'Material', 'Style'],
    shoes:    ['Size', 'Color', 'Width'],
    electronics: ['Storage', 'Color', 'Connectivity'],
    sports:   ['Size', 'Color'],
    home:     ['Color', 'Material', 'Size'],
    beauty:   ['Variant', 'Size'],
    toys:     ['Size', 'Color'],
    automotive: ['Color', 'Compatibility'],
    art:      ['Size', 'Material'],
    books:    ['Format', 'Edition'],
    restaurant: ['Size', 'Spice Level', 'Protein', 'Side'],
    other:    ['Size', 'Color', 'Material'],
  };
  const SIZE_SUGGESTIONS = {
    Size: isRestaurant ? ['Small', 'Medium', 'Large', 'XL'] : ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    Color: ['Black', 'White', 'Red', 'Blue', 'Green', 'Yellow', 'Pink', 'Grey', 'Brown'],
    Storage: ['64GB', '128GB', '256GB', '512GB', '1TB'],
    Material: ['Cotton', 'Polyester', 'Leather', 'Wool', 'Silk', 'Denim'],
    Format: ['Hardcover', 'Paperback', 'eBook', 'Audiobook'],
    Width: ['Narrow', 'Regular', 'Wide'],
    'Spice Level': ['Mild', 'Medium', 'Hot', 'Extra Hot'],
    Protein: ['Chicken', 'Beef', 'Shrimp', 'Tofu', 'Pork', 'Lamb'],
    Side: ['Fries', 'Salad', 'Rice', 'Coleslaw', 'Soup'],
  };
  const presetNames = PRESETS[storeType] || PRESETS.other;
  return (
    <BulkEditModalOverlay onClick={() => setShowBulkEditModal(false)}>
      <BulkEditModalContent
        theme={shopData?.theme}
        onClick={(e) => e.stopPropagation()}
        style={{ maxHeight: '85vh', overflowY: 'auto' }}
      >
        <h3>Bulk Edit — {selectedItemsForBulk.size} Items</h3>

        <div className="info-text">
          Changes will apply to all {selectedItemsForBulk.size} selected {shopContentType}
        </div>

        <div className="input-group">
          <label>New Price ($) <span style={{ fontWeight: 400, opacity: 0.55 }}>(leave blank to keep existing)</span></label>
          <input
            type="number"
            step="0.01"
            min="0"
            value={bulkEditPrice}
            onChange={(e) => setBulkEditPrice(e.target.value)}
            placeholder="0.00"
            autoFocus
          />
        </div>

        {shopContentType === 'services' && (
          <div className="input-group" style={{ marginTop: '1rem' }}>
            <label>Service Type <span style={{ fontWeight: 400, opacity: 0.55 }}>(leave blank to keep existing)</span></label>
            <select
              value={bulkEditJobType}
              onChange={e => setBulkEditJobType(e.target.value)}
              style={{ width: '100%', padding: '0.5rem 0.75rem', borderRadius: '8px', border: `1px solid ${accent}40`, background: 'rgba(0,0,0,0.3)', color: 'inherit', fontSize: '0.85rem', outline: 'none', cursor: 'pointer' }}
            >
              <option value="">— Keep existing —</option>
              {getAllServiceTypes().map(jt => (
                <option key={jt.id} value={jt.id}>{jt.icon} {jt.label}</option>
              ))}
            </select>
          </div>
        )}

        {shopContentType !== 'services' && <div style={{ marginTop: '1rem' }}>
            <label style={{ fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem' }}>
              {isRestaurant ? 'Item Options' : 'Attributes'} <span style={{ fontWeight: 400, opacity: 0.55 }}>(replaces existing on selected items)</span>
            </label>

            {/* Quick-add preset chips */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem', marginBottom: '0.6rem' }}>
              {presetNames.filter(n => !bulkEditAttributes.some(a => a.name === n)).map(name => (
                <button
                  key={name}
                  onClick={() => setBulkEditAttributes(prev => [...prev, { name, values: [] }])}
                  style={{ padding: '0.25rem 0.65rem', borderRadius: '20px', fontSize: '0.78rem', cursor: 'pointer', border: `1px dashed ${accent}80`, background: 'transparent', color: accent }}
                >+ {name}</button>
              ))}
            </div>

            {/* Attribute rows */}
            {bulkEditAttributes.map((attr, ai) => (
              <div key={ai} style={{ marginBottom: '0.75rem', padding: '0.6rem', borderRadius: '8px', border: `1px solid ${accent}30`, background: 'rgba(0,0,0,0.08)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.4rem' }}>
                  <input
                    value={attr.name}
                    onChange={e => setBulkEditAttributes(prev => prev.map((a, i) => i === ai ? { ...a, name: e.target.value } : a))}
                    style={{ flex: 1, padding: '0.25rem 0.5rem', borderRadius: '6px', border: `1px solid ${accent}40`, background: 'rgba(255,255,255,0.05)', color: 'inherit', fontSize: '0.82rem' }}
                    placeholder="Attribute name"
                  />
                  <button
                    onClick={() => setBulkEditAttributes(prev => prev.filter((_, i) => i !== ai))}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', opacity: 0.5, fontSize: '1rem', lineHeight: 1, padding: '0 0.2rem' }}
                  >✕</button>
                </div>
                {/* Value chips */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginBottom: '0.35rem' }}>
                  {attr.values.map((v, vi) => (
                    <span key={vi} style={{ padding: '0.2rem 0.55rem', borderRadius: '20px', fontSize: '0.78rem', background: `${accent}22`, border: `1px solid ${accent}55`, display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                      {v}
                      <button
                        onClick={() => setBulkEditAttributes(prev => prev.map((a, i) => i === ai ? { ...a, values: a.values.filter((_, vi2) => vi2 !== vi) } : a))}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', opacity: 0.55, fontSize: '0.75rem', lineHeight: 1, padding: 0 }}
                      >✕</button>
                    </span>
                  ))}
                  {/* Suggestion chips */}
                  {(SIZE_SUGGESTIONS[attr.name] || []).filter(s => !attr.values.includes(s)).map(s => (
                    <button
                      key={s}
                      onClick={() => setBulkEditAttributes(prev => prev.map((a, i) => i === ai ? { ...a, values: [...a.values, s] } : a))}
                      style={{ padding: '0.2rem 0.55rem', borderRadius: '20px', fontSize: '0.78rem', cursor: 'pointer', border: `1px dashed ${accent}60`, background: 'transparent', color: accent }}
                    >{s}</button>
                  ))}
                </div>
                {/* Custom value input */}
                <form
                  onSubmit={e => {
                    e.preventDefault();
                    const val = (bulkAttrInput[ai] || '').trim();
                    if (!val || attr.values.includes(val)) return;
                    setBulkEditAttributes(prev => prev.map((a, i) => i === ai ? { ...a, values: [...a.values, val] } : a));
                    setBulkAttrInput(prev => ({ ...prev, [ai]: '' }));
                  }}
                  style={{ display: 'flex', gap: '0.35rem' }}
                >
                  <input
                    value={bulkAttrInput[ai] || ''}
                    onChange={e => setBulkAttrInput(prev => ({ ...prev, [ai]: e.target.value }))}
                    placeholder="Add value…"
                    style={{ flex: 1, padding: '0.22rem 0.5rem', borderRadius: '6px', border: `1px solid ${accent}30`, background: 'rgba(255,255,255,0.05)', color: 'inherit', fontSize: '0.78rem' }}
                  />
                  <button type="submit" style={{ padding: '0.22rem 0.6rem', borderRadius: '6px', border: `1px solid ${accent}60`, background: 'transparent', color: accent, fontSize: '0.78rem', cursor: 'pointer' }}>Add</button>
                </form>
              </div>
            ))}

            <button
              onClick={() => setBulkEditAttributes(prev => [...prev, { name: '', values: [] }])}
              style={{ fontSize: '0.8rem', background: 'none', border: `1px dashed ${accent}60`, borderRadius: '6px', padding: '0.3rem 0.7rem', cursor: 'pointer', color: accent, marginTop: '0.2rem' }}
            >+ Add Attribute</button>
          </div>}

        <div className="modal-actions" style={{ marginTop: '1.2rem' }}>
          <BulkActionButton
            className="cancel"
            theme={shopData?.theme}
            onClick={() => {
              setShowBulkEditModal(false);
              setBulkEditPrice('');
              setBulkEditAttributes([]);
              setBulkAttrInput({});
              setBulkEditJobType('');
            }}
          >
            Cancel
          </BulkActionButton>

          <BulkActionButton
            className="edit-price"
            theme={shopData?.theme}
            onClick={handleBulkApply}
            disabled={!bulkEditPrice && bulkEditAttributes.filter(a => a.name.trim() && a.values.length > 0).length === 0 && !bulkEditJobType}
          >
            <Check size={16} />
            Apply to {selectedItemsForBulk.size} Items
          </BulkActionButton>
        </div>
      </BulkEditModalContent>
    </BulkEditModalOverlay>
  );
})()}


    </PageContainer>


{showWebsiteScraper && (
  <WebsiteScraper
    onClose={() => setShowWebsiteScraper(false)}
    onProductsScraped={handleProductsScraped}
    theme={shopData?.theme}
    isService={shopContentType === 'services'}
  />
)}

{showMenuScanner && (
  <MenuScanner
    onClose={() => setShowMenuScanner(false)}
    onItemsExtracted={handleProductsScraped}
    theme={shopData?.theme}
  />
)}

{showStripeWizard && (
  <StripeWizard
    onClose={() => setShowStripeWizard(false)}
    onComplete={async () => {
      console.log('✅ Wizard completed');
      setShowStripeWizard(false);
      
      // Force recheck after completion
      setStripeChecked(false);
      await manualCheckStripe();
      
      setStatusMessage({ 
        type: 'success', 
        text: '✅ Stripe setup complete!' 
      });
    }}
    userId={auth.currentUser?.uid}
    userEmail={auth.currentUser?.email}
    shopName={shopData?.name}
    existingAccountData={stripeStatus}
  />
)}

  </ThemeProvider>
);
};



export default ShopPage;